(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var $cache = {},
    config = {
        container : '.birthdayfields',
        daySelect : 'select[name$="_day"]',
        monthSelect : 'select[name$="_dobmonth"]',
        yearSelect : 'select[name$="_dobyear"]'
    };

function empty(arg) {
    var argType = typeof arg;

    if (arg == null) {
        return true;
    }

    if (/(string|array|object|number)/.test(argType) && arg.length > 0) {
        return false;
    }

    return true;
}

function initializeCache() {
    $cache.container = $(config.container);
}

function daysInMonth(month, year) {
    if (empty(year)) {
        year = new Date().getFullYear();
    }
    var dd = new Date(year, month, 0);
    return dd.getDate();
}

function setDays($day, $month, $year) {
    var day = $day.val(),
        month = $month.val(),
        year = $year.val(),
        options = $day[0].options,
        days = empty(month) ? 31 : daysInMonth(month, year),
        selectBoxIt = $day.data('selectBox-selectBoxIt'),
        i;

    options.length = 29;

    for (i = 29; i <= days; i++) {
        options[options.length] = new Option(i, i);
    }

    $day.val(day > days ? days : day);
    if (selectBoxIt) {
        selectBoxIt.refresh();
    }
}

function initializeEvents() {
    var $day, $month, $year;
    $cache.container.each(function () {
        var $this = $(this);
        $day = $this.find(config.daySelect);
        $month = $this.find(config.monthSelect);
        $year = $this.find(config.yearSelect);
        var setDate = function () {
            setDays($day, $month, $year);
        };

        $month.on('change', setDate);
        $year.on('change', setDate);
    });

    if ($cache.container.length) {
        setDays($day, $month, $year);
    }
}

var accountSelectDate = {
    init: function () {
        initializeCache();
        initializeEvents();
    }
};

module.exports = accountSelectDate;

},{}],2:[function(require,module,exports){
var $cache = {};

function initializeCache() {
    $cache.registrationForm = $('#RegistrationForm');
    $cache.birthDate = $('#birthDate', $cache.registrationForm);
    $cache.birthMonth = $('#birthMonth', $cache.registrationForm);
    $cache.birthYear = $('#birthYear', $cache.registrationForm);
    $cache.birthDateControl = $cache.registrationForm.find('select[name$=\'birthdayfields_day\']');
    $cache.birthMonthControl = $cache.registrationForm.find('select[name$=\'birthdayfields_dobmonth\']');
    $cache.birthYearControl = $cache.registrationForm.find('select[name$=\'birthdayfields_dobyear\']');
    $cache.birthDateError = $('#dobError');
}

function initializeEvents() {
    $cache.registrationForm.on('submit', function (event) {

        var birthdayError = false,
            isBirthdayValidVal = isBirthdayValid(),
            isBirthdayFilledVal = isBirthdayFilled(),
            isBirthdayLessThanAgeLimitVal = isBirthdayLessThanAgeLimit();

        if (isBirthdayFilledVal) {
            birthdayError = isBirthdayLessThanAgeLimitVal;
            if (birthdayError) {
                $cache.birthDateError.text(Resources.DOB_LESS_THAN_AGE_LIMIT);
            }
        }

        if ($cache.birthMonthControl.val() || $cache.birthDateControl.val() || $cache.birthYearControl.val()) {
            birthdayError = !isBirthdayValidVal;
            if (birthdayError) {
                $cache.birthDateError.text(Resources.DOB_WRONG);
            }
        }

        $cache.birthDateError.toggle(birthdayError);
        return !birthdayError;
    });

    $('select', $cache.registrationForm).on('change', function(e) {
        if ($cache.birthDateError.length) {
            var isBirthdayFilledVal = isBirthdayFilled(),
                isBirthdayValidVal = isBirthdayValid(),
                isBirthdayLessThanAgeLimitVal = isBirthdayLessThanAgeLimit();

            if (isBirthdayFilledVal && isBirthdayValidVal) {
                $cache.birthDateError.hide();
            }
            if (isBirthdayFilledVal && isBirthdayLessThanAgeLimitVal) {
                $cache.birthDateError.text(Resources.DOB_LESS_THAN_AGE_LIMIT).show();
            }
            if (isBirthdayFilledVal && !isBirthdayLessThanAgeLimitVal) {
                $cache.birthDateError.hide();
            }
            if (isBirthdayFilledVal && !isBirthdayValidVal) {
                $cache.birthDateError.text(Resources.DOB_WRONG).show();
            }
        }

        if ($cache.birthDateControl.val() || $cache.birthMonthControl.val() || $cache.birthYearControl.val()) {
            $cache.birthDateControl.attr('required', true);
            $cache.birthMonthControl.attr('required', true);
            $cache.birthYearControl.attr('required', true);
        } else {
            $cache.birthDateControl.removeAttr('required').removeClass('error');
            $cache.birthMonthControl.removeAttr('required').removeClass('error');
            $cache.birthYearControl.removeAttr('required').removeClass('error');

            $('.error-message.list-13').empty();
        }
    });

    selectBirthday();
}

function isBirthdayFilled() {
    return $cache.birthMonthControl.val() && $cache.birthDateControl.val() && $cache.birthYearControl.val();
}

function isBirthdayValid() {
    if (isBirthdayFilled()) {
        var month = $cache.birthMonthControl.val(),
            date = $cache.birthDateControl.val(),
            year = $cache.birthYearControl.val();

        return (new Date(year, month - 1, date)).getDate() === parseInt(date);
    }

    return false;
}

function isBirthdayLessThanAgeLimit() {
    var minimumAgeLimit = SitePreferences.MINIMUM_AGE_LIMIT;
    if (minimumAgeLimit == 0) {
        return false;
    }

    if (isBirthdayFilled()) {
        var month = $cache.birthMonthControl.val(),
            date = $cache.birthDateControl.val(),
            year = $cache.birthYearControl.val(),
            dob = new Date(year, month - 1, date),
            now = new Date(),
            customerAge = now.getFullYear() - dob.getFullYear();

        if (new Date(now.getFullYear(), dob.getMonth(), dob.getDate()) > new Date(now.getFullYear(), now.getMonth(), now.getDate())) {
            customerAge--;
        }
        return customerAge > 0 && customerAge < minimumAgeLimit;
    }

    return true;
}

function selectBirthday() {

    if ($cache.birthMonth.val() != 0) {
        var monthOfBirthSelect = $cache.registrationForm.find('#dwfrm_profile_customer_birthdayfields_dobmonth');
        monthOfBirthSelect.find('option[value=\'' + $cache.birthMonth.val() + '\']').prop('selected', 'selected').attr('selected', 'selected');
        monthOfBirthSelect.trigger('change');
    }

    if ($cache.birthDate.val() != 0) {
        var dayOfBirthSelect = $cache.registrationForm.find('#dwfrm_profile_customer_birthdayfields_day');
        dayOfBirthSelect.find('option[value=\'' + $cache.birthDate.val() + '\']').prop('selected', 'selected').attr('selected', 'selected');
        dayOfBirthSelect.trigger('change');
    }

    if ($cache.birthYear.val() != 0) {
        var yearOfBirthSelect = $cache.registrationForm.find('#dwfrm_profile_customer_birthdayfields_dobyear');
        yearOfBirthSelect.find('option[value=\'' + $cache.birthYear.val() + '\']').prop('selected', 'selected').attr('selected', 'selected');
        yearOfBirthSelect.trigger('change');
    }
}

var validatedob = {
    init: function() {
        initializeCache();
        initializeEvents();
    }
}

module.exports = validatedob;

},{}],3:[function(require,module,exports){
/* --- handle Clean button for Address list --- */
var initCleanAutoFill = {
    init: function() {
        $('#clear-auto-fill').on('click', function() {
            var $auto_fill = $('.auto-fill');
            $auto_fill.find('input').val('');
            $auto_fill.find('select').prop('selectedIndex', 0);
        });
    }
}

module.exports = initCleanAutoFill;
},{}],4:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

/**
* @function 
* @description toggle multiple payment section on checkout page
*/
function initAfterPayCheckout(){
	var afterPayPaymentMethodID = "AFTERPAY_PBI";
	$(document).on('click','.afterpay-payment-method-wrapper .afterpay-payment-method input',function(e){
		var isAfterPayPaymentEnabled = $(".afterpay-payment-method-wrapper .afterpay-payment-method input.after-pay-input-radio").is(':enabled');
		if(isAfterPayPaymentEnabled){
			$(".multiple-payment-selection-wrapper .payment-method-radio-btn input#is-"+afterPayPaymentMethodID).trigger("click");
			$(".afterpay-payment-method-wrapper .afterpay-payment-method-message").removeClass("hide");
			$("button#dwfrm_billing_save").removeAttr("disabled");
			//$('.spc-cc-title').addClass('spc-cc-expanded');
			//$('.creditcard-form-container').hide();
		}
	});
	
	$(document).on('click','.multiple-payment-selection-wrapper .payment-method-radio-btn input',function(e){
		var selectedID = $(this).attr("id");
		if(selectedID != 'is-'+afterPayPaymentMethodID){
			$(".afterpay-payment-method-wrapper .afterpay-payment-method input.after-pay-input-radio").removeAttr("checked");
			$(".afterpay-payment-method-wrapper .afterpay-payment-method-message").addClass("hide");
		}
	});
}

/**
* @function 
* @description open afterpay modal window on pdp and cart page
*/
function initAfterPayPopUp(){
	let $body = $('body');
	
	let modalResize = function() {
		if($(window).height() > $('.afterpay-payment').height()){
			$('.afterpay-payment').css({
				position : 'absolute',
				left : '50%',
				top : '50%',
				transform: 'translate(-50%, -50%)',
				height: 'auto'
			});
		} else {
			$('.afterpay-payment').css({
				position : 'absolute',
				left : '50%',
				top : '0',
				transform: 'translateX(-50%)',
				height: '100%'
			});
		}
	};
	$(document).on('click', '.afterpay-btn', function (e) {
    	e.preventDefault();
    	dialog.open({
    		url: $(this).attr('href'),
    		options: {
                width: 970,
                dialogClass: "afterpay-payment"
            },
            callback: function() {
            	$body.addClass('afterpay-dialog-open');
            	modalResize();
            }
    	});
    	
    });
	$body.on( "dialogclose", '.afterpay-payment', function( event, ui ) {
		$body.removeClass('afterpay-dialog-open');
	});
	$( window ).on("resize", modalResize);
}


var afterpay = {
    init: function () {
    	initAfterPayCheckout();
    	initAfterPayPopUp();
    }
}

module.exports = afterpay;

},{"./dialog":16}],5:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    })
    .done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;

},{"./progress":75,"./util":87}],6:[function(require,module,exports){
var util = require("./util");
var unbind = 0;
var unbindcarousel = 0;
function getPageCategory() {
	//return window.pageContext.title || "Content"; ###### this throws product name
	switch(window.Resources.PAGE_CATEGORY)	{
	case 'product-showincategory':
		return "Product Page";
		break;
	case 'product-show':
		return "Product Page";
		break;
	case 'search-show':
		return "Category Page";
		break;
	case 'home-show':
		return "Home Page"
		break;
	case 'cart-show':
		return "Cart Page"
		break;
	case 'cart-submitform':
		return "Cart Page"
		break;
	case 'cart-addtowishlist':
		return "Cart Page"
		break;
	case 'customerservice-contactus':
		return "Contact Customer Care"
		break;
	case 'customerservice-concierge':
		return "Ask An Expert"
		break;
	case 'account-startregister':
		return "Account Creation"
		break;
	case 'account-editprofile' :
		return "My Account"
		break;
	case 'address-list':
		return "My Account"
		break;
	case 'paymentinstruments-list':
		return "My Account"
		break;
	case 'wishlist-show':
		return "My Account"
		break;
	case 'order-history':
		return "My Account"
		break;
	case 'orderreplenishment-show':
		return "My Account"
		break;
	case 'login-show':
		return "Account Registration"
		break;
	case 'coshipping-start':
		return "Checkout"
		break;
	case 'coshipping-singleshipping':
		return "Checkout"
		break;
	case 'cobilling-start':
		return "Checkout"
		break;
	case 'cobilling-billing':
		return "Checkout"
		break;
	case 'search-showcontent':
		return "Site Search"
		break;
	case 'giftcert-purchase':
		return "Gift Card Page"
		break;
	case 'cocustomer-loginform':
		return "Customer Login";
		break;
	case 'default-start':
		return "Home Page";
		break;
	case 'search-brandify':
		return "Store Locator Page";
		break;
	default:
		return "Content";
		break;
	}
}
// Specific for checkout and cart page only
function couponsubcategory(){
	switch(window.Resources.PAGE_CATEGORY){
	case 'cart-show':
		return "Cart"
		break;
	case 'coshipping-start':
		return "Shipping"
		break;
	case 'coshipping-singleshipping':
		return "Payment"
		break;
	case 'cobilling-start':
		return "Payment"
		break;
	case 'cobilling-removegiftcertificate':
		return "Payment"
		break;
	case 'cobilling-billing':
		return "Review"
		break;
	case 'account-editprofile' :
		return "Profile"
		break;
	case 'address-list':
		return "Addresses"
		break;
	case 'paymentinstruments-list':
		return "Payment Methods"
		break;
	case 'wishlist-show':
		return "Saved For Later"
		break;
	case 'order-history':
		return "Order History"
		break;
	case 'orderreplenishment-show':
		return "Replenishment"
		break;
	default:
		break;
	}
}

function isMobile() {
	return $(window).width() <= 640;
}
//Specific for PDP
function getProductName()	{
	return $(".product-detail .product-name").text().trim();
}
//Specific for PDP
function getProductBrand() {
	return "The Ginza"; //$(".product-detail .product-brand").text();
}
//Specific for PDP
function getProductID()	{
	return $("#pid").val();
}
//Specific for PDP
function getProductCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(1)").text().trim();
}
//Specific for PDP
function getProductsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(2)").text().trim();
}
// Specific for PDP
function getProductsubsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(3)").text().trim();
}
// Specific for PDP
function getProductOrederType() {
	var replen = $(".replenishmentCycle").val();
	if(replen>0){
		return "Replenishment"
	} else {
		return "Regular"
	}

}

function getPageSubcategory() {
	return window.pageContext.title || "Content";
}

function getLanguage() {
	var lang = window.User.locale;
	if (lang.indexOf("\\u005f")) {
		lang = lang.replace("\\u005f", "_");
	}

	if (lang.indexOf("en_JP") >= 0) {
		return "English";
	} else if (lang.indexOf("zh_CN") >= 0) {
		return "Simplified Chinese";
	} else if (lang.indexOf("zh_TW") >= 0) {
		return "Traditional Chinese";
	} else if (lang.indexOf("ja_JP") >= 0) {
		return "Japanese";
	} else {
		return lang;
	}
}

// page-specific: Cart, Checkout
function getPageError() {
	var $errorMsg = $(".error-form");
	if ($errorMsg.length === 0) {
		return "";
	}

	return $errorMsg.html().trim();
}

function getActiveSortingRule() {
	var httpParams = util.getQueryStringParams(window.location.href);
	var sortParam = httpParams["srule"];

	if (!sortParam) {
		return null;
	}

	return sortParam.split("-").map(function (w) {
		return w[0].toUpperCase() + w.substr(1);
	}).join(" ");
}

function pushToDataLayer(o) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(util.filterObj(o));
	//alert(JSON.stringify(util.filterObj(o)));
}

function isScrolledIntoView(elem)
{
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height() - 150;
	var elemTop = $(elem).offset().top;
	return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
}

function getpage(){
	 var url = window.location.href;
	 var splittedurl = url.split("?");
	 var page = splittedurl[0].split("/");
	 return page[page.length-1]
}
//page-specific: PLP
function getRefinementsFromURL() {
	var str = "";
	if(window.location.href.split("?").length > 1){
		var urlparam;
		if(window.location.href.split("?")[1].indexOf("&")>-1){
			urlparam = window.location.href.split("?")[1].split("&");
			var length = urlparam.length;
			var prefnval,prefnkey,prefvval,prefvkey;
			for(var i =0;i<length;i++){
				var prefn = urlparam[i].indexOf("prefn");
				if(prefn > -1){
				  prefnkey = urlparam[i].split("=")[0];
				  prefnval = urlparam[i].split("=")[1];
				  console.log(prefnkey);
				  var num = prefnkey.charAt(5);
				  for(var a =0;a<length;a++){
					var prefv = urlparam[a].indexOf("prefv");
					prefvkey = urlparam[a].split("=")[0];
					if(prefvkey == "prefv"+num){
					   prefvval = urlparam[a].split("=")[1];
					   str += "[" + prefnval  + ":" + prefvval  + "]";
					}
				  }
				}
			}
		}
	}
	return str;
}

function getCountry() {
    if (window.User.locale !== null && window.User.locale.split('\\u005f').length === 2) {
        if (window.User.locale.split('\\u005f')[0] == "en" && window.User.locale.split('\\u005f')[1] == "JP") {
            return 'EN';
        } else {
            return window.User.locale.split('\\u005f')[1];
        }
    } else {
        return 'EN';
    }
}

function trackConsultationEvent(data) {
	var TOOL_TYPES = {
		"skincareConsultation": "Skincare Consultation"
	};

	pushToDataLayer({
		"event": "consultation" + data.element[0].toUpperCase() + data.element.substr(1),
		"pageCategory": "Consultation Tool",
		"consultationToolType": TOOL_TYPES[data.toolname] || data.toolname,
		"consultationQuestion": data.question,
		"consultationResponse": data.answers[0]
	});
}

function trackConsultationPageview(data) {
	pushToDataLayer({
		"event": "consultationSteps",
		"pageCategory": "Consultation Tool",
		"consultationToolType": data.toolname,
		"consultationStep": data.pagename
	});
}

function trackInternalPromotionEvent(data) {

	var promotionURL = data.pageName;

	pushToDataLayer({
		"event": "eePromoClick",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
		"position": data.position,
		"id": data.id,
		"creative": data.creative,
		"name": data.name
		}]
	}), (function(){setTimeout(function(){
		if (promotionURL != undefined) {
			document.location = promotionURL;
		}
		}, 1000);
	})();
}

function trackInternalPromotionPageView(data) {
	pushToDataLayer({
		"eeAction": "eePromoView",
		"event" : "eePromoView",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
		"position": data.position,
		"id": data.id,
		"creative": data.creative,
		"name": data.name
		}]
	});
}

function spcGABillingEvent() {

	pushToDataLayer({
    	"eeAction": "eeCheckout",
    	"event": "virtualPageview",
    	"page":"/checkout/payment",
    	"checkoutStep": "4",
    	"funnelType": basketConfirmation.funnelType,
    	"giftWrapping": basketConfirmation.giftWrapping,
    	"checkoutErrorMessage": basketConfirmation.checkoutErrorMessage,
    	"pageCategory": "Checkout",
    	"pageSubCategory": "Billing",
    	'products':  basketConfirmation.productLineItems
    	});


}

function spcGACheckoutOptionEvent() {

	pushToDataLayer({
	"event": "eeCheckoutOption",
	"checkoutStep": "3",
	"checkoutOption": $(document).find('.selected-option.selected .shipping-name').text().trim()
	});

}


function spcGAReviewEvent(){
	pushToDataLayer({
	         "eeAction": "eeCheckout",
	         "event": "virtualPageview",
	         "page":"/checkout/order-review",
	         "checkoutStep": "5",
	         "funnelType": basketConfirmation.funnelType,
	         "giftWrapping": basketConfirmation.giftWrapping,
	         "checkoutErrorMessage":  basketConfirmation.checkoutErrorMessage,
	         "pageCategory": "Checkout",
	         "pageSubCategory": "Review",
	         'products':  basketConfirmation.productLineItems
	     	});

}

//Clear the previous product object.
window.dataLayer.push({ products: null });

//add to cart from top page and Product List
function addToCartFromPLP(currentId) {
    pushToDataLayer({
        "event": "addToCart",
        "addToCartType": "Product Page",
        "websiteCountry": getCountry(),
        "language": getLanguage(),
        "pageCategory": getPageCategory(),
        "currencyCode": window.Resources.CURRENCY,
        'products': [{
        "id": $(currentId + " .js_addtocart").data("pid"),
        "category": $(currentId + " .js_addtocart").data("subsubcategory"),
        "price": $(currentId + " .js_addtocart").data("price"),
        "name": $(currentId + " .name-link .product-name").text().trim(),
        "brand": getProductBrand(),
        "quantity": 1,
        "variant": $(currentId + " .js_addtocart").data("size") ? $(currentId + " .js_addtocart").data("size") : "null",
        "productOutOfStock": $(currentId + " .js_addtocart").data("instock"),
        "productType": "Product"}]
    });
}

//add to cart from PDP and quick view
function addToCartFromPDP() {
    var quantity = Number($(".quantity select").val());
    pushToDataLayer({
        "event": "addToCart",
        "addToCartType": "Product Page",
        "websiteCountry": getCountry(),
        "language": getLanguage(),
        "pageCategory": getPageCategory(),
        "currencyCode": window.Resources.CURRENCY,
        'products': [{
        "id": getProductID(),
        "category": $("#add-to-cart").data("subsubcategory"),
        "price": $("#add-to-cart").data("price").replace(/\.0$/, ""),
        "name": $(".product-detail .product-name, .product-title .product-name").text().trim(),
        "brand": getProductBrand(),
        "quantity": quantity ? quantity : 1,
        "variant":  $("#add-to-cart").data("size") ? $("#add-to-cart").data("size") : "null",
        "productOutOfStock": $("#add-to-cart").data("instock"),
        "productType": "Product"}]
    });
}

function eeListClick(argThis) {
	var categoryId = "";
	if (argThis.parents('.search-representative-result-items').attr('id') === undefined) {
		categoryId = ".search-representative-result-items";
	} else {
		categoryId = "#" + argThis.parents('.search-representative-result-items').attr('id');
	}
	var index = argThis.parents(".gtmindex").index(categoryId + " .gtmindex") + 1;
	var currentId = "#" + argThis.parents('.product-tile').attr('id');
	var list = "All";
	var listType = "product category list"
	if (searchItems.kw55 == "" && $("h1.text-center").text() != "ALL PRODUCTS") {
		list = $("h1.text-center").text();
	}
	if (searchItems.kw55) {
		listType = prodholder[0][0].listType;
	}
	pushToDataLayer({
		"event": "eeListClick",
		"websiteCountry": getCountry(),
		"language": getLanguage(),
		"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
		'products': [{
			"list" : searchItems.kw55 ? decodeURIComponent(searchItems.kw55) : list,
			"listType": listType,
			"listName": searchItems.kw55 ? "Search" : list,
			"position": index,
			"id": $(currentId + " .js_addtocart").data("pid"),
			"category": $(currentId + " .js_addtocart").data("subsubcategory"),
			"price": $(currentId + " .js_addtocart").data("price"),
			"name": $(currentId + " .name-link .product-name").text().trim(),
			"brand":getProductBrand(),
			"size": "",
			"productOutOfStock": $(currentId + " .js_addtocart").data("instock"),
			"productType": "Product"}]
	})
}
function initializeGlobalEvents() {
	var navctr = true;
	var gtmNavData = "";

	$(document)

		// add to wishlist in pdp and quickview
		.on('click', ".product-form-actions .iconfont-heart", function (e) {
				pushToDataLayer({
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"event": "clickSaveForLater",
					"productCategory": $("#add-to-cart").data("subsubcategory"),
					"productName": $(".product-detail .product-name, .product-title .product-name").text().trim(),
					"pageCategory": getPageCategory(),
					"productId": getProductID()
					});
		})

		// add to wishlist in product list
		.on('click', ".product-tile .iconfont-heart", function (e) {
				var currentId = "#" + $(this).parents('.product-tile').attr('id');
				pushToDataLayer({
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"event": "clickSaveForLater",
					"productCategory": $(currentId + " .js_addtocart").data("subcategory"),
					"productName": $(currentId + " .name-link .product-name").text().trim(),
					"pageCategory": getPageCategory(),
					"productId": $(currentId + " .js_addtocart").data("pid")
					});
		})

		// remove from wishlist in pdp and quickview
		.on('click', ".product-form-actions .iconfont-heart_solid", function (e) {
				pushToDataLayer({
					"event": "removeFromWishlist",
					"productCategory": $("#add-to-cart").data("subsubcategory"),
					"productName": $(".product-detail .product-name, .product-title .product-name").text().trim(),
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					"productId": getProductID()
					});
		})

		// remove from wishlist in product list
		.on('click', ".product-tile .iconfont-heart_solid", function (e) {
				var currentId = "#" + $(this).parents('.product-tile').attr('id');
				pushToDataLayer({
					"event": "removeFromWishlist",
					"productCategory": $(currentId + " .js_addtocart").data("subsubcategory"),
					"productName": $(currentId + " .name-link .product-name").text().trim(),
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					"productId": $(currentId + " .js_addtocart").data("pid")
					});
		})

		// remove from wishlist in my account
		.on('click', ".wishlist-item .iconfont-heart_solid", function (e) {
				pushToDataLayer({
					"event": "removeFromWishlist",
					"productCategory": $(this).parent('button').data("category"),
					"productSubCategory": $(this).parent('button').data("subcategory"),
					"productName": $(this).parent('button').data("name").trim(),
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					"productId":$(this).parent('button').data("pid")
					});
		})

		// Product Recommendation Interaction
		.on("click",".plp-image-hover, .name-link",function(e){
			if ($(this).parents(".recommendations").length > 0) {
				var quantity = Number($(".quantity select").val());
				var currentId = "#" + $(this).parents('.product-tile').attr('id');
				pushToDataLayer({
					"event": "productRecommendation",
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					"productId": $(currentId + " .js_addtocart").data("pid"),
					"productCategory": $(currentId + " .js_addtocart").data("subsubcategory"),
					"productName": $(currentId + " .name-link .product-name").text().trim()
				});
			}
			// Recommendation eelistclick in homepage,pdp,cart
			if ($(this).parents("#recommendations").length > 0) {
	        	var currentId = "#" + $(this).parents('.product-tile').attr('id');
				var index = $(this).parents(".product-tile").index("#recommendations .slick-active .product-tile") + 1;
				pushToDataLayer({
					"event": "eeListClick",
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					'products': [{
					"list" : "All",
					"listType" : "we recommend",
					"listName": prodData.product[0].listName,
					"position": index,
					"id": $(currentId + " .js_addtocart").data("pid"),
					"category": $(currentId + " .js_addtocart").data("subsubcategory"),
					"price": $(currentId + " .js_addtocart").data("price"),
					"name": $(currentId + " .name-link .product-name").text().trim(),
					"brand": getProductBrand(),
					"quantity": "",
					"size": "",
					"productOutOfStock": $(currentId + " .js_addtocart").data("instock"),
					"productType": "Product"}]
				})
				sessionStorage.setItem('listType',prodData.product[0].listType);
				sessionStorage.setItem('listName',prodData.product[0].listName);
			}
			// bestseller eelistclick in homepage
			if ($(this).parents(".pi .slick-active .product-tile").length > 0) {
				var currentId = "#" + $(this).parents('.product-tile').attr('id');
				var index = $(this).parents(".product-tile").index(".pi .slick-active .product-tile") + 1;
				pushToDataLayer({
					"event": "eeListClick",
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					'products': [{
					"list" : "All",
					"listType" : "Homepage product carrousel",
					"listName": prodData.product[0].listName,
					"position": index,
					"id": $(currentId + " .js_addtocart").data("pid"),
					"category": $(currentId + " .js_addtocart").data("subsubcategory"),
					"price": $(currentId + " .js_addtocart").data("price"),
					"name": $(currentId + " .name-link .product-name").text().trim(),
					"brand": getProductBrand(),
					"quantity": "",
					"size": "",
					"productOutOfStock": $(currentId + " .js_addtocart").data("instock"),
					"productType": "Product"}]
				})
				sessionStorage.setItem('listType',prodData.product[0].listType);
				sessionStorage.setItem('listName',prodData.product[0].listName);
			}
			// Recently viewed eelistclick in homepage
			if ($(this).parents(".recently-viewed").length > 0) {
				var currentId = "#" + $(this).parents('.product-tile').attr('id');
				var index = $(this).parents(".product-tile").index(".recently-viewed .slick-active .product-tile") + 1;
				pushToDataLayer({
					"event": "eeListClick",
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					'products': [{
					"list" : "All",
					"listType" : "Recently viewed",
					"listName": prodData.product[0].listName,
					"position": index,
					"id": $(currentId + " .js_addtocart").data("pid"),
					"category": $(currentId + " .js_addtocart").data("subsubcategory"),
					"price": $(currentId + " .js_addtocart").data("price"),
					"name": $(currentId + " .name-link .product-name").text().trim(),
					"brand": getProductBrand(),
					"quantity": "",
					"size": "",
					"productOutOfStock": $(currentId + " .js_addtocart").data("instock"),
					"productType": "Product"}]
				})
				sessionStorage.setItem('listType',prodData.product[0].listType);
				  sessionStorage.setItem('listName',prodData.product[0].listName);
			}
		})

		// newsletter in navigation;
		.on("clicknewsletter", function (e, data) {
				 pushToDataLayer({
					"event": "newsletterSubscription",
					"siteLocation": data.siteloc,
					"pageSubCategory": getPageCategory() == "My Account" ? getProductsubCategory():"",
					"pageCategory": getPageCategory()
					});
		 })


		// click ask question in pdp
		.on("click",".bv-ask-question",	function (e) {
			pushToDataLayer({
				page:getpage(),
				"event": "askQuestion",
				productCategory:getProductCategory(),
				pageSubCategory:"Ask a Question",
				productName:getProductName(),
				pageCategory:"Product Page"
			});
		})

		// Scroll on reviews in pdp
		.on("scroll", function() {
			 if ($(".bv-section-summary").length) {
				if (isScrolledIntoView(".bv-section-summary") && unbind < 1) {
					unbind = 1;
					pushToDataLayer({
							page: getpage(),
							event: "productReviewsView",
							productCategory: getProductCategory(),
							pageSubCategory: "Reviews",
							productName:getProductName(),
							pageCategory: "Product Page"
					});
				}
			 }

			 // for recommendation in pdp and cart, Best Seller and Recently Viewed in Homepage
			 if ($(".pi .carousel-recommendations").length > 0  || $(".cross-sell .carousel-recommendations").length > 0 ) {
				 if (isScrolledIntoView(".carousel-recommendations") &&  unbindcarousel < 1) {
					    unbindcarousel =  1;
					    pushToDataLayer({
							"currencyCode": window.User.currencyCode,
							"eeAction": "eeListView",
							"event" : "eeListView",
							"pageCategory": getPageCategory(),
							"products":window.forpageload.product});
				 }
			 }

		})

		// Click on Reviews in PDP
		.on("click", ".bv-inline-histogram-ratings-star-container", function () {
			pushToDataLayer({
				page: getpage(),
				event: "productReviewsView",
				productCategory: getProductCategory(),
				pageSubCategory: "Reviews",
				productName:getProductName(),
				pageCategory: "Product Page"
			});
		})

		// Check balance giftcard in gift card page
		.on('click', "#CheckBalanceButton", function(){
			if($("#dwfrm_giftcert_balance_giftCertID").val() != "" && $("#dwfrm_giftcert_balance_giftCertPIN").val() != ""){
				pushToDataLayer({
					"event": "giftCard",
					"pageSubCategory": "Gift Card",
					"pageCategory": "My Account"
					});
			}
		})

		// Check balance giftcard in checkout page
		.on('click', ".modal-body .gift-cert-balance-submit #check-giftcert-modal", function(e){
			if($(".modal-body .gift-card-number #dwfrm_billing_giftCertCode").val() != "" && $(".modal-body .gift-card-pin #dwfrm_giftcert_balance_giftCertPIN").val() != ""){
				pushToDataLayer({
					"event": "giftCard",
					"pageSubCategory": "Payment",
					"pageCategory": "Checkout"
					});

			}
		})

		// Submit ask a question
		.on('click', ".bv-submission-section button:contains('Post Question')" , function(e){
				pushToDataLayer({
					"page": getpage(),
					"event": "submitQuestion",
					"productCategory": getProductCategory(),
					"question": $("#bv-textarea-field-questionsummary").val(),
					"productName": getProductName(),
					"pageSubCategory": "Ask a Question",
					"pageCategory": getPageCategory()
					});
		})

		// remove from cart
		.on('click', ".button-text.not-underline", function (e) {
			var index = $(this).parents(".cart-row").index();
			var country = getCountry();
			pushToDataLayer({
				"event": "removeFromCart",
				"websiteCountry": getCountry(),
				"language": getLanguage(),
				"pageCategory": getPageCategory(),
				"currencyCode": window.Resources.CURRENCY,
				'products': [{
				"id": basketConfirmation.productLineItems[index-1].id,
				"category": basketConfirmation.productLineItems[index-1].subCategory,
				"price": $(this).data("price").replace(/\.0$/, ""),
				"productOutOfStock": basketConfirmation.productLineItems[index-1].productOutOfStock,
				"name": basketConfirmation.productLineItems[index-1].name,
				"brand": getProductBrand(),
				"quantity": basketConfirmation.productLineItems[index-1].quantity,
				"size": basketConfirmation.productLineItems[index-1].size,
				"variant":  $(this).data("size") ? $(this).data("size") : "null",
				"productType": basketConfirmation.productLineItems[index-1].productType}]
			})
		})

		// click full ingredients in pdp
		.on('click', ".accordion-item.is-active #composition-label", function(e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": productCache.subsubcategory,
				"productName": getProductName(),
				"websiteCountry": getCountry(),
				"language": getLanguage(),
				"pageCategory": getPageCategory(),
				"productId": getProductID(),
				"interactionType" : "View Full Product Ingredients"
			})
		})

		// tracking change on image in
		.on("clickproductthumbnail",function(){
			if (window.productCache) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": productCache.subsubcategory,
					"productName": getProductName(),
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					"productId": getProductID(),
					"interactionType" : "Image Change"
				})
			}
		})

		// click slick arrow in pdp
		.on("click", ".product-images.product-slide-large .slick-arrow",function(){
			if (window.productCache) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": productCache.subsubcategory,
					"productName": getProductName(),
					"websiteCountry": getCountry(),
					"language": getLanguage(),
					"pageCategory": getPageCategory(),
					"productId": getProductID(),
					"interactionType" : "Image Change"
				})
			}
		})

		.on("click", ".cart-promo-approaching", function(){
			pushToDataLayer({
				"event": "eePromoClick",
				"pageSubCategory": "Internal marketing",
				"pageCategory": "Cart Page",
				'promotions': [{
				"position": "Cart",
				"id": $(".cart-promo-approaching").data("promoid"),
				"creative": "Cart-Banner",
				"name": $(".cart-promo-approaching").data("promoname").trim()
				}]
			})
		})

		.on("click", ".cart-coupon-code #add-coupon", function () {
			localStorage.removeItem('couponvalidation');
		})

		// track share button on PDP
		.on("click", ".social-sharing-container .share-icon", function() {
			pushToDataLayer({
				"socialAction": "Share",
				"event": "socialShare",
				"siteLocation": "product page",
				"pageCategory": getPageCategory(),
				"socialNetwork": $(this).data("share")
				})

		})

		// Track Follow button on Footer
		.on("click", ".social-links a", function() {
			pushToDataLayer({
				"socialAction": "Follow",
				"event": "socialFollow",
				"siteLocation": "footer",
				"pageCategory": getPageCategory(),
				"socialNetwork": $(this).data("follow")
				})
		})

		// click email hyper link in navigation
		.on('click','.emailcsr-nav', function(){
			if(window.Resources.PAGE_CATEGORY == "page-show"){
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					//"pageSubCategory": couponsubcategory(),
					"pageCategory": getProductCategory()
					});

			}else{
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					"pageSubCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? "" :couponsubcategory(),
					"pageCategory": getPageCategory()
					});
			}

		})
		// Click email link in the customer care
		.on("click",".content-asset a:contains('customerservice@shiseidousa.com')",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email",
				"siteLocation": window.Resources.PAGE_CATEGORY=="cart-show" ? "Right Nav":"Body",
				//"pageSubCategory": couponsubcategory(),
				"pageCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? getPageCategory(): getProductCategory()
				});
		})

		.on("gtmcontactus",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Contact Customer Care Submission",
				"siteLocation": "Body",
				"pageCategory": getPageCategory()
				});
		})
		.on("askanexpert",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Ask An Expert Submission",
				"siteLocation": "Body",
				"pageSubCategory": couponsubcategory(),
				"pageCategory": "Ask An Expert"
			});
		})

		.on("click",".LPMcontainer",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Live Chat",
				"siteLocation": getPageCategory()=="Checkout" ? "Header": "Body",
				"pageSubCategory":couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		})

		.on("click",".LPMimage",function(){
			var id = $(this).attr("id");
			var chk = id.charAt(id.length - 1)
			if(chk == 1){
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Live Chat",
					"siteLocation": "Pop-up",
					"pageSubCategory":couponsubcategory(),
					"pageCategory": getPageCategory()
				});
			}
		})

		.on("click",".footer-container .products ul li:nth-child(4)",function(){
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Phone",
				"siteLocation": "Footer",
				"pageSubCategory":window.Resources.PAGE_CATEGORY=="cart-show" ? "" :couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		})

		// click on recommendation
		.on("click",".recommendation-item",function(){
			if(getPageCategory()== "Product Page"){
				sessionStorage.setItem('listType', "Recommended Product List");
				sessionStorage.setItem('listName', "Product Page");
			}else if(getPageCategory()== "Home Page"){
				sessionStorage.setItem('listType', "Recently Viewed List");
				sessionStorage.setItem('listName', "Home Page");
			}

		})


		.on("click",".catalog-link",function(e){
			 if(navctr==true){
				 gtmNavData = $(this).text().trim();
				 sessionStorage.setItem("navlink",gtmNavData);
				 sessionStorage.setItem("menuloc","topmenu");
				 util.setCookie('navdata',gtmNavData,.20);
				 navctr = false;
			 }
		})

		.on("click",".main-nav .has-sub-menu a",function(e){
			if(navctr==true){
				gtmNavData = $(this).text().trim();
				sessionStorage.setItem("navlink",gtmNavData);
				sessionStorage.setItem("menuloc","topmenu");
				util.setCookie('navdata',gtmNavData,.20);
				navctr = false;
			}
		})

		.on("click",".refinement-header",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})

		.on("click",".refinement-link",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})

		.on("click",".breadcrumb-element",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("breadcrumbs",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})

		.on("change","#quantity",function(e){
			if(getPageCategory() == "Cart Page"){
				if($(".edit-modal").length > 0){
					sessionStorage.setItem("cartupdate","1");
				}else{
					sessionStorage.setItem("productUpdate","1");
				}

			}

		})

		.on("change",".quantity-select",function(e){
			if(window.Resources.PAGE_CATEGORY == "wishlist-show"){
				sessionStorage.setItem("productUpdate","1");
			}
		})

		.on("click",".account-left-nav li a",function(e){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData);
			sessionStorage.setItem("menuloc","leftmenu");
		})

		// Remove uservalidation attribute for userlogin validation
		.on('click', ".user-logout", function (e) {
			localStorage.removeItem('uservalidation');
		})

		.on("change","#va-color",function(){
			if(getPageCategory() == "Cart Page"){
				sessionStorage.setItem("cartupdate","1");
			}
		})

		.on("click",".close-button",function(){
			if(getPageCategory() == "Cart Page"){
				sessionStorage.setItem("cartupdate","");
			}
		})

		.on("click","#save-for-later",function(){
			if(getPageCategory() == "Cart Page"){
				sessionStorage.setItem("cartupdate","");
			}
		})

		.on("click","#pdp-swatches .selectable",function(){
			if(getPageCategory() == "Cart Page"){
				if(!$(this).hasClass("selected")){
					sessionStorage.setItem("cartupdate","1");
				}
			}
		})

		.on("click",".search-suggestion-wrapper .hit",function(){
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink",gtmNavData.replace(/\s\s+/g, ' '));
			sessionStorage.setItem("menuloc","site search pop-in");
		})

		.on("click",".search-suggestion-wrapper .product-suggestion",function(){
			gtmNavData = $(this).text().trim();
			var rep = gtmNavData.replace(/\n/g," ");
			sessionStorage.setItem("navlink",rep.replace(/ +/g," "));
			sessionStorage.setItem("menuloc","site search pop-in");
		})

		// PLP click in list
		.on("click", "#search-result-items .gtmindex .thumb-link", function(){
			eeListClick($(this));
		})

		// PLP click in list
		.on("click", "#search-result-items .gtmindex .name-link", function(){
			eeListClick($(this));
		})

		// click on viewmore button
		.on("plpviewmore",function(e){
			if(getPageCategory() == "Category Page"){
				if(prodholder && typeof productData.product != undefined){
					if(productData.page>1){
						prodholder = prodholder.concat(productData.product);
					}else{
						prodholder = prodholder[0].concat(productData.product);
					}


					for(var i=0;i<prodholder.length;i++){
						prodholder[i].position = i+1;
					}
					for(var a=0;a<productData.product.length;a++){
						var diff =  productData.product.length - a;
						productData.product[a].position = (prodholder.length - diff) + 1;
					}
					pushDtLayer({
			                    "event": "eeListView",
			                    "eeAction": "eeListView",
			                    "pageCategory": searchItems.search ? "Site Search" :"Product List Page",
			                    "dropDown": "",
			                    "filterChoice": "",
			                    "currencyCode" : window.User.currencyCode,
			                    "products": productData.product || new Array()
			        });
				}
			}
		})

		// pdp fire when variation was change
		.on("click", ".js_quickview", function (e) {
			var currentId = "#" + $(this).parents('.product-tile').attr('id');
			var quantity = Number($(".quantity select").val());
			pushToDataLayer({
				"eeAction": "eeProductDetail",
                "event" : "eeProductDetail",
                "pageCategory": "Product Page",
                "productViewType": "quick view",
                "websiteCountry": getCountry(),
                "language": getLanguage(),
                'products': [{
                "id": $(currentId + " .js_addtocart").data("pid"),
                "category": $(currentId + " .js_addtocart").data("subsubcategory"),
                "price": $(currentId + " .js_addtocart").data("price"),
                "name": $(currentId + " .name-link .product-name").text().trim(),
                "brand":getProductBrand(),
                "quantity":quantity ? quantity : 1,
                "variant": $(currentId + " .js_addtocart").data("size") ? $(currentId + " .js_addtocart").data("size") : "null",
                "productOutOfStock": $(currentId + " .js_addtocart").data("instock"),
                "productType": "Product"}]
			})

		})
}


switch (gtCurPage) {
	case 'cart-show':
		//Users adding a coupon code during the checkout process
		var couponCode = $(".button-fancy-large").data("coupon");
		if (couponCode) {
			pushToDataLayer({
				"websiteCountry": getCountry(),
				"language": getLanguage(),
				"event": "couponSubmission",
				"pageCategory": getPageCategory(),
				"productCoupon": couponCode
			});
		}
		break;
	default:
		break;
}

module.exports = {
	init: function () {
		initializeGlobalEvents();
	},
	tagmanager: {
		click: function (data) {
			return trackConsultationEvent(data);
		},

		pageview: function (data) {
			return trackConsultationPageview(data);
		}
	},
	gtmInternalPromotion: {
		click: function (data) {
			return trackInternalPromotionEvent(data);
		},

		pageview: function (data) {
			return trackInternalPromotionPageView(data);
		}
	},
	initSPCBillingEvent: function(){
		spcGABillingEvent();
		spcGACheckoutOptionEvent();
	},
	initSPCReviewEvent: function(){
		spcGAReviewEvent();
		spcGACheckoutOptionEvent();
	},
    initAddToCartFromPLP: function(currentId){
        addToCartFromPLP(currentId);
    },
    initAddToCartFromPDP: function(){
        addToCartFromPDP();
    }
}
},{"./util":87}],7:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),f=o(c),s=n(8),d=o(s),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",throttleDelay:99,debounceDelay:50,disableMutationObserver:!1},j=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,x),(0,b.default)(w,x.once),w},O=function(){w=(0,h.default)(),j()},_=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},S=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},z=function(e){x=i(x,e),w=(0,h.default)();var t=document.all&&!window.atob;return S(x.disable)||t?_():(document.querySelector("body").setAttribute("data-aos-easing",x.easing),document.querySelector("body").setAttribute("data-aos-duration",x.duration),document.querySelector("body").setAttribute("data-aos-delay",x.delay),"DOMContentLoaded"===x.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?j(!0):"load"===x.startEvent?window.addEventListener(x.startEvent,function(){j(!0)}):document.addEventListener(x.startEvent,function(){j(!0)}),window.addEventListener("resize",(0,f.default)(j,x.debounceDelay,!0)),window.addEventListener("orientationchange",(0,f.default)(j,x.debounceDelay,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,x.once)},x.throttleDelay)),x.disableMutationObserver||(0,d.default)("[data-aos]",O),w)};e.exports={init:z,refresh:j,refreshHard:O}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(s,t),_?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return S?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||S&&o>=y}function s(){var e=O();return c(e)?d(e):void(h=setTimeout(s,a(e)))}function d(e){return h=void 0,z&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(s,t),o(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,k=0,_=!1,S=!1,z=!0;if("function"!=typeof e)throw new TypeError(f);return t=u(t)||0,i(n)&&(_=!!n.leading,S="maxWait"in n,y=S?x(u(n.maxWait)||0,t):y,z="trailing"in n?!!n.trailing:z),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(f);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return s;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?s:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},f="Expected a function",s=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(s,t),_?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return S?x(i,y-o):i}function f(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||S&&o>=y}function s(){var e=j();return f(e)?d(e):void(h=setTimeout(s,u(e)))}function d(e){return h=void 0,z&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=f(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(s,t),i(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,O=0,_=!1,S=!1,z=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(_=!!n.leading,S="maxWait"in n,y=S?k(a(n.maxWait)||0,t):y,z="trailing"in n?!!n.trailing:z),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==s}function a(e){if("number"==typeof e)return e;if(r(e))return f;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?f:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",f=NaN,s="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e,t){var n=window.document,r=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,a=new r(o);i=t,a.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}function o(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),n=Array.prototype.slice.call(e.removedNodes),o=t.concat(n).filter(function(e){return e.hasAttribute&&e.hasAttribute("data-aos")}).length;o&&i()})}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){};t.default=n},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,f=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new f},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e=e||document.querySelectorAll("[data-aos]"),Array.prototype.map.call(e,function(e){return{node:e}})};t.default=n}])});
},{}],8:[function(require,module,exports){
'use strict';

var analytics = require('./analytics'),
    countries = require('./countries'),
    dialog = require('./dialog'),
    quickview = require("./quickview"),
    minicart = require('./minicart'),
    page = require('./page'),
    rating = require('./rating'),
    searchsuggest = require('./searchsuggest'),
    tooltip = require('./tooltip'),
    util = require('./util'),
    validator = require('./validator'),
    slick = require('./slick'),
    animation = require('./aos'),
    tls = require('./tls'),
    video = require("./video"),
    headerMenu = require('./header-menu'),
    footerSelector = require('./footer-selector'),
    newsletter = require('./newsletter'),
    orderreplenishment = require('./order-replenishment'),
    pdpredesign = require('./pdpredesign'),
    inputEntry = require('./input-entry'),
    producttile = require('./product-tile'),
    afterpay = require('./afterpay'),
    removeScreenOverlay = require('./drawerControl');

const EventNames = require('./constants/EventNames');
//if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');

    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');

    document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
require('./captcha')();

function initializeEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function(e) {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function() {
            var text = $(this).val(),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length,
                charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).closest('.field-wrapper').find('.char-remain-count').html(charsRemain);

        });

    /**
     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
     * */
    var $searchContainer = $('.utility-nav .header-search');

    searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').on("click", function() {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();
    $('.toggle').on("click", function() {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');

    if ($subscribeEmail.length > 0) {
        $subscribeEmail.on("focus", function() {
            var val = $(this.val());

            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({
                color: '#999999'
            }, 500, 'linear', function() {
                $(this).val('').css('color', '#333333');
            });
        }).on("blur", function() {
            var val = $.trim($(this.val()));

            if (val.length > 0) {
                return; // do not animate when contains value
            }

            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({
                    color: '#333333'
                }, 500, 'linear');
        });
    }

    if (SitePreferences.MOTIONPOINT_ENABLED) {

        $('#chooseLanguage').on('click', function(e) {
            e.preventDefault();

            var script = document.createElement('script');

            //MP.SrcUrl = unescape('mp_js_orgin_url'); - commented out per MotionPoint
            MP.UrlLang = 'mp_js_current_lang';
            MP.oSite = decodeURIComponent('mp_js_origin_baseUrl');
            MP.tSite = decodeURIComponent('mp_js_translated_baseUrl');

            MP.init();

            script.src = 'https://shiseidoamericas.mpeasylink.com/mpel/mpel_chooser.js';

            document.body.appendChild(script);

            return false;
        });

    }

    $('.privacy-policy').on('click', function(e) {
        e.preventDefault();

        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    if ($('.order-confirmation-details').length) {
        sessionStorage.removeItem('isGift');
        sessionStorage.removeItem('giftMessage');
    }

    var url = Urls.passwordReset;

    if ($('.reset-password-link').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.reset-password-link').each(function () {
            $(this).find('a').attr('href', url);
        });
    }

    if ($('.user-recognized').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.user-recognized').find('a').attr('href', url);
    }

    // checkout checkout minicart on right side event handling
    addSummaryScrollbar();
    producttile.globalQuickView();
    
    $(document).on(EventNames.TRIGGER_CLICK_ORDER_DETAIL, function () {
        $('.header-detail-order').on('click', function(e) {
            var viewDetailOrder = $(this).parent().find('button.show-detail-order');
            if (viewDetailOrder.length > 0) {
                viewDetailOrder.trigger('click');
            }
        });
    })
    
    $('.search-pagination').on('click','#view-more-landing', buttonClickCategoryLandingPage);
    $('.search-pagination').on('click','#view-all-landing', buttonClickCategoryLandingPage);
    
    $('.search-pagination').on('click','#view-more-landing-search', buttonClickCategoryLandingPage);
    $('.search-pagination').on('click','#view-all-landing-search', buttonClickCategoryLandingPage);
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');

    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }

    // load js specific styles
    util.limitCharacters();
}

function backToTopHandler() {
    $(document).on('scroll', function() {
        if ($(window).scrollTop() > 100) {
            $('.scroll-top-wrapper').addClass('show');
        } else {
            $('.scroll-top-wrapper').removeClass('show');
        }
    });

    $('.scroll-top-wrapper').on('click', scrollToTop);
}

function scrollToTop(e) {
    e.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;

    $('html, body').animate({
        scrollTop: offsetTop
    }, 500, 'linear');
}

// Minimize header and make it stick to the top
function minimizedHeaderHandler() {
    checkScrolledTop();

    $(window).on("scroll", function() {
        checkScrolledTop();
    });
}

// Sticky header on scroll back to top
var iScrollPos = 0;
var threashHold = 0;
if($('#header-top').find('#homepage-hero').length > 0) {
    threashHold = $('#header-top').find('#homepage-hero').find('.hero-slide').find('img')[0].clientHeight;
}
else {
    threashHold = $('#main').offset().top;
}

function checkScrolledTop(){
    var iCurScrollPos = $(window).scrollTop();
    var $stickyHeader = $('#minimized-header-container');

    if (iCurScrollPos > iScrollPos && !($('.nav-open').length === 1)) { //scroll down
        if(iCurScrollPos > threashHold){ //reached position to slide header up.
            if($(window).scrollTop() > 115 && !($('#wrapper').hasClass('sticky-header'))){
                $('#wrapper').addClass('sticky-header');
            }
        }
    }

    if(iCurScrollPos < iScrollPos){ //scroll up
        if($('#header-top').length === 1 && $(window).innerWidth() >= 768){
            if(iCurScrollPos > threashHold){
                if($stickyHeader.css('position')!='fixed'){
                    $stickyHeader.addClass('fix-menu');
                }
            }

            if(iCurScrollPos < threashHold){
                if($stickyHeader.css('position')!='absolute'){
                    $stickyHeader.removeClass('fix-menu');
                }
            }
        }
        else {
            if ($('#header-top').length > 0) {
                var offsetTop = $('#header-top').offset().top;
                if ($(window).scrollTop() > offsetTop) {
                    $('.header-top-outer').css('position', 'fixed');
                    $('.user-bag').css('position', 'fixed');
                    if ($('.header-promotion').length) {
                        $stickyHeader.removeClass('has-header-promotion');
                    }
                }
                else {
                    $('.header-top-outer').css('position', 'relative');
                    $('.user-bag').css('position', 'absolute');
                    if ($('.header-promotion').length) {
                        $stickyHeader.addClass('has-header-promotion');
                    }
                }
            }
        }
        if($('#wrapper').hasClass('sticky-header')){
            $('#wrapper').removeClass('sticky-header');
        }
    }
    iScrollPos = iCurScrollPos;
}

function responsiveMegaMenu() {
    var $dropdowns = $('.level-1 li.has-sub-menu');

        $dropdowns.on('keydown', function(e) {
            var $this = $(this);

            if ( e.keyCode === 13 ) {

                if (!$this.hasClass('hover')) {
                    e.preventDefault();

                    $dropdowns.removeClass('hover');
                    $this.addClass('hover');

                }
            }

            if ( e.keyCode === 32 ) {
                e.preventDefault();
                $dropdowns.removeClass('hover');
            }
        });


        $dropdowns.on("mouseenter", function() {
                var $this = $(this);
                if ($this.prop('hoverTimeout')) {
                    $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
                }
                $this.prop('hoverIntent', setTimeout(function () {
                    $this.addClass('hover');
                }, 200));
        }).on("mouseleave", function() {
                var $this = $(this);
                if ($this.prop('hoverIntent')) {
                    $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
                }
                $this.prop('hoverTimeout', setTimeout(function () {
                    $this.removeClass('hover');
                }, 200));
        });

        if ('ontouchstart' in document.documentElement && window.innerWidth >= 640 ) {

            $dropdowns.each(function () {
                var $this = $(this);

                this.addEventListener('touchstart', function (e) {
                    if (e.touches.length === 1) {
                        e.stopPropagation();

                        if (!$this.hasClass('hover')) {
                            if (e.target === this || e.target.parentNode === this) {
                                e.preventDefault();
                            }

                            $dropdowns.removeClass('hover');
                            $this.addClass('hover');

                            document.addEventListener('touchstart', function closeDropdown(e) {
                                e.stopPropagation();

                                $this.removeClass('hover');
                                document.removeEventListener('touchstart', closeDropdown);
                            });
                        }
                    }
                }, false);
            });
        }

        $('a.no-link, span.category-header').on('click', function(e){
            if (window.innerWidth < 640) {
                $(this).next($('.menu-item-toggle')).trigger('click');
            } else {
                e.preventDefault();
            }
        });

    var ogMenuHeight = $('ul.level-1').height();
    // main menu toggle
    $('.menu-toggle').on('click', function() {
        $('#wrapper').toggleClass('menu-active');
        ogMenuHeight = $('ul.level-1').height();
    });

    $('.main-nav li .menu-item-toggle').on('click', function(e) {
        e.preventDefault();

        var $parentLi = $(e.target).closest('li');
        var menuHeight = $parentLi.find('.sub-level-wrapper').height();

        if (ogMenuHeight <= menuHeight) {
            $('ul.level-1').css('height', menuHeight);
        }

        $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle');
        $parentLi.toggleClass('active');

        $(e.target).toggleClass('active');
    });

    $('.mobile-menu-back').on('click', function() {

        var $closestActiveMenu =  $(this).closest('.active')
        var prevMenuHeight = $closestActiveMenu.parent().parent().height();

        $closestActiveMenu.removeClass('active');

        if (ogMenuHeight <= prevMenuHeight) {
            $('ul.level-1').css('height', prevMenuHeight);
        }

    });

    // my function

    /**
    * onclick bar icon on mobile, show the navigation overlay
    */
    $('#nav-icon').click(function(){
        if(!($(this).hasClass('open') && $('#navigation').hasClass('active'))){
            removeScreenOverlay.init();
            $('html').addClass('nav-open');
        }
        else {
            $('html').removeClass('nav-open');
        }
        $(this).toggleClass('open');
        $('#navigation').toggleClass('active');
    });

    /**
     * show search popup
     */
    $('#show-search').on('click', function(){
        $('#search').addClass('active');
        $('.search-language').css('z-index', 20);
    });

    $('#close-search').on('click', function(){
        $('#search').removeClass('active');
        $('.search-language').css('z-index', 50);
    });
    
    /**
    * onclick user icon to show the Sign in popup
    */
    $('#account-info').on('click', function(){
        removeScreenOverlay.init();
        $('.bubble').toggleClass('active');
        if (window.innerWidth < 640) {
            $('html').addClass('nav-open');
        }
    });

    $('#close-login').on('click', function(){
        $('.bubble').toggleClass('active');
        if (window.innerWidth < 640) {
            $('html').removeClass('nav-open');
        }
    });

    $('.search-page').find('input[name="q"]').attr('placeholder', Resources.SEARCHDIFF);

    /**
    * menu navigation: hover level 2 will show items of level 3 corresponding
    */
    $('.language-dropdown').find('li').each(function(){
        $(this).click(function(){
            $('.language-dropdown').find('li').removeClass('active');
            $(this).addClass('active');
        });
    });

    $('.icon-link').click(function(){
        $(this).parent().toggleClass('active');
        $(this).toggleClass('active');
        $(this).siblings('.icon-link').toggleClass('active');
    });

if ($('.header-promotion').length) {
    $('#minimized-header-container').addClass('has-header-promotion');
}

    /**
    * animation fadeup homepage
    */
    if ($('.pt_storefront').length || window.innerWidth > 767) {
        animation.init({
            offset: 0,
            duration: 500,
            delay: 0,
            once: true
        });
    }

    /**
        * close toast notification
        */
    $('.toast__close').click(function(e){
        e.preventDefault();
        var parent = $(this).parent('.toast');
        parent.fadeOut("slow", function() {
            $(this).remove();
        });
  });

    /* --- handle gift message at shipping page --- */

    if($('.b-giftmessage').length > 0) {
        var form = '.checkout-shipping',
            selector = 'input[name=dwfrm_singleshipping_shippingAddress_isGift]',
            $giftmess = $('.b-giftwrapmessage'),
            $giftmessValue = $('input[name=dwfrm_singleshipping_shippingAddress_giftMessage]'),
            chk_value;
        chk_value = $(selector + ':checked', form).val();
        check_giftmess(chk_value);
    }

    $(selector, form).on('change', function() {
        chk_value = this.value;
        check_giftmess(chk_value);
    });

    function check_giftmess(value) {
        if(value === 'true') {
            $giftmess.show(300);
            $giftmessValue.addClass("required");
        }
        else {
            $giftmess.hide(300);
            $giftmessValue.removeClass("required");
        }
    }

    /* --- handle radio button (CREDIT CARD) for shipping page --- */
    $('#creditcard-mask').on('click', function() {
        $('#is-CREDIT_CARD').prop('checked', true);
        $('.cvs-payment-methods-item').find('input[name=dwfrm_convenience_convenienceStore]').prop('checked', false);
        $('select[name*="dwfrm_billing_paymentMethods_creditCard"],input[name*="dwfrm_billing_paymentMethods_creditCard"]').removeClass("ignore");
    });

    $('.cate-level-2').find('li').each(function() {
        if($(this).hasClass('isBetween')) {
            $(this).parent('.cate-level-2').addClass('hasContentAssets');
        }
    });

    /**
     * Preload flyout on hover to prevent flicker on reveal
     */
    if ($(window).width() >= 768) {
        var $mainNav = $('.main-nav');
        $mainNav.one('mouseenter', function () {
            $mainNav.find('.lazyload').addClass('lazypreload');
        });
    }


    $('.user-account').on('click', function(e) {
        e.preventDefault();

        $(this).parent('.user-info').toggleClass('active');
    });

    $('button#cancelOrder').click(function() {
        $(this).prop('disabled', true).addClass('loading');
        $('button[name$="_orders_cancel_confirm"]').trigger('click');
        return true;
    });
}

function searchMenuEvent(){
    // Search for mobile view
    $('.quick-access-menu [title="Search"]').on('click', function(e) {
        e.preventDefault();

        $('.header-search').slideToggle(200);
    });

    // show the search button when the user switches to desktop view
    $(window).on("resize", function(e){
        if(window.innerWidth > 639 ){
            $('.header-search').show();
        }
    });
}

//add class for scrollbar on miniline summary
function addSummaryScrollbar () {
    var itemCount = $('.pt_checkout .checkout-mini-cart .accordion-content .mini-cart-product').length;

    if (itemCount > 4) {
        $('.checkout-mini-cart .accordion-content').addClass('scroll-items');
    }
}

function playVideoHandler() {
    var MAIN_VIDEO_SELECTOR = ".main-video";
    var CAROUSEL_VIDEO_SELECTOR = ".modal-video";
    $(document)
        // main video (inline)
        .on("click", MAIN_VIDEO_SELECTOR, function () {
            var $this = $(this);

            var $inlineEle = $this.parent("div"),
                videoId = $this.data("video-id");

            video.playInline($inlineEle, videoId);
        })

        // carousel videos (launched in modal)
        .on("click", CAROUSEL_VIDEO_SELECTOR, function () {
            var videoId = $(this).data("video-id");

            video.playInModal(videoId);
        });
}



function resetFooterError () {

    if ($('.store-locator-form .field-button-container div').hasClass('error')) {
        $('.store-locator-form .field-button-container div').removeClass('error');
        $('.store-locator-form .field-button-container .error-message').remove();
    }
}

function buttonClickCategoryLandingPage() {
    // getting the hidden div, which is the placeholder for the next page
    var targetEl = $(this);
    var searchResultItems, searchResultBlock, paginationButtons, gridUrl;
    var loadingPlaceHolder = targetEl.closest('.pagination-buttons').find('.infinite-scroll-placeholder');
    paginationButtons = targetEl.closest('.pagination-buttons');
    gridUrl = targetEl.attr('data-grid-url');
    searchResultItems = targetEl.closest('#search-result-items');
    searchResultBlock = targetEl.closest('.search-representative-result-items');
    if (targetEl.closest('.listcontent').length > 0) {
        searchResultItems = targetEl.closest('.folder-content-list');
        searchResultBlock = targetEl.closest('.search-result-content-items');
    }
    
    if (loadingPlaceHolder.length === 1) {
        loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('infinite-scroll-loading');

        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function (html) {
            loadingPlaceHolder.removeClass('infinite-scroll-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            
            if (targetEl.attr('id') == 'view-more-landing') {
                searchResultBlock.append(html);
                searchResultBlock.find(".tiles-container .column").appendTo(searchResultItems);

            } else if (targetEl.attr('id') == 'view-all-landing'){
                searchResultBlock.html(html);

            } else if (targetEl.attr('id') == 'view-more-landing-search') {
                searchResultBlock.append(html);
                searchResultBlock.find(".tutorial-detail-link").appendTo(searchResultItems);
            } else if (targetEl.attr('id') == 'view-all-landing-search') {
                searchResultBlock.html(html);
            }
         // rebind the View More event
            $('.search-pagination').off('click','#view-more-landing-search').on('click','#view-more-landing-search', buttonClickCategoryLandingPage);
            $('.search-pagination').off('click','#view-all-landing-search').on('click','#view-all-landing-search', buttonClickCategoryLandingPage);
            $('.search-pagination').off('click','#view-more-landing').on('click','#view-more-landing', buttonClickCategoryLandingPage);
            $('.search-pagination').off('click','#view-all-landing').on('click','#view-all-landing', buttonClickCategoryLandingPage);

            checkLimitCharacter.init({
                outerElem: '.tutorial-detail-link',
                innerElem: '.content-description',
                limit: 160
            });
            
            checkLimitCharacter.init({
                outerElem: '.tiles-container .gtmindex',
                innerElem: '.short-desc.limited',
                limit: 60
            });
            checkLimitCharacter.init({
                outerElem: '.wishlist-item',
                innerElem: '.short-desc.limited',
                limit: window.innerWidth > 767 ? 60 : 19
            });
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function (response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {
                    // nothing to catch in case of out of memory of session storage
                    // it will fall back to load via ajax
                }
                // update UI
                paginationButtons.remove();
                fillEndlessScrollChunk(response);
                producttile.init();
            }
        });
    }
}

var pages = {
    account: require('./pages/account'),
    login: require('./login'),
    cart: require('./pages/cart'),
    checkout: require('./pages/checkout'),
    singlepagecheckout: require('./pages/singlepagecheckout'),
    compare: require('./pages/compare'),
    product: require('./pages/product'),
    registry: require('./pages/registry'),
    orderconfirmation: require('./pages/order-confirm'),
    search: require('./pages/search'),
    tutorial: require('./pages/tutorial'),
    storefront: require('./pages/storefront'),
    wishlist: require('./pages/wishlist'),
    storelocator: require('./pages/storelocator'),
    checkorder: require('./pages/checkorder'),
    content: require('./pages/content'),
    promotionlanding: require('./pages/promotionlanding'),
    error: require('./pages/error')
};

var checkLimitCharacter = require('./limitCharacter');

var app = {
    init: function() {

        $(document).foundation();

        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        initializeDom();
        initializeEvents();
        backToTopHandler();
        minimizedHeaderHandler();
        resetFooterError();
        responsiveMegaMenu();
        searchMenuEvent();

        // init specific global components
        analytics.init();
        countries.init();
        tooltip.init();
        minicart.init();
        validator.init();
        orderreplenishment.init();
        rating.init();
        slick.init();
        headerMenu.init();
        video.init();
        checkLimitCharacter.init({
            outerElem: '.tutorial-detail-link',
            innerElem: '.content-description',
            limit: 160
        });
        checkLimitCharacter.init({
            outerElem: '.tiles-container .gtmindex',
            innerElem: '.short-desc.limited',
            limit: 60
        });
        checkLimitCharacter.init({
            outerElem: '.wishlist-item',
            innerElem: '.short-desc.limited',
            limit: window.innerWidth > 767 ? 60 : 19
        });
        //checkoutLogin.init();

        if (SitePreferences.IS_MARKET_MAPPING_ENABLED) {
            footerSelector.languageSelector();
            footerSelector.countrySelector();
        }
        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        inputEntry.entry();
        playVideoHandler();
        pdpredesign.init();

        if (SitePreferences.AFTERPAY_ENABLED) {
            afterpay.init();
        }

        // execute page specific initializations
        $.extend(page, window.pageContext);

        var ns = page.ns;

        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }
        util.autoSuggestionAddressField();
        $(document).trigger(EventNames.TRIGGER_CLICK_ORDER_DETAIL);
    }
};

//general extension functions
(function() {
    String.format = function() {
        var s = arguments[0];
        var i, len = arguments.length - 1;

        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');

            s = s.replace(reg, arguments[i + 1]);
        }

        return s;
    };
})();

// initialize app
$(function() {
    app.init();
});
$(window).on("load", function(){
    util.renderGoogleInvisibleReCaptchaFunc();
});
// expose global app obj for 3rd party integrations
window.app = {
    quickView: quickview,
    minicart: minicart,
    user: window.User,
    SCemailUrl: window.Urls.SCemailUrl,
    Product: {},
    tagmanager: analytics.tagmanager,
    gtmInternalPromotion: analytics.gtmInternalPromotion
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = addSummaryScrollbar;
window.scrollToTop = scrollToTop;
},{"./afterpay":4,"./analytics":6,"./aos":7,"./captcha":10,"./constants/EventNames":12,"./cookieprivacy":13,"./countries":14,"./dialog":16,"./drawerControl":17,"./footer-selector":18,"./header-menu":22,"./input-entry":23,"./jquery-ext":24,"./limitCharacter":25,"./login":26,"./minicart":27,"./newsletter":29,"./order-replenishment":30,"./page":31,"./pages/account":32,"./pages/cart":33,"./pages/checkorder":34,"./pages/checkout":39,"./pages/compare":43,"./pages/content":44,"./pages/error":46,"./pages/order-confirm":47,"./pages/product":52,"./pages/promotionlanding":57,"./pages/registry":58,"./pages/search":59,"./pages/singlepagecheckout":64,"./pages/storefront":68,"./pages/storelocator":69,"./pages/tutorial":70,"./pages/wishlist":71,"./pdpredesign":72,"./product-tile":74,"./quickview":77,"./rating":78,"./searchsuggest":80,"./slick":81,"./tls":85,"./tooltip":86,"./util":87,"./validator":88,"./video":89}],9:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util'),
    modal = require('./modal').global;

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
    var bonusproducts = [];

    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
        var p = {
            pid: selectedList[i].pid,
            qty: selectedList[i].qty,
            options: {}
        };
        var a, alen, bp = selectedList[i];
        if (bp.options) {
            for (a = 0, alen = bp.options.length; a < alen; a++) {
                var opt = bp.options[a];
                p.options = {optionName:opt.name, optionValue:opt.value};
            }
        }
        bonusproducts.push({product:p});
    }
    return {bonusproducts: bonusproducts};
}

var selectedItemTemplate = function (data) {
    var attributes = '';
    for (var attrID in data.attributes) {
        var attr = data.attributes[attrID];
        attributes += '<li data-attribute-id="' + attrID + '">\n';
        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
        attributes += '</li>';
    }
    attributes += '<li class="item-qty">\n';
    attributes += '<span class="display-name">Qty</span>: ';
    attributes += '<span class="display-value">' + data.qty + '</span>';
    return [
        '<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">',
        '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>',
        '<div class="item-name">' + data.name + '</div>',
        '<ul class="item-attributes">',
        attributes,
        '<ul>',
        '<li>'
    ].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
    $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
    // prevent unselecting the selected variant
    $('.bonus-product-item .swatches .selected').on('click', function () {
        return false;
    });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
    var $bonusProductList = $('#bonus-product-list');
    if (!selectedList.length) {
        $bonusProductList.find('li.selected-bonus-item').remove();
    } else {
        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
        var i, len;
        for (i = 0, len = selectedList.length; i < len; i++) {
            var item = selectedList[i];
            var li = selectedItemTemplate(item);
            $(li).appendTo(ulList);
        }
    }

    // get remaining item count
    var remain = maxItems - selectedList.length;
    $bonusProductList.find('.bonus-items-available').text(remain);
    if (remain <= 0) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    } else {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
    }
}

function initializeGrid () {
    var $bonusProduct = $('#bonus-product-dialog'),
        $bonusProductList = $('#bonus-product-list'),
        bliData = $bonusProductList.data('line-item-detail');
    maxItems = bliData.maxItems;
    bliUUID = bliData.uuid;

    if (bliData.itemCount >= maxItems) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    }

    var cartItems = $bonusProductList.find('.selected-bonus-item');
    cartItems.each(function () {
        var ci = $(this);
        var product = {
            uuid: ci.data('uuid'),
            pid: ci.data('pid'),
            qty: ci.find('.item-qty').text(),
            name: ci.find('.item-name').html(),
            attributes: {}
        };
        var attributes = ci.find('ul.item-attributes li');
        attributes.each(function () {
            var li = $(this);
            product.attributes[li.data('attributeId')] = {
                displayName:li.children('.display-name').html(),
                displayValue:li.children('.display-value').html()
            };
        });
        selectedList.push(product);
    });

    $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
        e.preventDefault();
        var url = this.href,
            $this = $(this);
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'format': 'ajax'
        });
        $.ajax({
            url: url,
            success: function (response) {
                $this.closest('.bonus-product-item').empty().html(response);
                hideSwatches();
            }
        });
    })
    .on('change', '.input-text', function () {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    })
    .on('click', '.select-bonus-item', function (e) {
        e.preventDefault();
        if (selectedList.length >= maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            $bonusProductList.find('.bonus-items-available').text('0');
            return;
        }

        var form = $(this).closest('.bonus-product-form'),
            detail = $(this).closest('.product-detail'),
            uuid = form.find('input[name="productUUID"]').val(),
            qtyVal = form.find('input[name="Quantity"]').val(),
            qty = (isNaN(qtyVal)) ? 1 : (+qtyVal);

        if (qty > maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
            return;
        }

        var product = {
            uuid: uuid,
            pid: form.find('input[name="pid"]').val(),
            qty: qty,
            name: detail.find('.product-name').text(),
            attributes: detail.find('.product-variations').data('attributes'),
            options: []
        };

        var optionSelects = form.find('.product-option');

        optionSelects.each(function () {
            product.options.push({
                name: this.name,
                value: $(this).val(),
                display: $(this).children(':selected').first().html()
            });
        });
        selectedList.push(product);
        updateSummary();
    })
    .on('click', '.remove-link', function (e) {
        e.preventDefault();
        var container = $(this).closest('.selected-bonus-item');
        if (!container.data('uuid')) { return; }

        var uuid = container.data('uuid');
        var i, len = selectedList.length;
        for (i = 0; i < len; i++) {
            if (selectedList[i].uuid === uuid) {
                selectedList.splice(i, 1);
                break;
            }
        }
        updateSummary();
    })
    .on('click', '.add-to-cart-bonus', function (e) {
        e.preventDefault();
        var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
        var bonusProducts = getBonusProducts();
        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
            bonusProducts.bonusproducts[0].product.qty = maxItems;
        }
        // make the server call
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: JSON.stringify(bonusProducts)
        })
        .done(function () {
            // success
            page.refresh();
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        })
        .always(function () {
            $bonusProduct.dialog('close');
        });
    })
    .on('click', '#more-bonus-products', function (e) {
        e.preventDefault();
        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

        //get the next page of choice of bonus products
        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
            bonusDiscountLineItemUUID: uuid,
            format: 'ajax',
            lazyLoad: 'true',
            pageStart: lineItemDetail.pageStart,
            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
        });

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: url
        })
        .done(function (data) {
            //add the new page to DOM and remove 'More' link if it is the last page of results
            $('#more-bonus-products').before(data);
            if ((lineItemDetail.pageStart + lineItemDetail.pageSize) >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
                $('#more-bonus-products').remove();
            }
        })
        .fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });
}

var bonusProductsView = {
    /**
     * @function
     * @description Open the list of bonus products selection dialog
     */
    show: function (url) {
        var $bonusProduct = $('#bonus-product-dialog');
        // create the dialog
        dialog.open({
            target: $bonusProduct,
            url: url,
            options: {
                width: 795,
                title: Resources.BONUS_PRODUCTS
            },
            callback: function () {
                initializeGrid();
                hideSwatches();
            }
        });
    },
    /**
     * @function
     * @description Open bonus product promo prompt dialog
     */
    loadBonusOption: function () {
        var    self = this,
            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
        if (!bonusDiscountContainer) { return; }

        // get the html from minicart, then trash it
        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 'auto',
                title: Resources.BONUS_PRODUCT,
                dialogClass: 'bonus-eligibility-modal',
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    click: function () {
                        var uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = util.appendParamsToUrl(Urls.showBonusProducts, {
                                bonusDiscountLineItemUUID: uuid,
                                source: 'bonus',
                                format: 'ajax',
                                lazyLoad: 'false',
                                pageStart: 0,
                                pageSize: 0,
                                bonusProductsTotal: -1
                            });
                        $(this).dialog('close');
                        //self.show(url);
                        modal.addCustomClass('bonus-item-modal');
                        modal.renderByUrl(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function () {
                        $(this).dialog('close');
                    }
                }]
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
            }
        });
    },

    hasBonusOptions: function () {
    	return ($(".bonus-discount-container").length > 0);
    }
};

module.exports = bonusProductsView;

},{"./dialog":16,"./modal":28,"./page":31,"./util":87}],10:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');
var util = require('./util');
var SessionAttributes = window.SessionAttributes;

/**
 * @function captcha    Used to display/control the scrim containing the simulated captcha code
 **/
module.exports = function () {
    /**
     * if the session.privacy.ratelimited element is present then show the notification
     * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
     */
    if (SessionAttributes.SHOW_CAPTCHA) {
        dialog.open({
            html: '<h1>' + Resources.ARE_YOU_HUMAN + '</h1>',
            options: {
                closeOnEscape: false,
                dialogClass: 'no-close',
                buttons: [{
                    text: Resources.OK,
                    click: function () {
                        var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
                        $.ajax({
                            url: url
                        });
                        $(this).dialog('close');
                    }
                }]
            }
        });
    }
};

},{"./dialog":16,"./util":87}],11:[function(require,module,exports){
'use strict';

var page = require('./page'),
    util = require('./util'),
    TPromise = require('promise');

var _currentCategory = '',
    MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
    var $compareContainer = $('.compare-items');
    var $compareItems = $compareContainer.find('.compare-item');
    var numActive = $compareItems.filter('.active').length;

    if (numActive < 2) {
        $('#compare-items-button').attr('disabled', 'disabled');
    } else {
        $('#compare-items-button').removeAttr('disabled');
    }

    $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
    // get the first compare-item not currently active
    var $item = $('.compare-items .compare-item').not('.active').first(),
        $productTile = $('#' + data.uuid);

    if ($item.length === 0) {
        if ($productTile.length > 0) {
            $productTile.find('.compare-check')[0].checked = false;
        }
        window.alert(Resources.COMPARE_ADD_FAIL);
        return;
    }

    // if already added somehow, return
    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
        return;
    }
    // set as active item
    $item.addClass('active')
        .attr('data-uuid', data.uuid)
        .attr('data-itemid', data.itemid)
        .data('uuid', data.uuid)
        .data('itemid', data.itemid)
        .append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
    if ($item.length === 0) { return; }
    // remove class, data and id from item
    $item.removeClass('active')
        .removeAttr('data-uuid')
        .removeAttr('data-itemid')
        .data('uuid', '')
        .data('itemid', '')
        // remove the image
        .find('.compare-item-image').remove();
}

function addProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareAdd,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_ADD_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function removeProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareRemove,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function shiftImages() {
    return new TPromise(function (resolve) {
        var $items = $('.compare-items .compare-item');
        $items.each(function (i, item) {
            var $item = $(item);
            // last item
            if (i === $items.length - 1) {
                return removeFromList($item);
            }
            var $next = $items.eq(i + 1);
            if ($next.hasClass('active')) {
                // remove its own image
                $next.find('.compare-item-image').detach().appendTo($item);
                $item.addClass('active')
                    .attr('data-uuid', $next.data('uuid'))
                    .attr('data-itemid', $next.data('itemid'))
                    .data('uuid', $next.data('uuid'))
                    .data('itemid', $next.data('itemid'));
            }
        });
        resolve();
    });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
    var promise;
    var $items = $('.compare-items .compare-item');
    var $cb = $(args.cb);
    var numActive = $items.filter('.active').length;
    if (numActive === MAX_ACTIVE) {
        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
            $cb[0].checked = false;
            return;
        }

        // remove product using id
        var $firstItem = $items.first();
        promise = removeItem($firstItem).then(function () {
            return shiftImages();
        });
    } else {
        promise = TPromise.resolve(0);
    }
    return promise.then(function () {
        return addProductAjax(args).then(function () {
            addToList(args);
            if ($cb && $cb.length > 0) { $cb[0].checked = true; }
            refreshContainer();
        });
    }).then(null, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
    var $cb = args.cb ? $(args.cb) : null;
    return removeProductAjax(args).then(function () {
        var $item = $('[data-uuid="' + args.uuid + '"]');
        removeFromList($item);
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
        refreshContainer();
    }, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = true; }
    });
}

function removeItem($item) {
    var uuid = $item.data('uuid'),
        $productTile = $('#' + uuid);
    return removeProduct({
        itemid: $item.data('itemid'),
        uuid: uuid,
        cb: ($productTile.length === 0) ? null : $productTile.find('.compare-check')
    });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
    var $compareContainer = $('.compare-items');
    _currentCategory = $compareContainer.data('category') || '';
    var $active = $compareContainer.find('.compare-item').filter('.active');
    $active.each(function () {
        var $productTile = $('#' +  $(this).data('uuid'));
        if ($productTile.length === 0) {return;}
        $productTile.find('.compare-check')[0].checked = true;
    });
    // set container state
    refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
    // add event to buttons to remove products
    $('.compare-item').on('click', '.compare-item-remove', function () {
        removeItem($(this).closest('.compare-item'));
    });

    // Button to go to compare page
    $('#compare-items-button').on('click', function () {
        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
    });

    // Button to clear all compared items
    // rely on refreshContainer to take care of hiding the container
    $('#clear-compared-items').on('click', function () {
        $('.compare-items .active').each(function () {
            removeItem($(this));
        });
    });
}

exports.init = function () {
    initializeDom();
    initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":31,"./util":87,"promise":118}],12:[function(require,module,exports){
module.exports = {
    VALIDATOR_CUSTOM_INITIALIZE: 'VALIDATOR_CUSTOM_INITIALIZE',
    TRIGGER_CLICK_ORDER_DETAIL: 'TRIGGER_CLICK_ORDER_DETAIL'
}
},{}],13:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function () {
    /**
     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
     */
    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            dialog.open({
                url: Urls.cookieHint,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'no-close',
                    buttons: [{
                        text: Resources.I_AGREE,
                        click: function () {
                            $(this).dialog('close');
                            enableCookies();
                        }
                    }]
                }
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enableCookies();
    }

    function enableCookies() {
        if (document.cookie.indexOf('dw=1') < 0) {
            document.cookie = 'dw=1; path=/';
        }
        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
            document.cookie = 'dw_cookies_accepted=1; path=/';
        }
    }
};

},{"./dialog":16}],14:[function(require,module,exports){
'use strict';
var util = require('./util');

exports.init = function init () {
    $('.country-selector .current-country').on('click', function () {
        $('.country-selector .selector').toggleClass('active');
        $(this).toggleClass('selector-active');
    });
    // set currency first before reload
    $('.country-selector .selector .locale').on('click', function (e) {
        e.preventDefault();
        var url = this.href;
        var currency = this.getAttribute('data-currency');
        $.ajax({
            dataType: 'json',
            url: Urls.setSessionCurrency,
            data: {
                format: 'ajax',
                currencyMnemonic: currency
            }
        })
        .done(function (response) {
            if (!response.success) {
                throw new Error('Unable to set currency');
            }
            window.location.href = url;
        });
    });

    $(document).ready(function() {
        var COOKIE_LANGUAGE = 'language';
        var durationCookie = 30 * 24 * 60;

        $('.language .language-dropdown li a').on('click', function () {
            var selectedLanguage = $(this).data('locale');
            console.log(selectedLanguage);
            util.setCookie(COOKIE_LANGUAGE, selectedLanguage, durationCookie);
        });
    });
};

},{"./util":87}],15:[function(require,module,exports){
var $cache = {};
var util = require('./util');

function initializeCache(params) {
    $cache.wrapper = $(params && params.hasOwnProperty('wrapper') ? params.wrapper : '#wrapper'),
    $cache.ccNumber = $cache.wrapper.find('input[name*="_number"]');
    $cache.cvn = $cache.wrapper.find('input[name*="_cvn"]');
    $cache.ccTypeSelect = $cache.wrapper.find('select[name$="_type"]');
    $cache.ccImageCtnr = $cache.wrapper.find('.card-images-list-container');
    $cache.ccNumberRow = $cache.wrapper.find('.form-row.cc-number');
    $cache.defaultCCType = 'Visa';
    $cache.ccTypeRegex = {
        Amex: /^3[47][0-9]{13}$/,
        Diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        JCB: /(^3[0-9]{15}$)|(^(2131|1800)[0-9]{11}$)/,
        Master: /^5[1-5][0-9]{14}$/,
        Visa: /^4[0-9]{12}(?:[0-9]{3})?$/
    };
}

function initializeEvents() {
    $cache.ccNumber.on('keyup', function() {
        updateCCType();
    });
}

/**
 * @function
 * @description returns credit card type by credit card number
 */
function getCCType(ccNumber) {
    var creditCardType = '';
    ccNumber = util.replaceTwoByteToOneByteNumber(ccNumber).replace(/\s+/g, '');
    for (var ccType in $cache.ccTypeRegex) {
        var regex = $cache.ccTypeRegex[ccType];
        if (regex.test(ccNumber)) {
            creditCardType = ccType;
            return creditCardType;
        }
    }
    return creditCardType;
}

/**
 * @function
 * @description sets credit card type
 */
function setCCType(ccType) {
    var length = 3;

    if (ccType && $cache.ccTypeSelect.find('option[value$="' + ccType + '"]').length > 0) {
        // Set value to hidden select
        $cache.ccTypeSelect.val(ccType);

        // Show card image
        $cache.ccImageCtnr.find('.card-image-container').removeClass('selected');
        $cache.ccImageCtnr.find('.card-image-container.card-image-' + ccType).addClass('selected');

        // Update cvn minlength and maxlength
        if (ccType === 'Amex') {
            length = 4;
        } 

    } else {
        $cache.ccTypeSelect.val($cache.defaultCCType);
        $cache.ccImageCtnr.find('.card-image-container').removeClass('selected');
    }

    $cache.cvn.attr('minlength', length).attr('maxlength', length);
    $cache.cvn && $cache.cvn.val($cache.cvn.val().substr(0, length));
}

/**
 * @function
 * @description updates credit card type field basing on credit card number fireld value
 */
function updateCCType() {
    if ($cache.ccNumber.length === 0) {
        return;
    }
    var ccNumber = $cache.ccNumber.val() || '',
        ccType = getCCType(ccNumber);

    setCCType(ccType);
}

var creditCardValidator = {
    init: function(params) {
        initializeCache(params);
        initializeEvents();

        if ($cache.ccImageCtnr.length > 0 && $cache.ccNumberRow.length > 0) {
            $cache.ccNumberRow.find('.field-wrapper').append($cache.ccImageCtnr);
        }

        $cache.wrapper.find('.form-row.required.error').find('input').on('focusout', function() {
            var parent = $(this).parents('.form-row');
            if (parent.hasClass('error')) {
                parent.removeClass('error');
                parent.find('.form-caption.error-message').removeClass('error-message').empty();
            }
        });

        $cache.wrapper.find('.required.error select').on('change', function() {
            var parent = $(this).parents('.exp-date');
            parent.removeClass('error');
            parent.find('.form-caption.error-message').removeClass('error-message').empty();
        });

        /**
        * re-validate expiration date of credit card
        */
        $('select[name*="expiration_month"]').change(function () {
            $('select[name*="expiration_year"]').blur();
        });
    }
};

module.exports = creditCardValidator;

},{"./util":87}],16:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        var $target, id;
        var className = params.className ? params.className : '';

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content ' + className).appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        // close any open dialog
        this.close();
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '800',
        close: function () {
            $(this).dialog('close');
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;

},{"./ajax":5,"./util":87,"imagesloaded":115,"lodash":116}],17:[function(require,module,exports){
var removeScreenOverlay = {
	init: function() {
        $('#nav-icon').removeClass('open');
        $('#navigation').removeClass('active');
		$('.bubble').removeClass('active');
		$('.mini-cart-content').removeClass('active');
	}
}
module.exports = removeScreenOverlay;
},{}],18:[function(require,module,exports){
'use strict';

var util = require('./util');

function countrySelector() {

    $('.countries-selector').on('change', function(e) {
        e.preventDefault();

        var countrySelected = $(this).find(':selected').text().toLowerCase();
        if (countrySelected == 'us' || countrySelected == 'united states') {
        	return false;
        }

       
        var countryUrl = (countrySelected.indexOf('other') >= 0) ? Urls.countrySelectorUrl : $(this).find(':selected').val();
       
        if(window.open(countryUrl, '_blank') == null) {
        	document.location.href = countryUrl;
        }
    });
    
	 if($('.country-selector-wrapper').length > 0){
	    	
	    	var popup = new Foundation.Reveal($('#country-selector-container'));
	    	popup.open();
	    	
	    	$('.shopnow-button').on('click', function(){
	    		if($(this).closest('#country-selector-container').find('.selectcountry.popup').val() != ''){
	    			location = $(this).closest('#country-selector-container').find('.selectcountry.popup').val();
	    		}
	    	});
	    	 
	    	
	    	$('#country-selector-container').find('.close-button').on("click", function (e) {
	    		var element = e.currentTarget;
	        	var marketID = element.dataset.market;
	        	var lifetime = element.dataset.countrycookieliftime;
	        
	        	util.setCookie('nars_emea-preferredSite', marketID, lifetime);
	    	})
	    }
}

function languageSelector() {
	if($('#language-selector-popup').length > 0) {
		var popupdata = $('#language-selector-popup');
		
		var popup = new Foundation.Reveal(popupdata);

		popup.open();
	}
}

exports.countrySelector = countrySelector;
exports.languageSelector = languageSelector;
},{"./util":87}],19:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');
/**
 * @function
 * @description Load details to a given gift certificate
 * @param {String} id The ID of the gift certificate
 * @param {Function} callback A function to called
 */
exports.checkBalance = function (id, pin, callback) {
    // load gift certificate details
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.giftCardCheckBalance, { 'giftCertCode': id, 'giftCertPIN': pin }),
        callback: callback
    });
};

},{"./ajax":5,"./util":87}],20:[function(require,module,exports){
'use strict';

var util = require('./util');
var giftcert = require('./giftcert');
var modal = require('./modal').global;
var validator = require('./validator');

function updateCart () {
    $('#AddToBasketButton').on('click', function () {
        $('#GiftCertificateForm').trigger("submit");
    });
}

exports.init = function () {
    $('.gift-cert-edit').on('click', function (e) {
        e.preventDefault();

        modal.addCustomClass('edit-modal quickview-modal');
        modal.renderByUrl($(this).attr('href'));
        modal.setCallback(function () {
            updateCart();
            giftcert.init();
            util.limitCharacters();
            validator.initForm('form#GiftCertificateForm');
        });
    });
}
},{"./giftcert":21,"./modal":28,"./util":87,"./validator":88}],21:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util');

var setAddToCartHandler = function (e) {
    e.preventDefault();
    if ($(".termsandconditions").hasClass("error")) {
    	return false;
    }    
    
    setGiftCard();
    
    if($('#GiftCertificateForm').length > 0 && !$('#GiftCertificateForm').valid()){   
       return false;
    }
    var widgetOpt;
    if( util.getGoogleRecaptchaEnableStatus('GiftCertificateForm') == true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha == 'object'){    	    	
    	try {
    		widgetOpt= util.getGoogleRecaptchaWidgetOptionNum('GiftCertificateForm');
    		if( grecaptcha.getResponse(widgetOpt) == '' ){
        		e.preventDefault();
        		e.stopPropagation();
        		grecaptcha.execute(widgetOpt);
        		return;
        	}
    	}
    	catch(err) {
    	    console.log(err.message);    	    
    	}
    	
    }
    
    var form = $(this).closest('form');
    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };

    $.ajax(options).done(function (response) {    	
    	if(response.success == false){    		
    		return window.alert(response.invalidErrMsg);    		
    	} else if (response.success) {
    		if( util.getGoogleRecaptchaEnableStatus('GiftCertificateForm') == true && widgetOpt!=undefined) {
        	    util.resettingGoogleInvRecaptcha(widgetOpt, 'GiftCertificateForm');
    		}
            ajax.load({
                url: Urls.minicartGC,
                data: {
                    lineItemId: response.result.lineItemId
                },
                callback: function (response) {
                    minicart.show(response);
                    form.find('input:not([name=csrf_token]),textarea').val('');
                    setGiftCard();                   
                }
            });

            if (response.result.device === 'mobile') {
                var popup = new Foundation.Reveal($('#giftcertpurchase-notification'));

                popup.open();

                setTimeout(function () {
                    popup.close();
                }, 3000);
                form[0].reset();
            }
        }else if(response.error){
        	var urls = Urls.navigateToCSRFFailed;
        	window.location.href = urls;
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            return window.alert(Resources.BAD_RESPONSE);
        }

        window.alert(Resources.SERVER_CONNECTION_ERROR);
    });
};

function initializeEvents() {
    $('.gift-templates li').on('click', function (e) {
        e.preventDefault();

        $('.gift-templates li').removeClass('active');
        $(this).addClass('active');

        setGiftCard();
    });

    $('.gift-templates select').on("change", function () {
        var imageSource = $(this).find('option:selected').val();
        var imageAlt = $(this).find('option:selected').text();

        $('.gift-templates li.active').removeClass('active');
        $('.gift-templates li:has(img[alt="' + imageAlt + '"])').addClass('active');

        setGiftCardImage(imageSource);
        setGiftCardName(imageAlt);
    });
}

function setGiftCard() {
    var imageSource = $('.gift-templates li.active').find('img').attr('src') || $('.img-source input').val();
    var imageAlt = $('.gift-templates li.active').find('img').attr('alt') || $('.img-alt input').val();

    $('.gift-templates select').val(imageSource);
    $('.gift-templates li:has(img[alt="' + imageAlt + '"])').addClass('active');

    setGiftCardImage(imageSource);
    setGiftCardName(imageAlt);
}

function setGiftCardImage(imageSource) {
    $('.img-preview').html('<img src="' + imageSource + '" />');
    $('#GiftCertificateForm .img-source input').val(imageSource);
}

function setGiftCardName (imageAlt) {
    $('.gift-templates strong').text(imageAlt);
    $('#GiftCertificateForm .img-alt input').val(imageAlt);
}

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);

    if ($('.gift-check-balance').length) {
        $('.gift-templates li').first().addClass('active');
    }

    initializeEvents();
    
    if ($('#giftcertrecaptcha').length > 0) {
        //util.renderGoogleInvRecaptcha("giftcertrecaptcha","#AddToBasketButton","GiftCertificateForm");
    }
    if ($('#giftcertcheckbalance').length > 0) {
        //util.renderGoogleInvRecaptcha("giftcertcheckbalance","#CheckBalanceButton","gcBalanceCheckForm");
    }
};

},{"./ajax":5,"./minicart":27,"./util":87}],22:[function(require,module,exports){
'use strict';

exports.init = function () {
	$('.menu-utility-user .contact, .menu-utility-user .newsletter').on("mouseenter", function() {
		$(this).find('.menu-utility-content').show();
    }).on("mouseleave", function() {
    	$(this).find('.menu-utility-content').hide();
    });
	
	// 'tap' doesn't work as expected so using touchstart instead
	$(document).on('touchstart',function(e){
		// the tapped element
		var $target = $(e.target);
		
		// check if it's not the menu or the dropdown itself
		if($target.closest('.dropdown-menu').length == 0){
			// check if some dropdown menu is open, otherwise foundation will return an error 
			if($('.dropdown-pane.is-open').length){
				$('.dropdown-pane.is-open').foundation('close');
			}
		}
	});

	$('a.utility-link').on("click", function(evt) {
		evt.preventDefault();
	});

	// overwrite foundation Enter key event 
	$('.menu-utility-user input').each(function(i, input){
		var $input = $(input);
		
		// overwrite only on input type text, email and password
		if($input.attr('type') == 'text' 
			|| $input.attr('type') == 'email' 
				|| $input.attr('type') == 'password'){
			
			$input.on("keydown", function(e) {
				Foundation.Keyboard.handleKey(e, "DropdownMenu", {		
					submit: function () {
						var $form = $input.closest('form');
						
						// simulate blur event to check if it has error or not
						$input.trigger("blur");
						
						// prevent submit if there are errors
						if($form.find('span.error').length == 0){
							
							// $form.submit() doesn't work on login so it has to be this *sigh*
							$form.find('button[type="submit"]').trigger("click");
						}
					}
				});
			});
		}		
	});

}
Foundation.Keyboard.register("DropdownMenu", {
	"ENTER": 'submit'
});

},{}],23:[function(require,module,exports){
'use strict';

function entry () {
    $(document).on('keyup blur', '.cart-coupon-code input', function () {
        var inputEntry = $(this).val();
        if (inputEntry && inputEntry.trim().length) {
            return $(this).siblings('button').prop('disabled', false);
        }

        $(this).siblings('button').prop('disabled', true);
    });
}

exports.entry = entry;
},{}],24:[function(require,module,exports){
'use strict';
// jQuery extensions

module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) { return this; }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {options.callback();}
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };
};

},{}],25:[function(require,module,exports){
/* --- handle limit Character --- */
var checkLimitCharacter = {
    init: function (e) {
        var o = e.outerElem,
            i = e.innerElem,
            l = e.limit;
        if ($(o).length > 0 && $(i).length > 0) {
            $(o).each(function() {
                var $selector = $(this).find(i);
                if ($selector.length > 0) {
                    var charCount = $selector.html();
                    if (charCount.length > l) {
                        $selector.html(charCount.substr(0, l) + '...');
                    }
                }
            });
        }
    }
}

module.exports = checkLimitCharacter;
},{}],26:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util'),
    validator = require('./validator'),
    customaddress = require('./pages/customaddress');

var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        //o-auth binding for which icon is clicked
        $('.oAuthIcon').on('click', function () {
            $('#OAuthProvider').val(this.id);
        });


        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').on('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });
        if ($('#loginrecaptcha').length > 0) {
            util.renderGoogleInvRecaptcha("loginrecaptcha","#login","dwfrm_login")
        }
        customaddress.init();
    }
}

//Reset Password
$('.password-reset').on('click', function (e) {
    e.preventDefault();

    if ($('#sign-in-dropdown').length) {
        $('#sign-in-dropdown').foundation('close');
    }

    var page = require('./page'),
    util = require('./util'),
    validator = require('./validator'),
    customaddress = require('./pages/customaddress'),
    modal = require('./modal').global;

        modal.events.onOpen(function () {
            validator.init();
            var $requestPasswordForm = $('[name$="_requestpassword"]');
            var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
            $($submit).on('click', function (e) {
                if (!$requestPasswordForm.valid()) {
                    return;
                }
                e.preventDefault();
                var data = $requestPasswordForm.serialize();
                // add form action to data
                data += '&' + $submit.attr('name') + '=';
                // make sure the server knows this is an ajax request
                if (data.indexOf('ajax') === -1) {
                    data += '&format=ajax';
                }
                $.ajax({
                    type: 'POST',
                    url: $requestPasswordForm.attr('action'),
                    data: data,
                    success: function (response) {
                        if (typeof response === 'object' &&
                                !response.success &&
                                response.error === 'CSRF Token Mismatch') {
                            page.redirect(Urls.csrffailed);
                        } else if (typeof response === 'string') {
                            modal.renderContent(response);
                        }
                    },
                    failure: function () {
                        modal.renderContent('<h1>' + Resources.SERVER_ERROR + '</h1>');
                    }
                });
            });
        });
        modal.addCustomClass('password-reset-step1');
        modal.renderByUrl($(e.target).attr('href'));
});

module.exports = login;

///Login Greetings
if (window.User.isCustomerAuthenticated != false || window.User.isRegistered == true) {
    var myDate = new Date();
    var hrs = myDate.getHours();
    var mins = myDate.getMinutes();
    var time;
    var greeting;

    mins = ('0' + mins).slice(-2);
    time = hrs + mins;
    time = Number(time);

    if (time >= 300 && time <= 1159) {
        greeting = window.Resources.GREETINGS_MORNING;
    } else if (time >= 1200 && time <= 1700) {
        greeting = window.Resources.GREETINGS_AFTERNOON;
    } else {
        greeting = window.Resources.GREETINGS_EVENING;
    }

    $('#login-greetings').text(greeting);
    $('.menu-greeting #login-greetings').text(greeting);
}
},{"./dialog":16,"./modal":28,"./page":31,"./pages/customaddress":45,"./util":87,"./validator":88}],27:[function(require,module,exports){
'use strict';

var util = require('./util'),
    bonusProductsView = require('./bonus-products-view'),
    samples = require('./samples'),
    removeScreenOverlay = require('./drawerControl'),
    modal = require('./modal').global,
    analytics = require('./analytics');

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var minicart = {
    init: function () {
        this.$el = $('#mini-cart');
        this.$content = this.$el.find('.mini-cart-content');
        this.$btnClose = this.$el.find('#minicart-close');

        if (!util.isMobile()) {
            // events
            this.$el.find('.mini-cart-total').on('mouseenter', function () {
                if (this.$content.not(':visible')) {
                    this.slide();
                }
            }.bind(this));

            this.$content.on('mouseenter', function () {
                timer.clear();
            }).on('mouseleave', function () {
                timer.clear();
                timer.start(200, this.close.bind(this));
            }.bind(this));
        } else {
            this.$el.find('.mini-cart-total').on('click', function (e) {
                e.preventDefault();
                removeScreenOverlay.init();
                $('html').removeClass('nav-open');
                if (this.$content.not(':visible')) {
                    this.slide();
                }
            }.bind(this));
        }

        this.$btnClose.on('click', function(e) {
            e.preventDefault();
            this.$content.removeClass('active');
            this.$content.attr('aria-expanded', false);
        }.bind(this));
    },

    addProduct: function (data) {
        var show = this.show.bind(this);
        var promise = require('promise');
        var currentId = data.currentId;
        return new promise(function (resolve, reject) {
            if (data.hasOwnProperty("pid") === false) {
                return reject();
            }

            var data_json = {
                "format": "ajax",
                "pid": encodeURIComponent(data.pid),
                "Quantity": data.hasOwnProperty("Quantity") ? data.Quantity : "1",
            };

            if ($('#csrf_token') && $('#csrf_token').length === 1) {
                var csrfTokenVal = $('#csrf_token').val();
                var csrfTokenKey = $('#csrf_token').prop('name');
                data_json[csrfTokenKey] = csrfTokenVal;
            }

            $.post(util.appendParamsToUrl(Urls.addProduct, data_json), function (data) {
                if (data.success === false) {
                    modal.addCustomClass('normal-modal');
                    modal.renderContent(data.error);
                    return reject(data.error);
                }

                analytics.initAddToCartFromPLP(currentId);

                show(data);
                resolve();
            }).fail(function (err) {
                reject(err.error);
            });
        });
    },

    addAllToWishlistFromContent: function (pids) {
        return window.location.href = Urls.addAllFromContent
                + "?pid=" + pids.join(":1,") // pass qty of one
                + "&cid=" + window.contentAssetID
                + "&hashparam=" + window.location.hash.split('#')[1];
    },

    addAllProducts: function (pids, to) {
        if (!pids || pids.length === 0) {
            return;
        }

        var isWishlist = (to && to.toLowerCase() === "wishlist");
        if (isWishlist && !window.User.isCustomerAuthenticated) {
            if (window.contentAssetID) {
                return this.addAllToWishlistFromContent(pids);
            } else {
                var footerURL = $('footer') ? $('footer').data('url') : null;
                window.location = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
                return;
            }
        }

        var show = this.show.bind(this);
        var urlName = Urls.addMultipleProducts;

        if (isWishlist) {
            urlName = Urls.wishlistAddAll.split(window.location.hostname)[1];
        }

        $.post(util.appendParamsToUrl(urlName, {
            format: 'ajax',
            pid: pids
        }), function (data) {
            if (isWishlist) {
            	var redirectLocation = util.appendParamsToUrl( window.location.href, { "recadd" : "yes" } )
                window.location.href = redirectLocation;
                return;
            }

            if (data) {
                show(data);
            }
        });
    },

    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html) {
    	// re-fetch mini-cart object
    	if (!this.$el) {
    		this.$el = $('#mini-cart');
    	}

        this.$el.html(html);
        this.init();
        this.slide();

        // identify if we can show the sample overlay
        var canShowSamples = false;
        $(document).find('#mini-cart input[name="eligible-for-sample"]').each(function() {
        	if (!canShowSamples && $(this).val() == 'true') {
        		canShowSamples = true;
        	}
        });

        if ((bonusProductsView.hasBonusOptions() === false && samples.canShowSelection())
        		&& canShowSamples) {
        	setTimeout(function() {
                samples.showSelection();
            }, 1000);

        }

        bonusProductsView.loadBonusOption();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        timer.clear();
        // show the item
        this.$content.addClass('active');
        this.$content.attr('aria-expanded', true);
        // after a time out automatically close it
        timer.start(6000, this.close.bind(this));
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function (delay) {
        timer.clear();
        this.$content.removeClass('active');
        this.$content.attr('aria-expanded', false);
    }
};

module.exports = minicart;

},{"./analytics":6,"./bonus-products-view":9,"./drawerControl":17,"./modal":28,"./samples":79,"./util":87,"promise":118}],28:[function(require,module,exports){
var util = require('./util');

function Modal(modalCntr, modalBody, option) {
    this.$cntr = $(modalCntr);
    this.$body = $(modalBody);
    
    if($.isEmptyObject(option) === false){
    	this.modal = new Foundation.Reveal($(modalCntr), option);
    } else {
    	this.modal = new Foundation.Reveal($(modalCntr));
    }
    this.callbackFn = null;

    this.events = {
        onOpen: function (cb) {
            $(document).off('open.zf.reveal').on('open.zf.reveal', function () {
                cb();
                $(document).off('open.zf.reveal');
            });
        },

        onClose: function (cb) {
            $(document).off('closed.zf.reveal').on('closed.zf.reveal', function () {
                cb();
                $(document).off('closed.zf.reveal');
            });
        }
    };
}

Modal.prototype.open = function () {
    this.modal.open();
};

Modal.prototype.close = function () {
    this.modal.close();
};

Modal.prototype.restoreDefaultClass = function () {
	this.$cntr.removeAttr('class');
	this.$cntr.attr('class','reveal');
};

Modal.prototype.addCustomClass = function(customClass){
	this.restoreDefaultClass();
	this.$cntr.addClass(customClass);
};

Modal.prototype.setContent = function (content) {
    return this.$body.html(content);
};

Modal.prototype.renderContent = function(content, type) {
    var classType = type || '';

    this.$body.html('<div id="modal-content" class="modal-content ' + classType + '">' + content + '</div>');
    this.modal.open();

    if(typeof this.callbackFn === 'function') {
    	this.callbackFn();
    	this.callbackFn = null; // clear after each use
    }
};

Modal.prototype.renderByUrl = function (contentUrl) {
    return $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(this.renderContent.bind(this));
};

Modal.prototype.setCallback = function (cb) {
	this.callbackFn = cb;
};

module.exports.global = new Modal("#modal-cntr", ".modal-body", {}); // global modal
module.exports.create = function (modalCntr, modalBody, option) {
    return new Modal(modalCntr, modalBody, option);
};
},{"./util":87}],29:[function(require,module,exports){
'use strict';

var util = require('./util'),
	validator = require('./validator'),
    modal = require('./modal').global;


function showNewsletterModal() {
        modal.events.onClose(function () {
            var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
            util.setCookie(shouldDisplayNewsletter, false, 10);
        });

        modal.renderByUrl(Urls.showFullNewsletterForm)
            .done(function (response) {
                modal.addCustomClass('newsletter-signup-modal');

            $('.modal-content button').prop('disabled', true);
            $('.modal-content button').css('color', '#FFFFFF');
            
            if( window.User.isCustomerAuthenticated ){
            	var fname = $('.newsletterpopup-data').attr('data-fname');//$('.news-letter-form input[name="newsletterfname"]').val();
				var lname = $('.newsletterpopup-data').attr('data-lname');//$('.news-letter-form input[name="newsletterlname"]').val();
            	$('.modal-content input[name="newsletterfname"]').val(fname).prop( "disabled", true );
            	$('.modal-content input[name="newsletterlname"]').val(lname).prop( "disabled", true );;

            }

            validator.initForm('.newsletter-signup-modal form');
        });
}

function isNewsletterEnabled() {
    $('.register-newsletter').removeClass('hide');
    $('.newsletter-success').addClass('hide');

    if (!enableNewsletter) {
        return;
    }

    var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
    var isViewedNewsletterValid = util.getCookieSelector(hasViewedNewsletter);

    if (isViewedNewsletterValid === 'true') {
        return;
    }

    var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
    var isDisplayedNewsletterValid = util.getCookieSelector(shouldDisplayNewsletter);

    if (isDisplayedNewsletterValid === 'false') {
        return;
    }

    util.setCookie(hasViewedNewsletter, false, newsletterCookieDuration);
    util.setCookie(shouldDisplayNewsletter, true, newsletterCookieDuration);
    if ($('#newsletterrecaptcha').length > 0) {
        //util.renderGoogleInvRecaptcha("newsletterrecaptcha","#headernewslettersubmit", "headerNewsLetter");
    }

    setNewsletterCounterCookie();
    signUpEventListener();
}

function setNewsletterCounterCookie() {
    var pageViewCount = [siteId, 'pageViewCount'].join('-');
    var isCookieValid = util.getCookieSelector(pageViewCount);
    var counterCookie = Number(isCookieValid);

    if (!isCookieValid) {
        counterCookie = 0;
    } else {
        counterCookie += 1;
    }

    util.setCookie(pageViewCount, counterCookie, newsletterCookieDuration);

    var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
    var isDisplayedNewsletterValid = util.getCookieSelector(shouldDisplayNewsletter);

    if (counterCookie >= pageViewsToNewsletter && isDisplayedNewsletterValid === 'true') {
       showNewsletterModal();
    }
}

function signUpEventListener() {
    $(document)
        .on('submit', '.modal-content .news-letter-form', function (e) {
            e.preventDefault();

            var emailAddress = $('.modal-content input.email').val();
            var fname = $('.modal-content input[name="newsletterfname"]').val();
            var lname = $('.modal-content input[name="newsletterlname"]').val();
            validateNewsletterEmail(true, emailAddress, fname, lname);
        })

        .on('keyup blur', '.modal-content input.email', function (e) {
            var emailAddress = $(this).val();

            $('.modal-content button').prop('disabled', false);
            $('.modal-content button').css('color', '');

            if (!emailAddress.length) {
                $('.modal-content button').prop('disabled', true);
                $('.modal-content button').css('color', '#FFFFFF');
            }
        });
}

function newsletterHeader() {
    $(document).on('submit', '.newsletter-content .news-letter-form', function (e) {
        e.preventDefault();

        var emailAddress = $('.news-letter-form input.email').val();
        var fname = $('.news-letter-form input[name="newsletterfname"]').val();
        var lname = $('.news-letter-form input[name="newsletterlname"]').val();
        validateNewsletterEmail(false, emailAddress, fname, lname);
    });
}

function validateNewsletterEmail(isModal, emailAddress, fname, lname) {
    var validateClass = '.news-letter-form';

    if (isModal) {
        validateClass = '.modal-content';
    }

    $(validateClass + ' input').removeAttr('aria-invalid');
    $(validateClass + ' input').removeAttr('aria-describedby');
    $(validateClass + ' input').removeAttr('class');
    $(validateClass + ' span').remove();

    if (!util.validateEmail(emailAddress)) {
        var errorMessage;

        if (isModal) {
            errorMessage = [
                '<span id="-error" class="error">',
                Resources.VALIDATE_EMAIL,
                '</span>'
            ].join('');

            $(validateClass + ' .promotions-container').after(errorMessage);
            $(validateClass + ' button').prop('disabled', true);
        } else {
            errorMessage = [
                '<span id="-error" class="error">',
                Resources.VALIDATE_EMAIL,
                '</span>'
            ].join('');

            $(validateClass + ' input').before(errorMessage);
        }
    }

    var postData = ['dwfrm_newsletter_email=', emailAddress].join('');
    var formAction = $('.newsletter-container form').attr('action');
    
    if($('.newsletter-container form').length > 0){
    	$.ajax({
            type: 'POST',
            url: formAction,
            async: false,
            data: postData,
            success: function(textStatus) {
                $('.register-newsletter').addClass('hide');
                $('.newsletter-success').removeClass('hide');
                $('.newsletter-success').addClass('show');
                $('.newsletter-success .registered-email').html(emailAddress);
                if(window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')){
                	window.universal_variable.user.email = emailAddress;
                }
            }
        });
    }
    var formSerliazeData;
    if (isModal) {
        setHasViewedNewsletterCookie(true);
        formSerliazeData = $('#modalNewsLetter').serialize();
    } else {
    	formSerliazeData = $('#headerNewsLetter').serialize();
    }
    
    if($('.news-letter-form').length > 0){
        var sourceValue = isModal ? 'modal' : 'header';
    	$.ajax({
            type: 'POST',
            url: $('.news-letter-form').attr('action'),
            async: false,
            data: formSerliazeData +'&email='+ emailAddress +'&source='+sourceValue+'&fname='+fname+'&lname='+lname,
            success: function (response) {
            	if(typeof response.success != "undefined" && response.success==false){
            		if (isModal) {
	                    modal.renderContent(response.error);
	                    modal.addCustomClass('newsletter-signup-modal');
	                    $(document).trigger("clicknewsletter",{"siteloc":"pop-up"});
	                } else {
	                    $('.newsletter-content').html(response.error);
	                    $(document).trigger("clicknewsletter",{"siteloc":"navbar"});
	                }
            	}else{
	                if (isModal) {
	                    modal.renderContent(response);
	                    modal.addCustomClass('newsletter-signup-modal');
	                    $(document).trigger("clicknewsletter",{"siteloc":"pop-up"});
	                } else {
	                    $('.newsletter-content').html(response);
	                    $(document).trigger("clicknewsletter",{"siteloc":"navbar"});
	                }
	                if(window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')){
	                	window.universal_variable.user.email = emailAddress;
	                }
            	}
            }
        });
    }
    
}

function setHasViewedNewsletterCookie(val) {
    var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
    util.setCookie(hasViewedNewsletter, val, newsletterCookieDuration);
}

exports.isNewsletterEnabled = isNewsletterEnabled;
exports.newsletterHeader = newsletterHeader;
},{"./modal":28,"./util":87,"./validator":88}],30:[function(require,module,exports){
'use strict';

var modal = require('./modal').global, 
	util = require('./util');

exports.init = function init() {

//On Change Select in PDP
$(".replenishmentCycle").on("change", function() {
	var footerURL = window.location.href;
	var selection = $(this).val();

	if ( window.User.isCustomerAuthenticated == false && selection!= 0) { 
		$( ".replenishmentCycle" ).val("0");

		// render content to modal by url
		modal.renderByUrl(Urls.replenishmentLogin);
		modal.setCallback(function(){
			$(".modal-btn-signin").on("click", 
					function() {
						var urlLink = util.appendParamToURL(Urls.showLogin,
								'original', footerURL);
						window.location = util.appendParamToURL(urlLink,
								'replenishment', selection);
					});
			
			$(".modal-btn-register").on("click", function() {
				window.location = Urls.showCreateAccount;
			});
		});
	}

	$( ".modal-btn-signin" ).on("click", function() {
		var urlLink = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
		window.location = util.appendParamToURL(urlLink, 'replenishment', selection);
	});

	$( ".modal-btn-register" ).on("click", function() {
		window.location = Urls.showCreateAccount;
	});	
});

//Update the Order replenishment suggestion based on product variant sizeVariations	
$("input[name=size]").on("click", function(){		
	//Get the recommendation from the input data-isreplenishable
	var replennumber = this.getAttribute('data-isreplenishable');
					
	//Construct the replenishment message
	var replenmsg = "";
	if(replennumber !== null && replennumber > 0){
		var message = Resources.RECOMMENDED_REPLENISHMENT;
	
		replenmsg += message;
		replenmsg += replennumber;			
		replenmsg += " ";
		replenmsg += replennumber > 1 ? "${spanPlural}" : "${span}";
		replenmsg += ".";
	}		
	
	//Assign it to replenreccomendation
	$("#replenrecommendation").text(replenmsg);
});

//My Account Replenishment Update Button
$( ".replenishmentupdate" ).on("click", function(e) {
	e.preventDefault();
	var href = $(this).attr('href');
	var uuid = getQueryValue("rid", href);
	var rdays = $("." + uuid.substring(0,26) + "_days").val();
	var replenishmentQuantity = $("." + uuid.substring(0,26) + "_quantity").val();
	var updateReplenishment = href + "&rdays=" + rdays + "&qty=" + replenishmentQuantity;
	window.location = updateReplenishment;
	
});

//My Account Replenishment Cancel Button
$( ".replenishmentcancel" ).on("click", function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var popup = new Foundation.Reveal($('#cancel-replenishment'));
    popup.open();
    
    $( ".modal-btn-confirm" ).on("click", function() {
        window.location = href;
    });
    
    $( ".modal-btn-keep" ).on("click", function() {
        popup.close();
    });
});

// Gets the query string value if it exists, returns null if it does not.
// Example: getQueryValue("reset") will return the value true if the URL is http://www.domain.com?reset=true
function getQueryValue(str,href) 
{
	/*var queryString = window.location.search.substring(1);*/
	var queryString = href
	var queries = queryString.split("?");
	for (var i=0;i<queries.length;i++) {
		var ft = queries[i].split("=");
		if (ft[0] == str) {
			return ft[1];
		}
	}
	return null;
}
};

},{"./modal":28,"./util":87}],31:[function(require,module,exports){
'use strict';

var util = require('./util');

var page = {
    title: '',
    type: '',
    params: util.getQueryStringParams(window.location.search.substr(1)),
    redirect: function (newURL) {
        setTimeout(function () {
            window.location.href = newURL;
        }, 0);
    },
    refresh: function () {
        setTimeout(function () {
            window.location.assign(window.location.href);
        }, 500);
    }
};

module.exports = page;

},{"./util":87}],32:[function(require,module,exports){
'use strict';

var giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    util = require('../util'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    modal = require('../modal').global,
    cardValidation = require('./checkout/card-validation'),
    validator = require('../validator'),
    accountSelectDate = require('../account-select-date'),
    accountPersonalData = require('../account-validate-dob'),
    search = require('./search'),
    creditCardValidator = require('../credit-card-validator'),
    customaddress = require('./customaddress'),
    initCleanAutoFill = require('../address-book');

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
    var $form = $('#edit-address-form');

    $form.find('input[name="format"]').remove();
    tooltip.init();
    //$("<input/>").attr({type:"hidden", name:"format", value:"ajax"}).appendTo(form);

    $form.on('click', '.apply-button', function (e) {
            /****
             * e.preventDefault();
             * if (!$form.valid()) {
             *     return false;
             * }
             * var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
             * var applyName = $form.find('.apply-button').attr('name');
             * var options = {
             *     url: url,
             *     data: $form.serialize() + '&' + applyName + '=x',
             *     type: 'POST'
             * };
             * $.ajax(options).done(function (data) {
             *     if (typeof(data) !== 'string') {
             *         if (data.success) {
             *             dialog.close();
             *             page.refresh();
             *         } else if (data.error) {
             *             page.redirect(Urls.csrffailed);
             *         } else {
             *             window.alert(data.message);
             *             return false;
             *         }
             *     } else {
             *         $('#dialog-container').html(data);
             *         account.init();
             *         tooltip.init();
             *     }
             * });
             ****/
        })
        .on('click', '.cancel-button, .close-button', function (e) {
            e.preventDefault();
            dialog.close();
        })
        .on('click', '.delete-button', function (e) {
            e.preventDefault();
            if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
                var url = util.appendParamsToUrl(Urls.deleteAddress, {
                    AddressID: $form.find('#addressid').val(),
                    format: 'ajax'
                });
                $.ajax({
                    url: url,
                    method: 'POST',
                    dataType: 'json'
                }).done(function (data) {
                    if (data.status.toLowerCase() === 'ok') {
                        dialog.close();
                        page.refresh();
                    } else if (data.message.length > 0) {
                        window.alert(data.message);
                        return false;
                    } else {
                        dialog.close();
                        page.refresh();
                    }
                });
            }
        });
}
/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder() {
    $('.order-items')
        .find('li.hidden:first')
        .prev('li')
        .append('<a class="toggle">View All</a>')
        .children('.toggle')
        .on("click", function () {
            $(this).parent().siblings('li.hidden').show();
            $(this).remove();
        });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var addresses = $('#addresses');
    if (addresses.length === 0) {
        return;
    }

    addresses.on('click', '.address-edit, .address-create', function (e) {
        e.preventDefault();
        dialog.open({
            url: this.href,
            options: {
                open: initializeAddressForm
            }
        });
    }).on('click', '.delete', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            $.ajax({
                url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    page.redirect(Urls.addressesList);
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                } else {
                    page.refresh();
                }
            });
        }
    });
}
/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
    $('.hide-newcard').on('click', function () {
        $(this).closest('#b-newpaymentmethod').toggleClass("not-active");
    });

    $('.add-card').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                open: initializePaymentForm
            }
        });
    });

    if ($("#CreditCardForm").is(":visible")) {
        creditCardTypeDetector();
        validator.initForm('form[id$="CreditCardForm"]');

    }

    $(document).on("click", ".credit-card-create", function (evt) {
        modal.events.onOpen(function () {
            creditCardTypeDetector();
            validator.initForm('form[id$="CreditCardForm"]');
            creditCardValidator.init({
                wrapper: '.medium.add-credit-card form[id$="CreditCardForm"]'
            });
        });
        modal.addCustomClass('medium add-credit-card')
        modal.renderByUrl(Urls.myaccountAddCreditCard);
        modal.setCallback(cardValidation.init);
    });

    $(document).on("submit", "div.add-credit-card #CreditCardForm", function(evt) {
        evt.preventDefault();

        var $form = $(this);
        var $formDataError = $('.error-form');

        $.ajax({
            url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
            data: $form.serialize() + '&' + $form.find('#applyBtn').attr('name') + '=x',
            type: 'POST'
        }).done(function(data) {
            if (!data) {
                $formDataError.html(Resources.BAD_RESPONSE);
                return false;
            }

            if (data.length) {
                modal.setContent(data);
                validator.init();
                creditCardValidator.init({
                    wrapper: '.medium.add-credit-card form[id$="CreditCardForm"]'
                });
                $('input[id*="newcreditcard_number"]').val('');
                $('input[id*="newcreditcard_number"]').focus();
                $('input[id*="newcreditcard_cvn"]').val('');
                return;
            }

            if (!location.assign(Urls.paymentsList)) {
                window.location.href = Urls.paymentsList;
            }
        });
    });

    $('form.remove-card-form button.delete').on('click', function (e) {
        e.preventDefault();
        var $button = $(this);
        var $form = $button.closest('form.remove-card-form');
        var popup = new Foundation.Reveal($('#remove-card'));
        popup.open();

        //Yes button
        $(".cardDelete-modal-btn-ok").unbind();
        $(".cardDelete-modal-btn-ok").on("click", function () {
            popup.close();

            $('<input/>').attr({
                type: 'hidden',
                name: $button.attr('name'),
                value: $button.attr('value') || 'delete card'
            }).appendTo($form);
            var data = $form.serialize();

            $.ajax({
                    type: 'POST',
                    url: $form.attr('action'),
                    data: data
                })
                .done(function () {
                    page.redirect(Urls.paymentsList);
                });
        });

        //No button
        $(".cardDelete-modal-btn-cancel").unbind();
        $(".cardDelete-modal-btn-cancel").on("click", function () {
            popup.close();
        });
    });

}

function initializePaymentForm() {
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        dialog.close();
    });
}

function mobileAccountMenu() {
    var pageContainer = $('#main');
    var primaryContent = $('#primary');
    var primaryContentHeight = $('#primary').outerHeight();
    var mobileNav = $('#secondary');
    var accountText = $('.account-text');
    var currentUrl = window.location.href;
    var cleanUrl = currentUrl.split('?')[0];

    $('.account-nav-asset a[href="' + cleanUrl + '"]').addClass('active-menu');

    $('.account-nav-asset a').not('.accordion-title').on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');

        if (url != cleanUrl) {
            window.location = url;
        } else {
            mobileNav.css('min-height', primaryContentHeight);
            pageContainer.addClass('content-show');
            hideLastBreadcrumbForMyAccount(false);

        }
    });

    $('.back-to-account-btn a').on('click', function (e) {
        e.preventDefault();
        pageContainer.removeClass('content-show');
        mobileNav.css('min-height', 0);
        hideLastBreadcrumbForMyAccount(true);


    });
}

/*
 * To hide the last breadcrumb on mobile devices on My Account page as a part of UI change.
 * @param : hide ( Boolean )
 *
 * "noAfter" class is used to hide the >>(arrow) in breadcrumb.
 * It hides :after pseudo class.
 * Pseudo classes are not supported in JQuery or JS as they are not part of DOM.
 * So we added a css to hide the pseudos via adding a class.
 */

function hideLastBreadcrumbForMyAccount(hide) {

    var breadCrumbs = ($(".breadcrumb-element").length > 0) ? $(".breadcrumb-element") : null;
    var secondLastBreadCrumb = 2; //Default set as 2 as per current length of breadcrumbs


    if (breadCrumbs === null) {
        return;
    } else {
        //If breadCrumb length increases in future
        secondLastBreadCrumb = breadCrumbs.length - 1;
    }

    if (hide) {
        $(".breadcrumb-element:last").hide();
        $(".breadcrumb-element:nth-last-child(" + secondLastBreadCrumb + ")").addClass("noafter");
    } else {
        $(".breadcrumb-element:last").show();
        $(".breadcrumb-element:nth-last-child(" + secondLastBreadCrumb + ")").removeClass("noafter");
    }
}



function registerAccountEvents() {
    // get the field elements
    var $gender = $('.registration-box #dwfrm_profile_customer_gender');
    var $newsletterCB = $('.registration-box #dwfrm_profile_customer_addtoemaillist');

    $gender.on('change', function (e) {
        $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
    });
    $newsletterCB.on('change', function (e) {
        $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
    });
    if ($('#registrationrecaptcha').length > 0) {
        util.renderGoogleInvRecaptcha('registrationrecaptcha', '#registrationSubmitButton', 'RegistrationForm');
    }

}

//Removes 'PO Box shipping is not available' caption from address1 field if preference is true
function removePOBoxCaption() {

    if (SitePreferences.ENABLE_POBOX_ADDRESS) {
        var $addressOne = $('input[name$="_address1"]');
        $addressOne.closest(".form-row").find(".form-caption").text('');
        var $addressTwo = $('input[name$="_address2"]');
        $addressTwo.closest(".form-row").find(".form-caption").text('');
    }
}

function addressEvents() {
    $(document).on("click", ".address-create", function (evt) {
        modal.addCustomClass('edit-add-address');
        var _YubinBango = typeof (YubinBango) !== 'undefined' && YubinBango ? YubinBango : '';
        modal.events.onOpen(function () {
            // customaddress.init();
            if (_YubinBango) {
                new _YubinBango.MicroformatDom();
            }
            validator.initForm('form[id="EditAddressForm"]');
            removePOBoxCaption();
            initCleanAutoFill.init();
        });

        modal.renderByUrl(Urls.checkoutAddAccountAddress);
    });

    $(document).on("click", ".address-edit", function (evt) {
        var element = document.getElementById(evt.currentTarget.id);
        var addressID = element.dataset.addressId;
        var url = Urls.checkoutEditAccountAddress + addressID;

        modal.setCallback(function () {
            initCleanAutoFill.init();
        });
        var _YubinBango = typeof (YubinBango) !== 'undefined' && YubinBango ? YubinBango : '';
        modal.events.onOpen(function () {
            if (_YubinBango) {
                new _YubinBango.MicroformatDom();
            }
            validator.initForm('form[id$="EditAddressForm"]');
            removePOBoxCaption();
        });
        modal.addCustomClass('edit-add-address');
        modal.renderByUrl(url);
    });

    var href;
    $(document).on('click', '.address-delete', function (e) {
        e.preventDefault();
        href = $(this).attr('href');
        var popup = new Foundation.Reveal($('#remove-address'));
        popup.open();
        //No button
        $(".addressDelete-modal-btn-cancel").on("click", function () {
            popup.close();
        });
    });

    //Yes button
    $(".addressDelete-modal-btn-ok").on("click", function() {
        var data_json = {};

        if ($('#csrf_token') && $('#csrf_token').length === 1) {
            var csrfTokenVal = $('#csrf_token').val();
            var csrfTokenKey = $('#csrf_token').prop('name');
            data_json[csrfTokenKey] = csrfTokenVal;
        }
        $.ajax({
            type: 'POST',
            url: util.appendParamToURL(href, 'format', 'ajax'),
            dataType: 'json',
            data: data_json,
        }).done(function(data) {
            page.refresh();
        });
    });

    $(document).on('click', '.address-make-default', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var data_json = {};

        if ($('#csrf_token') && $('#csrf_token').length === 1) {
            var csrfTokenVal = $('#csrf_token').val();
            var csrfTokenKey = $('#csrf_token').prop('name');
            data_json[csrfTokenKey] = csrfTokenVal;
        }

        $.ajax({
            type: 'POST',
            url: util.appendParamToURL(href, 'format', 'ajax'),
            data: data_json,
        }).done(function (data) {
            page.refresh();
        });
    });

    $(document).on("click", ".show-hanatsubaki-modal", function (e) {
        e.preventDefault();
        var $hanatsubakiContent = $("#hanatsubaki-modal");
        modal.addCustomClass('normal-modal');
        modal.renderContent($hanatsubakiContent.html());
    });
}

function enableCountryField(status) {
    var countryField = $('select[id$="billing_billingAddress_addressFields_country"]');
    if (status) {
        countryField.prop('disabled', false);
    } else {
        countryField.prop('disabled', true);
    }
}

function initContactUs() {
    var registrationForm = $('form#ContactUSForm');

    $(document).on('click', 'button#sendBtn', function (e) {
        e.preventDefault();
        $.ajax({
                url: util.appendParamToURL(Urls.customerServiceSubmit, 'format', 'ajax'),
                data: registrationForm.serialize(),
                method: 'POST'
            })
            .done(function (response) {
                if (response.status) {
                    var popup = new Foundation.Reveal($('#customer-contact-us-modal'));
                    //Window height minus 80px, which sets the modal to fit inside the device's screen
                    var windowHeight = window.innerHeight - 130;

                    popup.$element.children('.modal-body').css('max-height', windowHeight);
                    popup.open();
                    $(document).trigger("gtmcontactus");
                    clearContactUsForm(response.status);
                    registrationForm[0].reset();
                } else if (response.status == false) {
                    clearContactUsForm(response.status);
                } else {
                    clearContactUsForm(response.status);
                }
            });
    });
    /**
     * Re-validate contact us form when country is changed
     */
    registrationForm.find('select.country').change(function() {
        registrationForm.find('.form-row.required').find('input, select, textarea').blur();
    });
}

/**
 * Clear contact us form
 */
function clearContactUsForm(status) {
    let widgetOpt = util.getGoogleRecaptchaWidgetOptionNum('ContactUSForm');
    if (util.getGoogleRecaptchaEnableStatus('ContactUSForm') == true && widgetOpt != undefined) {
        util.resettingGoogleInvRecaptcha(widgetOpt, 'ContactUSForm');
    }
    if (status !== undefined && status !== null && status) {
        $('.error-form.gicErrorMessage').hide();
        $('input[name$="_contactus_firstname"]').val('');
        $('input[name$="_contactus_lastname"]').val('');
        $('input[name$="_contactus_email"]').val('');
        $('input[name$="_contactus_phone"]').val('');
        $('input[name$="_contactus_ordernumber"]').val('');
        $('textarea[name$="_contactus_comment"]').val('');
        //$('form#RegistrationForm button[type="submit"]').prop('disabled', true);
    } else if (status !== undefined && status !== null && status == false) {
        $('.error-form.gicErrorMessage').attr('style', 'display: block !important');
    } else {
        $('.error-form.gicErrorMessage').hide();
    }
}

function enableDisableSubmitButton(el) {
    var $saveBtn = $(el).closest('form').find('button[type="submit"]');

    var hasError = $saveBtn.closest('form').find('span.error');
    if (hasError.length) {
        //        $saveBtn.prop('disabled', true);
    } else {
        $saveBtn.prop('disabled', false);
    }
}

function setGender() {
    var gender = $('.gender select').data('gender');

    $('.gender select').val(gender);
}

function getBirthday(birthmonth, dob, birthyear) {
    var birthday = [
        birthmonth,
        '/',
        dob,
        '/',
        birthyear
    ].join('');

    if (birthday === '00/00/' || birthday === '0/0/') {
        birthday = '';

        $('.birthmonth select').val('00');
        $('.dob select').val('00');
    }

    $('.birthday input').val(birthday);
}

function setBirthday() {
    var birthmonth = ('0' + $('.birthmonth select').data('birthmonth')).slice(-2) || Number('00');
    var dob = ('0' + $('.dob select').data('dob')).slice(-2) || Number('00');
    var birthyear = $('.birthyear input').data('birthyear');

    $('.birthmonth select').val(birthmonth);
    $('.dob select').val(dob);
    $('.birthyear input').val(birthyear);

    getBirthday(birthmonth, dob, birthyear);
}

function setNewBirthday(birthmonth, dob, birthyear) {
    var monthField = $('.birthmonth select');
    var dayField = $('.dob select');
    var yearField = $('.birthyear input');

    var month = ~~birthmonth ? birthmonth : '';
    var day = ~~dob ? dob : '';
    var year = ~~birthyear ? birthyear : '';

    monthField.siblings('.error').remove();
    monthField.removeClass('-error-pad');
    dayField.removeClass('-error-pad');
    yearField.removeClass('-error-pad');

    if (month || day || year) {
        var now = new Date();
        var birthday = new Date(birthyear, birthmonth - 1, dob, 0, 0, 0, 0);
        var dateRegex = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
        var formattedDate = [day, '-', month, '-', year].join('');
        var validDate = dateRegex.test(formattedDate);

        if (!month.match(/^[\d]{1,2}$/) ||
            !day.match(/^[\d]{1,2}$/) ||
            !year.match(/^[\d]{4}$/) ||
            !birthday.getTime() ||
            now.getTime() <= birthday.getTime() ||
            !validDate) {

            $('<span class="error">' + Resources.INVALID_BIRTHDAY + '</span>').insertBefore(monthField);
            monthField.addClass('-error-pad');
            dayField.addClass('-error-pad');
            yearField.addClass('-error-pad');
        }
    }

    getBirthday(birthmonth, dob, birthyear);

    var hasError = $('#profile-save-changes').closest('form').find('span.error');

    if (hasError.length) {
        $('#profile-save-changes').prop('disabled', true);
    } else {
        $('#profile-save-changes').prop('disabled', false);
    }
}

function updateBirthday() {
    var birthday = $('.birthday input').val();
    var birthmonth = $('.birthmonth select').val();
    var dob = $('.dob select').val();
    var birthyear = $('.birthyear input').val();

    $('.birthmonth select').on("change", function () {
        birthmonth = $(this).val();
        setNewBirthday(birthmonth, dob, birthyear);
    });

    $('.dob select').on("change", function () {
        dob = $(this).val();
        setNewBirthday(birthmonth, dob, birthyear);
    });

    $('.birthyear input').on('keydown blur', function () {
        birthyear = $(this).val();

        setNewBirthday(birthmonth, dob, birthyear);
    })
}

function creditCardTypeDetector(options) {

    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),

        // MasterCard
        mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

        // American Express
        amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

        //Discover
        discover_regex = new RegExp('^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'),

        //JCB
        unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

    $('.cc-number input').focusout(function (e) {
        var cur_val = $(this).val();

        //Commenting this out since the event is handled on focusout
        // if ( cur_val.length == 16 ) {
        //     e.preventDefault();
        //     return;
        // }

        var $ccNumberContain = $(this).parents('.cc-number');

        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            $ccNumberContain.addClass('is_visa');
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_visa');
        }

        if (cur_val.match(mastercard_regex)) {
            $ccNumberContain.addClass('is_mastercard');
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            $ccNumberContain.addClass('is_amex');
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_amex');
        }

        if (cur_val.match(discover_regex)) {
            $ccNumberContain.addClass('is_discover');
            $creditCard.find('input[name$="_type"]').val("Discover").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_discover');
        }

        if (cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) &&
            !cur_val.match(amex_regex) && !cur_val.match(discover_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
        } else {
            $ccNumberContain.removeClass('is_nothing');
        }
    });

};

function scrollToPasswordChange() {
    if ($('.b-password-change .password-changed').length > 0) {
        $('.account-left-nav .active-menu').trigger("click");
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#ChangePasswordForm").offset().top
        }, 800);
    }
}

function showPopupDetail() {
    $(document).on('click', '.js_giftproductdetail' , function(e) {
        e.preventDefault();

        var url = Urls.productExchangeDetail;
        url = util.appendParamToURL(url, 'format', 'ajax');
        var pid = $(this).data('pid');
        var originURL = location.href;
        var data = {
            pid: pid,
            originURL: originURL
        };

        $.ajax({
            type: 'GET',
            url: url,
            dataType: 'html',
            data: data,
            success: function (response) {
                if (typeof response === 'object' && !response.isUserAuthenticated) {
                    var redirectURL = response.redirectURL;
                    location.href = redirectURL;
                } else if (typeof response === 'string') {
                    modal.addCustomClass('normal-modal giftproductdetail-modal');
                    modal.renderContent(response);
                }
            },
            failure: function () {
                modal.addCustomClass('normal-modal');
                modal.renderContent(Resources.SERVER_ERROR);
            }
        });
    });
}

function hidePersonalNumberForOverseasCustomer () {
    $(document).on('change', 'select[id$="_addressFields_country"]' , function() {
        var countryCode = $(this).val();
        var personalNumberElement = $('div.personal-number');
        countryCode.toUpperCase() === 'JP' ? personalNumberElement.addClass('hidden') : personalNumberElement.removeClass('hidden');
    })
    $('select[id$="_addressFields_country"]').trigger('change');
}

function unsubscribe() {
    var questionnaire = $('input[name$="_unsubscribe_questionnaire"]').val();
    var reasonConfirm = $('.unsubscribe-confirm').find('.reason-confirm');

    $('input[name$="questionnaire[]"]').each(function() {
        $(this).on('change', function () {
            setValueQuestionnaireToHiddenField();
            var questionnaireToValidate = $('input[name$="_unsubscribe_questionnaire"]').val();
            if (questionnaireToValidate) {
                reasonConfirm.addClass('hidden');
            } else {
                reasonConfirm.removeClass('hidden');
            }
        });
    });

    if (questionnaire) {
        $('input[name$="questionnaire[]"]').each(function() {
            if (questionnaire.indexOf($(this).val()) > -1) {
                $(this).prop('checked', true).attr('checked', true);
            }
        });
    }

    function setValueQuestionnaireToHiddenField() {
        var currentQuestionnaire = [];
        var questionnaireElement = $('input[name$="_unsubscribe_questionnaire"]');
        var questionnaireField = $('.questionnaire-field');

        $('input:checked[name$="questionnaire[]"]').each(function () {
            currentQuestionnaire.push($(this).val());
        });

        if (questionnaireField.find(questionnaireElement).is(':checked').length === 0) {
            currentQuestionnaire = [];
        }

        questionnaireElement.val(currentQuestionnaire.join(','));
    };

    $('.unsubscribe-confirm').on('click', '.btn-unsubscribe-popup', function(e) {
        e.preventDefault();
        setValueQuestionnaireToHiddenField();
        if ($('input[name$="_unsubscribe_questionnaire"]').val()) {
            reasonConfirm.addClass('hidden');
            modal.renderByUrl(Urls.unsubscribePopup);
        } else {
            reasonConfirm.removeClass('hidden');
        }
    });

    $(document).on('click', '.unsubscribe-popup #close-cancel-confirm', function(e){
        e.preventDefault();
        dialog.close();
    });
}

function handlePaymentList () {
    function setValueSecretToHiddenField(cardSeq, deleteUrl, typeCard, nameCard, expired) {
        var $form = $('.payment.payment-popup').find('form');
        $form.find('input[name="cardSeq"]').val(cardSeq);
        $form.find('.type-card').text(typeCard);
        $form.find('.name-card').text(nameCard);
        $form.find('.expired-card').text(expired);
        $form.attr("action", deleteUrl);
    };

    $('.account-edit').on('click','button.delete', function (e) {
        e.preventDefault();
        var $form = $(this).parent('form');
        var cardSeq =  $form.find('input[name="cardSeq"]').val();
        var actionUrl = $(this).closest('form').attr('action');
        var deleteUrl = actionUrl + '?page=EditProfile';
        var $info = $(this).closest('.creditcard-tile-inner').find('.cc-details');
        var typeCard = $info.find('.cc-number').text();
        var nameCard = $info.find('.cc-owner').text();
        var expired = $info.find('.cc-exp').text();
        var ajaxUrl = Urls.confirmDeleteCardPopup;

        $.ajax({
            url: ajaxUrl,
            method: 'GET',
            dataType: 'html'
        }).done (function (data) {
            modal.events.onOpen(function() {
                setValueSecretToHiddenField(cardSeq, deleteUrl, typeCard, nameCard, expired);
            })
            modal.addCustomClass('normal-modal remove-card');
            modal.renderContent(data);
        });
        return;

    });
    $(document).on('click', '#submit-delete-card', function(e){
        e.preventDefault();
        var applyName = $(this).attr('name');
        var data = $('.payment.payment-popup').find('form').serialize();

        var ajaxUrl = Urls.confirmDeleteCard;
        $.ajax({
            type: 'POST',
            data: data + '&' + applyName + '=x',
            url: util.appendParamToURL(ajaxUrl, 'format', 'ajax')
        })
        .done(function (result) {
            if('OK' == result.status){
                $('.remove-card').foundation('close');
                page.refresh();
            } else {
                $('.error-message').text(result.message);
                $('.error-message').removeClass('hide');
                return;
            }
        })
        .error(function (result) {
            $('.remove-card').foundation('close');
            page.refresh();
        })
    });

    $(document).on('click', '#close-cancel-confirm', function(e){
        e.preventDefault();
        $('.remove-card').foundation('close');
    });

    creditCardValidator.init({
        wrapper: '#wrapper .account-edit form[id$="CreditCardForm"]'
    });
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
    cardValidation.init();
    // customaddress.init();
    toggleFullOrder();
    //initAddressEvents();
    initPaymentEvents();
    login.init();
    accountSelectDate.init();
    accountPersonalData.init();
    registerAccountEvents();
    addressEvents();
    initContactUs();
    mobileAccountMenu();
    setGender();
    setBirthday();
    updateBirthday();
    search.viewMore();
    scrollToPasswordChange();
    showPopupDetail();
    unsubscribe();
    handlePaymentList();
    initCleanAutoFill.init();
    hidePersonalNumberForOverseasCustomer();
}


var account = {
    init: function () {
        initializeEvents();
        giftcert.init();
    },
    initCartLogin: function () {
        login.init();
    },
    initMobileMenu: function () {
        mobileAccountMenu();
    }
};

module.exports = account;
},{"../account-select-date":1,"../account-validate-dob":2,"../address-book":3,"../credit-card-validator":15,"../dialog":16,"../giftcert":21,"../login":26,"../modal":28,"../page":31,"../tooltip":86,"../util":87,"../validator":88,"./checkout/card-validation":37,"./customaddress":45,"./search":59}],33:[function(require,module,exports){
'use strict';

var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    quickview = require('../quickview'),
    images = require('./product/image'),
    variant = require('./product/variant'),
    giftShipping = require('./checkout/shipping'),
    recommendations = require('./product/recommendations'),
    cartStoreInventory = require('../storeinventory/cart'),
    modal = require('../modal').global,
    samples = require('../samples'),
    giftCert = require('../giftcert-modal'),
    login = require('./checkout/login'),
    util = require('../util');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    $('#cart-table').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        quickview.show({
            url: e.target.href,
            source: 'cart',
            callback: function() {
                variant();
                renderThumbnails();
            }
        });
    })
    .on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });

    // override enter key for coupon code entry
    $('input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13 && $(this).val().length === 0) { return false; }
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('button[name$="deleteProduct"]').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
        }
    });


    // product level bonus modal
    $('div.bonus-item-promo').on('click', 'a.select-bonus', function (e) {
        e.preventDefault();

        var urlToRender = $(this).attr('href');
        if (urlToRender) {
            modal.addCustomClass('bonus-item-modal');
            modal.renderByUrl(urlToRender);
        }
    });

    $(document).on('click', 'a#selectsample', function(e){
        samples.showSelectionInCart();
    })
    .on('click', 'a#pointexchangeproduct', function(){
        samples.showPointExchangeInCart();
    })
    .on('click', '.paypal-container a', function(e) {
        e.preventDefault();

        var cartCheckoutForm = $('.cart-action-checkout');
        if (cartCheckoutForm.length > 0) {
            cartCheckoutForm.attr('action', Urls.cartPaypalCheckout);
            cartCheckoutForm.trigger("submit");
        }
    });
    
    // Add to Wishlist and Add to Gift Registry links behaviors
    $(document.body).on('click', '.save-for-later-cart', function () {
    	if( $('.pdpForm:visible').length > 0 ){
    		var data = util.getQueryStringParams($('.pdpForm').serialize());
    		var url = util.appendParamsToUrl(this.href, data);
    	}else{
    		var data = $(this).parents(".quantity-column").find(".quantity-select").val();
    	    var url = util.appendParamToURL(this.href, "Quantity", data);
    	}

    	this.setAttribute('href', url);
    });
}

function renderThumbnails(){
    if($('#thumbnails').length > 0){
        $('#thumbnails').empty();   // clear the list
        images();                   // populate the thumbnails
    }
};

function isGift () {
    var isGift = (sessionStorage.getItem('isGift') === 'true');
    var isGiftName = [
        $('#cart-items-form').attr('name'),
        'isGift'
    ].join('_');

    $('#checkout-form .is-gift').val(isGift);
    $('#checkout-form .is-gift').attr('name', isGiftName);
    $('.gift-container .input-checkbox').attr('checked', isGift);
    $('.gift-container .input-checkbox').on("change", function () {
        isGift = $(this).is(':checked');

        if (!isGift) {
            $('.gift-container .input-textarea').val('');
            $('#checkout-form .gift-message').val('');
            $('#checkout-form button').prop('disabled', false);// Added by ADe to enable Checkout button
            $('.third-party-container').css('opacity',1);
            $('.third-party-container').css('pointer-events','all');
            //Ade
            if ($('.gift-message-textarea span.error:visible').length > 0) {
                $('.gift-message-textarea span.error').remove();
            }
            sessionStorage.removeItem('isGift');
            sessionStorage.removeItem('giftMessage');
        } else {
            $('.gift-container .input-textarea').trigger("keyup");
            sessionStorage.setItem('isGift', isGift);
        }

        $('#checkout-form .is-gift').val(isGift);
    });
}

function giftMessage () {
    var giftMessage = sessionStorage.getItem('giftMessage') ? sessionStorage.getItem('giftMessage') : '';
    var giftMessageName = [
        $('#cart-items-form').attr('name'),
        'giftMessage'
    ].join('_');

    $('#checkout-form .gift-message').val(giftMessage);
    $('#checkout-form .gift-message').attr('name', giftMessageName);
    $('.gift-container .input-textarea').val(giftMessage);
    $('.gift-container .input-textarea').on('keyup', function () {
        giftMessage = $(this).val().trim();

        if (giftMessage === '' || util.validateMessage(giftMessage)) {
            $('#checkout-form .gift-message').val(giftMessage);
            $('.gift-message-textarea .form-caption').removeClass('error-message');
            $('.gift-message-textarea .form-caption').empty();
            $('#checkout-form button').prop('disabled', false);
            $('.third-party-container').css('opacity',1);
            $('.third-party-container').css('pointer-events','all');
            sessionStorage.setItem('giftMessage', giftMessage);
        } else {
            $('.gift-message-textarea .form-caption').addClass('error-message');
            $('.gift-message-textarea .form-caption').text('Invalid message');
            $('#checkout-form button').prop('disabled', true);
            $('.third-party-container').css('opacity',0.5);
            $('.third-party-container').css('pointer-events','none');
        }
    });
}

function couponCodeEvent () {
    $('.cart-coupon-code input').on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#add-coupon').on("click");
        }
    })
}

function updateCart () {
    $('.item-quantity select').on("change", function () {
        $('#cart-items-form').trigger("submit");
    });
}

function cartCount () {
    if ($('.cart-empty').length) {
        sessionStorage.removeItem('isGift');
        sessionStorage.removeItem('giftMessage');
    }
}

exports.init = function () {
    login.init();
    initializeEvents();
    recommendations();
    isGift();
    giftMessage();
    updateCart();
    couponCodeEvent();
    cartCount();
    giftShipping.init();
    giftCert.init();

    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }

    account.initCartLogin();
};

},{"../bonus-products-view":9,"../giftcert-modal":20,"../modal":28,"../quickview":77,"../samples":79,"../storeinventory/cart":82,"../util":87,"./account":32,"./checkout/login":40,"./checkout/shipping":42,"./product/image":51,"./product/recommendations":54,"./product/variant":56}],34:[function(require,module,exports){
'use strict';

var formPrepare = require('./checkout/formPrepare'),
	validator = require('../validator');

/**
 * @private
 * @function
 * @description Validates if check order form is filled out before enabling button
 */
function initializeEvents() {
	validator.initForm('form[id$="ordertrack"]');
}

exports.init = function () {
    initializeEvents();

}

},{"../validator":88,"./checkout/formPrepare":38}],35:[function(require,module,exports){
'use strict';

var util = require('../../util');
var shipping = require('./shipping');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('.address');
    // select address from list
    $('select[name$="_addressList"]', $form).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) { return; }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        // re-validate the form
        $form.validate().form();
    });
};

},{"../../util":87,"./shipping":42}],36:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    progress = require('../../progress'),
    giftcard = require('../../giftcard'),
    util = require('../../util'),
    page = require('../../page'),
    modal = require('../../modal').global,
    cardValidation = require('./card-validation'),
    validator = require('../../validator'),
    creditCardValidator = require('../../credit-card-validator'),
    customaddress = require('../customaddress'),
    initCleanAutoFill = require('../../address-book');

var $cache;

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
    var $paymentMethods = $('.payment-method');
    //$paymentMethods.removeClass('payment-method-expanded');

    var dataMethod = paymentMethodID;
    if (paymentMethodID == 'SA_SILENTPOST') {
        dataMethod = 'CREDIT_CARD';
    }

    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + dataMethod + '"]');
    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }

    if (paymentMethodID == "VISA_CHECKOUT") {
        $(".continue-place-order").hide();
        $(".visacheckoutbutton").show();
    } else if (paymentMethodID == "PAYPAL" || paymentMethodID == "PAYPAL_CREDIT") {
        $("#billingAgreementCheckbox").attr('checked', false);
        $(".continue-place-order").hide();
    } else if (paymentMethodID == "AFTERPAY_PBI" || paymentMethodID == "GMO_PAYMENT_ALIPAY" || paymentMethodID == "GMO_PAYMENT_UNION" || paymentMethodID == "NO_PAYMENT" || paymentMethodID=="GMO_PAYMENT_CVS") {
        if ($("#dwfrm_billing").length > 0) {
            $("#dwfrm_billing").validate().resetForm();
            if ($("#dwfrm_billing").validate().numberOfInvalids() > 0) {
                $("#dwfrm_billing").validate().invalid = {};
            }
            $('select[name*="dwfrm_billing_paymentMethods_creditCard"],input[name*="dwfrm_billing_paymentMethods_creditCard"]').addClass("ignore");
            $('.creditcard-tile').removeClass('selected')
        }
    } else if (paymentMethodID == "CREDIT_CARD") {
        $('select[name*="dwfrm_billing_paymentMethods_creditCard"],input[name*="dwfrm_billing_paymentMethods_creditCard"]').removeClass("ignore");
        if ($("#dwfrm_billing").length > 0)
            $("#dwfrm_billing").validate().resetForm();
    } else {
        $(".continue-place-order").show();
        $(".visacheckoutbutton").hide();
    }

    if (paymentMethodID == "CREDIT_CARD" || paymentMethodID == "SA_SILENTPOST") {
        $(".spsavecard").show();
    } else if ((paymentMethodID == "SA_REDIRECT" || paymentMethodID == "SA_IFRAME") && SitePreferences.TOKENIZATION_ENABLED) {
        $(".spsavecard").show();
    } else {
        $(".spsavecard").hide();
    }

    //$selectedPaymentMethod.addClass('payment-method-expanded');

    // ensure checkbox of payment method is checked
    $('input[name$="_selectedPaymentMethodID"]').prop('checked', false);
    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');
    //$('input[name$="_selectedPaymentMethodID"]').val(paymentMethodID);

}

function creditCardTypeDetector(options) {

    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),

        // MasterCard
        mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

        // American Express
        amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

        //Discover
        discover_regex = new RegExp('^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'),

        //JCB
        unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

    $('.cc-number input').focusout(function(e) {
        var cur_val = $(this).val();

        //Commenting this out since the event is handled on focusout
        // if ( cur_val.length == 16 ) {
        //     e.preventDefault();
        //     return;
        // }
        var $ccNumberContain = $(this).parents('.cc-number');

        var piCardType = '';
        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            piCardType = 'visa';
            $ccNumberContain.addClass('is_visa');
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_visa');
        }

        if (cur_val.match(mastercard_regex)) {
            piCardType = 'mastercard';
            $ccNumberContain.addClass('is_mastercard');
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            piCardType = 'amex';
            $ccNumberContain.addClass('is_amex');
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_amex');
        }

        if (cur_val.match(discover_regex)) {
            piCardType = 'discover';
            $ccNumberContain.addClass('is_discover');
            $creditCard.find('input[name$="_type"]').val("Discover").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_discover');
        }

        if (cur_val.match(unionpay_regex)) {
            piCardType = 'unionpay';
            $ccNumberContain.addClass('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) &&
            !cur_val.match(amex_regex) && !cur_val.match(discover_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
        } else {
            $ccNumberContain.removeClass('is_nothing');
        }
    });

};

function checkGiftCert() {
    var $balance = $('div#gift-card-balance-form .balance');
    var $error = $('div#gift-card-balance-form .balance-error');
    var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
    var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

    $error.html('');
    $balance.html('');
    if ($giftCode.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_INVALID);
        return;
    } else if ($giftCode.val().length !== 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_PIN_INVALID);
        return;
    } else if ($giftCode.val().length === 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
        return;
    }

    giftcard.checkBalance($giftCode.val(), $giftPin.val(), function(data) {
        if (data && data.error) {
            return $error.html(data.error);
        }

        if (!data || !data.giftCertificate) {
            $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
            return;
        }

        if (!data || !data.giftCertificate) {
            $balance.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('error');
            return;
        }

        $balance.html(Resources.GIFT_CERT_CURRENT_BALANCE + ' ' + data.giftCertificate.balance);

        $giftCode.attr('disabled', "true");
        $giftPin.attr('disabled', "true");
        $('button#check-giftcert-modal').addClass('hide');
        $('button#add-giftcert-modal').removeClass('hide');
        $('button#new-giftcert-modal').removeClass('hide');
    });
};

function applyGiftCert() {
    var $error = $('div#gift-card-balance-form .balance-error');
    var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
    var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

    $error.html('');
    if ($giftCode.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_INVALID);
        return;
    }
    /*else if ($giftCode.val().length !== 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_PIN_INVALID);
        return;
    } else if ($giftCode.val().length === 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
        return;
    }*/

    var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
        giftCertCode: $giftCode.val(),
        giftCertPIN: $giftPin.val(),
        format: 'ajax'
    });
    $.getJSON(url, function(data) {
        var fail = false;
        var msg = '';
        if (!data) {
            msg = Resources.BAD_RESPONSE;
            fail = true;
        } else if (!data.success) {
            msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
            fail = true;
        }
        if (fail) {
            $error.html(msg);
            return;
        } else {
            window.location.assign(Urls.billing);
        }
    });
};

function initCache() {
    $cache = {};

    $cache.checkoutForm = $(".checkout-billing");
    $cache.selectedCardIdInput = $cache.checkoutForm.find('input[name$="_selectedCardID"]');
}

function initCreditCardForm() {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    $cache.checkoutForm.find('input[name*="_number"]').val('');
    $cache.checkoutForm.find('select[name*="_month"]').val('').trigger("change");
    $cache.checkoutForm.find('select[name*="_year"]').val('').trigger("change");
    $cache.checkoutForm.find('input[name*="_owner"]').val('');

    var $ccContainer = $cache.checkoutForm.find(".payment-method").filter(function() {
        return $(this).data("method") == "CREDIT_CARD";
    });

    $ccContainer.find('input[name*="_number"]').on('change', function(e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });
    $ccContainer.find('input[name$="_owner"]').on('change', function(e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });

    $ccContainer.find('select[name*="expiration"]').on('change', function(e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');

        var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
        var cardNumber = $cache.checkoutForm.find('input[name*="_number"]').val();
        if (cardNumber.indexOf('****') != -1 && selectedPaymentMethodID == 'SA_SILENTPOST') {
            $cache.checkoutForm.find('input[name*="_number"]').val('');
        }
    });
}

function setSelectedCardID(uuid) {
    $cache.selectedCardIdInput.val(uuid);
}

function clearSelectedCardID() {
    $cache.selectedCardIdInput.val('');
}

function setCCType(ccType) {
    $cache.checkoutForm.find('input[name$="_type"]').val(ccType);
}

function enableCountryField(status) {
    var countryField = $('select[id$="billing_billingAddress_addressFields_country"]');
    if (status) {
        countryField.prop('disabled', false);
    } else {
        countryField.prop('disabled', true);
    }
}

function addCVNEvent() {
    $('input[name$="creditCard_cvn"]').on('keydown', function(e) {
        if (e.key.toString().match(/[\d]/) ||
            $.inArray(e.keyCode, [8, 9, 13, 46, 33, 34, 35, 36, 37, 38, 39, 40]) >= 0) {
            // do nothing
        } else {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    });
}

function initGiftCardBalance() {
    var $checkoutForm = $('.checkout-billing');
    var $addGiftCert = $('#add-giftcert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $giftCertPin = $('input[name$="_giftCertPIN"]');
    var $addCoupon = $('#add-coupon');
    var $couponCode = $('input[name$="_couponCode"]');

    // Check Balance button is clicked in Check Balance Modal
    $(document).off('click', 'button#check-giftcert-modal');
    $(document).on('click', 'button#check-giftcert-modal', function(e) {
        e.preventDefault();
        checkGiftCert();
    });

    // Check Another Card button is clicked in Check Balance Modal
    $(document).off('click', 'button#new-giftcert-modal');
    $(document).on('click', 'button#new-giftcert-modal', function(e) {
        var $balance = $('div#gift-card-balance-form .balance');
        var $error = $('div#gift-card-balance-form .balance-error');
        var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
        var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

        $balance.html('');
        $error.html('');
        $giftCode.val(null).prop('disabled', false);
        $giftPin.val(null).prop('disabled', false);

        $('button#add-giftcert-modal').addClass('hide');
        $('button#new-giftcert-modal').addClass('hide');
        $('button#check-giftcert-modal').removeClass('hide');
    });

    // Apply button is clicked in Check Balance Modal
    $(document).off('click', 'button#add-giftcert-modal');
    $(document).on('click', 'button#add-giftcert-modal', function(e) {
        e.preventDefault();
        applyGiftCert();
    });

    $addGiftCert.off();
    $addGiftCert.on('click', function(e) {
        e.preventDefault();
        var code = $giftCertCode.val();
        var pin = $giftCertPin.val();
        //var $error = $checkoutForm.find('.giftcert-error');
        var $error = $checkoutForm.find('.apply-error');

        // clear all errors
        $(this).closest('form').find('span.error').remove();

        $error.html('');
        if (code.length === 0) {
            $error.html(Resources.GIFT_CARD_CODE_INVALID);
            return;
        } else if (code.length !== 0 && pin.length === 0) {
            $error.html(Resources.GIFT_CARD_PIN_INVALID);
            return;
        } else if (code.length === 0 && pin.length === 0) {
            $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
            return;
        }

        var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
            giftCertCode: code,
            giftCertPIN: pin,
            format: 'ajax'
        });
        $.getJSON(url, function(data) {
            var fail = false;
            var msg = '';
            if (!data) {
                msg = Resources.BAD_RESPONSE;
                fail = true;
            } else if (!data.success) {
                msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
                fail = true;
            }
            if (fail) {
                $error.html(msg);
                return;
            } else {
                window.location.assign(Urls.billing);
            }
        });
    });

    $giftCertCode.off();
    $giftCertCode.on('keydown', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            $addGiftCert.trigger("click");
        }
    });
}

//Removes 'PO Box shipping is not available' caption from address1 field if preference is true
function removePOBoxCaption() {

    if (SitePreferences.ENABLE_POBOX_ADDRESS) {
        var $addressOne = $('input[name$="_address1"]');
        $addressOne.closest(".form-row").find(".form-caption").text('');
        var $addressTwo = $('input[name$="_address2"]');
        $addressTwo.closest(".form-row").find(".form-caption").text('');
    }
}

/**
 * Set User's shipping default submitted address to be setting
 * as default billing address on Billing column.
 * We have set by getting the SAMEASSHIPPING forms submitted value on
 * Billing Continue submit(Continue To Review) of SFCC form framework.
 * */
function setDefaultMPCSameAsShippingAddressCheckbox() {
    let $sameAsShippingAdrs = $('#secondary .mpcBillingAdresSameAsShippingAdrs');
    let $sameAsShippingAddressChk = $('input#same-as-shipping');
    if ($sameAsShippingAdrs.length > 0) {
        let billingAddresSameAsShippingadrs = $sameAsShippingAdrs.attr('data-mpc-sameasshippingaddress');
        if (billingAddresSameAsShippingadrs !== undefined && billingAddresSameAsShippingadrs == 'true') {
            $sameAsShippingAddressChk.prop('checked', true);
            $sameAsShippingAddressChk.trigger('change');
        } else {
            $sameAsShippingAddressChk.prop('checked', false);
        }
    }
}

function check_cvs() {
    if($('input[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID][value=GMO_PAYMENT_CVS]').is(":checked")) {
        $('input[name=dwfrm_convenience_convenienceStore]').addClass('required');
        $('.gmo_payment_cvs.form-row').addClass('required');
        $('.payment-notice').addClass('has-validation');
    }
    else {
        $('input[name=dwfrm_convenience_convenienceStore]').removeClass('required error');
        $('.gmo_payment_cvs.form-row').removeClass('required');
        $('.payment-notice').removeClass('has-validation');
    }
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function() {
    cardValidation.init();
    customaddress.init();
    initCache();
    initCreditCardForm();
    initGiftCardBalance();
    initCleanAutoFill.init();
    check_cvs();

    var $selectPaymentMethod = $('.selectable-payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find('input[name="dwfrm_billing_paymentMethods_selectedPaymentMethodID"]:checked').val();

    validator.initForm('form[id$="billing"]');
    removePOBoxCaption();

    function toggleBillingAddressFields(visible) {
        if (window.User.isCustomerAuthenticated == false) {
            $('.checkout-billing').find('.set-default-cb').hide();
        }
    }

    $(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country, #dwfrm_billingaddress_country', function() {
        toggleBillingAddressFields();
    });
    $('input#same-as-shipping').on('change', function() {
        var sameascheckbox = $(this);

        if (sameascheckbox.is(":checked")) {
            $('.saved-addresses.select-billing-address').addClass('hide');
            $('.saved-addresses.default-billing-address').removeClass('hide');

            $('#dwfrm_billing_billingAddress_addressFields_firstName').val($('#dwfrm_billing_billingAddress_addressFields_firstName').attr('data-firstname'));
            $('#dwfrm_billing_billingAddress_addressFields_lastName').val($('#dwfrm_billing_billingAddress_addressFields_lastName').attr('data-lastname'));
            $('#dwfrm_billing_billingAddress_addressFields_address1').val($('#dwfrm_billing_billingAddress_addressFields_address1').attr('data-address1'));
            $('#dwfrm_billing_billingAddress_addressFields_address2').val($('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2'));
            $('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
            $('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
            $('#dwfrm_billing_billingAddress_addressFields_postal').val($('#dwfrm_billing_billingAddress_addressFields_postal').attr('data-postal'));
            $('#dwfrm_billing_billingAddress_addressFields_country').val($('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country'));
            $('#dwfrm_billing_billingAddress_addressFields_states_state').val($('#dwfrm_billing_billingAddress_addressFields_states_state').attr('data-state'));
            $('#dwfrm_billing_billingAddress_addressFields_phone').val($('#dwfrm_billing_billingAddress_addressFields_phone').attr('data-phone'));
            sameascheckbox.val('true');
            toggleBillingAddressFields(true);

            var selectedShipping = $('div.default-billing-address div.address-tile');
            if (selectedShipping) {
                selectedShipping.removeClass('selected');
                selectedShipping.removeClass('default');
                selectedShipping.trigger('click');
            }

            //$(this).submit();
        } else {
            $('.saved-addresses.default-billing-address').addClass('hide');
            $('.saved-addresses.select-billing-address').removeClass('hide');

            var prefAddress = $('div.select-billing-address div.address-tile');
            if (prefAddress) {
                prefAddress.removeClass('selected');
                prefAddress.removeClass('default');
                prefAddress.trigger('click');
            }

            sameascheckbox.val('false');
            toggleBillingAddressFields();
        }
    });

    // default payment method to 'CREDIT_CARD'
    updatePaymentMethod((selectedPaymentMethod) ? selectedPaymentMethod : 'CREDIT_CARD');
    $selectPaymentMethod.on('click', 'input[name="dwfrm_billing_paymentMethods_selectedPaymentMethodID"]', function() {
        updatePaymentMethod($(this).val());
    });

    $('.gift-card-form-toggle').on('click', function(e) {
        e.preventDefault();

        var $giftCardForm = $('.gift-card-form');
        var $giftCardCheckLink = $('.check-gift-card');

        $giftCardForm.slideDown().removeClass('rolledup');
        $giftCardCheckLink.removeClass('hide');
        $(this).addClass('hide');
        initGiftCardBalance();

        $('.gift-card-form input[name$="_giftCertCode"], .gift-card-form input[name$="_giftCertPIN"]').on('blur', function(e) {
            var $this = $(this);
            $this.siblings('span.error').remove();
            $this.removeClass('error');
            $('#add-giftcert').prop('disabled', false);
            $('.gift-card-form .apply-error').html('');

            if ($this.val() && !$this.val().trim().match(/^[a-z0-9]+$/i)) {
                $('<span class="error">' + $this.attr('data-required-text') + '</span>').insertBefore($this);
                $this.addClass('error');
            }

            if ($('.gift-card-form span.error').length > 0) {
                // $('#add-giftcert').prop('disabled',true);
            }
        });

    });

    var $giftCardCheckModal = $('#gift-card-balance-modal').detach();
    $('.check-gift-card').on('click', function(e) {
        modal.events.onOpen(function() {
            initGiftCardBalance();

            $('.gift-card-balance-modal input[name$="_giftCertCode"], .gift-card-balance-modal input[name$="_giftCertPIN"]').on('blur', function(e) {
                var $this = $(this);
                $this.siblings('span.error').remove();
                $this.removeClass('error');
                $('.gift-card-balance-modal button#check-giftcert-modal').prop('disabled', false);
                $('.gift-card-balance-modal .balance-error').html('');

                if ($this.val() && !$this.val().trim().match(/^[a-z0-9]+$/i)) {
                    $('<span class="error">' + $this.attr('data-required-text') + '</span>').insertBefore($this);
                    $this.addClass('error');
                }

                if ($('.gift-card-balance-modal span.error').length > 0) {
                    // $('.gift-card-balance-modal button#check-giftcert-modal').prop('disabled',true);
                }
            });
        });
        modal.restoreDefaultClass();
        modal.addCustomClass('gift-card-balance-modal');
        modal.renderContent($giftCardCheckModal.html());
    });


    creditCardTypeDetector();


    $(document).on("click", ".credit-card-create", function(evt) {
        modal.events.onOpen(function() {
            creditCardTypeDetector();
            validator.initForm('form[id$="CreditCardForm"]');
            creditCardValidator.init({
                wrapper: '.medium.add-credit-card form[id$="CreditCardForm"]'
            });
        });
        modal.restoreDefaultClass();
        modal.addCustomClass('medium add-credit-card');
        modal.renderByUrl(Urls.checkoutAddCreditCard);
        modal.setCallback(cardValidation.init);
    });

    $('.payment-method-item').each(function() {
        $(this).find('input[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]').on('change', function(e) {
            $('.cvs-payment-methods-item').find('input[name=dwfrm_convenience_convenienceStore]').prop('checked', false);
            if($('.creditcard-tile').length > 0){
                clearSelectedCardID();
                $('.creditcard-tile').removeClass("selected");
            }
            check_cvs();
        });
    });

    $('.cvs-payment-methods-item').each(function() {
        $(this).on('change', function() {
            $('input[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID][value=GMO_PAYMENT_CVS]').prop('checked', true);
            if($('.creditcard-tile').length > 0){
                $('.creditcard-tile').removeClass("selected");
                return;
            }
            if ($("#dwfrm_billing").length > 0) {
                $("#dwfrm_billing").validate().resetForm();
                if ($("#dwfrm_billing").validate().numberOfInvalids() > 0) {
                    $("#dwfrm_billing").validate().invalid = {};
                }
                $('select[name*="dwfrm_billing_paymentMethods_creditCard"],input[name*="dwfrm_billing_paymentMethods_creditCard"]').addClass("ignore");
            }
        });
    });

    $(document).on("submit", "#CreditCardForm", function(evt) {
        evt.preventDefault();

        var $form = $(this);
        var $formDataError = $('.form-data-error');
        var url = $form.attr('action');
        var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]');

        if (selectedPaymentMethodID && selectedPaymentMethodID.length > 0) {
            var selectedPaymentMethodIDName = selectedPaymentMethodID.prop('name') || '';
            var selectedPaymentMethodIDVal = selectedPaymentMethodID.val() || '';
            if (selectedPaymentMethodIDVal) {
                url = util.appendParamToURL(url, selectedPaymentMethodIDName, selectedPaymentMethodIDVal);
            }
        }

        var selectedCardID = $('input[name$="_selectedCardID"]');

        if (selectedCardID && selectedCardID.length > 0) {
            var selectedCardIDName = selectedCardID.prop('name') || '';
            var selectedCardIDVal = selectedCardID.val() || '';
            if (selectedCardIDVal) {
                url = util.appendParamToURL(url, selectedCardIDName, selectedCardIDVal);
            }
        }

        $.ajax({
            url: util.appendParamToURL(url, 'format', 'ajax'),
            data: $form.serialize() + '&' + $form.find('#add-card-submit-billing').attr('name') + '=x',
            type: 'POST'
        }).done(function(data) {
            if (!data) {
                $formDataError.html(Resources.BAD_RESPONSE);
                return false;
            }

            if (data.length) {
                modal.setContent(data);
                validator.initForm('form[id$="CreditCardForm"]');
                creditCardValidator.init({
                    wrapper: '.medium.add-credit-card form[id$="CreditCardForm"]'
                });
                $('input[id*="newcreditcard_number"]').val('');
                $('input[id*="newcreditcard_number"]').focus();
                $('input[id*="newcreditcard_cvn"]').val('');
                return;
            }

            if (!location.assign(Urls.billing)) {
                window.location.href = Urls.billing;
            }
        });
    });

    $(document).on("click", ".credit-card-edit", function(evt) {
        var element = document.getElementById(evt.currentTarget.id);
        var creditcardPositin = element.dataset.creditcardPosition;
        var url = Urls.checkoutEditCreditCard + creditcardPositin;

        modal.restoreDefaultClass();
        modal.events.onOpen(function() {
            $('.cc-number input').prop('disabled', true);
            validator.initForm('form[id$="CreditCardForm"]');
        });
        modal.addCustomClass('small edit-credit-card');
        modal.renderByUrl(url);

    });

    //select credit card tile
    $(document).on('click', '.creditcard-tile', function(evt) {
        var $this = $(this);
        $('#is-CREDIT_CARD').prop('checked', true);
        $('.cvs-payment-methods-item').find('input[name=dwfrm_convenience_convenienceStore]').prop('checked', false);
        var ccType = $this.find('.creditcard-tile-inner .cc-number').attr('data-cctype');

        if ($(this).is('.selected, .default')) {
            return false;
        } else {
            $('.creditcard-tile').each(function() {
                $(this).removeClass('selected');
                $(this).removeClass('default');
            });

            $this.addClass('selected');
            setSelectedCardID($this.data("uuid"));
            setCCType(ccType);
            check_cvs();
        }

    });
    //added for custom validation for multiple card CVN validation for register customer
    if ($('.payment-list.customerPCLDetails').length > 0) {
        $('.clientsite-cardcvnvalid-error').hide();
        $(document).on('keyup blur focusout keypress', 'input.regcustpclCVN', function(e) {
            var cardCvnLength = $(this).val().length;
            var cvnMinLen = $(this).attr('data-min-length');
            var cvnMaxLen = $(this).attr('data-max-length');
            if (cardCvnLength < cvnMinLen || cardCvnLength > cvnMaxLen) {
                displayCVNErrorMessage('show');
            } else if (cardCvnLength == cvnMinLen || cardCvnLength == cvnMaxLen) {
                displayCVNErrorMessage();
            } else {
                displayCVNErrorMessage();
            }
        });
        var $billingCheckoutForm = $('.checkout-billing');
        if ($billingCheckoutForm.find('button[name $= "billing_save"]').length > 0) {
            $billingCheckoutForm.find('button[name $= "billing_save"]').on('click', function() {
                var cardCVNMinLen = $('.creditcard-tile.selected input.regcustpclCVN').attr('data-min-length');
                var cardCVNMaxLen = $('.creditcard-tile.selected input.regcustpclCVN').attr('data-max-length');
                cardCVNMinLen = (cardCVNMinLen !== undefined && cardCVNMinLen !== '') ? cardCVNMinLen : 0;
                cardCVNMaxLen = (cardCVNMaxLen !== undefined && cardCVNMaxLen !== '') ? cardCVNMaxLen : 0;
                $('.clientsite-cardcvnvalid-error').hide();
                if ($('input[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked').val() == 'CREDIT_CARD') {
                    if ($('#dwfrm_billing_paymentMethods_creditCard_cvn').is(':visible') == true || $('.creditcard-tile').hasClass('selected')) {
                        var cvnobj = $('#dwfrm_billing_paymentMethods_creditCard_cvn').val();
                        let cvnObjLen = (cvnobj !== '' && cvnobj !== undefined && cvnobj != null) ? cvnobj.length : 0;
                        if ((cvnObjLen == 0 && cvnobj == '') || cvnObjLen < cardCVNMinLen || cvnObjLen > cardCVNMaxLen) {
                            $('#dwfrm_billing_paymentMethods_creditCard_cvn').trigger("focus");
                            displayCVNErrorMessage('show');
                            return false;
                        } else {
                            displayCVNErrorMessage();
                            return true;
                        }
                    } else {
                        $('.clientsite-cardcvnvalid-error').removeClass('hide');
                        $('.error-form.clientsite-cardcvnvalid-error').show();
                        $('.scroll-top-inner').trigger('click');
                        return false;
                    }
                } else {
                    displayCVNErrorMessage();
                    $('.clientsite-cardcvnvalid-error').hide();
                    return true;
                }
            });
        }

        function displayCVNErrorMessage(display) {
            if (display !== undefined && display != '' && display == 'show') {
                $('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').show();
                $('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').html(Resources.VALIDATE_CVN);
            } else {
                $('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').html('');
                $('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').hide();
            }
        }
    }

    $("#dwfrm_billing").on("submit", function() {
        var $sameasshippingObj = $('input[name=dwfrm_billing_billingAddress_sameasshipping]');
        if ($sameasshippingObj.is(':checked')) {
            $sameasshippingObj.val(true);
        } else {
            $sameasshippingObj.val(false);
        }

        var paymentSelected = $('input[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked');
        $('.error-form.clientsite-cardcvnvalid-error').hide();
        if (paymentSelected.length === 0) {
            $('.clientsite-cardcvnvalid-error').removeClass('hide');
            $('.error-form.clientsite-cardcvnvalid-error').show();
            $('.scroll-top-inner').trigger('click');
            return false;
        }
        return true;
    });

    $(document).on("click", ".address-create", function(evt) {
        modal.setCallback(function() {
            toggleBillingAddressFields(false);
        });

        modal.restoreDefaultClass();
        modal.addCustomClass('edit-add-address');
        var _YubinBango = typeof (YubinBango) !== 'undefined' && YubinBango ? YubinBango : '';
        modal.events.onOpen(function() {
            if (_YubinBango) {
                new _YubinBango.MicroformatDom();
            }
            validator.initForm('form[id$="EditAddressForm"]');
            removePOBoxCaption();
        });

        modal.renderByUrl(Urls.checkoutAddBillingAddress);
    });

    $(document).on("click", ".address-edit", function(evt) {
        var element = document.getElementById(evt.currentTarget.id);
        var addressID = element.dataset.addressId;
        var addressCode = element.dataset.addressCode;
        var url = Urls.checkoutEditBillingAddress + addressID;
        modal.setCallback(function() {
            toggleBillingAddressFields(true);
        });
        modal.restoreDefaultClass();
        var _YubinBango = typeof (YubinBango) !== 'undefined' && YubinBango ? YubinBango : '';
        modal.events.onOpen(function() {
            if (_YubinBango) {
                new _YubinBango.MicroformatDom();
            }
            validator.initForm('form#EditAddressForm');
            removePOBoxCaption();
            initCleanAutoFill.init();
        });
        modal.addCustomClass('edit-add-address');
        modal.renderByUrl(url);
    });

    var href;
    $(document).on('click', '.address-delete', function(e) {
        e.preventDefault();
        href = $(this).attr('href');
        var popup = new Foundation.Reveal($('#remove-address'));
        popup.open();
        //No button
        $(".addressDelete-modal-btn-cancel").on("click", function() {
            popup.close();
        });
    });

    //Yes button
    $(".addressDelete-modal-btn-ok").on("click", function() {
        var data_json = {};

        if ($('#csrf_token') && $('#csrf_token').length === 1) {
            var csrfTokenVal = $('#csrf_token').val();
            var csrfTokenKey = $('#csrf_token').prop('name');
            data_json[csrfTokenKey] = csrfTokenVal;
        }

        $.ajax({
            type: 'POST',
            url: util.appendParamToURL(href, 'format', 'ajax'),
            dataType: 'json',
            data: data_json,
        }).done(function(data) {
            page.refresh();
        });
    });

    $(document).on('click', '.address-list .address-tile', function(evt) {

        if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
            return false;
        } else {
            $('.address-list .address-tile').each(function() {
                $(this).removeClass('selected');
                $(this).removeClass('default');
            });

            $(this).addClass('selected');

            var element = document.getElementById(evt.currentTarget.id);

            if (!element) {
                return false;
            }

            var addressID = element.dataset.addressId;
            var sameAsShipping = $('#same-as-shipping').is(':checked');

            var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
                addressID: addressID,
                sameAsShipping: sameAsShipping
                //format: 'ajax'
            });
            progress.show($('.billing-address-section.billing-step-item'));
            $.ajax({
                url: url,
                type: 'GET',
                success: function(result) {
                    //alert(result);
                    progress.hide();
                }
            });


        }

    });

    $('.order-summary-footer form').on("submit", function() {
        $('#summary-place-order').prop('disabled', true).addClass('loading');
        return true;
    });
    setDefaultMPCSameAsShippingAddressCheckbox();

    if ($('input#same-as-shipping').length > 0 && $('input#same-as-shipping').is(":checked")) {
        $(document).find('div.default-billing-address div.address-tile').each(function(ind, evt) {
            $(this).removeClass('selected');
            $(this).removeClass('default');
            $(this).trigger('click');
        });
    } else {
        var reSelectTile = $('div.select-billing-address div.address-tile.selected');
        reSelectTile.removeClass('selected');
        reSelectTile.removeClass('default');
        reSelectTile.trigger('click');
    }

    // trigger click event for selected by default cc (to manually trigger cc code)
    var selectedCC = $('div.payment-method div.creditcard-tile.selected');
    if (selectedCC) {
        selectedCC.removeClass('selected').trigger("click");
    }

    // maximize order checkout summary dropdown
    util.maximizeCheckoutSummary();

    // trigger only for non-registered users
    if (window.User.isCustomerAuthenticated == false) {
        $('input[name$="_creditCard_cvn"], input[name$="_creditCard_owner"]').on('change', function() {
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
        });
        $('.checkout-billing').find('.set-default-cb').hide();
    }

    /* point exchange */
    $(function() {
      if($('[id=point-redeem-01]').prop('checked')){
          $('#point-tile-box-02').removeClass("selected");
          $('#point-tile-box-01').addClass("selected");
          $('#js-order-point').hide();
          $('#isRadioPointExchange').val(false);
          $('.point-tile-use-button-part').prop("disabled", true);
          $('.point-tile-button-all').prop("disabled", true);
      } else if ($('[id=point-redeem-02]').prop('checked')) {
          $('#point-tile-box-01').removeClass("selected");
          $('#point-tile-box-02').addClass("selected");
          $('#js-order-point').show();
          $('#isRadioPointExchange').val(true);
          $('.point-tile-use-button-part').prop("disabled", false);
          $('.point-tile-button-all').prop("disabled", false);
      }
      $('[name="point-redeem"]:radio').change( function() {
        if($('[id=point-redeem-01]').prop('checked')){
          $('#point-tile-box-02').removeClass("selected");
          $('#point-tile-box-01').addClass("selected");
          $('#js-order-point').hide();
          $('#isRadioPointExchange').val(false);
          $('.point-tile-use-button-part').prop("disabled", true);
          $('.point-tile-button-all').prop("disabled", true);
        } else if ($('[id=point-redeem-02]').prop('checked')) {
          $('#point-tile-box-01').removeClass("selected");
          $('#point-tile-box-02').addClass("selected");
          $('#js-order-point').show();
          $('#isRadioPointExchange').val(true);
          $('.point-tile-use-button-part').prop("disabled", false);
          $('.point-tile-button-all').prop("disabled", false);
        }
      });
    });

    util.renderGoogleInvRecaptcha("billingrecaptcha", "#dwfrm_billing_save", "dwfrm_billing")

    creditCardValidator.init({
        wrapper: '#wrapper form[id$="billing"]'
    });

    $('[name="point-redeem"]:radio').change( function() {
        if($('[id=point-redeem-01]').prop('checked')){
            var url = util.appendParamsToUrl(Urls.ressetTmpUsePoint);
            $.ajax({
                url: url,
                type: 'POST',
                success: function(result) {
                    window.location.href = Urls.billing;
                    // page.refresh();
                }
            });
        } else if ($('[id=point-redeem-02]').prop('checked')) {
            return false;
        }
    });
}

},{"../../address-book":3,"../../ajax":5,"../../credit-card-validator":15,"../../giftcard":19,"../../modal":28,"../../page":31,"../../progress":75,"../../util":87,"../../validator":88,"../customaddress":45,"./card-validation":37,"./formPrepare":38}],37:[function(require,module,exports){
'use strict';

// https://gist.github.com/ShirtlessKirk/2134376

var luhnCheck = (function (arr) {
    return function (ccNum) {
        var len = ccNum.length;
        var bit = 1;
        var sum = 0;
        var val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

var cvvCheck = function (cvv) {
    return /^[0-9]{3,4}$/.test(cvv);    
};

var initCardExpiry = function(){
	var ccSave = $('#CreditCardForm #applyBtn');
	ccSave.on('click', function(e){
		validateCardExpiry(this, true);
	});
	
	$('.card-expiry.month, .card-expiry.year').on('change blur', function(){
		validateCardExpiry(this);
	});
};

var validateCardExpiry = function(el, checkEmpty){
	// need to declare specifically in order not to confuse with other forms with similar inputs
	var $this = $(el);
	var $month = $this.closest('form').find('.card-expiry.month');
	var $year = $this.closest('form').find('.card-expiry.year');
	var $submit = $this.closest('form').find('button[type="submit"]');
	var hasError = false;
	
	var now = new Date();
	var nowMonth = now.getMonth() + 1; 
	var nowYear = now.getFullYear();
	
	$month.siblings('span.error').remove();
	$year.siblings('span.error').remove(); //-- Ade CG-4
	$month.removeClass('error');
	$year.removeClass('error');
	$submit.prop('disabled', false);
	
	// validate only on form submit
	/*if(checkEmpty && (!$month.val() || !$year.val())){
		$('<span class="error">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($month);
		hasError = true;*/
	if(checkEmpty) {
		if (!$month.val()){
			$('<span class="error" id="errormonth">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($month);
			hasError = true;
		}
		if (!$year.val()){
			$('<span class="error" id="erroryear">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($year);
			hasError = true;
		}
	// validate only if month and year has value, otherwise, ignore
	} else if($month.val() && $year.val()){
		if ($year.val() < nowYear) {
			$('<span class="error">' + Resources.VALIDATE_CARDEXPIRY + '</span>').insertBefore($year);
			hasError = true;
		} else if ($month.val() < nowMonth && $year.val() == nowYear) {
			$('<span class="error">' + Resources.VALIDATE_CARDEXPIRY + '</span>').insertBefore($month);
			hasError = true;
		}
	}
	
	// highlight inputs if expiry has error 
	if(hasError){
		$month.addClass('error');
		$year.addClass('error');
	}
	
	// disable button if there are errors -- // change by ticket shi-5388
	if($this.closest('form').find('span.error').length > 0){
		$submit.prop('disabled', true);
	}
};

exports.init = function () {
	initCardExpiry();
}
},{}],38:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var hasEmptyRequired = function () {
    // filter out only the visible fields
    var requiredValues = this.$requiredInputs.filter(':visible').map(function () {
        return $(this).val();
    });
    return _(requiredValues).contains('');
};

var validateForm = function () {
	var _self = this;
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
    if (!this.validator) {
        return;
    }
    
    // wait for the form to show before validating.. this applies to modals
    this.timer = setInterval(function(){ 
    	if(_self.$form.is(':visible')) {
    		if (_self.$form.find('span.error:visible, .error-form:visible').length == 0) { //!_self.hasEmptyRequired() &&
    			_self.$continue.prop('disabled', false);
    		} else {
    			_self.$continue.prop('disabled', true);
    		}
    		clearInterval(_self.timer);
    	}
    }, 100);
    
};

var validateEl = function (e) {
    if ($(e.target).val() === '') {
        this.$continue.prop('disabled', true);
    } else {
        // enable continue button on last required field that is valid
        // only validate single field
        if (!this.hasEmptyRequired()) { 
            this.$continue.prop('disabled', false);
        } else {
            this.$continue.prop('disabled', true);
        }
    }
};

var checkValue = function(repopulateRequiredFields, e) {
	var $el = $(e.target);
	var attr = $el.attr('clear-on-error');
	
	// check for new required fields (e.g. changing US -> CH in address)
	if(repopulateRequiredFields){
		this.$requiredInputs = this.$form.find('input.required');
	}
	
	// remove any error message residue from previous validation
    if (this.$form.find('.-error-pad').length == 0) {
        $el.siblings('span.error').remove();
    }
	
    if (this.validator.element($el) 
    		&& this.$form.find('span.error:visible').length == 0) {
        this.$continue.prop('disabled', false);
    } else {
//        this.$continue.prop('disabled', true);
        
        // clear the value if input has error
        if(typeof attr !== typeof undefined && attr !== false) $el.val('');
    }
};

var submitForm = function(e) {
    this.$form.find('input').trigger("blur");
    this.$form.find('select').trigger("blur");

    if (this.$continue.hasClass('password-ignore')) {
        if ($(".form-row.username .field-wrapper span.error").length) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    } else if(this.validator.numberOfInvalids() > 0 || this.$form.data('submitting') == true){
//    	this.$continue.prop('disabled', true);
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    // Execute Google Recaptcha once validation is completed.
    var util = require('../../util');
    if (util.getGoogleRecaptchaEnableStatus(this.$form.attr('id')) == true) {    	    
        util.callingGoogleReCaptchaOnFormSubmitORAJAXCall(e, this.$form.attr('id'));
    }
    
    // adding this to prevent multiple submission of forms
    if(this.$form.attr('multiple-submission') === 'false'){
    	this.$form.data('submitting', true);
    }
    
   /* if( SitePreferences.ENABLE_SINGLE_PAGE_CHECKOUT && $("#singlepagecheckouthidden").length > 0 ){
	    e.preventDefault();
	    e.stopPropagation();
	    return;
    }*/
};

var init = function (opts, settings) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    this.$form = $(opts.formSelector);
    this.$continue = $(opts.continueSelector); 
    this.validator = settings? this.$form.validate(settings) : this.$form.validate();
    this.$allInputs = $('input, textarea', this.$form);
    this.$allSelect = $('select', this.$form);
    this.$requiredInputs = this.$form.find('input.required');
//    this.validateForm();
    
    
    this.$allInputs.on('keyup', $.proxy(this.checkValue, this, false)); 
    this.$allSelect.on('blur', $.proxy(this.checkValue, this, true));
    /*Below code is for only Single page checkout handler*/
    if(SitePreferences.ENABLE_SINGLE_PAGE_CHECKOUT && SitePreferences.IS_QAS_AUTO_SUGGESTION_ENABLE && $('.spc-checkoutdiv.spcGuestUser .spc-shipping.active #dwfrm_singleshipping_shippingAddress').length > 0) {
   	 // start listening for only single page checkout
       this.$requiredInputs.on('change', $.proxy(this.validateEl, this));
       this.$requiredInputs.on('keydown', $.proxy(this.validateEl, this));
       this.$requiredInputs.on('keypress', $.proxy(this.validateEl, this));
    }
    this.$continue.on('click', $.proxy(this.submitForm, this));
	// [life-hack:5079] needed to trigger onclick since blur prevents the form from submitting
    if(this.$continue.attr('mousesubmit') === 'true'){
    	this.$continue.on('mousedown', $.proxy(function(e){ this.$continue.trigger("click"); }, this));
    }
};

var formPrepare = function(){
	return {
		$form: null,
		$continue: null,
		$allInputs: null,
		$allSelect: null,
		$requiredInputs: null, 
		validator: null,
		init: init,
		timer: null,
		hasEmptyRequired: hasEmptyRequired,
		checkValue: checkValue,
		validateForm: validateForm,
		submitForm: submitForm,
		validateEl: validateEl
	}
}

module.exports = formPrepare;

},{"../../util":87,"lodash":116}],39:[function(require,module,exports){
'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    address.init();
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else {
        billing.init();
    }

    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
        }
    }
};

},{"./address":35,"./billing":36,"./multiship":41,"./shipping":42}],40:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Enable/disable button depending if input has value
 */
exports.init = function () {
    var $emailInput = $('.checkoutlogin input[type="email"]');
    var $emailButton = $('.checkoutlogin button');
    $emailInput.on('keyup', function(e){
    	    if($emailInput.val().length){
    	    	$emailButton.prop('disabled', false);
    	    } else {
//    	    	$emailButton.prop('disabled', true);
    	    }
    });
};

},{}],41:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox() {
    $.each($('.item-list'), function () {
        var $this = $(this);
        var $giftMessage = $this.find('.gift-message-text');

        //handle initial load
        $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');

        //set event listeners
        $this.on('change', function () {
            $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
        });
    });
}


/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
    var $addressForm = $('form[name$="multishipping_editAddress"]'),
        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
        $addressList = $addressForm.find('.address-list'),
        add = true,
        originalUUID,
        resetOptionValue = false,
        selectedAddressUUID = $(target).parent().siblings('.select-address').val();

    $addressDropdown.on('change', function (e) {
        e.preventDefault();

        var selectedAddress = $addressList.find('select').val();
        if (selectedAddress !== 'newAddress') {
            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
                return add.UUID === selectedAddress;
            })[0];
            add = false;
            resetOptionValue = false;
            // proceed to fill the form with the selected address
            util.fillAddressFields(selectedAddress, $addressForm);
        } else if  (selectedAddress === 'newAddress') {
            add = true;
            resetOptionValue = true;
            $addressForm.find('.input-text, .input-select').val('');
        } else {
            //reset the form if the value of the option is not a UUID
            $addressForm.find('.input-text, .input-select').val('');
        }
    });

    $addressForm.on('click', '.cancel', function (e) {
        e.preventDefault();
        dialog.close();
    });

    $addressForm.on('submit', function (e) {
        e.preventDefault();
        if (!$addressForm.valid()) {
            return false;
        }

        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
            if (!response.success) {
                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
                return;
            }
            $('#multiaddresserror').toggleClass('hidden', response.success);

            var address = response.address,
                $shippingAddress = $(target).closest('.shippingaddress'),
                $select = $shippingAddress.find('.select-address'),
                $selected = $select.find('option:selected'),
                newOption = '<option value="' + address.UUID + '">' +
                    ((address.ID) ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' +
                    address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode +
                    '</option>';
            dialog.close();

            if (address.UUID !== originalUUID) {
                resetOptionValue = true;
            }

            if (add) {
                $('.shippingaddress select').removeClass('no-option').append(newOption);
                $('.no-address').hide();
            } else {
                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
            }
            // if there's no previously selected option, select it
            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
            }
        });
    });

    //preserve the uuid of the option for the hop up form
    if (selectedAddressUUID) {
        //update the form with selected address
        $addressList.find('option').each(function () {
            //check the values of the options
            if ($(this).attr('value') === selectedAddressUUID) {
                $(this).prop('selected', 'selected');
                $addressDropdown.trigger('change');
            }
        });
        originalUUID = selectedAddressUUID;
    }

    validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
    initMultiGiftMessageBox();
    if ($('.cart-row .shippingaddress .select-address').length > 0) {
    	validator.initForm('form[id$="multishipping_addressSelection"]');
    }
    $('.edit-address').on('click', 'span', function (e) {
        dialog.open({url: this.attributes.href.value,  options: {open: function () {
            address.init();
            addEditAddress(e.target);
        }}});
    });
};

},{"../../dialog":16,"../../util":87,"../../validator":88,"./address":35,"./formPrepare":38}],42:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    progress = require('../../progress'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    validator = require('../../validator'),
    page = require('../../page'),
    modal = require('../../modal').global,
    addressVerificationSvc = require('../../qas'),
    customaddress = require('../customaddress'),
    initCleanAutoFill = require('../../address-book');

var $cache, shippingMethods;

function initCache() {
    var $formEle = $('form[id$="_shippingAddress"]');
    $cache = {
        addrForm: {
            address1: $formEle.find('input[name$="_address1"]'),
            address2: $formEle.find('input[name$="_address2"]'),
            countryCode: $formEle.find('select[id$="_country"]'),
            stateCode: $formEle.find('select[id$="_state"]'),
            postalCode: $formEle.find('input[name$="_postal"]'),
            city: $formEle.find('input[name$="_city"]')
        }
    };
}

// Removes 'PO Box shipping is not available' caption from address1 field if preference is true
function removePOBoxCaption(){

    if (SitePreferences.ENABLE_POBOX_ADDRESS){
    	var $addressOne = $('input[name$="_address1"]');
    	$addressOne.closest(".form-row").find(".form-caption").text('');
    	var $addressTwo = $('input[name$="_address2"]');
    	$addressTwo.closest(".form-row").find(".form-caption").text('');
    }
}

function initEvents() {
    var href;
    $(document)
        // create address link
        .on("click", ".address-create", function (evt) {
            modal.addCustomClass('edit-add-address');
            var _YubinBango = typeof (YubinBango) !== 'undefined' && YubinBango ? YubinBango : '';
            modal.events.onOpen(function() {
                if (_YubinBango) {
                    new _YubinBango.MicroformatDom();
                }
                validator.initForm('form[id="EditAddressForm"]');
                addressVerificationSvc.init();
                removePOBoxCaption();
                initCleanAutoFill.init();
                $('.country').trigger('change');
            });

            modal.renderByUrl(Urls.checkoutAddAddress);
        })

        // edit address link
        .on("click", ".address-edit", function (evt) {
            var $this = $(this);
            var addressID = $this.data('addressId');

            modal.addCustomClass('edit-add-address');
            var _YubinBango = typeof (YubinBango) !== 'undefined' && YubinBango ? YubinBango : '';
            modal.events.onOpen(function() {
                if (_YubinBango) {
                    new _YubinBango.MicroformatDom();
                }
                validator.initForm('form[id="EditAddressForm"]');

                var setDefaultCheckbox = $('input[id$="_setdefault"]');
                if (setDefaultCheckbox.prop('checked')) {
                    setDefaultCheckbox.attr('disabled', 'true');
                }

                addressVerificationSvc.init();
                removePOBoxCaption();
                initCleanAutoFill.init();
                $('.country').trigger('change');
            });

            modal.renderByUrl(Urls.checkoutEditAddress + addressID);
        })

        .on('click', '.address-delete', function (e) {
            e.preventDefault();
            href = $(this).attr('href');
            var popup = new Foundation.Reveal($('#remove-address'));
            popup.open();
            //No button
            $(".addressDelete-modal-btn-cancel").on("click", function () {
                popup.close();
            });
        })

        //Yes button
        .on("click", ".addressDelete-modal-btn-ok", function (e) {
            var data_json = {};

            if ($('#csrf_token') && $('#csrf_token').length === 1) {
                var csrfTokenVal = $('#csrf_token').val();
                var csrfTokenKey = $('#csrf_token').prop('name');
                data_json[csrfTokenKey] = csrfTokenVal;
            }
            $.ajax({
                type: 'POST',
                url: util.appendParamToURL(href, 'format', 'ajax'),
                dataType: 'json',
                data: data_json,
            }).done(function (data) {
                page.refresh();
            });
        })

        .on("click", ".address-make-default", function (e) {
            e.preventDefault();
            var href = $(this).attr('href');
            var data_json = {};

            if ($('#csrf_token') && $('#csrf_token').length === 1) {
                var csrfTokenVal = $('#csrf_token').val();
                var csrfTokenKey = $('#csrf_token').prop('name');
                data_json[csrfTokenKey] = csrfTokenVal;
            }

            $.ajax({
                type: 'POST',
                url: util.appendParamToURL(href, 'format', 'ajax'),
                data: data_json,
            }).done(function (data) {
                page.refresh();
            });
        })

        // authenticated user address change
        .on('click', '.address-list .address-tile', function (evt) {
            if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
                return false;
            }

            $('.address-list .address-tile').each(function() {
                $(this).removeClass('selected');
                $(this).removeClass('default');
            });

            $(this).addClass('selected');

            var element = document.getElementById(evt.currentTarget.id);
            var addressID = element.dataset.addressId;

            // update address; on success update shipping method list
            $.get(Urls.updateAddressDetails, { addressID: addressID }, function (response) {
                updateShippingMethodList();
            });
            renderTemplateFollowCountry();
            checkSelectedAddress();
        });

    // guest user address change
    var timer = null;
    $('form[id$="_shippingAddress"]').on('change', 'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], select[name$="_addressFields_states_state"], input[name$="_addressFields_city"], input[name$="_addressFields_postal"]', function () {
        if (!validateAddrForm()) {
            return;
        }

        if (timer) {
            window.clearTimeout(timer);
        }

        timer = window.setTimeout(function () {
            $.post(Urls.setShippingAddressDetails, $('form[id$="_singleshipping_shippingAddress"]').serialize(), function (result) {
                updateShippingMethodList();
            });
        }, 200);
    });

    $('form[id$="_shippingAddress"]').on('change', 'select[name$="_shippingaddress_country"]', renderTemplateFollowCountry);
    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
    $('input[name$="_cart_isGift"]').on('click', giftMessageBox);
}

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
    $('.complimentary-gift-container').toggleClass('hidden, hide', $('input[name$="_cart_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
    var $summary = $('#secondary.summary');
    var couponError;

    if ($('.cart-coupon-code .error').length) {
        couponError = $('.cart-coupon-code .error').clone();
    }

    var showmsg = "none";
    if ($('.cart-coupon-code .success').length > 0) {
    	showmsg = "show";
    }

    // indicate progress
    progress.show($summary);

    // load the updated summary area
    $summary.load(Urls.summaryRefreshURL+"?showmsg="+showmsg, function () {
        // hide edit shipping method link
        $summary.fadeIn('fast');

       // checkout checkout minicart on right side event handling
        addSummaryScrollbar();

        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        $('.cart-coupon-code').append(couponError);
        util.maximizeCheckoutSummary();

        $(".checkout-mini-cart .accordion").foundation();
        isCanShipToChina();
    });
}

function getAddressFromTile() {
    var $selectedAddress = $(".address-tile.selected address");

    return {
        address1: $selectedAddress.data("address-one"),
        address2: $selectedAddress.data("address-two") || "",
        countryCode: $selectedAddress.data("country-code"),
        stateCode: $selectedAddress.data("state-code"),
        postalCode: $selectedAddress.data("postal-code"),
        city: $selectedAddress.data("city")
    };
}

function getAddressFromForm() {
    return {
        address1: $cache.addrForm.address1.val(),
        address2: $cache.addrForm.address2.val(),
        countryCode: $cache.addrForm.countryCode.val(),
        stateCode: $cache.addrForm.stateCode.val(),
        postalCode: $cache.addrForm.postalCode.val(),
        city: $cache.addrForm.city.val()
    };
}
/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var $form = $('form[id$="_shippingAddress"]');
    var params = User.isCustomerAuthenticated ? $form.find('.address-tile').length > 0 ? getAddressFromTile() : getAddressFromForm() : getAddressFromForm();
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, {shippingMethodID: shippingMethodID});
    ajax.getJson({
        url: url,
        callback: function (data) {
            updateSummary();
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();


            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
            //     var len = data.shippingPriceAdjustments.length;
            //     for (var i=0; i < len; i++) {
            //         var spa = data.shippingPriceAdjustments[i];
            //     }
            // }
        }
    });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
    var $shippingMethodList = $('#shipping-method-list');
    if (!$shippingMethodList || $shippingMethodList.length === 0) { return; }
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert('Couldn\'t get list of applicable shipping methods.');
                return false;
            }

            // shipping methods remain unchanged; update summary as selected method may/may not change
            if (shippingMethods && shippingMethods.toString() === data.toString()) {
                updateSummary();
                return true;
            }

            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            progress.show($shippingMethodList);

            // load the shipping method form
            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
            $shippingMethodList.load(smlUrl, function () {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').on("click", function () {
                    selectShippingMethod($(this).val());
                });

                // update the summary
                updateSummary();
                progress.hide();
                tooltip.init();
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                    $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
                }
            });
        }
    });
}

function isCanShipToChina() {
    var url = Urls.isCanShipToChina;
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: url
    })
    .done(function (response) {
        if (response.status) {
            $('.error.isCanShipToChina').addClass('hide');
        } else {
            $('.error.isCanShipToChina').removeClass('hide');
        }
    });
}

/**
 * Check there is an address selected, if not, disable the continue button
 * */
function checkSelectedAddress(){
	var $form = $('form[id$="_shippingAddress"]');
	var $submit = $form.find('button[type="submit"]');

	// enable the submit button if there are no shipping card
	// if there are, user must have at least 1 selected shipping card for the button to be enabled
	if($form.find('.address-tile').length == 0 || $form.find('.address-tile.selected').length){
		$submit.prop('disabled', false);
	} else {
		$submit.prop('disabled', true);
	}
}

function renderTemplateFollowCountry () {
    var $form = $('form[id$="_shippingAddress"]');
    var params = User.isCustomerAuthenticated ? $form.find('.address-tile').length > 0 ? getAddressFromTile() : getAddressFromForm() : getAddressFromForm();
    var countryCode = params.countryCode.toLowerCase();

    check_countryCode(countryCode);
}

function chk_emptyAddress() {
    if($('.no-address-items').length > 0) {
        var countryCode = $('select[name=dwfrm_singleshipping_shippingAddress_addressFields_country]').val();
        check_countryCode(countryCode);
        initCleanAutoFill.init();
        $('select[name=dwfrm_singleshipping_shippingAddress_addressFields_country]').change(function() {
            countryCode = $(this).val();
            check_countryCode(countryCode)
        });
    }
}

function check_countryCode(countryCode) {
    if (countryCode.toLowerCase() === 'jp') {
        //show shipping time, hide and empty personal number
        $('div.shipping-time').removeClass('hidden');
        $('div.personal-number').addClass('hidden');
        $('input[name=dwfrm_singleshipping_shippingAddress_isGiftWrapping]').attr('disabled', false);
        $('.gitf-service').find('.form-row').first().removeClass('fade-6');
        $('.personal-number').find('.form-row').removeClass('required');
        $('input[name=dwfrm_singleshipping_personalNumber]').removeClass('required personalnumberid');
        $('.shipping-time').find('.form-row').addClass('required');
        $('input[name=dwfrm_singleshipping_shippingAddress_deliverytime]').addClass('required');
    } else {
        //show personal number, hide and choose undefine shipping time, choose gift wrapping
        $('div.shipping-time').addClass('hidden');
        $('div.personal-number').removeClass('hidden');
        $('.gitf-service input.isgiftwrapping:first-child').addClass('disabled');
        $('.gitf-service input.isgiftwrapping:nth-child(2)').addClass('disabled');
        $('input[name=dwfrm_singleshipping_shippingAddress_isGiftWrapping]').attr('disabled', true);
        $('#dwfrm_singleshipping_shippingAddress_isGiftWrapping_true').prop('checked', true);
        $('.gitf-service').find('.form-row').first().addClass('fade-6');
        $('.personal-number').find('.form-row').addClass('required');
        $('input[name=dwfrm_singleshipping_personalNumber]').addClass('required personalnumberid');
        $('.shipping-time').find('.form-row').removeClass('required');
        $('input[name=dwfrm_singleshipping_shippingAddress_deliverytime]').removeClass('required');
    }
}

function validateAddrForm() {
    var addr = getAddressFromForm();
    return addr.address1 && addr.city && addr.postalCode && addr.stateCode && addr.countryCode;
}

function initCouponCodeField() {
    $('.cart-coupon-code input').on('keydown', function (e) {
    	var couponCode = $('.cart-coupon-code input').val(); 
        if (couponCode == '') {
            $('#add-coupon').prop('disabled', true);
        } else {
            $('#add-coupon').prop('disabled', false);
        }
        
        if (e.which === 13) {
            e.preventDefault();
            $('#add-coupon').trigger("click");
        }
    })
}

exports.init = function () {
    initCache();
    initEvents();
    customaddress.init();
    addressVerificationSvc.init();

    if (window.User.isCustomerAuthenticated == false) {
        $('.checkout-shipping').find('.set-default-cb').hide();
    }
    removePOBoxCaption();
	validator.initForm('form[name$="shippingAddress_save"]');


    giftMessageBox();
    updateShippingMethodList();
    initCouponCodeField(); 

    chk_emptyAddress();

    $(document).find('div.address-list div.address-tile').each(function() {
        if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
            $(this).removeClass('selected');
            $(this).removeClass('default');

    	    $(this).trigger("click");
        }
    });

    checkSelectedAddress();

};

exports.updateShippingMethodList = updateShippingMethodList;

},{"../../address-book":3,"../../ajax":5,"../../modal":28,"../../page":31,"../../progress":75,"../../qas":76,"../../tooltip":86,"../../util":87,"../../validator":88,"../customaddress":45}],43:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', function (e) {
        e.preventDefault();
        ajax.getJson({
            url: this.href,
            callback: function () {
                page.refresh();
            }
        });
    })
    .on('click', '.open-quick-view', function (e) {
        e.preventDefault();
        var url = $(this).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    });

    $('#compare-category-list').on('change', function () {
        $(this).closest('form').trigger("submit");
    });
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    addProductToCart();
};

},{"../ajax":5,"../page":31,"../product-tile":74,"../quickview":77,"./product/addToCart":48}],44:[function(require,module,exports){
'use strict';

var util = require('../util');

function initializeEvents() {
	$(document)

		// mobile navigation
		.on('change', '.promotion-nav-select select', function (e) {
			var newUrl = $(this).find("option:selected").val();

			if (newUrl) {
				window.location.href = newUrl;
			}
		});

    // concierge form events
    var conciergeForm = $('form[id$="_beautyconsultant"]');
    if (conciergeForm.length > 0) {
        // secure concierge access
        /*if (location && location.protocol === 'http:') {
            window.location.href = Urls.secureConciergeForm;
        }*/

        var successShown = false;
        conciergeForm.on('click', 'button#sendBtn', function(e) {
            e.preventDefault();

            $.ajax({
                url: util.appendParamToURL(Urls.customerServiceSubmit, 'source', 'concierge'),
                data: conciergeForm.serialize(),
                method: 'POST'
            }).done(function (response) {
                var conciergeModal = $('#concierge-modal');
                if (response && response.success && conciergeModal.length > 0) {
                    // show success modal
                    successShown = true;
                    var popup = new Foundation.Reveal(conciergeModal);
                    //Window height minus 80px, which sets the modal to fit inside the device's screen
                    var windowHeight = window.innerHeight - 130;

                    popup.$element.children('.modal-body').css('max-height', windowHeight);	
                    popup.open();

                    // trigger ga
                    window.history.pushState("", "", Urls.conciergeForm);
                    $(document).trigger("askanexpert");
                }
            });
        });

        $(document).on('click', '.reveal-overlay', function () {
            // trigger redirect when concierge overlay is closed
            if (successShown && $(this).css('display') == 'none') {
                successShown = false;
               window.location.href = Urls.secureConciergeForm;
            }
        });
    }
}

module.exports.init = function () {
	initializeEvents();
};
},{"../util":87}],45:[function(require,module,exports){
'use strict';

var util = require('../util');

function initializeEvents() {
    $(document)
        // change country
        .on("change", ".country ", function (evt) {
            var currentCountry = $(this).val();
            var $postal = $('input[name$="_postal"]');
            if (currentCountry == 'JP') {
                toggleClassYubinBango(true);
                $postal.attr('maxlength', '7');
                $('[name$="_phone"]').attr('minlength', '10').attr('maxlength', '13');
            } else {
                toggleClassYubinBango(false);
                if ($postal.val() && $postal.val().length > 6) {
                    $postal.val($postal.val().slice(0, 6))
                }
                $postal.attr('maxlength', '6');
                $('[name$="_phone"]').attr('minlength', '10').attr('maxlength', '14');
            }
            loadStatesList(currentCountry);

        })
        .on("keyup focusout", ".p-postal-code", function (evt) {
            var postalCode = $('.p-postal-code').val();
            var country = $('.country').val();
            if (country == 'JP' && postalCode.length >= 7) {
                if ($('.p-region').val()) {
                    $('.p-region').blur();
                }
                if ($('.p-locality').val()) {
                    $('.p-locality').blur();
                }
                if ($('.p-street-address').val()) {
                    $('.p-street-address').blur();
                }
            }
        })
        .on("submit", "form#EditAddressForm", function (evt) {
            evt.preventDefault();
            var applyName = $(this).find('button.apply-button').attr('name');
            var url = util.ajaxUrl($(this).attr('action'));
            var data = $(this).serialize();
            $.ajax({
                type: 'post',
                data: data + '&' + applyName + '=x',
                dataType: 'json',
                url: url
            }).done(function (res) {
                if (res.success) {
                    window.location.href = res.urlRedirect;
                } else {
                    $('#AddressForm span.form-error-message').html(res.message);
                    $('.modal-body').animate({scrollTop: 0}, 200, 'linear');
                }
            });
        });

    $('.country').trigger("change");

}

function toggleClassYubinBango(turnOn) {
    if (turnOn) {
        $('.state').addClass('p-region');
        $('.city').addClass('p-locality');
        $('.address1').addClass('p-street-address');
    } else {
        $('.state').removeClass('p-region');
        $('.city').removeClass('p-locality');
        $('.address1').removeClass('p-street-address');
    }
}

function loadStatesList(currentCountry) {
    if (currentCountry) {
        var statesSelectListContent = $('select[name*="states_state"]');
        var url = Urls.getStatesList + '?country=' + currentCountry;
        $.get(url, function (response) {
            if (response.success) {
                var states = response.states;
                var html = '';
                var selectedState = statesSelectListContent.find('option:selected').val() || '';

                for (var i = 0; i < states.length; i++) {
                    var state = states[i];
                    var selected = (selectedState == state.value) ? 'selected="selected"' : '';
                    html += '<option class="select-option" label="' + state.label + '" value="' + state.value + '" ' + selected + '>' + state.label + '</option>'
                }
                statesSelectListContent.html(html);
            }
        });
    }
}

exports.init = function () {
    initializeEvents();
};

exports.loadStatesList = loadStatesList;
},{"../util":87}],46:[function(require,module,exports){
'use strict';

var util = require('../util');



var errorpages = {
		
	init: function () {
		
	}
		
};

$(function() {
	var $carousel = $('.carousel-recommendations').not('.slick-initialized');
	var isHomepage = $('.pt_storefront').length > 0;
	if (!$carousel || $carousel.length === 0 || $carousel.children().length === 0) {
	return;
}
	$carousel.slick({
		infinite: true,
		slidesToShow: isHomepage > 0 ? 3 : 4,
		slidesToScroll: 1,
		slide: 'li',
		dots: isHomepage ? false : true,
		responsive: [
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true,
				arrows: true,
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: isHomepage > 0 ? 1 : 2,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				dots: true
			}
		}
		]
	});
});

module.exports = errorpages;
},{"../util":87}],47:[function(require,module,exports){
'use strict';

var recommendations = require('./product/recommendations');

exports.init = function () {
	if ($('.pt_order-confirmation').length) {
		recommendations();
	} else {
		return;
	}
};
},{"./product/recommendations":54}],48:[function(require,module,exports){
'use strict';

var minicart = require('../../minicart'),
    page = require('../../page'),
    util = require('../../util'),
    modal = require('../../modal').global,
    Promise = require('promise'),
    _ = require('lodash'),
    analytics = require('../../analytics');

/**
 * @description set addToCart error message
 * @param {String} msg
 */
var timer;
var setAddToCartError = function (msg) {
    var $errEle = $("#a2c-error");
    $errEle.html(msg).show();

    // if(timer) {
    //     clearTimeout(timer);
    // }

    // timer = setTimeout(function () {
    // 	$errEle.hide();
    // }, 1500);
};

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
    var $form = $(form);

    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: $form.serialize()
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            setAddToCartError(response.error);
            throw new Error(response.error);
            return false;
        }

        return response;
    });
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
    e.preventDefault();
    var $form = $(this).closest('form');

    addItemToCart($form).then(function (response) {
        var $uuid = $form.find('input[name="uuid"]');
        if ($uuid.length > 0 && $uuid.val().length > 0) {
            page.refresh();
        } else {
            // do not close quickview if adding individual item that is part of product set
            // @TODO should notify the user some other way that the add action has completed successfully
            //if (!$(this).hasClass('sub-product-item')) {
            $(".quickview-modal .close-button").trigger("click");
            //dialog.close();
            //}
            analytics.initAddToCartFromPDP();
            $(document).trigger("gtadd-to-cart");
            minicart.show(response);
        }
    }.bind(this));
};

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllTo = function (e) {
    e.preventDefault();

    var pidData = formatPidDataFromEles($('.product-set-list').find('form'));
    minicart.addAllProducts(pidData, e.data.to);
    $(".quickview-modal .close-button").trigger("click");
};

// Accepts jQuery selector of n elements containing data attr storing pid
// Returns formatted pid data required for addAllProducts request (ex. 'pidA:1,pidB:1,pidN:1')
// To fetch qty, searches for qty dropdown or defaults to 1
function formatPidDataFromEles($selector) {
    return $selector.toArray().map(function (ele) {
        var $ele = $(ele),
            pid = $ele.data('pid'),
            qty = $ele.find('select[name="Quantity"]').length ? $ele.find('select[name="Quantity"]').val() : 1;

        return pid + ":" + qty;
    }).join(',');
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
    $('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
    $('#add-all-to-cart').on('click', {to: 'Cart'}, addAllTo);
    $('.product-form-actions .product-set-wishlist').on('click', {to: 'Wishlist'}, addAllTo);
};

/**
 * duplicated add-to-cart from export above - endorse for re-factoring
 * reason for duplication : sometimes add to bag/cart script won't trigger/execute
 */
$(document).on('click', '.product-detail .add-to-cart', addToCart);
$(document).on('click', '#add-all-to-cart', {to: 'Cart'}, addAllTo);
$(document).on('click', 'button#samples-add-to-cart', addSamplesToCart);

$(document).on('click', '.product-tile-wrapper', sampleTileSelect);

$(document).on('click', 'button#exchange-gifts-add-to-cart', addExchangeGiftsToCart);

$(document).on('click', 'button#add-to-cart-gifts', addExchangeGiftsToCart);

$(document).on('click', 'button#exchange-gifts-add-to-confirm', addExchangeGiftsToConfirm);

$(document).on('click', 'button#add-to-confirm-my-page', addExchangeGiftsToConfirmMyPage);


$(document).on('change', 'select[name="quantity"]', addQuantity);

$(document).on('click', '.reveal.sample-selection .close-button', function (e) {
    scrollToTop(e);
});
$("form.multi-select-form").on('submit', function (e) {
    e.preventDefault();

    var pidData = formatPidDataFromEles($(this).find('button.multiselect[value="selected"]'));
    minicart.addAllProducts(pidData, 'Cart');
});
$(document).off('click', '.js_addtocart').on('click', '.js_addtocart', globalAddtoCart);

function sampleTileSelect(e) {
    e.preventDefault();

    var $this = $(this);
    var $btn = $this.find('button.multiselect');
    var $multiSelectForm = $this.parents('form');
    var $thresholdInput = $multiSelectForm.find('input#pids');

    var selectedCount = $multiSelectForm.find('button[value="selected"]').length;
    var limitCount = $thresholdInput.data('limit');

    if ($('#sampleserror')) {
        $('#sampleserror').html(null);
    }

    // do checking to compare if limit is met
    var btnIsSelected = $btn.val() == 'selected';

    if (btnIsSelected || selectedCount < limitCount) {
        // toggle val/text
        $btn.toggleClass('outline');
        $btn.val(btnIsSelected ? 'selectable' : 'selected');
        $btn.html(btnIsSelected ? $btn.data('select') : $btn.data('selected'));
    } else if ($('#sampleserror')) { // cap reached, report error
        $('#sampleserror').html($("input#pids").data('error'));

        $('.modal-body').animate({
            scrollTop: 0
        }, 200);
    }

    var selectedProductList = [];
    var enableAddToBag = true;

    // fetch all items that are selected
    $multiSelectForm.find('button[value="selected"]').each(function(index, item) {
        selectedProductList.push($(item).data('pid'));
        enableAddToBag = true;
    });

    // store all selected products to hidden input
    $thresholdInput.val(selectedProductList);
    if (selectedProductList === undefined || selectedProductList.length == 0) {
        enableAddToBag = false;
    }

    // update selected counter
    var selectedCount = parseInt(selectedProductList.length);
    var selectedLimit = parseInt($thresholdInput.data('count'));
    $("span#sample-count").html((selectedCount <= selectedLimit ? selectedCount : selectedLimit));

    // enable "Add to Bag" button
    var cartButton = $thresholdInput.data('button');
    if (enableAddToBag) {
        $('button#' + cartButton).prop('disabled', false);
    } else {
        $('button#' + cartButton).attr('disabled', 'true');
    }
}

function addSamplesToCart(e) {
    e.preventDefault();

    var url = util.toAbsoluteUrl($(this).data('action'));

    var data = {
            pid: $(this).parents('form').find("input#pids").val()
        };
    var $form = $(this).parents('form');
    var csrfToken = $form.find('input[name="csrf_token"]');
    if (csrfToken && csrfToken.length === 1) {
        var csrfTokenVal = csrfToken.val();
        var csrfTokenKey = csrfToken.prop('name');
        data[csrfTokenKey] = csrfTokenVal;
    }

    $.ajax({
        url: util.appendParamToURL(url, 'format', 'ajax'),
        data: data,
        method: 'POST'
    }).done(function (response) {
        if ($('#samples-add-to-cart').data('redirect')) {
            window.location.assign(Urls.cartShow);
        } else {
            minicart.show(response);
        }
    });
}

function globalAddtoCart(e) {
    e.preventDefault();
    var $this = $(this),
        $wrapper = $this.closest('.product-tile'),
        pid = typeof $this.data('pid') !== 'undefined' ? $this.data('pid') : $wrapper.find('a.selected').data('pid'),
        currentId = "#" + $(this).parents('.product-tile').attr('id'),
        data = {
            pid: pid || '',
            currentId: currentId || ''
        };
    minicart.addProduct(data);
}

function addQuantity(e) {
    e.preventDefault();

    var val = $(this).val();
    var $this = $(this);

    $this.parents('.exchange-gift-product').find('button').data('quantity', val);
    exchangeGiftsTileSelect($this);
}

function addExchangeGiftsToConfirm(e) {
    e.preventDefault();
    var url = Urls.showExchangeGiftsConfirmInCart;
    var $form = $(this).parents('form');
    var csrfToken = $form.find('input[name="csrf_token"]');
    var originURL = location.href;
    var data = {
        pid: $(this).parents('form').find("input#pids").val(),
        originURL: originURL
    };

    if (csrfToken && csrfToken.length === 1) {
        var csrfTokenVal = csrfToken.val();
        var csrfTokenKey = csrfToken.prop('name');
        data[csrfTokenKey] = csrfTokenVal;
    }

    $.ajax({
        type: 'POST',
        url: util.appendParamToURL(url, 'format', 'ajax'),
        data: data,
        success: function(response) {
            if (typeof response === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
                page.redirect(Urls.csrffailed);
            } else if (typeof response === 'object' && !response.isUserAuthenticated) {
                var redirectURL = response.redirectURL;
                location.href = redirectURL;
            } else if (typeof response === 'string') {
                modal.renderContent(response, 'pointexchange-confirm');
            }
        },
        failure: function() {
            modal.addCustomClass('normal-modal');
            modal.renderContent(Resources.SERVER_ERROR);
        }
    });
}

function addExchangeGiftsToConfirmMyPage(e) {
    e.preventDefault();

    var url = Urls.showExchangeGiftsConfirmInCart;
    var $form = $('form.pdpForm.pointexchange-selection');
    var csrfToken = $form.find('input[name="csrf_token"]');

    var originURL = location.href;
    var data = {
        pid: $(this).parents('form').find("input#pids").val(),
        originURL: originURL
    };

    if (csrfToken && csrfToken.length === 1) {
        var csrfTokenVal = csrfToken.val();
        var csrfTokenKey = csrfToken.prop('name');
        data[csrfTokenKey] = csrfTokenVal;
    }

    $.ajax({
        type: 'POST',
        url: util.appendParamToURL(url, 'format', 'ajax'),
        data: data,
        success: function(response) {
            if (typeof response === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
                page.redirect(Urls.csrffailed);
            } else if (typeof response === 'object' && !response.isUserAuthenticated) {
                var redirectURL = response.redirectURL;
                location.href = redirectURL;
            } else if (typeof response === 'string') {
                $('.show-content-add-to-cart-my-page').html(response);
            }
        },
        failure: function() {
            modal.addCustomClass('normal-modal');
            modal.renderContent(Resources.SERVER_ERROR);
        }
    });

    $([document.documentElement, document.body]).animate({
        scrollTop: $(".pointexchange-confirm").offset().top
    }, 200);
}

function addExchangeGiftsToCart(e) {
    e.preventDefault();

    var url = util.toAbsoluteUrl($(this).data('action'));
    var csrfToken = $(this).parent().find('input[name="csrf_token"]');
    var originURL = location.href;

    var data = {
        pid: $(this).parent().find("input#pids").val(),
        originURL: originURL
    };

    if (csrfToken && csrfToken.length === 1) {
        var csrfTokenVal = csrfToken.val();
        var csrfTokenKey = csrfToken.prop('name');
        data[csrfTokenKey] = csrfTokenVal;
    }

    $.ajax({
        type: 'POST',
        url: util.appendParamToURL(url, 'format', 'ajax'),
        data: data,
        success: function(response) {
            if (typeof response === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
                page.redirect(Urls.csrffailed);
            } else if (typeof response === 'object' && !response.isUserAuthenticated) {
                var redirectURL = response.redirectURL;
                location.href = redirectURL;
            } else if (typeof response === 'string') {
                window.location.assign(Urls.cartShow);
            }
        },
        failure: function() {
            modal.addCustomClass('normal-modal');
            modal.renderContent(Resources.SERVER_ERROR);
        }
    });
}

function exchangeGiftsTileSelect(el) {


    var $this = el.closest(".exchange-gift-product");
    var $btn = $this.find('button.multiselect');
    var $multiSelectForm = $this.parents('form');
    var $thresholdInput = $multiSelectForm.find('input#pids');
    var $btnAdd = $('#add-to-confirm-my-page');

    // do checking to compare if limit is met
    var btnIsSelected = $btn.data('quantity') == 0;

    // toggle val/text

    $btn.val(btnIsSelected ? 'selectable' : 'selected');



    var selectedProductList = [];
    var enableAddToBag = false;

    // fetch all items that are selected
    $multiSelectForm.find('button[value="selected"]').each(function (index, item) {
        selectedProductList.push('{"name":"' + $(item).data('pid') + '";"quantity":"' + $(item).data('quantity') + '";"point":"' + $(item).data('point') + '"}');
        enableAddToBag = true;
    });

    // store all selected products to hidden input
    $thresholdInput.val(selectedProductList);
    var cartButton = $thresholdInput.data('button');
    if (enableAddToBag) {
        $('button#' + cartButton).prop('disabled', false);
        $btnAdd.prop('disabled', false);
    } else {
        $('button#' + cartButton).attr('disabled', 'true');
        $btnAdd.prop('disabled', true);
    }
}
},{"../../analytics":6,"../../minicart":27,"../../modal":28,"../../page":31,"../../util":87,"lodash":116,"promise":118}],49:[function(require,module,exports){
'use strict';

var ajax =  require('../../ajax'),
    util = require('../../util');

var updateContainer = function (data) {
    var $availabilityMsg = $('#pdpMain .availability .availability-msg');
    var message; // this should be lexically scoped, when `let` is supported (ES6)
    if (!data) {
        $availabilityMsg.html(Resources.ITEM_STATUS_NOTAVAILABLE);
        return;
    }
    $availabilityMsg.empty();
    // Look through levels ... if msg is not empty, then create span el
    if (data.levels.IN_STOCK > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            // Just in stock
            message = Resources.IN_STOCK;
        } else {
            // In stock with conditions ...
            message = data.inStockMsg;
        }
        $availabilityMsg.append('<p class="in-stock-msg">' + message + '</p>');
    }
    if (data.levels.PREORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.PREORDER;
        } else {
            message = data.preOrderMsg;
        }
        $availabilityMsg.append('<p class="preorder-msg">' + message + '</p>');
    }
    if (data.levels.BACKORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.BACKORDER;
        } else {
            message = data.backOrderMsg;
        }
        $availabilityMsg.append('<p class="backorder-msg">' + message + '</p>');
    }
    if (data.inStockDate !== '') {
        $availabilityMsg.append('<p class="in-stock-date-msg">' + String.format(Resources.IN_STOCK_DATE, data.inStockDate) + '</p>');
    }
    if (data.levels.NOT_AVAILABLE > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
            message = Resources.NOT_AVAILABLE;
        } else {
            message = Resources.REMAIN_NOT_AVAILABLE;
        }
        $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
    }
};

var getAvailability = function () {
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.getAvailability, {
            pid: $('#pid').val(),
            Quantity: $(this).val()
        }),
        callback: updateContainer
    });
};

module.exports = function () {
    $('#pdpMain').on('change', '.pdpForm input[name="Quantity"]', getAvailability);
};

},{"../../ajax":5,"../../util":87}],50:[function(require,module,exports){

function initializeEvents() {
	$('.video-carousel').slick({
		dots: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 480,
			settings: 'unslick'
			}
		]
	});
}

module.exports = {
	init: function () {
		initializeEvents();
	}
};
},{}],51:[function(require,module,exports){
'use strict';
var dialog = require('../../dialog');
var modal = require('../../modal').global;
var util = require('../../util');
var qs = require('qs');
var url = require('url');
var _ = require('lodash');
var video = require("../../video");
var CarouselQuickview = require ('../../product-tile-carousel');

var zoomMediaQuery = matchMedia('(min-width: 960px)');

/**
 * @description Enables the zoom viewer on the product detail page
 * @param zmq {Media Query List}
 */
function loadZoom (zmq) {
    /* --- re-handle zoom function for multi large image (slide show), old-function zoom only use for 1 large image --- */
    $('#pdpMain').find('.blk_main-image').each(function(){
        var $imgZoom = $(this).find('.main-image'),
            hiresUrl;
        if (!zmq) {
            zmq = zoomMediaQuery;
        }
        if ($imgZoom.length === 0 || dialog.isActive() || util.isMobile() || !zoomMediaQuery.matches) {
            // remove zoom
            $imgZoom.trigger('zoom.destroy');
            return;
        }

        hiresUrl = $imgZoom.attr('href');
    
        if (hiresUrl && hiresUrl !== 'null' && hiresUrl.indexOf('noimagelarge') === -1 && zoomMediaQuery.matches) {
            $imgZoom.zoom({
                url: hiresUrl
            });
        }
    });

    $('#pdpMain .main-image').on("click", function (e) {
    	e.preventDefault();
    });
}


zoomMediaQuery.addListener(loadZoom);

function getProductImageURL(viewType) {
    var pid = $("span[itemprop='productID']").data("pid");
    return util.appendParamsToUrl(Urls.getProductImages, { "pid": pid, "sz": viewType });
}

function lazyLoadThumbnails() {
    var viewType = util.isMobile() ? "large" : "icon";
    var thumbnailProductImageURL = getProductImageURL(viewType);

    $.get(thumbnailProductImageURL).done(function (res) {
        $("#thumbnails").html(res);

        var thumbnailImageCount = $(".pt_product-details #thumbnails li").length;
        if (thumbnailImageCount == 0) {
            return false;
        } else if (thumbnailImageCount > 1) {
            CarouselQuickview.init();
        }
    });
}

function initThumbnailCarousel() {
    $('#thumbnails ul').slick({
        dots: false,
        infinite: true,
        arrows: true,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true
    });
}

function initMainImageCarousel() {
    $('#thumbnails ul').slick({
        dots: true,
        vertical: false,
        infinite: true,
        arrows: false,
        centerMode: false,
        slidesToShow: 1,
        focusOnSelect: true
    });
}

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage(atts,zoomimg) {
    updatePinButton(atts.url);
    updateFacebookButton(atts.url);
    if (!dialog.isActive() && !util.isMobile()) {
        $('.product-slide-large .slick-current .main-image').find('img').attr('src', zoomimg);
    }
}

function updatePinButton(imageUrl) {
    var pinButton = document.querySelector('.share-icon[data-share=pinterest]');

    if (!pinButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        if ($('#pdpMain .primary-image').length > 0 && ($('#pdpMain .primary-image').attr('src') || $('#pdpMain .primary-image').attr('data-src'))) {
            newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src') || document.querySelector('#pdpMain .primary-image').getAttribute('data-src')
        } else {
            newUrl = '';
        }
    }
    var href = url.parse(pinButton.href);
    var query = qs.parse(href.query);
    
    var smShareURL;
    if ($('.share-icons.allsm-shareurl').length > 0) {
    	smShareURL = $('.share-icons.allsm-shareurl').attr('data-share-targeturl');
    }
    smShareURL = (smShareURL != undefined && smShareURL!= null && smShareURL!= '')? smShareURL : window.location.href;
    
    query.media = url.resolve(smShareURL, newUrl);
    query.url = smShareURL;
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    pinButton.href = newHref;
}

function updateFacebookButton(imageUrl) {
    var facebookButton = document.querySelector('.share-icon[data-share=facebook]');

    if (!facebookButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        if ($('#pdpMain .primary-image').length > 0 && ($('#pdpMain .primary-image').attr('src') || $('#pdpMain .primary-image').attr('data-src'))) {
            newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src') || document.querySelector('#pdpMain .primary-image').getAttribute('data-src')
        } else {
            newUrl = '';
        }
    }
    
    var smShareURL;
    if ($('.share-icons.allsm-shareurl').length > 0) {
    	smShareURL = $('.share-icons.allsm-shareurl').attr('data-share-targeturl');
    }
    smShareURL = (smShareURL != undefined && smShareURL!= null && smShareURL!= '')? smShareURL : window.location.href;
    
    var href = url.parse(facebookButton.href);
    
    var query = qs.parse(href.query);    
    query.picture = url.resolve(smShareURL, newUrl);
    
    query.u = smShareURL;
    
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    
    facebookButton.href = newHref;
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
    if (dialog.isActive() || util.isMobile()) {
        $('#pdpMain .main-image').removeAttr('href');
    }
    updatePinButton();
    updateFacebookButton();
    lazyLoadThumbnails();
    loadZoom();
    
    // handle product thumbnail click event
    $("#thumbnails").on('click', '.productthumbnail', function () {
        var $that = $(this);
        if(!$that.hasClass("selected")){
        	$(document).trigger("clickproductthumbnail");
        }

        $("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
        $that.addClass('selected');
    });

    $(document).on('click', '.image-zoom', function (evt) {
        evt.preventDefault();
        var viewType = "zoom";
        // var thumbnailProductImageURL = getSingleProductImageURL(viewType);
        // modal.renderByUrl(thumbnailProductImageURL);

        var zoomImageUrl = null;
        if($('.productthumbnail').length > 1) {
        	zoomImageUrl = $('.productthumbnail.slick-current').data('zoomimg');
        } else {
        	// for only one thumbnail, select that one image
        	zoomImageUrl = $($('.productthumbnail')[0]).data('zoomimg');
        }

        modal.renderContent('<img src="' + zoomImageUrl + '">');

        modal.addCustomClass('productImageZoom');

    });
    
    // handle product thumbnail click event CG-361
    $(".product-thumbnails").on('mouseenter', '.productthumbnail.product-image-thumbnail', function () {
    	$(document).trigger("pdpinteraction",{"interactionType":"Change Image"});
        var $that = $(this);
        $(".product-thumbnails").find('.productthumbnail.selected').removeClass('selected');
        $that.addClass('selected');
        setMainImage($that.data('lgimg'),$that.data('zoomimg'));

        $('.image-zoom').attr('href', $that.data('zoomimg'));
        if( !($(this).hasClass('video-thumbnail-image')) ){
    		var mainImageDiv = $('#thumbnails').siblings(".main-image");
    		mainImageDiv.find('#alt-video').attr('src','');
    		$('.product-image').show();
    		$('#alt-video').hide();
    		
    	}
    });
  //CG-361 Add video or GIF to PDP
    $("body").on("click touchstart mouseenter",".productthumbnail.video-thumbnail-image", function(e){
    	let $altVideo = $('#alt-video'); 
		e.preventDefault();
		var mainImageDiv = $('#thumbnails').siblings(".main-image");
		$altVideo.fadeIn();
		var altVideoID = $(this).attr('data-videourl');
		$altVideo.attr('src',altVideoID + "&autoplay=1");
		$('.product-image').hide();

    });
    
  //CG-361 Add video or GIF to PDP
    $("body").on("mouseup touchstart", function(e){
	    var quickviewModalContainer = $(".quickview-modal");
	    // if the target of the click isn't the container
	    if (!quickviewModalContainer.is(e.target)){
	    	var videourl = $(".quickview-modal #alt-video").attr('src');
	    	if(!videourl){
	    		videourl = $(".quickview-modal #alt-video-small").attr('src');
	    	} 
	    	if(!videourl){
	    	    videourl = $("#primary #alt-video-small").attr('src');
	    	}
	    	if(videourl){
		    	var newurl = videourl.replace("autoplay=1", "autoplay=0");	        
		    	$("#primary #alt-video").attr('src', newurl);
		    	if (window.matchMedia("(min-width: 767px)").matches) {
		    		$(".quickview-modal #alt-video").attr('src', newurl);
		        } else{
		        	$(".quickview-modal #alt-video-small").attr('src', newurl);
		        	$("#primary #alt-video-small").attr('src', newurl);
		        }
	    	}
	    }
	}); 
    
    //CG-361 Add video or GIF to PDP
    video.init(function () {
        $(document).on('afterChange', '.slick-slider.slider-main-image', function(event, slick, currentSlide) {
            resetVideoPlayer();
            setVideoPlayer( $(this).find(".slide").eq(currentSlide) );
        });
    });
    
};

//CG-361 Add video or GIF to PDP
function setVideoPlayer($slide) {
    var videoID = $('.product-video', $slide).attr("data-videoid");
    if(!videoID)    {return;}

    var $player = $("#videoplayer_pdp");
    if(!$player.length) {
        $slide.find(".product-video .video-wrapper").html('<div id="videoplayer_pdp"></div></div>');
    }
    else {
        $slide.find(".product-video .video-wrapper").html("").append( $player.remove() );
    }
    videoplayer = video.playInline($("#videoplayer_pdp"), videoID);
}

//CG-361 Add video or GIF to PDP
function resetVideoPlayer() {
    if(videoplayer) {
        videoplayer.destroy();
        videoplayer = null;
    }
}

module.exports.loadZoom = loadZoom;
module.exports.setMainImage = setMainImage;
module.exports.lazyLoadThumbnails = lazyLoadThumbnails;
module.exports.resetVideoPlayer = resetVideoPlayer;
module.exports.setVideoPlayer = setVideoPlayer;
},{"../../dialog":16,"../../modal":28,"../../product-tile-carousel":73,"../../util":87,"../../video":89,"lodash":116,"qs":128,"url":134}],52:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
	modal = require('../../modal').global,
    productStoreInventory = require('../../storeinventory/product'),
    util = require('../../util'),
    addToCart = require('./addToCart'),
    availability = require('./availability'),
    image = require('./image'),
    //productNav = require('./productNav'),
    howToSection = require('./howToSection'),
    productSet = require('./productSet'),
    recommendations = require('./recommendations'),
    socialShareIcons = require('./socialShareIcons'),
    variant = require('./variant'),
    wishlistCustom = require('../../wishlist.custom');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */


function initializeDom() {
    //productNav();
    recommendations();
}


/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $pdpMain = $('#pdpMain');

    addToCart();
    availability();
    variant();
    image();
    howToSection.init();
    productSet();
    socialShareIcons();
    if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
    }

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });


    $('.full-ingredients').on('click', function(e){
        e.preventDefault();
        var $this = $(this);
        var $fullIngredientList = $('.full-ingredients-list');
        var contentUrl = $this.attr('href');

        if ($fullIngredientList.length ) {
            $this.toggleClass('show-list');

        } else {
            $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done( function(content) {
                $('<div class="full-ingredients-list"><a class="close"><i class="icon-close"></i></a>' + content + '</div>').insertAfter($this);
            });
            $this.toggleClass('show-list');
        }



    });

     $pdpMain.on('click', '.close', function(e){
            e.preventDefault();
            $('.full-ingredients.show-list').removeClass('show-list');
        });


    if ($('.product-set-actions').length) {
            var $productForms = $('.product-set-list').find('form').toArray();
            var pids = $productForms.map(function (formEle) {
                return $(formEle).data('pid');
            }).join(',');

            $.post(util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
                pid: pids
            }), function (data) {
                if (data === 'false') {
                    $('.product-form-actions .product-set-wishlist').removeClass('hide');
                    $('.product-form-actions .remove-product-set-from-wishlist').addClass('hide');
                } else {
                    $('.product-form-actions .product-set-wishlist').addClass('hide');
                    $('.product-form-actions .remove-product-set-from-wishlist').removeClass('hide');
                }
            });

            $('.remove-product-set-from-wishlist').on('click', function (e) {
                e.preventDefault();

                $.post(util.appendParamsToUrl(Urls.wishlistRemoveAll, {
                    pid: pids
                }), function () {
                    window.location.href = window.location.href;
                })
            });
        }

    $('.size-chart-link a').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });

    $('.accordion-toggle').on('click', function(e) {
        e.preventDefault();
        var $toggleFor = $(this).attr('href');
        var $toggleHeight = $('.accordion-toggle').outerHeight();
        var $stickyHeader = $('.sticky-header').outerHeight();

        var totalOffset = $toggleHeight + $stickyHeader;

        if ( $(this).hasClass('is-open') ) {
            $(this).removeClass('is-open');
            $($toggleFor).removeClass('is-open').slideUp();
            return false;
        } else {
            var accordionToggle = $('.accordion-toggle.is-open');
            var accordionContent = $('.pdp-content-section.is-open');

            // $(document).find(accordionToggle).removeClass('is-open');
            // $(document).find(accordionContent).removeClass('is-open').slideUp(100);

            $(this).toggleClass('is-open');
            $($toggleFor).toggleClass('is-open').slideDown(function() {
                $('html, body').animate({
                    scrollTop: $(this).offset().top - totalOffset
                }, 400);
            });
        }

        if ($(this).attr('id') == 'rec-toggle') {
            $('.carousel-recommendations.slick-slider').slick('refresh');
        }
    });
    wishlistCustom.handleWishlist();
}



var product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeDom();
        initializeEvents();
    }
};

module.exports = product;

},{"../../dialog":16,"../../modal":28,"../../storeinventory/product":84,"../../util":87,"../../wishlist.custom":90,"./addToCart":48,"./availability":49,"./howToSection":50,"./image":51,"./productSet":53,"./recommendations":54,"./socialShareIcons":55,"./variant":56}],53:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
    var $addToCart = $('#add-to-cart'),
        $addAllToCart = $('#add-all-to-cart'),
        $productSetList = $('#product-set-list');

    var updateAddToCartButtons = function () {
        if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
            $addAllToCart.attr('disabled', 'disabled');
            // product set does not have an add-to-cart button, but product bundle does
            $addToCart.attr('disabled', 'disabled');
        } else {
            $addAllToCart.removeAttr('disabled');
            $addToCart.removeAttr('disabled');
        }
    };

    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }
    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        e.preventDefault();
        var url = Urls.getSetItem + this.search;
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('form input[name="Quantity"]').first().val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });

    $productSetList.on('change', '.product-set-item .variation-select', function (e) {
        e.preventDefault();

        var $selectedVariantOption = $(this).find("option:selected");
        if($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
            return;
        }

        var url = Urls.getSetItem + "?" + util.getQueryString($selectedVariantOption.val());
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('select[name="Quantity"] option:selected').val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });
    if (screen.width > 640) {
	    $(window).on("load", function() {
	    	$('#pdpMain').find('#BVRRSummaryContainer .bv-rating-stars-container').off().on('click', function (e) {
	    		e.preventDefault();
	    		e.stopPropagation();
	    		$(".tabs-title:nth-child(1)").removeClass("is-active");
	    		$(".tabs-title:nth-child(2)").addClass("is-active");
	    		$("#questions").removeClass("is-active");
	    		$("#reviews").addClass("is-active").stop(true, true);
	    		$('html, body').stop( true, true ).animate({
	    	        scrollTop: $("#bazaarvoice-tabs").offset().top-150
	    	    }, 1000);
	    	});
	    });
    }
};

$(document).on('click', '.bv-popup-in .bv-read-review', function() {
	$(".tabs-title:nth-child(1)").removeClass("is-active");
	$(".tabs-title:nth-child(2)").addClass("is-active");
	$("#questions").removeClass("is-active");
	$("#reviews").addClass("is-active");
	e.preventDefault();
	e.stopPropagation();
	$('html, body').stop( true, true ).animate({
        scrollTop: $("#bazaarvoice-tabs").offset().top-150
    }, 1000);
});




},{"../../ajax":5,"../../tooltip":86,"../../util":87}],54:[function(require,module,exports){
'use strict';

/**
 * @description Creates product recommendation carousel using Slick carousel
 **/
module.exports = function () {
    var $carousel = $('.carousel-recommendations').not('.slick-initialized');
    if (!$carousel || $carousel.length === 0 || $carousel.children().length === 0) {
        return;
    }
    $carousel.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        slide: 'li',
        dots: true,
        responsive: [
          {
        	  breakpoint: 600,
        	  settings: {
    	        slidesToShow: 3,
    	        slidesToScroll: 3,
    	        infinite: true,
    	        dots: true
        	  }
          },
          {
        	  breakpoint: 480,
              settings: {
            	slidesToShow: 1,
      	        slidesToScroll: 1,
      	        infinite: true,
      	        arrows: false,
      	        dots: true
              }
          }
        ]
    });

};

},{}],55:[function(require,module,exports){
module.exports = function socialShareIcons() {
    $('.social-share-trigger').on('click', function() {
        $(this).parent().toggleClass('animate');

       if ( !Foundation.MediaQuery.atLeast('medium') ) {
            $('#wrapper').toggleClass('overlay');
        };

    });

    $('.social-modal-close').on('click', function(){
        $(this).parent().removeClass('animate');
        $('#wrapper').removeClass('overlay');
    });
};
},{}],56:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    image = require('./image'),
    progress = require('../../progress'),
    productStoreInventory = require('../../storeinventory/product'),
    socialShareIcons = require('./socialShareIcons'),
    util = require('../../util'),
    wishlistCustom = require('../../wishlist.custom'),
    CarouselQuickview = require('../../product-tile-carousel');

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/
function pdpMobileSwatchesCarousel() {
    
}

function updateContent(href, currentElem, isPDPQV) {
    var $pdpForm = $('#modal-content').find('.pdpForm');
    var targetDiv = $('#modal-content').find('#product-content');
    var $primaryDiv = currentElem.parents('#pdpMain').parent().hasClass('primary-content');
    var qty = $pdpForm.find('select[name="Quantity"] option:selected').val();
    var activeTab = currentElem.parents('.product-variation-swatch-lists').find('.shade-filter-tabs li.is-active').index();
    var isPDPQV = isPDPQV || 0;
    if($primaryDiv){
    	$pdpForm = $('#primary').find('.pdpForm');
    	targetDiv = $('#primary').find('#product-content');
    }
    
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };
    
    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: targetDiv,
        callback: function () {
        	if(isPDPQV > 0){
        		selectedColorNameDesc('pdp-quickview');
        	} else {
        		selectedColorNameDesc();
        	}
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }
            
            var wishlistProd = window.User.wishlistProducts;
    		$(".pdp-wishlist-icon").each(function(){
    				var _this = $(this);
    				var currEle = _this.attr('data-element-pid');
    				if(window.User.wishlistProducts != null && wishlistProd.indexOf(currEle) >= 0){
    					_this.addClass("pdp-active-wishlist");
    				}
    			});	
    		if($primaryDiv){
    			image();
    			$(document).trigger("pdpshadechangeevent",{"currrentElem":"#primary"});
    		} else {
    			image('pdp-quickview');
    			$(document).trigger("pdpshadechangeevent",{"currrentElem":"#modal-content"});
    		}
    		
            pdpMobileSwatchesCarousel();
            $(document).trigger("gtvariationchange");
            socialShareIcons();
            if($primaryDiv){
	            $('.shade-filter-tabs li').removeClass('is-active');
	            $('.shade-filter-tabs li').eq(activeTab).trigger("click");
            } else {
            	$('#modal-content').find('.shade-filter-tabs li').removeClass('is-active');
            	$('#modal-content').find('.shade-filter-tabs li').eq(activeTab).trigger("click");
            }
            if($('#questions-label').length > 0){
            	$('#questions-label').parent().trigger("click");
            }
            $(document).foundation();
            wishlistCustom.handleWishlist();
            CarouselQuickview.init();
        }
    });
}

function updateSetContent($ele, href) {
    var $productSetItemCtnr = $ele.parents(".product-set-item"),
        qty = $productSetItemCtnr.find('form select[name="Quantity"]').val();

    progress.show($productSetItemCtnr);

    $.get(util.appendParamsToUrl(href, {
        Quantity: isNaN(qty) ? '1' : qty,
        format: "ajax",
        setproduct: true
    })).done(function (html) {
    	var isPDPQV = $(this).parents('#modal-content');
    	if(isPDPQV.length > 0){
    		selectedColorNameDesc('pdp-quickview');
    	} else {
    		selectedColorNameDesc();
    	}
        $productSetItemCtnr.html(html);
        image();
        socialShareIcons();
        pdpMobileSwatchesCarousel();
        $(document).foundation();
        wishlistCustom.handleWishlist();
        CarouselQuickview.init();
    });
}

function selectedColorNameDesc(containerClass){
	var selectedColor = $('.filter-variation-select option:selected').html(); 
	var selectedColorDesc = $('.pdp-main-redesign .color-desc').html(); 
	
	if(containerClass == 'pdp-quickview'){
	    selectedColor = $('#modal-content .filter-variation-select option:selected').html(); 
		selectedColorDesc = $('#modal-content .pdp-main-redesign .color-desc').html();
		$('#modal-content #selected-color').html(selectedColor);
		$('#modal-content #selected-color-desc').html(selectedColorDesc);
	} else {
		$('#selected-color').html(selectedColor);
		$('#selected-color-desc').html(selectedColorDesc);
		
		var persSelectedColor = $('.miniproduct-actions .variation-select option:selected').attr('style');
		$('.selected-color-img').attr('style',persSelectedColor);
		
		var persSelectedColor = $('.miniproduct-actions .variation-select option:selected').html(); 
		$('#pers-selected-color').html(persSelectedColor);
	}
}

module.exports = function () {
    var $pdpMain = $('#pdpMain');

    // // hover on swatch - should update main image with swatch image
    // $pdpMain.on('mouseenter mouseleave', '.swatchanchor', function () {
    //     var largeImg = $(this).data('lgimg'),
    //         $imgZoom = $pdpMain.find('.image-zoom'),
    //         $mainImage = $pdpMain.find('.primary-image');

    //     if (!largeImg) {
    //         return;
    //     }

    //     // store the old data from main image for mouseleave handler
    //     $(this).data('lgimg', {
    //         hires: $imgZoom.attr('href'),
    //         url: $mainImage.attr('src'),
    //         alt: $mainImage.attr('alt'),
    //         title: $mainImage.attr('title')
    //     });

    //     // set the main image
    //     image.setMainImage($(this).data('lgimg'));
    // });

    $("body").on('click', '#pdpMain #product-content .swatchanchor', function (e) {
        e.preventDefault();
        if ($(this).parents("#pdp-swatches").hasClass('color')) {
    		$(document).trigger("pdpinteraction",{"interactionType":"Change Color"});
        }
        updateContent(this.href, $(this), $(this).parents('#modal-content').length);
    }).on('change', '#pdpMain #product-content .variation-select', function () {
        var img = $(this).closest('ul').find('#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() +'"])');
        var href = img.closest('a').attr('href');

        if ($(this).attr("id") == 'va-color') {
     		$(document).trigger("pdpinteraction",{"interactionType":"Change Color"});
    	}
        
        var $selectedVariantOption = $(this).find("option:selected");
        if($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
            return;
        }
        
        updateContent(href, $(this), $(this).parents('#modal-content').length);
    });

    $("body").on('click', '#pdpMain #product-set .swatchanchor', function (e) {
        e.preventDefault();

        updateSetContent($(this), $(this).attr("href"));
    }).on('change', '#pdpMain #product-set .variation-select', function () {
        var img = $(this).closest('ul').find('#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() +'"])');
        var href = img.closest('a').attr('href');

        updateSetContent($(this), href);
    });

    pdpMobileSwatchesCarousel();
};
},{"../../ajax":5,"../../product-tile-carousel":73,"../../progress":75,"../../storeinventory/product":84,"../../util":87,"../../wishlist.custom":90,"./image":51,"./socialShareIcons":55}],57:[function(require,module,exports){
'use strict';
var util = require('../util');

var $cache;

function initializeCache() {
	$cache = {};
	$cache['errorMsg'] = $('#promotion-landing-container .landing-error');
}

function initializeEvents() {
	$(document)
		.on('submit', '#PromoLandingForm', function (e) {
			var httpParams = util.getQueryStringParams(util.getQueryString(window.location.href));
			$('<input type="hidden" name="promoid" value="' + httpParams["promoid"] + '" />').appendTo(e.target);
		})

		.on('focus', '#PromoLandingForm input', function () {
			$cache.errorMsg.hide();
		});
}

module.exports.init = function () {
	initializeCache();
	initializeEvents();

	if (window.location.href.indexOf('error') > -1) {
		$cache.errorMsg.show();
	}
	if (window.couponCode) {
		$("#promo-code").text(window.couponCode);
	}
};
},{"../util":87}],58:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    util = require('../util');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    var url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
            // $form.parent('form').validate().form();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    var $eventAddressForm = $('form[name$="_giftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            var fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });
    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $beforeAddress);
    })
    .on('change', 'select[name$="_addressAfterList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $afterAddress);
    });

    $('.item-list').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        var productListID = $('input[name=productListID]').val();
        quickview.show({
            url: e.target.href,
            source: 'giftregistry',
            productlistid: productListID
        });
    });
}

exports.init = function () {
    initializeEvents();
    addProductToCart();
    login.init();
    util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../ajax":5,"../login":26,"../quickview":77,"../util":87,"./product/addToCart":48}],59:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    video = require("../video"),
    util = require('../util');

const EventNames = require('../constants/EventNames');

function copyBottomResultHitsToTop() {
    $("#results-hits-top").html($("#results-hits-bottom .results-hits").html());
}

function viewMoreClick() {
    // getting the hidden div, which is the placeholder for the next page
    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
    // get url hidden in DOM
    var gridUrl = loadingPlaceHolder.attr('data-grid-url');

    if (loadingPlaceHolder.length === 1 && util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('infinite-scroll-loading');


        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function (html) {
            loadingPlaceHolder.removeClass('infinite-scroll-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $('div.search-result-content').append(html);

            // move all product tiles up to search grid to prevent arbitrary breaklines
            $(".tiles-container .column").appendTo("#search-result-items");

            // rebind the View More event
            $("#view-more").off();
            $("#view-more").on("click", viewMoreClick);
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function (response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {
                    // nothing to catch in case of out of memory of session storage
                    // it will fall back to load via ajax
                }
                // update UI
                $("#view-more").remove();
                $("#view-all").remove();
                $(".results-hits").remove();
                fillEndlessScrollChunk(response);
                copyBottomResultHitsToTop();
                productTile.init();
                $(document).trigger("plpviewmore");
                $(document).trigger(EventNames.TRIGGER_CLICK_ORDER_DETAIL);
                
            }
        });
    }
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url) {
    if (!url || url === window.location.href) {
        return;
    }
    progress.show($('.search-result-content'));
    $('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
        compareWidget.init();
        productTile.init();
        progress.hide();
        displayLHSRMSlideAccodianIcon();
        history.pushState(undefined, '', url);
    });
}

function excludeCompoundAttributeRefinements(refineUrl) {
    var newUrl = refineUrl;

    var params = util.getQueryStringParams(refineUrl);
    Object.keys(params).forEach(function (paramName) {
        if (paramName.indexOf('prefv') === -1) {
            return;
        }

        var splitParam = params[paramName].split("|");
        newUrl = util.updateQueryStringParam(newUrl, paramName, splitParam[splitParam.length - 1]);
    });

    return newUrl;
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('#main');
    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function () {
        var cb = $(this);
        var tile = cb.closest('.product-tile');

        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        var itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
        });

    });

    // handle events for updating grid
    $main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href);
    });

    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        updateProductListing($(this).find('option:selected').val());
    })
    .on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    });

    //handle refinement change
    $main.on('change', '.top-filter select', function (e) {
        e.preventDefault();

        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl.indexOf('prefv') > -1) {
           refineUrl = excludeCompoundAttributeRefinements(refineUrl);
        }

        updateProductListing(refineUrl);
    })
    .on('change', '.items-per-page select', function() {
    		var refineUrl = $(this).find('option:selected').val();
    		$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
    		updateProductListing(refineUrl);
	});



    $('.category-tab-links select').on('change', function(e){
    	var $selected = $(this).find(":selected");
    	var link = $selected.attr('href');

    	if(link){
    		window.location.href = link;
    	}
    });

}

/**
 * Below function for expanding Left side Refinement Icons for
 * PLP and search Pages.
 * */
function displayLHSRMSlideAccodianIcon(){
	var $accordionToggle = $('.refinements .accordion-arrow');

    $accordionToggle.on('click', function(evt) {        
        evt.preventDefault();
        $(this).next($('#category-level-2')).slideToggle();     
        $(this).parent($('li')).toggleClass('expanded');
    });
}

exports.init = function () {

    video.init(function () {
        initializeEvents();
    });

    compareWidget.init();
    //$("#view-more").on("click", viewMoreClick);

    $(document).on("click", "#view-more", viewMoreClick);
    //$('#filter1-submit').on("click", function() {
    //	$('#filter1').val('0');
    //});
    productTile.init();
    initializeEvents();

    // content navigation title link
    $('.nav.content-navigation .accordion-title span').on('click', function() {
    	window.location = $(this).data('url');
    });

    // content navigation dropdown redirect
    $('.nav.content-navigation select').on('change', function() {
    	window.location = $(this).val();
    });

    displayLHSRMSlideAccodianIcon();


};
exports.viewMore = function() {
	$(document).on("click", "#view-more", viewMoreClick);
};
},{"../compare-widget":11,"../constants/EventNames":12,"../product-tile":74,"../progress":75,"../util":87,"../video":89}],60:[function(require,module,exports){
arguments[4][35][0].apply(exports,arguments)
},{"../../util":87,"./shipping":66,"dup":35}],61:[function(require,module,exports){
'use strict';
/**
 * We have created SPC JS file for handling all Singlepage checkout AJAX events along with required events
 * and we have followed the Site Genesis coding standard to complete the Single pageCheckout Flow.
 * we have used abbreviated from single page checkout short name is SPC.
 * a) we are using $.get method to render the form HTML structure dynamically into DIV.
 * b) $.post method is used to send the data to server for all single page checkout form submit functionality. 
 * c) On AJAX event success call added the HTML content to DIV of specific column.
 * List of important function to achieve billing functionality for single page checkout.
 *  1) initBillingColumnCache()
 *  2) updatePaymentMethod()- Existing payment method
 *  3) creditCardTypeDetector() - Detecting the credit card type.
 *  4) updateBillingColumn() - Updating the billing column
 *  5) spcBillingColumnEvents() - All events for Billing payment column
 *  6) selectDefaultSavedCreditCard() - displaying default credit card
 *  7) spcAddPromoCouponCode() - Adding promotion coupon code on order summary column 
 * */ 
var ajax = require('../../ajax'),
    giftcard = require('../../giftcard'),
    util = require('../../util'),
    modal = require('../../modal').global,
    cardValidation = require('./card-validation'),
    validator = require('../../validator'),
    spccybcustom = require('./spccybcustom'),
    analytics = require('../../analytics');

var $cache = {};
var SessionAttributesStep = window.SessionAttributes;

function initBillingColumnCache() {
    $cache.checkoutForm = $(".checkout-billing");
    $cache.selectedCardIdInput = $cache.checkoutForm.find('input[name$="_selectedCardID"]');
    $cache.billingcol = $('#spcBilling.spc-billing .spc-column');
    $cache.summarycol = $('#spcSummary.spc-summary .spc-column');
    $cache.billingSubmitBtn = $('#dwfrm_billing_save');
    $cache.summarySubmitBtn = $('.spcSummaryPageSubmitBtn');
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
    var $paymentMethods = $('.payment-method');
    //$paymentMethods.removeClass('payment-method-expanded');

    var dataMethod = paymentMethodID;
    if (paymentMethodID == 'SA_SILENTPOST') {
        dataMethod = 'CREDIT_CARD';
    }

    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + dataMethod + '"]');
    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }


    if (paymentMethodID == "VISA_CHECKOUT") {
        $(".continue-place-order").hide();
        $(".visacheckoutbutton").show();
    } else if (paymentMethodID == "PAYPAL" || paymentMethodID == "PAYPAL_CREDIT") {
        $("#billingAgreementCheckbox").attr('checked', false);
        $(".continue-place-order").hide();
    } else if (paymentMethodID == "AFTERPAY_PBI") {
        if ($("#dwfrm_billing").length > 0) {
            $("#dwfrm_billing").validate().resetForm();
            if ($("#dwfrm_billing").validate().numberOfInvalids() > 0) {
                $("#dwfrm_billing").validate().invalid = {};
            }
            $('select[name*="dwfrm_billing_paymentMethods_creditCard"],input[name*="dwfrm_billing_paymentMethods_creditCard"]').addClass("ignore");
        }
    } else if (paymentMethodID == "CREDIT_CARD") {
        $('select[name*="dwfrm_billing_paymentMethods_creditCard"],input[name*="dwfrm_billing_paymentMethods_creditCard"]').removeClass("ignore");
        if ($("#dwfrm_billing").length > 0)
            $("#dwfrm_billing").validate().resetForm();
    } else {
        $(".continue-place-order").show();
        $(".visacheckoutbutton").hide();
    }


    if (paymentMethodID == "CREDIT_CARD" || paymentMethodID == "SA_SILENTPOST") {
        $(".spsavecard").show();
    } else if ((paymentMethodID == "SA_REDIRECT" || paymentMethodID == "SA_IFRAME") && SitePreferences.TOKENIZATION_ENABLED) {
        $(".spsavecard").show();
    } else {
        $(".spsavecard").hide();
    }

    //$selectedPaymentMethod.addClass('payment-method-expanded');

    // ensure checkbox of payment method is checked
    $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');
    //$('input[name$="_selectedPaymentMethodID"]').val(paymentMethodID);

}
/**
 * By this function is detecting the credit card type(Eg:- Visa,JCB,Union Pay, American express card etc...).
 * This event fires on focus out event of card number field.
 * */
function creditCardTypeDetector(options) {
    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),

        // MasterCard
        mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

        // American Express
        amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

        //Discover
        discover_regex = new RegExp('^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'),

        //JCB
        unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

    $(document).on('focusout', '.spc-billing .cc-number input', function(e) {
        var cur_val = $(this).val();

        var piCardType = '';
        var $ccNumberContain = $(this).parents('.cc-number');

        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            piCardType = 'visa';
            $ccNumberContain.addClass('is_visa');
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_visa');
        }

        if (cur_val.match(mastercard_regex)) {
            piCardType = 'mastercard';
            $ccNumberContain.addClass('is_mastercard');
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            piCardType = 'amex';
            $ccNumberContain.addClass('is_amex');
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_amex');
        }

        if (cur_val.match(discover_regex)) {
            piCardType = 'discover';
            $ccNumberContain.addClass('is_discover');
            $creditCard.find('input[name$="_type"]').val("Discover").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_discover');
        }

        if (cur_val.match(unionpay_regex)) {
            piCardType = 'unionpay';
            $ccNumberContain.addClass('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) &&
            !cur_val.match(amex_regex) && !cur_val.match(discover_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
        } else {
            $ccNumberContain.removeClass('is_nothing');
        }

        if ($('.cvn').length > 0) {
            var setCVVCardLength = util.setCheckoutPaymentCardCVVLength(piCardType);
            var cvnMaxLength = setCVVCardLength.maxLength;
            var cvnMinLength = setCVVCardLength.minLength;
            $('.cvn').attr('minlength', cvnMinLength);
            $('.cvn').attr('maxlength', cvnMaxLength);
        }
    });

};
/**
 * Below function for Giftcertificate Modal Balance Checking functionality.
 * spcModalCheckAnotherCard :- Handled the functionality for adding another card checking button on modal form.
 * spcGCModalBalanceCheck :- It handles the balance checking for Gift card Modal form.
 * spcApplyGiftCertModal :- It is used for to Apply Gift card to basket from Gift Card Modal form.
 ***/
function spcModalCheckAnotherCard($giftCode, $giftPin) {
    var $balance = $('div#gift-card-balance-form .balance');
    var $error = $('div#gift-card-balance-form .balance-error');

    $balance.html('');
    $error.html('');
    $giftCode.val(null).prop('disabled', false);
    $giftPin.val(null).prop('disabled', false);

    $('button.checkBalanceGiftCertModal').removeClass('hide');
    $('button.gcModalCheckAnotherCard').addClass('hide');
    $('button.applyGiftCertModal').addClass('hide');
}

function spcGCModalBalanceCheck($giftCode, $giftPin) {
    var $balance = $('div#gift-card-balance-form .balance');
    var $error = $('div#gift-card-balance-form .balance-error');

    $error.html('');
    $balance.html('');
    if ($giftCode.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_INVALID);
        return;
    } else if ($giftCode.val().length !== 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_PIN_INVALID);
        return;
    } else if ($giftCode.val().length === 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
        return;
    }

    giftcard.checkBalance($giftCode.val(), $giftPin.val(), function(data) {
        if (data && data.error) {
            return $error.html(data.error);
        }

        if (!data || !data.giftCertificate) {
            $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
            return;
        }

        if (!data || !data.giftCertificate) {
            $balance.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('error');
            return;
        }

        $balance.html(Resources.GIFT_CERT_CURRENT_BALANCE + ' ' + data.giftCertificate.balance);

        $giftCode.attr('disabled', "true");
        $giftPin.attr('disabled', "true");
        $('button.checkBalanceGiftCertModal').addClass('hide');
        $('button.gcModalCheckAnotherCard').removeClass('hide');
        $('button.applyGiftCertModal').removeClass('hide');
    });
};

function spcApplyGiftCertModal($giftCode, $giftPin) {
    var $error = $('div#gift-card-balance-form .balance-error');
    $error.html('');
    if ($giftCode.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_INVALID);
        return;
    }

    var url = util.appendParamsToUrl(Urls.spcApplyGiftcertificate, {
        giftCertCode: $giftCode.val(),
        giftCertPIN: $giftPin.val(),
        format: 'ajax'
    });
    $.getJSON(url, function(data) {
        var fail = false;
        var msg = '';
        if (!data) {
            msg = Resources.BAD_RESPONSE;
            fail = true;
        } else if (!data.success) {
            msg = data.message;
            fail = true;
        }
        if (fail) {
            $error.html(msg);
            return;
        } else {
            clearGiftCertForm();
            $('.close-button').trigger('click');
            $(document).foundation();
            updateBillingColumn();
            return false;
        }
    });
};
/**
 * Initializing the Billing Column Credit Card form for Payment.
 * */
function initCreditCardForm() {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    $cache.checkoutForm.find('input[name*="_number"]').val('');
    $cache.checkoutForm.find('select[name*="_month"]').val('').trigger("change");
    $cache.checkoutForm.find('select[name*="_year"]').val('').trigger("change");
    $cache.checkoutForm.find('input[name*="_owner"]').val('');

    var $ccContainer = $cache.checkoutForm.find(".payment-method").filter(function() {
        return $(this).data("method") == "CREDIT_CARD";
    });

    $ccContainer.find('input[name*="_number"]').on('change', function(e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });
    $ccContainer.find('input[name$="_owner"]').on('change', function(e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });

    $ccContainer.find('select[name*="expiration"]').on('change', function(e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');

        var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
        var cardNumber = $cache.checkoutForm.find('input[name*="_number"]').val();
        if (cardNumber.indexOf('****') != -1 && selectedPaymentMethodID == 'SA_SILENTPOST') {
            $cache.checkoutForm.find('input[name*="_number"]').val('');
        }
    });
}
/**
 * Setting the default selected credit card ID for Register users.
 * */
function setSelectedCardID(uuid) {
    $cache.selectedCardIdInput.val(uuid);
}
/**
 * We are handling the disability functionality for Billing Edit address
 * section. Disabled the Country field for register user on Edit event of billing address form. 
 * */
function enableCountryField(status) {
    var countryField = $('select[id$="billing_billingAddress_addressFields_country"]');
    if (status) {
        countryField.prop('disabled', false);
    } else {
        countryField.prop('disabled', true);
    }
}
/**
 * Added events for Credit Card CVN field.
 * */
function addCVNEvent() {
    $('input[name$="creditCard_cvn"]').on('keydown', function(e) {
        if (e.key.toString().match(/[\d]/) ||
            $.inArray(e.keyCode, [8, 9, 13, 46, 33, 34, 35, 36, 37, 38, 39, 40]) >= 0) {
            // do nothing
        } else {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    });
}
/**
 * Initializing the Gift Card functionality for Billing column Gift card payment methods.
 * */
function initGiftCardBalance() {
    var $checkoutForm = $('.checkout-billing');
    var $addGiftCert = $('#spcAddGiftCert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $giftCertPin = $('input[name$="_giftCertPIN"]');

    $addGiftCert.off();
    $addGiftCert.on('click', function(e) {
        e.preventDefault();
        var code = $giftCertCode.val();
        var pin = $giftCertPin.val();
        var $error = $checkoutForm.find('.spc-apply-error');

        // clear all errors
        $(this).closest('form').find('span.error').remove();

        $error.html('');
        if (code.length === 0) {
            $error.html(Resources.GIFT_CARD_CODE_INVALID);
            return;
        } else if (code.length !== 0 && pin.length === 0) {
            $error.html(Resources.GIFT_CARD_PIN_INVALID);
            return;
        } else if (code.length === 0 && pin.length === 0) {
            $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
            return;
        }

        var url = util.appendParamsToUrl(Urls.spcApplyGiftcertificate, {
            giftCertCode: code,
            giftCertPIN: pin,
            format: 'ajax'
        });
        $.getJSON(url, function(data) {
            var fail = false;
            var msg = '';
            if (!data) {
                msg = Resources.BAD_RESPONSE;
                fail = true;
            } else if (!data.success) {
                msg = data.message;
                fail = true;
            }
            if (fail) {
                $error.html(msg);
                return;
            } else {
                updateBillingColumn();
                $(document).foundation();
            }
        });
    });

    $giftCertCode.off();
    $giftCertCode.on('keydown', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            $addGiftCert.trigger("click");
        }
    });
}

//Removes 'PO Box shipping is not available' caption from address1 field if preference is true
function removePOBoxCaption() {
    if (SitePreferences.ENABLE_POBOX_ADDRESS) {
        var $addressOne = $('input[name$="_address1"]');
        $addressOne.closest(".form-row").find(".form-caption").text('');
    	var $addressTwo = $('input[name$="_address2"]');
    	$addressTwo.closest(".form-row").find(".form-caption").text('');
    }
}

/**
 * On the basis of country(US , China...etc) we are displaying the form field.
 * */
function toggleBillingAddressFields(visible) {
    if (visible == true) {
        $('.spc-billing .country-dependent').each(function() {
            $(this).show();
        });
    } else {
        $('.spc-billing .country-dependent').each(function() {
            $(this).hide();
        });
    }

    if (window.User.isCustomerAuthenticated == false) {
        $('.checkout-billing').find('.set-default-cb').hide();
    }
}
/**
 * We are replacing the Billing column HTML structure on success of AJAX event call.
 * To avoid the page refresh we are replacing the HTML structure of Billing column section.
 * We have used this function(updateBillingColumn) for these are the AJAX events (Giftcertificate, Add new credit card
 *  and the edit billing address)
 * */
function updateBillingColumn(params) {    
    let billingColURL = Urls.billing;    
    if (params !== null && params !== undefined && params.OnlyGCInCart == 'true') {
    	billingColURL = util.appendParamToURL(billingColURL, 'onlyGCInCart', params.OnlyGCInCart);
    }    
    $.get(billingColURL, function(data) {
        $cache.billingcol.html(data);
        $(document).foundation();
        spccybcustom.init();
        cardValidation.init();
        removeSelectedUserSavedPamentMethods();
        settingDefaultPaymentMethodOnAjaxLoad();
        validator.init();
        return false;
    });
}
/**
 * Below function will avoid rendering 2 forms to be visible at the same time on Billing column edit address.
 */
function hideShowBillingAddressForm(currentevt, action) {
    $('.address-tile').show();
    if (currentevt && action == 'add') {
        $('.billing-edit-form-ajax').html('');
        currentevt.hide();
    } else if (currentevt && action == 'edit') {
        $('.billing-edit-form-ajax').removeClass('edit-spcbilling-address-ajax');
        currentevt.closest('.address-tile').hide();
        $('.spc-billing .spc-billing-address-create').hide();
        $('.spc-billing-address-form-ajax, .billing-edit-form-ajax').html('');
    } else {
        $('.billing-edit-form-ajax').removeClass('edit-spcbilling-address-ajax');
        $('.spc-billing-address-form-ajax, .billing-edit-form-ajax').html('');
        $('.spc-billing .spc-billing-address-create').hide();
    }
}
/**
 * Handling hide and show functionality for error message on form.
 * */
function showORHideSubmitErrorFunction(show, msg) {
    if (show == true) {
        $('.spcbilling-submit-error').html(msg);
        $('.spcbilling-submit-error').removeClass('hide').show();
    } else {
        $('.spcbilling-submit-error').html('');
        $('.spcbilling-submit-error').hide();
    }
}
/**
 * Removing the selected credit card of Register user.
 * */
function removeSelectedUserSavedPamentMethods() {
    $(document).find('div.payment-method div.creditcard-tile.selected').removeClass('selected').trigger('click');
}
/**
 * Handling the different Action event for Credit Card form
 * */
function hideShowBillingCreditCardForm(currentevt, action) {
    if (currentevt && action == 'add') {
        currentevt.hide();
    } else {
        $('.spc-credit-card-create-ajax-form').html('');
        $(".spc-credit-card-create").show();
    }
}
/**
 * Toggle the same as shipping address section on Billing column.
 * */
function toggleUnCheckShippingingAddressFields(billingAddressSec, visible) {
    if (visible == true) {
        billingAddressSec.find('.country-dependent').each(function() {
            $(this).show();
        });
    } else {
        billingAddressSec.find('.country-dependent').each(function() {
            $(this).hide();
        });
    }

    if (window.User.isCustomerAuthenticated == false) {
        $('.checkout-billing').find('.set-default-cb').hide();
    }
}
/**
 * Setting the selected credit card ID for Register users.
 * */
function closeAllOpenFormOnBillingSection() {
    if ($('.subtitle.SPCCardForm-continer-close').length > 0) {
        $('.subtitle.SPCCardForm-continer-close').trigger('click');
    }
    if ($('.close-gift-form').length > 0) {
        $('.close-gift-form').trigger('click');
    }
    hideShowBillingAddressForm();
}
/**
 * Clearing the Gift certificate form Input field value and error message.
 * */
function clearGiftCertForm(formType) {
    if (formType == 'gcform') {
        $('.checkout-billing').find('.spc-apply-error').html('');
        $('.checkout-billing').find('.spcGiftCertID .spc-gc-alphanumeric').val('');
        $('.checkout-billing').find('.spcGiftCertPin .spc-gc-alphanumeric').val('');
    } else {
        $('.modal-content .gift-card-number').find('.alphanumeric').val('');
        $('.modal-content .gift-card-pin').find('.alphanumeric').val('');
    }

}
/**
 * Focusing the page on top DIV section of Single page Checkout flow on javascript
 * Event call functionality(Eg:- click, submit, etc...).
 * */
function scrollToTopSection() {
    $('.scroll-top-inner').trigger('click');
}
/**
 * We are updating the order total on TOP div section
 * in Order Review Column.
 * */
function updateOrderTotalSec() {
    if ($('.review-total-amt').length > 0) {
        $('.review-total-amt').html($('.order-value').text());
    }
}
/**
 * Edit button in the payment summary
 */
function editPaymentSummary() {
	$(document).on('click', '.edit-btn.payment-summary-edit', function(e) {
		util.singlePageNextCheckoutStep(3);
		$('html, body').stop( true, true ).animate({
	        scrollTop: $(".SPCBillingPageSec").offset().top
	    }, 1000);
	});
}
/**
 * We are hiding the unnecessary error message on Single Page Checkout 
 * Review Column.
 * */
function hidingCouponCodeErrorMsgDIV() {
    var i = 0;
    $('.spc-applycoupon-error').each(function() {
        i = ++i;
        if (i > 1) {
            $(this).remove();
        }
    });
}
/**
 * Below function for adding coupon code at Summary section on SinglePageCheckout flow.
 * */
function spcAddPromoCouponCode() {
    var spcStep = $('.spcCheckoutSteps').val();
    spcStep = (spcStep !== undefined && spcStep > 1) ? spcStep : 1;

    $(document).on('click', '.spc-summary #add-coupon.spcAddCouponBtn', function(e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var formaction = Urls.spcApplyCouponCode;
        var formSer = $('form[id="CheckoutAddPromocode"]');
        var formData = formSer.serialize();
        $.post(formaction, formData)
            .done(function(data) {
                $(document).foundation();
                if (data.success == false) {
                    spcStep = data.steps;
                    util.setSpcCheckoutSteps(spcStep);
                    util.singlePageNextCheckoutStep(spcStep);
                    hidingCouponCodeErrorMsgDIV();
                    $('.spc-applycoupon-error').html(data.message);
                } else if (data.success == true) { //shipping section is not complete
                    spcStep = data.steps;
                    $('.spc-applycoupon-error').html('');
                    $(this).val('');
                    util.setSpcCheckoutSteps(spcStep);
                    util.singlePageNextCheckoutStep(spcStep);
                    updateOrderTotalSec();
                    require('./shipping').ShippingUpdateSummary();
                    scrollToTopSection();
                }

                return false;
            });
    });
}
/**
 * SinglePageCheckout Billing Form Submit section.
 * 
 * */
function spcBillingColumnEvents() {
    /**
     * Below function for register user save card payment methods and on click of Payment methods text filed
     * checked the validation.
     * */
    $(document).on('keyup blur focusout keypress', '.spc-billing input.regcustpclCVN', function(e) {
            var cardCvnLength = $(this).val().length;
            var cvnMinLen = $(this).attr('data-min-length');
            var cvnMaxLen = $(this).attr('data-max-length');
            if (cardCvnLength < cvnMinLen || cardCvnLength > cvnMaxLen) {
                util.displayCVNErrorMessage('show');
            } else if (cardCvnLength == cvnMinLen || cardCvnLength == cvnMaxLen) {
                util.displayCVNErrorMessage();
            } else {
                util.displayCVNErrorMessage();
            }
        })
        //checkout steps      
        .on('click', '.button-checkoutstep', function() {
        	var currentValue = $(this);
            $(this).hide();
            $('.checkout-progress-container .step').addClass('section-overlay').removeClass('active');
            $(this).closest('.step').removeClass('section-overlay').addClass('active');
            require('./shipping').scrollActiveSection(currentValue);
        })
        //giftcard form closing section
        .on('click', '.spc-billing .close-gift-form', function(e) {
            var $giftCardForm = $('.gift-card-form');
            var $giftCardCheckLink = $('.check-gift-card.checkGiftCardBalanceLink');
            $giftCardForm.slideUp().addClass('rolledup');
            $giftCardCheckLink.addClass('hide');
            clearGiftCertForm('gcform');
            $('.gift-card-form-toggle').removeClass('hide');
        })
        //Expanding gift-card-form-toggle
        .on('click', '.spc-billing .gift-card-form-toggle', function(e) { //click on Add GiftCard link
            e.preventDefault();
            var $giftCardForm = $('.gift-card-form');
            var $giftCardCheckLink = $('.check-gift-card.checkGiftCardBalanceLink');

            $giftCardForm.slideDown().removeClass('rolledup');
            $giftCardCheckLink.removeClass('hide');
            $(this).addClass('hide');
            initGiftCardBalance();

            $('.gift-card-form input[name$="_giftCertCode"], .gift-card-form input[name$="_giftCertPIN"]').on('blur', function(e) {
                var $this = $(this);
                $this.siblings('span.error').remove();
                $this.removeClass('error');
                $('#spcAddGiftCert').prop('disabled', false);
                $('.gift-card-form .apply-error').html('');

                if ($this.val() && !$this.val().trim().match(/^[a-z0-9]+$/i)) {
                    $('<span class="error">' + $this.attr('data-required-text') + '</span>').insertBefore($this);
                    $this.addClass('error');
                }

                if ($('.gift-card-form span.error').length > 0) {
                    $('#spcAddGiftCert').prop('disabled', true);
                }
            });
            clearGiftCertForm('gcform');
        })
        /**
         * Below function for Same as shipping address check box field on Billing Column address section.
         * */
        .on('change', '.spc-billing .spc-billing-address .same-shippingaddress input#shipping-address-checked', function(evt) {
            var sameascheckbox = $(this);
            var billingAdrsSec = $('.spc-billing .spc-billing-address');

            if (sameascheckbox.is(":checked")) {
                billingAdrsSec.find('.saved-addresses.select-billing-address').addClass('hide');
                billingAdrsSec.find('.saved-addresses.default-billing-address').removeClass('hide');

                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_firstName').val($('#dwfrm_billing_billingAddress_addressFields_firstName').attr('data-firstname'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_lastName').val($('#dwfrm_billing_billingAddress_addressFields_lastName').attr('data-lastname'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_address1').val($('#dwfrm_billing_billingAddress_addressFields_address1').attr('data-address1'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_address2').val($('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_postal').val($('#dwfrm_billing_billingAddress_addressFields_postal').attr('data-postal'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_country').val($('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_states_state').val($('#dwfrm_billing_billingAddress_addressFields_states_state').attr('data-state'));
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_phone').val($('#dwfrm_billing_billingAddress_addressFields_phone').attr('data-phone'));
                sameascheckbox.val('true');
                var currentEvent = evt.currentTarget;
                hideShowBillingAddressForm($(currentEvent), 'edit');
                billingAdrsSec.find(".flag-show-hide").fadeIn();
                toggleUnCheckShippingingAddressFields(billingAdrsSec, true);

                // for logged-in users with address, reselect default shipping address
                // if customer chooses to use the shipping address as their billing address
                var selectedShipping = $('div.address-tile.address-default');
                if (selectedShipping) {
                    selectedShipping.removeClass('selected');
                    selectedShipping.removeClass('default');
                    selectedShipping.trigger("click");
                }

            } else {
                billingAdrsSec.find('.saved-addresses.default-billing-address').addClass('hide');
                billingAdrsSec.find('.saved-addresses.select-billing-address').removeClass('hide');

                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_address1').val('');
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_address2').val('');
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_city').val('');
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_postal').val('');
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_phone').val('');
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_postcode').val('');
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_province').val('');
                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_states_state').val('');

                billingAdrsSec.find(".flag-show-hide").fadeOut(); //this is related with selection of country field and displaying the fields w.r.t. country    	   

                billingAdrsSec.find('#dwfrm_billing_billingAddress_addressFields_country').val('');
                sameascheckbox.val('false');

                toggleUnCheckShippingingAddressFields(billingAdrsSec, false);
            }
        }).on('click', '.spc-billing .spc-show-allsaved-cards', function() {
            /**
             * On click of Show-All-Saved-Credit-Cards link then it will display all related cards to user. 
             * */
            $('.spc-billing .creditcard-tile').removeClass('hide');
            $(this).addClass('hide');
            $(this).closest('.spc-selectable-pament-options').find('.hide-saved-card').removeClass('hide');
        }).on('click', '.hide-saved-card' , function(){
			 var container = $(this).closest('.spc-selectable-pament-options');
			 $(container).find('.spc-show-allsaved-cards').removeClass('hide');
			 $(container).find('.creditcard-tile').addClass('hide');
			 $(container).find('.creditcard-tile.selected').removeClass('hide');
			 $(this).addClass('hide');
		 })
        /**
         * Add Credit Card Section for Register USER. 
         * */
        .on('click', '.spc-billing .spc-credit-card-create', function(evt) {
            evt.stopPropagation();
            var currentEvent = evt.currentTarget;
            hideShowBillingCreditCardForm($(currentEvent), 'add');
            var formInsertDiv = $(".spc-credit-card-create-ajax-form");

            $.get(util.appendParamToURL(Urls.spcShowCreditCardForm, 'format', 'ajax'), function(data) {
                formInsertDiv.html(data);
                formInsertDiv.addClass('spc-billing-creditcard-form');
                validator.initForm('form[id="SPCCreditCardForm"]');
                cardValidation.init();
            });
        })
        /**
         * Add Credit Card Section form events. 
         * */
        .on('click', 'button.spcCreditCardCreateBtn', function(e) {
            e.preventDefault();
            var form = $('form[id="SPCCreditCardForm"]');
            var formaction = Urls.spcPaymentInstrumentSubmit;
            form.validate();
            if (!$('#SPCCreditCardForm').valid()) {
                util.formFieldFocusOnError(form);
                return false;
            }
            var formData = form.serialize() + "&format=ajax&dwfrm_paymentinstruments_creditcards_create=Apply";
            $.post(formaction, formData)
                .done(function(data) {
                    if (data.success == true) {
                        $('.spcbillingCC-submit-error').hide();
                        hideShowBillingCreditCardForm();
                        updateBillingColumn(data);
                    } else {
                        $('.spcbillingCC-submit-error').removeClass('hide').show().html(data.InvalidErr);
                        return false;
                    }
                });
            return false;
        })
        //Close the New Credit Card section
        .on('click', '.spc-billing .SPCCardForm-continer-close', function(evt) {
            hideShowBillingCreditCardForm();
        })
        .on('click', '.spc-billing .spc-billing-address-create', function(evt) {
            evt.stopPropagation();
            var currentEvent = evt.currentTarget;
            hideShowBillingAddressForm($(currentEvent), 'add');
            var formInsertDiv = $(".spc-billing-address-form-ajax");
            $(this).addClass('view-billing-form');

            if ($(this).hasClass('view-billing-form')) {
                $('.spc-billing-address-create').hide();
                $('.spc-billing-address-form-ajax').show();
            }

            $.get(util.appendParamToURL(Urls.checkoutSPCAddBillingAddress, 'format', 'ajax'), function(data) {
                formInsertDiv.html(data);
                formInsertDiv.addClass('spc-billing-address-form');
                var submitHandler = function() {
                    var form = $('form[id="SPCBillingEditAddressForm"]');
                    var formSer = form.serialize() + "&format=ajax&from=billing";
                    $.post(Urls.addUpdateAddress, formSer)
                        .done(function(data) {
                            $cache.billingcol.html(data);
                        });

                    return false;
                };

                validator.initForm('form[id="SPCBillingEditAddressForm"]', submitHandler);
                //addressVerificationSvc.init();
                removePOBoxCaption();
            });
        })
        // edit billing address link
        .on("click", ".spc-billing .address-tile .spc-billingaddress-edit", function(evt) {
            var currentEvent = evt.currentTarget;
            hideShowBillingAddressForm($(currentEvent), 'edit');

            var element = document.getElementById(evt.currentTarget.id);
            var addressID = element.dataset.addressId;
            var addressCode = element.dataset.addressCode;
            var url = Urls.spcEditBillingAddress + addressID;
            var formInsertDiv = $('.spc-billing-address-form-ajax-' + addressID);
            $.get(url, function(data) {
                formInsertDiv.html(data);
                formInsertDiv.addClass('edit-spcbilling-address-ajax');
                enableCountryField(false);
                var submitHandler = function() {
                    var form = $('form[id="SPCBillingEditAddressForm"]');
                    var formSer = form.serialize() + "&format=ajax&from=billing&dwfrm_profile_address_edit=Apply";
                    $.post(Urls.addUpdateAddress, formSer)
                        .done(function(data) {
                            $cache.billingcol.html(data);
                            removeSelectedUserSavedPamentMethods();
                            spccybcustom.init();
                        });
                    return false;
                };

                validator.initForm('form[id="SPCBillingEditAddressForm"]', submitHandler);
                removePOBoxCaption();
                var setDefaultCheckbox = $('input[id$="_setdefault"]');
                if (setDefaultCheckbox.prop('checked')) {
                    setDefaultCheckbox.attr('disabled', 'true');
                }
            });

        })
        .on('click', '.back-button, .sp-add-address-title', function(evt) {
            hideShowBillingAddressForm();
        })
        .on('click', '.edit_address_form .back-button, .addbillingaddress-title', function(evt) {
            $('.spc-billing .spc-billing-address-create').removeClass('view-billing-form');
            $('.spc-billing-address-form-ajax').hide();
            $('.spc-billing-address-create').hide();
        })
        .on('click', '.spc-billing .address-list .address-tile', function(evt) {
            if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
                return false;
            } else {
                $('.address-list .address-tile').each(function() {
                    $(this).removeClass('selected');
                    $(this).removeClass('default');
                });

                $(this).addClass('selected');

                var element = document.getElementById(evt.currentTarget.id);
                if (element) {
                    var addressID = element.dataset.addressId;

                    var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
                        addressID: addressID,
                        //format: 'ajax'
                    });
                    $.ajax({
                        url: url,
                        type: 'GET',
                        success: function(result) {
                            //alert(result);
                        }
                    });
                }

            }
        })
        /**
         * Add Credit Card Section for Register USER. 
         * */
        .on("click", ".spc-billing .spc-cc-section", function(evt) {
            $('.spc-cc-title').toggleClass('spc-cc-expanded');
            $('.creditcard-form-container').slideToggle();
            cardValidation.init();
            validator.init();
            evt.stopImmediatePropagation();
            return false;
        })
        /**
         * Function for removing the applied gift certificate from Cart.
         * */
        .on('click', '.spc-billing .spcRemoveGC.remove', function(e) {
            e.preventDefault();
            var code = $(this).attr('data-gccode');
            var $error = $(this).parents('.appliedGCToCart').children('.spc-remove-apply-error');
            $error.html('');

            if (code.length === 0 || code == undefined) {
                $error.html(Resources.GIFT_CARD_CODE_INVALID);
                return;
            }

            var url = util.appendParamsToUrl(Urls.spcRemoveAppliedGC, {
                giftCertificateID: code,
                format: 'ajax'
            });

            $.getJSON(url, function(data) {
                if (data.success) {
                    $error.html('');
                    updateBillingColumn();
                } else if (!data.success) {
                    $error.html(data.message);
                } else {
                    $error.html(Resources.BAD_RESPONSE);
                }
                return false;
            });
        })
        /**
         * Open the modal popup form to provide the balance check option
         * on modal popup.
         * */
        .on('click', '.spc-billing .checkGiftCardBalanceLink', function(evt) {
            modal.events.onOpen(function() {
                validator.initForm('form[id$="spcGCModalForm"]');
                $('.gift-card-number .input-text.spcModalGCNum').val(null);
                $('.gift-card-pin .input-text.spcModalGCPINNum').val(null);
            });
            modal.restoreDefaultClass();
            modal.renderByUrl(Urls.spcBalanceCheckModalForm);
            modal.addCustomClass('gift-card-balance-modal spcGiftCardBalanceModal');
        })
        /**
         * Checking Gift Card balance for GC card on Modal Popup form 
         * */
        .on('click', '.checkBalanceGiftCertModal', function(e) {
            e.preventDefault();
            var $giftCode = $('.gift-card-number .input-text.spcModalGCNum');
            var $giftPin = $('.gift-card-pin .input-text.spcModalGCPINNum');
            spcGCModalBalanceCheck($giftCode, $giftPin);
            return false;
        })
        /**
         * Checking Gift Card balance for another card on Modal Popup form.
         * */
        .on('click', '.gcModalCheckAnotherCard', function(evt) {
            var $giftCode = $('.gift-card-number .input-text.spcModalGCNum');
            var $giftPin = $('.gift-card-pin .input-text.spcModalGCPINNum');
            spcModalCheckAnotherCard($giftCode, $giftPin);
            return false;
        })
        /**
         * Below function for adding Gift Certificate form Giftcard Modal Popup functionality.
         * */
        .on('click', '.applyGiftCertModal', function(evt) {
            evt.preventDefault();
            var $error = $('div#gift-card-balance-form .balance-error');
            $error.html('');
            var $giftCode = $('.gift-card-number .input-text.spcModalGCNum');
            var $giftPin = $('.gift-card-pin .input-text.spcModalGCPINNum');
            if ($giftCode.val() !== undefined && $giftPin.val() !== undefined) {
                spcApplyGiftCertModal($giftCode, $giftPin);
            } else {
                $error.html(Resources.GIFT_CARD_CODE_INVALID);
            }
            return false;
        })
        /**
         * Below function for adding click action to edit button for  
         * Order-Summary column section on SinglePageCheckout flow.
         * */
        .on('click', '.spc-summary .spc-mini-cart-link-cart', function() {
            var btnHrefAttr = $(this).attr('href');
            btnHrefAttr = (btnHrefAttr !== undefined && btnHrefAttr !== '') ? btnHrefAttr : Urls.cartShow;
            window.location = btnHrefAttr;
        });
} //spcBillingColumnEvents
/**
 * Iterating the Saved User credit cards and on Payment section page load we are selecting or focusing
 * the card for register user only.
 * */
function selectDefaultSavedCreditCard() {
    //select credit card tile for register user
    $(document).on('click', '.spc-billing .creditcard-tile', function(evt) {
        var $this = $(this);
        var piCardTypeVal = $this.find('.creditcard-tile-inner .cc-number').attr('data-cctype');
        piCardTypeVal = (piCardTypeVal != undefined && piCardTypeVal != '' && piCardTypeVal != null) ? piCardTypeVal : '';
        var setCVVCardLength = util.setCheckoutPaymentCardCVVLength(piCardTypeVal);
        var cvnMaxLength = (setCVVCardLength != undefined) ? setCVVCardLength.maxLength : 4;
        var cvnMinLength = (setCVVCardLength != undefined) ? setCVVCardLength.minLength : 3;
        var ccEdit = $this.find('.credit-card-edit');
        var fauxCVNInput = '<div class="cvn-input"></div>';
        var CVNInput = '<input class="input-text regcustpclCVN " type="text" id="dwfrm_billing_paymentMethods_creditCard_cvn" name="dwfrm_billing_paymentMethods_creditCard_cvn" value="" data-min-length="' + cvnMinLength + '" data-max-length="' + cvnMaxLength + '" maxlength="' + cvnMaxLength + '" aria-invalid="false" data-regex-pattern="/^\d{' + cvnMinLength + ',' + cvnMaxLength + '}$/">';

        if (evt.target == ccEdit[0]) {
            return;
        }

        if ($(this).is('.selected, .default')) {
            return false;
        } else {
            $('.creditcard-tile').each(function() {
                $(this).removeClass('selected');
                $(this).removeClass('default');
                $(this).find('.saved-cvn').addClass('disabled');
                $(this).find('.saved-cvn input').replaceWith(fauxCVNInput);
            });
            
            $(this).closest('.payment-list').find('.creditcard-tile').addClass('hide');
        	$(this).closest('.payment-list').find('.show-allsaved-cards').removeClass('hide');
            if (!$('show-allsaved-cards').hasClass('hide')) {
        		$(this).closest('.spc-selectable-pament-options').find('.hide-saved-card').addClass('hide');
        	}
            $this.addClass('selected').removeClass('hide');
            $this.find('.cvn-input').removeClass('disabled');
            $this.find('.saved-cvn .cvn-input').replaceWith(CVNInput);
            $this.find('.saved-cvn input').trigger("focus");

            $('.creditcard-tile .cvnvalidationerror').removeClass('errorshow').addClass('errorhide');
            $('.creditcard-tile .cvnvalidationerror.errorhide').html('');
            $('.creditcard-tile').each(function() {
                if ($(this).hasClass('selected')) {
                    $('.creditcard-tile.selected .cvnvalidationerror').removeClass('errorhide').addClass('errorshow');
                }
            });

            var element = document.getElementById(evt.currentTarget.id);

            var creditcardPosition = element.dataset.creditcardPosition;

            var url = util.appendParamsToUrl(Urls.checkoutCreditCardSelection, {
                position: creditcardPosition,
            });
            $.ajax({
                url: url,
                type: 'GET',
                success: function(result) {}
            });

            setSelectedCardID($this.data("uuid"));
            addCVNEvent();
        }

    });
    cardValidation.init();
    initCreditCardForm();
    validator.init();
    validator.initForm('form[id$="billing"]');
    //trigger click event for selected by default cc on Page load of payment section(to manually trigger cc code)
    var selectedCC = $('div.payment-method div.creditcard-tile.selected');
    if (selectedCC && SessionAttributesStep.SPC_CHKOUTSTEPS > 2) {
        selectedCC.removeClass('selected').trigger("click");
    }
}
/**
 * This function(spcBillingColumnContinueToSubmitBtn) is responsible for submitting the events for Single page checkout Billing column
 * section. Once it is successfully submitted then we will render on OrderReview column.
 * We have handle the form submit functionality through AJAX event.
 * */
function spcBillingColumnContinueToSubmitBtn() {
    $(document).on('click', '#dwfrm_billing_save.spcBillingContinueBtn', function(e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var formID = form.attr('id');
        var formaction = Urls.spcBillingSubmit;
        var formSer = $('form[id="' + formID + '"]');
        var formData = formSer.serialize();
        closeAllOpenFormOnBillingSection();

        if ($('input[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked').val() == 'CREDIT_CARD' &&
            ($('.spcCustomerPCLDetails').length > 0 || $('.creditcard-form-container').length > 0)) {
            form.validate();
            var cardCVNMinLen = $('.creditcard-tile.selected input.regcustpclCVN').attr('data-min-length');
            var cardCVNMaxLen = $('.creditcard-tile.selected input.regcustpclCVN').attr('data-max-length');
            cardCVNMinLen = (cardCVNMinLen !== undefined && cardCVNMinLen !== '') ? cardCVNMinLen : 0;
            cardCVNMaxLen = (cardCVNMaxLen !== undefined && cardCVNMaxLen !== '') ? cardCVNMaxLen : 0;

            if (!form.valid()) {
                util.formFieldFocusOnError(form);
                return false;
            }

            if ($('#dwfrm_billing_paymentMethods_creditCard_cvn').is(':visible') == true) {
                var cvnobj = $('#dwfrm_billing_paymentMethods_creditCard_cvn').val();
                let cvnObjLen = (cvnobj !== '' && cvnobj !== undefined && cvnobj != null) ? cvnobj.length : 0;
                if ((cvnObjLen == 0 && cvnobj == '') || cvnObjLen < cardCVNMinLen || cvnObjLen > cardCVNMaxLen && $('input.regcustpclCVN').length > 0) {
                    $('#dwfrm_billing_paymentMethods_creditCard_cvn').trigger("focus");
                    util.displayCVNErrorMessage('show');
                    return false;
                } else {
                    util.displayCVNErrorMessage();
                    $.post(formaction, formData)
                        .done(function(data) {
                            if (data.success == false) {
                                showORHideSubmitErrorFunction(true, data.BillingError);
                                var currentPos = $('.spcbilling-payment-sec').offset().top;
                                require('./card-validation').scrollToPos(currentPos);
                            } else {
                                showORHideSubmitErrorFunction(false, '');
                                util.setSpcCheckoutSteps(4);
                                $cache.summarycol.html(data);
                                $(document).foundation();
                                util.singlePageNextCheckoutStep(4);
                                if ($('.spc-orderconfirmation-div').hasClass('guest-user')) {
                                	maskCardNumber();
                                } 
                                require('./shipping').scrollActiveSection(form);
                            }
                            // calling GA event for next checkout step [Review]
                            analytics.initSPCReviewEvent();
                        });
                    return false;
                }
            } else {
                showORHideSubmitErrorFunction(true, Resources.SPC_INVALID_PAYMENTINF);
                removeSelectedUserSavedPamentMethods();
                if ($('.sub-title.spc-cc-title.spc-cc-section').length > 0) {
                    $('.sub-title.spc-cc-title.spc-cc-section').trigger('click');
                    if (!form.valid()) {
                        util.formFieldFocusOnError(form);
                        return false;
                    }
                }
                scrollToTopSection();
                return false;
            }

        } else if ($('input[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked').val() == 'AFTERPAY_PBI') {
            $('#' + formID).attr('action', formaction).trigger("submit");
        } else {
            $.post(formaction, formData)
                .done(function(data) {
                    util.setSpcCheckoutSteps(4);
                    util.singlePageNextCheckoutStep(4);
                    $cache.summarycol.html(data);
                    $(document).foundation();
                    if ($('.spc-orderconfirmation-div').hasClass('guest-user')) {
                    	maskCardNumber();
                    } 
                    require('./shipping').scrollActiveSection(form);
                });
            //Calling GA tagging event
            analytics.initSPCReviewEvent();
            return false;
        }
    });
}
/**
 * Card Number Converted as MASK number(*********7891) for entered 
 * card number on text field by customer.
 * */
function maskCardNumber() {
	var cardNumber = $('.form-row.cc-number input'),
		cardValue = cardNumber.val(),
		cardLength = cardValue.length,
		editLength = cardLength - 4,
		hiddenValue = '*',
		slice1 = cardValue.slice(0,editLength-1),
		slice2 = cardValue.slice(editLength,cardLength),
		hiddenValueFix = '',
		maskCard='';
	for(var i=0;i<editLength;i++) {
		hiddenValueFix = hiddenValueFix + hiddenValue;
	}
	maskCard = hiddenValueFix + slice2;
	cardNumber.val(maskCard);
}
/**
 * Setting the default Billing Address same as shipping address
 * for that current session checkout flow in order to place order.
 * */
function setBillingAdrsSameAaShippingAddressCheckbox() {
	// if same as shipping is checked, re-select default address
    // or if nothing is selected, re-select default address
    if (($('input#shipping-address-checked').length > 0 && $('input#shipping-address-checked').is(":checked")) ||
        $('div.address-list div.address-tile.selected').length <= 0) {
        $(document).find('.spc-billing div.address-list div.address-tile').each(function(ind, evt) {
            if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
                $(this).removeClass('selected');
                $(this).removeClass('default');

                $(this).trigger("click");
            }
        });
    } else if ($('input#shipping-address-checked').length == 0 && $('div.address-list div.address-tile.selected').length > 0) {    	
        // if no physical product to ship, re-select tile to properly assign billing address
        var reSelectTile = $('.spc-billing div.address-list div.address-tile.selected');
        //commented the below line to retain back address selection upon continue from shipping to billing section.
        //reSelectTile.removeClass('selected');
        reSelectTile.removeClass('default');
        reSelectTile.trigger("click");
    }
}
/**
 * Set User's shipping default submitted address to be setting
 * as default billing address on Billing column. 
 * We have set by getting the SAMEASSHIPPING forms submitted value on 
 * Billing Continue submit(Continue To Review) of SFCC form framework.
 * */
function setDefaultBillingColCheckbox() {
	let $sameAsShippingAdrs = $('.spc-summary .SPCSummaryPageSec #secondary .spcBillColSameAsShippingAddress');
	let $sameAsShippingAddressChk = $('.spc-billing .spc-billing-address .same-shippingaddress input#shipping-address-checked');
	if ($sameAsShippingAdrs.length > 0) {
		let billingAddresSameAsShippingadrs = $sameAsShippingAdrs.attr('data-sameasshipping-address');	    
	    if (billingAddresSameAsShippingadrs !== undefined && billingAddresSameAsShippingadrs == 'true') {
	    	$sameAsShippingAddressChk.prop('checked', true);
	        $sameAsShippingAddressChk.trigger('change');
	    } else {
	    	$sameAsShippingAddressChk.prop('checked', false);
	    }     	
	}
	
	// trigger only for non-registered users
    if (window.User.isCustomerAuthenticated == false) {
        $('input[name$="_creditCard_cvn"], input[name$="_creditCard_owner"]').on('change', function() {
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
        });
        $('.checkout-billing').find('.set-default-cb').hide();
    }
}
/**
 * As we have multiple payment methods on our Global core we are setting
 * the payment methods on Page load or on ajax call page load.
 * */
function settingDefaultPaymentMethodOnAjaxLoad() {
	var $selectPaymentMethod = $(document).find('.selectable-payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();
	 // default payment method to 'CREDIT_CARD'
    updatePaymentMethod((selectedPaymentMethod) ? selectedPaymentMethod : 'CREDIT_CARD');
    $selectPaymentMethod.on('click', 'input[type="radio"]', function() {
    	updatePaymentMethod($(this).val());
    });
}
/**
 * Loading Billing column data on Shipping column when user submit's the shipping form
 * successfully on ContinueToPayment Button click action by user.
 * */
function initializeBillingColumnData() {
	selectDefaultSavedCreditCard();
	setBillingAdrsSameAaShippingAddressCheckbox();
	setDefaultBillingColCheckbox();
	settingDefaultPaymentMethodOnAjaxLoad();
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function() {
    if ($('.spc-container').length > 0) {
    	editPaymentSummary();
        initBillingColumnCache();
        cardValidation.init();
        initCreditCardForm();
        initGiftCardBalance();

        var $selectPaymentMethod = $(document).find('.selectable-payment-method-options');
        var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();
        validator.initForm('form[id$="billing"]');
        removePOBoxCaption();
        selectDefaultSavedCreditCard();
        spcBillingColumnEvents();
        spcBillingColumnContinueToSubmitBtn();

        $(document).on('change', '.spc-billing #dwfrm_billing_billingAddress_addressFields_country, .spc-billing #dwfrm_billingaddress_country', function() {
            var selectContry = $(this).val();
            if (selectContry == '') {
                toggleBillingAddressFields();
            } else if (selectContry == 'us') {
                toggleBillingAddressFields(true);
                $('.spc-billing .us-fields').show();
                $('.spc-billing .us-fields input').each(function() {
                    $(this).addClass('required');
                });

                $('.spc-billing .cn-fields').hide();
                $('.spc-billing .cn-fields input').each(function() {
                    $(this).removeClass('required');
                });
            } else {
                toggleBillingAddressFields(true);
                $(".spc-billing .cn-fields").show().css({
                    "display": "flex"
                });
                $('.spc-billing .cn-fields input').each(function() {
                    $(this).addClass('required');
                });

                $('.spc-billing .us-fields').hide();
                $('.spc-billing .us-fields input').each(function() {
                    $(this).removeClass('required');
                });
            }
        });

        settingDefaultPaymentMethodOnAjaxLoad();
        creditCardTypeDetector();

        $('.order-summary-footer form').on("submit", function() {
            $('#summary-place-order').prop('disabled', true).addClass('loading');
            return true;
        });        
        setBillingAdrsSameAaShippingAddressCheckbox();
        setDefaultBillingColCheckbox();
        
        // maximize order checkout summary dropdown
        util.maximizeCheckoutSummary();

        util.renderGoogleInvRecaptcha("billingrecaptcha", "#dwfrm_billing_save", "dwfrm_billing");
    }
    $(document).on('click','.spcSummaryPageSubmitBtn', function() {
    	$(this).addClass('loading');
    	$('#spcSummaryPageForm').on("submit", function() {
    		 $('#summary-place-order').prop('disabled', true).addClass('loading');
    		 return true;
    	});
    });
    if ($('.SPCSummaryPageSec').find('.error-form').length>0) {
    	//$('.spcSummaryPageSubmitBtn').removeAttr('disabled');
    	$('.spcSummaryPageSubmitBtn').prop('disabled', false);
		$('.spcSummaryPageSubmitBtn').removeClass('loading');
	}
    
}
exports.SPCAddPromoCouponCode = spcAddPromoCouponCode;
exports.spcSelectDefaultSavedCreditCard = selectDefaultSavedCreditCard;
exports.loadBillingColData = initializeBillingColumnData;
},{"../../ajax":5,"../../analytics":6,"../../giftcard":19,"../../modal":28,"../../util":87,"../../validator":88,"./card-validation":62,"./shipping":66,"./spccybcustom":67}],62:[function(require,module,exports){
'use strict';

// https://gist.github.com/ShirtlessKirk/2134376

var luhnCheck = (function (arr) {
    return function (ccNum) {
        var len = ccNum.length;
        var bit = 1;
        var sum = 0;
        var val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

var cvvCheck = function (cvv) {
    return /^[0-9]{3,4}$/.test(cvv);    
};

var initCardExpiry = function(){
	var ccSave = $('#CreditCardForm #applyBtn');
	ccSave.on('click', function(e){
		validateCardExpiry(this, true);
	});
	
	$('.card-expiry.month, .card-expiry.year').on('change blur', function(){
		validateCardExpiry(this);
	});
};

var validateCardExpiry = function(el, checkEmpty){
	// need to declare specifically in order not to confuse with other forms with similar inputs
	var $this = $(el);
	var $month = $this.closest('form').find('.card-expiry.month');
	var $year = $this.closest('form').find('.card-expiry.year');
	var $submit = $this.closest('form').find('button[type="submit"]');
	var hasError = false;
	
	var now = new Date();
	var nowMonth = now.getMonth() + 1; 
	var nowYear = now.getFullYear();
	
	$month.siblings('span.error').remove();
	$year.siblings('span.error').remove(); //-- Ade CG-4
	$month.removeClass('error');
	$year.removeClass('error');
	$submit.prop('disabled', false);
	
	// validate only on form submit
	/*if(checkEmpty && (!$month.val() || !$year.val())){
		$('<span class="error">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($month);
		hasError = true;*/
	if(checkEmpty) {
		if (!$month.val()){
			$('<span class="error" id="errormonth">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($month);
			hasError = true;
		}
		if (!$year.val()){
			$('<span class="error" id="erroryear">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($year);
			hasError = true;
		}
	// validate only if month and year has value, otherwise, ignore
	} else if($month.val() && $year.val()){
		if ($year.val() < nowYear) {
			$('<span class="error">' + Resources.VALIDATE_CARDEXPIRY + '</span>').insertBefore($year);
			hasError = true;
		} else if ($month.val() < nowMonth && $year.val() == nowYear) {
			$('<span class="error">' + Resources.VALIDATE_CARDEXPIRY + '</span>').insertBefore($month);
			hasError = true;
		}
	}
	
	// highlight inputs if expiry has error 
	if(hasError){
		$month.addClass('error');
		$year.addClass('error');
	}
	
	// disable button if there are errors -- // change by ticket shi-5388
	if($this.closest('form').find('span.error').length > 0){
		$submit.prop('disabled', true);
		var currentValue = $this.closest('form').offset().top;
		scrollToPos(currentValue);
	}
};

function scrollToPos(pos) {
    $('html, body').animate({
        scrollTop: pos
     }, 800);
}

exports.init = function () {
	initCardExpiry();
}

exports.scrollToPos = scrollToPos;
},{}],63:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var hasEmptyRequired = function () {
    // filter out only the visible fields
    var requiredValues = this.$requiredInputs.filter(':visible').map(function () {
        return $(this).val();
    });
    return _(requiredValues).contains('');
};

var validateForm = function () {
	var _self = this;
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
    if (!this.validator) {
        return;
    }
    
    // wait for the form to show before validating.. this applies to modals
    this.timer = setInterval(function(){ 
    	if(_self.$form.is(':visible')) {
    		if (_self.$form.find('span.error:visible, .error-form:visible').length == 0) { //!_self.hasEmptyRequired() &&
    			_self.$continue.prop('disabled', false);
    		} else {
    			_self.$continue.prop('disabled', true);
    		}
    		clearInterval(_self.timer);
    	}
    }, 100);
    
};

var validateEl = function (e) {
    if ($(e.target).val() === '') {
        this.$continue.prop('disabled', true);
    } else {
        // enable continue button on last required field that is valid
        // only validate single field
        if (!this.hasEmptyRequired()) { 
            this.$continue.prop('disabled', false);
        } else {
            this.$continue.prop('disabled', true);
        }
    }
};

var checkValue = function(repopulateRequiredFields, e) {
	var $el = $(e.target);
	var attr = $el.attr('clear-on-error');
	
	// check for new required fields (e.g. changing US -> CH in address)
	if(repopulateRequiredFields){
		this.$requiredInputs = this.$form.find('input.required');
	}
	
	// remove any error message residue from previous validation
    if (this.$form.find('.-error-pad').length == 0) {
        $el.siblings('span.error').remove();
    }
	
    if (this.validator.element($el) 
    		&& this.$form.find('span.error:visible').length == 0) {
        this.$continue.prop('disabled', false);
    } else {
//        this.$continue.prop('disabled', true);
        
        // clear the value if input has error
        if(typeof attr !== typeof undefined && attr !== false) $el.val('');
    }
};

var submitForm = function(e) {
    this.$form.find('input').trigger("blur");
    this.$form.find('select').trigger("blur");

    if (this.$continue.hasClass('password-ignore')) {
        if ($(".form-row.username .field-wrapper span.error").length) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    } else if(this.validator.numberOfInvalids() > 0 || this.$form.data('submitting') == true){
//    	this.$continue.prop('disabled', true);
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    // Execute Google Recaptcha once validation is completed.
    var util = require('../../util');
    if (util.getGoogleRecaptchaEnableStatus(this.$form.attr('id')) == true) {    	    
        util.callingGoogleReCaptchaOnFormSubmitORAJAXCall(e, this.$form.attr('id'));
    }    
    
    // adding this to prevent multiple submission of forms
    if(this.$form.attr('multiple-submission') === 'false'){
    	this.$form.data('submitting', true);
    }
};

var init = function (opts, settings) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    this.$form = $(opts.formSelector);
    this.$continue = $(opts.continueSelector); 
    this.validator = settings? this.$form.validate(settings) : this.$form.validate();
    this.$allInputs = $('input, textarea', this.$form);
    this.$allSelect = $('select', this.$form);
    this.$requiredInputs = this.$form.find('input.required');
//    this.validateForm();
    
    // start listening
//    this.$requiredInputs.on('change', $.proxy(this.validateEl, this));
    this.$allInputs.on('keyup', $.proxy(this.checkValue, this, false)); 
    this.$allSelect.on('blur', $.proxy(this.checkValue, this, true));
    this.$continue.on('click', $.proxy(this.submitForm, this));
	// [life-hack:5079] needed to trigger onclick since blur prevents the form from submitting
    if(this.$continue.attr('mousesubmit') === 'true'){
    	this.$continue.on('mousedown', $.proxy(function(e){ this.$continue.trigger("click"); }, this));
    }
};

var formPrepare = function(){
	return {
		$form: null,
		$continue: null,
		$allInputs: null,
		$allSelect: null,
		$requiredInputs: null, 
		validator: null,
		init: init,
		timer: null,
		hasEmptyRequired: hasEmptyRequired,
		checkValue: checkValue,
		validateForm: validateForm,
		submitForm: submitForm,
		validateEl: validateEl
	}
}

module.exports = formPrepare;

},{"../../util":87,"lodash":116}],64:[function(require,module,exports){
'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    ajax = require('../../ajax'),
    util = require('../../util'),
    shipping = require('./shipping');
    

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    initTabs();
    address.init();
    shipping.init();
    billing.init();
    hideShowAddressTiles();	    
    billing.SPCAddPromoCouponCode();
    util.isMacOS();
    util.isApplePayPresent();
    util.autoSuggestionAddressField('spc');
};

/*
 * This method sets an active class to the element once one of the tab is clicked.
 * */
function initTabs(){
	if($('.spc-container').length > 0) {
	    var spcStepsVal= (window.SessionAttributes.SPC_CHKOUTSTEPS >0)? window.SessionAttributes.SPC_CHKOUTSTEPS: 1;
	    util.singlePageNextCheckoutStep(spcStepsVal);
	}
}

function hideShowAddressTiles(){	
	 $(document).on("click", ".showmoreaddresses", function(){
		 var addresstype = '.spc-'+$(this).data('addresstype');
		 $(addresstype + " .address-tile").removeClass("hide");
		 $(this).addClass("hide");
	 });
}
},{"../../ajax":5,"../../util":87,"./address":60,"./billing":61,"./multiship":65,"./shipping":66}],65:[function(require,module,exports){
arguments[4][41][0].apply(exports,arguments)
},{"../../dialog":16,"../../util":87,"../../validator":88,"./address":60,"./formPrepare":63,"dup":41}],66:[function(require,module,exports){
'use strict';
/**
 * We have created SPC JS file for handling all shipping related functionality for Single page checkout flow by using AJAX call.
 * and we have followed Site Genesis coding standard to complete the Single page Checkout Flow.
 * we have used abbreviated from single page checkout short name is SPC.
 * a) we are using $.get method to render the form html structure dynamically into DIV.
 * b) $.post method is used to send the data server for all single page checkout form submit functionality. 
 * c) On AJAX event success call added the HTMl content to DIV of specific column. 
 * Some important useful functions are used to achieve the SHIPPING column functionality.
 * 1) initCache() - Initializing the cache for Shipping column
 * 2) removePOBoxCaption() - Removing PO Box shipping code if it is not available
 * 3) initEvents() - Initializing the events for Shipping column 
 * 4) giftMessageBox() - for Gift message
 * 5) updateSummary() - Refreshing the Summary section
 * 6) shippingContinueToCheckoutEvent()- Handled the Shipping form submit functionality
 * 7) init() - to initiate the default events ot functions.
 * */
var ajax = require('../../ajax'),
    progress = require('../../progress'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    validator = require('../../validator'),
    modal = require('../../modal').global,
    billing = require('./billing'),
    addressVerificationSvc = require('../../qas'),
    spccybcustom = require('./spccybcustom'),
    analytics = require('../../analytics');

var $cache, shippingMethods;
/**
 * Initialize the cache for shipping page.
 * */
function initCache() {
    var $formEle = $('form[id$="_shippingAddress"]');
    $cache = {
        addrForm: {
            address1: $formEle.find('input[name$="_address1"]'),
            address2: $formEle.find('input[name$="_address2"]'),
            countryCode: $formEle.find('select[id$="_country"]'),
            stateCode: $formEle.find('select[id$="_state"]'),
            postalCode: $formEle.find('input[name$="_postal"]'),
            city: $formEle.find('input[name$="_city"]')
        },
        main: $('#main'),
        primary: $('#primary'),
        secondary: $('#secondary'),
        shippingcol: $('.spc-shipping .spc-column'),
        billingcol: $('.spc-billing .spc-column')
    };
};

// Removes 'PO Box shipping is not available' caption from address1 field if preference is true
function removePOBoxCaption() {
    if (SitePreferences.ENABLE_POBOX_ADDRESS) {
        var $addressOne = $('input[name$="_address1"]');
        $addressOne.closest(".form-row").find(".form-caption").text('');
    	var $addressTwo = $('input[name$="_address2"]');
    	$addressTwo.closest(".form-row").find(".form-caption").text('');
    }
}
/**
 * We have written the function for shipping column related events.
 *  Below function is for creating Address event and edit address section.
 * */
function initEvents() {
    // create New address link
    $(document).on('click', '.spc-shipping .address-create-spc', function(evt) {
            evt.stopPropagation();
            var currentEvent = evt.currentTarget;
            hideshowaddressform($(currentEvent), 'add');
            var formInsertDiv = $(".address-form-ajax");
            $.get(util.appendParamToURL(Urls.spcAddShippingAddress, 'format', 'ajax'), function(data) {
                formInsertDiv.html(data);
                var submitHandler = function() {
                    var form = $('form[id="EditAddressForm"]');
                    $.post(Urls.addUpdateAddress, form.serialize())
                        .done(function(data) {
                            $cache.shippingcol.html(data);
                            iterateShippingAddressTile();
                            shippingContinueToCheckoutEvent();
                            displaySaveAddressMessage();
                        });
                    return false;
                };

                validator.initForm('form[id="EditAddressForm"]', submitHandler);
                addressVerificationSvc.init();
                removePOBoxCaption();
                util.autoSuggestionAddressField('spc');
            });
        })
        // edit address link for register user
        .on('click', '.spc-shipping .address-tile .address-edit-spc', function(evt) {
            var currentEvent = evt.currentTarget;
            hideshowaddressform($(currentEvent), 'edit');

            var element = document.getElementById(evt.currentTarget.id);
            var addressID = element.dataset.addressId;
            var addressCode = element.dataset.addressCode;
            var url = Urls.spcEditShippingAddress + addressID;
            var $this = $(this);
            var addressID = $this.data('addressId');
            var formInsertDiv = $('.address-form-ajax-' + addressID);
            $('.edit-add-address').show();
            $.get(url, function(data) {
                formInsertDiv.html(data);
                var submitHandler = function() {
                    var form = $('form[id="EditAddressForm"]');
                    $.post(Urls.addUpdateAddress, form.serialize())
                        .done(function(data) {
                            $cache.shippingcol.html(data);
                            iterateShippingAddressTile();
                            shippingContinueToCheckoutEvent();
                            displaySaveAddressMessage();
                        });
                    return false;
                };

                validator.initForm('form[id="EditAddressForm"]', submitHandler);
                addressVerificationSvc.init();
                removePOBoxCaption();
                util.autoSuggestionAddressField('spc');
                var setDefaultCheckbox = $('input[id$="_setdefault"]');
                if (setDefaultCheckbox.prop('checked')) {
                    setDefaultCheckbox.attr('disabled', 'true');
                }
            });

        })
        .on('click', '.back-button, .sp-add-address-title, .sp-add-address-title', function(evt) {
            hideshowaddressform();
        })
        // authenticated user address change
        .on('click', '.spc-shipping .address-list .address-tile', function(evt) {
            if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
            	if ($(this).closest('.saved-addresses').find('.showmoreaddresses').hasClass('hide')) {
                	$(this).closest('.address-list').find('.address-tile').not(".selected").addClass('hide');
                	$(this).closest('.saved-addresses').find('.showmoreaddresses').removeClass('hide');
                } 
            	return false;
            }
            $('.address-list .address-tile').each(function() {
                $(this).removeClass('selected');
                $(this).removeClass('default');
                $(this).find('.icon-checkmark').addClass('hide')
            });
            if ($(this).closest('.saved-addresses').find('.showmoreaddresses').hasClass('hide')) {
            	$(this).closest('.address-list').find('.address-tile').addClass('hide');
            	$(this).closest('.saved-addresses').find('.showmoreaddresses').removeClass('hide');
            }           
            $(this).addClass('selected').removeClass('hide');
            $(this).find('.icon-checkmark').removeClass('hide');

            var element = document.getElementById(evt.currentTarget.id);
            if (element) {
                var addressID = element.dataset.addressId;
                // update address; on success update shipping method list
                $.get(Urls.updateAddressDetails, {
                    addressID: addressID
                }, function(response) {
                    updateShippingMethodList();
                });
            }
            checkSelectedAddress();
        })
        /**
         * Accordion functionality goes on below
         * */
        .on('click', '.spc-shipping-default .sp-accordion-arrow', function(event) {
            event.preventDefault();
            if ($('.shipping-options-section').hasClass('show-shipping')) {
                $('.shipping-options-section').hide();
                $('.icon-chevron-thin-left.icon-chevron-right').css({
                    'transform': 'rotate(360deg)'
                });
            } else {
                $('.shipping-options-section').show();
                $('.icon-chevron-thin-left.icon-chevron-right').css({
                    'transform': 'rotate(90deg)'
                });
            }
            $('.shipping-options-section').toggleClass('show-shipping');
        });

    // guest user address change
    var timer = null;
    $('form[id$="_shippingAddress"]').on('change', 'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], select[name$="_addressFields_states_state"], input[name$="_addressFields_city"], input[name$="_addressFields_postal"]', function() {
        if (!validateAddrForm()) {
            return;
        }

        if (timer) {
            window.clearTimeout(timer);
        }

        timer = window.setTimeout(function() {
            $.post(Urls.setShippingAddressDetails, $('form[id$="_singleshipping_shippingAddress"]').serialize(), function(result) {
                updateShippingMethodList();
            });
        }, 200);
    });

    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
    $('input[name$="_cart_isGift"]').on('click', giftMessageBox);

}

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
    $('.complimentary-gift-container').toggleClass('hidden, hide', $('input[name$="_cart_isGift"]:checked').val() !== 'true');
}

/**
 * this will show shipping address save message 
 */
function displaySaveAddressMessage() {
	 var i = $('.saved-address-message').removeClass('hide'),
     scrollTop = $('.spc-shipping').offset().top;
     $("html, body").animate({ scrollTop:scrollTop }, "slow"); 
     i.fadeIn();
     setTimeout(function(){ i.fadeOut(); }, 3000); 
}


/**
 * this will avoid 2 forms to be visible at the same time.
 */

function hideshowaddressform(currentevt, action) {
	var $submit = $('#dwfrm_singleshipping_shippingAddress button[value="Continue"]');
    $('.address-tile').show();
    util.autoSuggestionAddressField('spc');
    if (currentevt && action == 'add') {
        $('.edit-form-ajax').html('');
        currentevt.hide();
    } else if (currentevt && action == 'edit') {
        currentevt.closest('.address-tile').hide();
        $('.spc-shipping .address-create-spc').show();
        $('.address-form-ajax, .edit-form-ajax').html('');
    } else {
        $('.address-form-ajax, .edit-form-ajax').html('');
        $('.spc-shipping .address-create-spc').show();
        $submit.prop('disabled', false);
    }
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
    var $summary = $('#secondary.summary');
    var couponError;

    if ($('.cart-coupon-code .error').length) {
        couponError = $('.cart-coupon-code .error').clone();
    }

    var showmsg = "none";
    if ($('.cart-coupon-code .success').length > 0) {
        showmsg = "show";
    }

    // indicate progress
    progress.show($('.checkout-progress-container'));

    // load the updated summary area
    $summary.load(Urls.spcSummaryRefreshURL + "?showmsg=" + showmsg, function() {
        // hide edit shipping method link
        $summary.fadeIn('fast');

        // checkout checkout minicart on right side event handling
        addSummaryScrollbar();

        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        $('.cart-coupon-code').append(couponError);
        util.maximizeCheckoutSummary();
        if ($('.review-total-amt').length > 0) {
            $('.review-total-amt').html($('.order-value').text());
        }

        $(".checkout-mini-cart .accordion").foundation();
        $(".shipping-options-section").hide();
        progress.hide();
    });
}
/**
 * Return Selected Address from Shipping Address tile.
 * */
function getAddressFromTile() {
    var $selectedAddress = $(".address-tile.selected address");

    return {
        address1: $selectedAddress.data("address-one"),
        address2: $selectedAddress.data("address-two") || "",
        countryCode: $selectedAddress.data("country-code"),
        stateCode: $selectedAddress.data("state-code"),
        postalCode: $selectedAddress.data("postal-code"),
        city: $selectedAddress.data("city")
    };
}
/**
 * Get address form details from Dom Element
 * */
function getAddressFromForm() {
    return {
        address1: $cache.addrForm.address1.val(),
        address2: $cache.addrForm.address2.val(),
        countryCode: $cache.addrForm.countryCode.val(),
        stateCode: $cache.addrForm.stateCode.val(),
        postalCode: $cache.addrForm.postalCode.val(),
        city: $cache.addrForm.city.val()
    };
}
/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var params = User.isCustomerAuthenticated ? getAddressFromTile() : getAddressFromForm();
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, {
        shippingMethodID: shippingMethodID
    });
    ajax.getJson({
        url: url,
        callback: function(data) {
            updateSummary();
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();
            $('.spc-spping-selection-list li .shipping-name i').addClass('hide')
            $('.spc-spping-selection-list li[data-value=' + $('#shippingMethodSelect').val() + '] .shipping-name i').removeClass('hide');
        }
    });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
    var $shippingMethodList = $('#shipping-method-list');
    if (!$shippingMethodList || $shippingMethodList.length === 0) {
        return;
    }
    
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);
    ajax.getJson({
        url: url,
        callback: function(data) {
            if (!data) {
                window.alert('Couldn\'t get list of applicable shipping methods.');
                return false;
            }

            // shipping methods remain unchanged; update summary as selected method may/may not change
            if (shippingMethods && shippingMethods.toString() === data.toString()) {
                updateSummary();
                return true;
            }

            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            //progress.show($shippingMethodList);
            progress.show($('.checkout-progress-container'));
            // load the shipping method form
            var smlUrl = getShippingMethodURL(Urls.spcShippingMethodsList);
            $shippingMethodList.load(smlUrl, function() {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').on("click", function() {
                    if (!$(this).closest('.shipping-method').hasClass('spc-shipping-default')) {
                        selectShippingMethod($(this).val());
                        $('.icon-chevron-thin-left.icon-chevron-right').css({
                            'transform': 'rotate(360deg)'
                        });
                        $(".shipping-options-section").removeClass("show-shipping");
                    }
                });

                // update the summary
                updateSummary();
                progress.hide();
                tooltip.init();
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                    $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
                }
            });
        }
    });
}

/**
 * Check there is an address selected, if not, disable the continue button
 * */
function checkSelectedAddress() {
    var $form = $('form[id$="_shippingAddress"]');
    var $submit = $form.find('button[type="submit"]');

    // enable the submit button if there are no shipping card
    // if there are, user must have at least 1 selected shipping card for the button to be enabled
    if ($form.find('.address-tile').length == 0 || $form.find('.address-tile.selected').length) {
        $submit.prop('disabled', false);
    } else {
        $submit.prop('disabled', true);
    }
}
/**
 * Return the the Validated address form from getAddressFromFormFunction.
 * */
function validateAddrForm() {
    var addr = getAddressFromForm();
    return addr.address1 && addr.city && addr.postalCode && addr.stateCode && addr.countryCode;
}
/**
 * Applying Coupon field to Checkout flow.
 * */
function initCouponCodeField() {

    $('.cart-coupon-code input').on('keydown', function(e) {
        var couponCode = $('.cart-coupon-code input').val();
        if (couponCode == '') {
            $('#add-coupon').prop('disabled', true);
        } else {
            $('#add-coupon').prop('disabled', false);
        }

        if (e.which === 13) {
            e.preventDefault();
            $('#add-coupon').trigger("click");
        }
    })
}
/**
 * Below function for Shipping column submit function and we will render on
 * billing column section(shippingContinueToCheckoutEvent).
 * Below mentioned parameter("&dwfrm_singleshipping_shippingAddress_save=Continue") is require to send server 
 * because with this parameter the SFCC form submit action is achieved at server side level by AJAX call.
 * */
function shippingContinueToCheckoutEvent() {
    $cache.primary.find('form#dwfrm_singleshipping_shippingAddress').on('submit', function(e) {
        e.preventDefault();
        $('.sp-add-address-title').trigger('click');        
        var $restrictedProd = $('.spc-restricted-proderr');        
        $restrictedProd.html('');
        var form = $('form[id="dwfrm_singleshipping_shippingAddress"]');
        addressVerificationSvc.init();
        form.validate();
        updateSummary();
        if (!form.valid()) {
            util.formFieldFocusOnError(form);
            return false;
        }
        /***
         * Below parameter is require because with this parameter the SFCC form submit action is achieved.
         */
        var formData = form.serialize() + "&dwfrm_singleshipping_shippingAddress_save=Continue";
        $.post(Urls.spcSingleShipping, formData)
            .done(function(data) {
                if (data.success == false) {
                    $restrictedProd.html(data.ShippingError);
                } else {
                    $restrictedProd.html('');
                    util.setSpcCheckoutSteps(3);
                    util.singlePageNextCheckoutStep(3);
                    $cache.billingcol.html(data);
                    billing.loadBillingColData();                    
                    spccybcustom.init();
                    scrollActiveSection(form);
                    util.isApplePayPresent();
                }
                //calling GA event for next checkout step.
        	    analytics.initSPCBillingEvent();                
            });
        return false;
    });
    
    $cache.primary.find('#dwfrm_singleshipping_shippingAddress button[type="submit"]').on('click' , function() {
    	var $submit = $(this);
		if($submit.closest('form').find('span.error').length > 0){
			$submit.prop('disabled', true);
			var currentPos = $('.SPCShippingPageSec').offset().top;
			require('./card-validation').scrollToPos(currentPos);
		} else {
			$submit.prop('disabled', false);
		}
    });
}
/**
 * Iterate the shipping address section and removing the default selected option
 * in Address tile for shipping section. Firing the trigger click event to select the default address. 
 * */
function iterateShippingAddressTile(){
	$(document).find('.spc-shipping div.address-list div.address-tile').each(function() {
	    if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
	        $(this).removeClass('selected');
	        $(this).removeClass('default');
	
	        $(this).trigger("click");
	    }
	});
}

function scrollActiveSection(currentBtn) {
	if ($(window).width()<=766){
		var steps = currentBtn.closest('.checkout-progress-container').find('.step.active'),
			topValue = steps.offset().top;
		$('html, body').animate({
			scrollTop: topValue
		}, 800);
	}
}
/**
 * Initializes the all Shipping page events.
 * */
exports.init = function() {
    if ($('.spc-container .spc-shipping').length > 0) {
        initCache();
        initEvents();
        shippingContinueToCheckoutEvent();
        util.singlePageNextCheckoutStep(window.SessionAttributes.SPC_CHKOUTSTEPS);
        util.selectbox();
        addressVerificationSvc.init();

        if (window.User.isCustomerAuthenticated == false) {
            $('.checkout-shipping').find('.set-default-cb').hide();
        }
        removePOBoxCaption();
        validator.initForm('form[name$="shippingAddress_save"]');
        //$(document).find('.checkoutShippingAddress').find('input[id$="_address1"]').attr("autocomplete", "nope");
        giftMessageBox();
        //updateShippingMethodList();
        initCouponCodeField();
        iterateShippingAddressTile();
        
        $(document).on('change', '.shippingMethodSelect', function() {
            selectShippingMethod($(this).val());
        });
        checkSelectedAddress();
    }
};

exports.updateShippingMethodList = updateShippingMethodList;
exports.ShippingUpdateSummary = updateSummary;
exports.scrollActiveSection = scrollActiveSection;
},{"../../ajax":5,"../../analytics":6,"../../modal":28,"../../progress":75,"../../qas":76,"../../tooltip":86,"../../util":87,"../../validator":88,"./billing":61,"./card-validation":62,"./spccybcustom":67}],67:[function(require,module,exports){
'use strict';
/**
 *  We have made this JS file for Singlepage Checkout flow only.
 *  We made it for including the Paypal Smart Pay button on AJAX call.
 * */
exports.init = function() {
	if ($('.spc-container').length > 0) {	
		$("#generic-form-submit").on('submit',function(e){
			var validator = $(this).validate();
			if(validator.form())
				return true;
			else
				return false;
		}); 	
		
	    // for Alipay Intermediate
		if($("body").hasClass("cyb_alipayintermediate"))
		{
			var loaded = false;
			setTimeout(function(){
				document.RedirectForm.submit();
				loaded = true;
			},1000);	
		}
	
	// For FingerPrint Unit testing 
		if($("body").hasClass("cyb_testfingerprintRedirect"))
		{
			var url_loc = document.getElementById("URl_redirect").value;
			setTimeout(function(){location.href=url_loc} , 1000); 
		}
		
		// For Payerauth during checkout 
		if($("div").hasClass("payerauth"))
		{	
			document.PAInfoForm.submit();
		}	
		// For payerauth during  Credit card  
		if($("body").hasClass("cyb_payerauthenticationredirect"))
		{	document.RedirectForm.submit();
			
		}	
		// For payerauth during  Unit testing 
		if($("body").hasClass("cyb_unitTest_payerauth"))
		{	
			document.RedirectForm.submit();
			
		}	
		// For payer auth during  Unit testing 
		if($("div").hasClass("cyb_unitTest_payerauthsubmit"))
		{	
			document.PAInfoForm.submit();
			
		}		
		// For Secure Acceptance Redirect 
		if($("body").hasClass("cyb_sa_redirect"))
		{	
			var url_loc = document.getElementById("redirect_url_sa").value;
			window.top.location.replace(url_loc);
			
		}
		// For Secure Acceptance Iframe  
		if($("div").hasClass("SecureAcceptance_IFRAME"))
		{	
			var url_loc = document.getElementById("sa_iframeURL").value;
			$(".SecureAcceptance_IFRAME").append('<iframe src='+url_loc+'  name="hss_iframe"  width="78" height="630" scrolling="no" />');
			
		}	
		// For Secure Acceptance Iframe 
		if($("body").hasClass("sa_iframe_request_form"))
		{	
			document.form_iframe.submit();
		}
		// For Secure Acceptance  
		if($("body").hasClass("cyb_sa_request_form"))
		{	
			document.ePayment.submit();
		}	
			
	    //FOR POS
		
		$("#entry-mode-pos_unittest select.input-select").on("change", function(){
			if(this.value == "swiped")
				$("#card-section, #sample-card-section").css("display","none");
			else if(this.value == "keyed")
				$("#card-section, #sample-card-section").css("display","block");
		});	
		var requestId,billingAgreementFlag,					//A Flag to show whether user has opted for Billing Agreement or not
		billingAgreementButton,					//The Billing Agreement Checkbox
		billingAgreementID,						//Billing Agreement ID
		isPayPalCredit=false;					//A Flag to show whether user has opted for PayPal Credit Card
		function toggleForm(actions) {
		        return isValid() ? actions.enable() : actions.disable();
		}
		function isValid() {
			var validator = $('.checkout-billing').validate();
			 if ( validator.form()) {
				 return true;
			 }else{
				 return false;
			 }
	    }
		function onChangeForm(handler) {
	        $('.checkout-billing').on('change', handler);
	    }
		var config = {
				env: 'sandbox', // sandbox | production
			    commit: true,
			    payment: function() {
			        var CREATE_URL = Urls.paypalinitsession;
			        if($('#paypal-credit-container').length>0 && $('#paypal-credit-container').is(":visible")){
			    		isPayPalCredit = true;
			    	}else{
			    		isPayPalCredit =false;
			    	}
			        billingAgreementButton = document.getElementById("billingAgreementCheckbox");
			        //billingAgreementFlag - This variable is used to indicate if billing agreement creation is request or not
			        billingAgreementFlag = (billingAgreementButton==null)?false:billingAgreementButton.checked;
			        //Append a parameter to URL when Billing Agreement is checked
			        if(billingAgreementFlag){
			        	CREATE_URL = CREATE_URL + "?billingAgreement=true";
			        } else if(isPayPalCredit){
			        	//Append a parameter to URL when PayPal Credit is used
			        	CREATE_URL = CREATE_URL + "?isPayPalCredit=true";
			        }
			        return paypal.request.post(CREATE_URL)
			            .then(function(res) {
			            	requestId=res.requestID;
			               return res.processorTransactionID;
			            });
			    }, 
			    onAuthorize: function(data, actions) {
			        var data = {
			        	requestId : requestId,	
			        	billingAgreementFlag : billingAgreementFlag,
			            paymentID: data.paymentID,
			            payerID: data.payerID,
			            isPayPalCredit: isPayPalCredit
			        };
			        
			        
			        var form = $('<form action="' + Urls.paypalcallback + '" method="post">' +
			          '<input type="hidden" name="requestId" value="' + requestId + '" />' +
			          '<input type="hidden" name="billingAgreementFlag" value="' + billingAgreementFlag + '" />' +
			          '<input type="hidden" name="paymentID" value="' + data.paymentID + '" />' +
			          '<input type="hidden" name="payerID" value="' + data.payerID + '" />' +
			          '<input type="hidden" name="isPayPalCredit" value="' +isPayPalCredit + '" />' +
			          '</form>');
			        $('body').append(form);
			        form.trigger("submit");
			    }
			};
		if(SitePreferences.ISPAYPALENABLED && $('.paypal-button-container-mini').length>0){
		paypal.Button.render(config,'.paypal-button-container-mini');
		}
		if(SitePreferences.ISPAYPALENABLED && $('.paypal-button-container-cart1').length>0){
			paypal.Button.render(config,'.paypal-button-container-cart1');	
		}
		if(SitePreferences.ISPAYPALENABLED && $('.paypal-button-container-cart2').length>0){
			paypal.Button.render(config,'.paypal-button-container-cart2');
		}
		if(SitePreferences.ISPAYPALENABLED && $('#paypal-button-container').length>0){
			paypal.Button.render(config,'#paypal-button-container');
		}
		//Settings for PayPal Credit Card Button
		if(SitePreferences.ISPAYPALENABLED && $('#paypal-credit-container').length>0){
			config.style ={
					label: 'credit',
		            size:  'small', // small | medium
		            shape: 'rect'   // pill | rect
				};
			
			paypal.Button.render(config,'#paypal-credit-container');
		}
		/*
		 * If billing agreement ID already exists in the user profile then a different button
		 * is displayed on the the page. This function handles the action of that button.
		 * This functions directly calls checkstatusservice
		 */
		$('.billingAgreementExpressCheckout').on("click", function(e){
			e.preventDefault();
			 var form = $('<form action="' + Urls.paypalcallback + '" method="post">' +
			  '</form>');
			 $('body').append(form);
		        form.trigger("submit");
		});
		
		/*
		 *This code has been used to initialize, load and authorize klarna widget
		 *and to process preapproval token returned by klarna auth service 
		 */
		if($('#processorToken').length > 0){
	    	var klarnaToken = $('#processorToken').val();
	    	var token ={};
	    	token.client_token=klarnaToken;
	    	Klarna.Credit.init(token);
	    	Klarna.Credit.load({
				container: "#klarna_container"
				}, function(res) {
					if (res["show_form"] == true){
						document.getElementById("auth_button").innerHTML = "<br><button id=\"klarnaPayButton\" type=\"button\" name=\"buy\">Pay</button>";
						$("#klarnaPayButton").on("click", function(){
							authorizeKlarnaOrder();												
						});	
						
						
					}
					
			});
	    	window.authorizeKlarnaOrder =  function (){
				  Klarna.Credit.authorize(function(res) {
					 if(res["approved"] == true){
						document.getElementById("klarnaAuthToken").value=res["authorization_token"];
						$('.submit-order button[type="submit"]').trigger("click");
					  }
					});
			 }
	    }
	}
};

},{}],68:[function(require,module,exports){
'use strict';

var recommendations = require('./product/recommendations');

exports.init = function () {

    recommendations();
    $('#homepage-hero').slick({
    	arrows: false,
    	autoplay: true,
    	autoplaySpeed: 5000,
    	dots: false,
       slidesToShow: 1,
       slidesToScroll: 1,
       speed: 2000,
       fade: true,
       infinite: true,
       responsive: [
             {
               breakpoint: 480,
                  settings: {
                	  arrows: false,
                  }
             }
        ]
    });
    $('.sub-feature-article').slick({
    	arrows: false,
    	dots: false,
    	infinite: false,
    	slidesToShow: 3,
    	slidesToScroll: 3,
    	responsive: [
	         {
	       	  breakpoint: 480,
	             settings: {
	            	slidesToShow: 1,
	     	        slidesToScroll: 1,
	     	        infinite: true,
	     	        arrows: false,
	     	        dots: true
	             }
	         }
       ]
    });
    
};

},{"./product/recommendations":54}],69:[function(require,module,exports){
'use strict';
var dialog = require('../dialog');

exports.init = function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
};

},{"../dialog":16}],70:[function(require,module,exports){
'use strict';

function initTutorialCarousel () {
	$('.related-carousel-wrapper .tutorial-wrapper').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        responsive: [
          {
        	  breakpoint: 1024,
        	  settings: {
    	        slidesToShow: 3,
    	        slidesToScroll: 1,
    	        infinite: true,
                arrows: false,
    	        dots: true
        	  }
          },
          {
        	  breakpoint: 640,
              settings: {
            	slidesToShow: 1,
      	        slidesToScroll: 1,
      	        infinite: true,
      	        arrows: false,
      	        dots: true
              }
          }
        ]
    });
	
	if ($("#thumbnails li").length == 0 ) {
        return false;
    } else if ($("#thumbnails li").length > 1 && window.innerWidth > 767 ) {
    	tutorialThumbnailCarousel();
    } else if ($("#thumbnails li").length > 1 && window.innerWidth < 768 ) {
    	tutorialMainImageCarousel();
    }
	tutorialImages();
}

function tutorialThumbnailCarousel() {
    $('#thumbnails ul').slick({
        dots: false,
        infinite: true,
        arrows: true,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1
    });
}

function tutorialMainImageCarousel() {
	$("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
    $('#thumbnails ul').slick({
        dots: true,
        vertical: false,
        infinite: true,
        arrows: false,
        centerMode: false,
        slidesToShow: 1
    });
}

// tutorial image carousel
function tutorialImages () {
	$("#thumbnails").on('click', '.productthumbnail', function () {
		var $that = $(this);
		
		$("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
		$that.addClass('selected');
		setTutorialMainImage($that.find('img').attr('src'));
	});
}

function setTutorialMainImage(src) {
    $('#tutorial-image-template .primary-image').attr('src', src);	
}

exports.init = function () {
	initTutorialCarousel();
};
},{}],71:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    page = require('../page'),
    login = require('../login'),
    util = require('../util'),
    account = require('./account'),
    minicart = require('../minicart');

function changeQuantity () {
    $('.quantity-container select').on("change", function () {
        var quantity = $(this).find('option:selected').val();

        $('.option-quantity-desired input').val(quantity);
        $(this).closest('form').find('.update-item').on("click");
    });
}

function addItemToBag() {
    $(document).on('click', 'button.add-all-to-cart', function(e) {
        e.preventDefault();
        var count;
        $(document).find('button[name$="_addToCart"]').each(function(index, e) {
        	count = index+1;
            $(this).trigger("click", { isAddAllToBagClicked : true, count: count } ); //since we want to know if the click is from add all to bag or not.
        });
    });

    $(document).on('click', 'button[name$="_addToCart"]', function(e, wishListData ) {
        e.preventDefault();
        var displayPopup = false;
        var wishListItemLen = $(".wishlist-item").length;
        var displayProdSpecificMsg = ( wishListItemLen == 1 ) ? true : false;
        if( typeof wishListData == "undefined" ) { 
        	var wishListData = {};
        	wishListData.isAddAllToBagClicked = false;
        	wishListData.count = 1 
        	displayProdSpecificMsg = true;
        }
        
        
        if( wishListData.isAddAllToBagClicked ==  false ){
        	displayPopup = true;
        
        }else{
        	
        	if( wishListItemLen == wishListData.count ){
        		displayPopup = true;
        	}
        }
        

        
        var $form = $(this).closest('form');
        var $serialize = $form.serialize();
        var extraParams = "&displayPopup=" + displayPopup + "&displayProdSpecificMsg="+ displayProdSpecificMsg + "&isAddAllToBagClicked=" + wishListData.isAddAllToBagClicked;
        $serialize = $serialize + extraParams;
        var divError = $form.find('div.product-error');

        $.ajax({
            type: 'POST',
            url: util.ajaxUrl(Urls.wishlistAddToCart),
            data: $serialize,
            success: function(response) {
                if (response.error) {
                    divError.html(response.error);
                } else {
                	var productRemaining = $(".wishlist-item:visible").length;
                	if( productRemaining > 1 ){
                		$form.css("display", "none");
                	}else{
                		$(".primary-content").html("<p>"+Resources.NO_PRODUCTS_IN_WISHLIST+"</p>");
                	}
                	minicart.show(response);
                }
            }
        });
    });
}

exports.init = function () {
    addProductToCart();
    changeQuantity();
    addItemToBag();

    $('#editAddress').on('change', function () {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();
    account.initMobileMenu();
};
},{"../login":26,"../minicart":27,"../page":31,"../util":87,"./account":32,"./product/addToCart":48}],72:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
	images = require('./pages/product/image'),
	quickview = require('./quickview'),
	productTile = require('./product-tile'),
	util = require('./util'),
	analytics = require('./analytics'),
	variant = require('./pages/product/variant');

var pdpredesign = {
	init: function() {
		var wishlistProd = window.User.wishlistProducts;
		$(function() {	
			$(".pdp-wishlist-icon").each(function(){
				var _this = $(this);
				var currEle = _this.attr('data-element-pid');
				if(window.User.wishlistProducts != null && wishlistProd.indexOf(currEle) >= 0){
					_this.addClass("pdp-active-wishlist");
				}
			});	
			 
			$(".plp-wishlist-icon").each(function(){
				var _this = $(this);
				var currEle = _this.attr('data-element-pid');
				if(window.User.wishlistProducts != null && wishlistProd.indexOf(currEle) >= 0){
					_this.addClass("plp-active-wishlist");
				}
			});	
			
		});
		
		$('.tips-slider-nav').on('init', function(event, slick) {
		    var currentSlide = $('.slick-current').attr("data-slick-index");
  		    var $slide_video = $('.tips-slider-nav-col *[data-slick-index="'+currentSlide+'"]');
  		    var reccomendedProductIDs = $slide_video.attr("data-featuredproducts"); 
  		    var url = util.appendParamsToUrl(Urls.getVideoProducts, {
			    ReccomendedProductIDs: reccomendedProductIDs,
                format: 'ajax'
            });
		    if(reccomendedProductIDs) {
			    $.ajax({
	               url: url
	            }).done(function (data) {
	        	    $(".pdp-other-products-featured-content").html(data);
	        	    renderCarousel();
	        	    renderSwatchCarousel();
	        	    productTile.initializeEvents(); 
	        	    plpWishList();
	        	    initQuickViewPlusIconButtons();
	            });
		    }
  		});
	    
	    
    	$('.tips-slider-nav').slick({
	      slidesToShow: 3,
	      slidesToScroll: 1,
	      //asNavFor: '.slider-for',
	      dots: true,
	      vertical: true,
	      focusOnSelect: true,
	      centerMode: false,
	      centerPadding: '0px',
	      responsive: [
              {
                  breakpoint: 600,
                  settings: {
   	    	      vertical: false,
   	    	      centerMode: true,
   	    	      centerPadding: '95px',
   	    	      slidesToShow: 1
                  }
              }
          ]
    	});
    	
		$('.tips-slider-nav').on('afterChange', function(event, slick, currentSlide) {
		    var $slide_video = $('.tips-slider-nav-col *[data-slick-index="'+currentSlide+'"]');
		    var reccomendedProductIDs = $slide_video.attr("data-featuredproducts"); 
		    var url = util.appendParamsToUrl(Urls.getVideoProducts, {
			    ReccomendedProductIDs: reccomendedProductIDs,
                format: 'ajax'
            });
		    if(reccomendedProductIDs) {
			    $.ajax({
	                url: url
	            }).done(function (data) {
	        	    $(".pdp-other-products-featured-content").html(data);
	        	    renderCarousel();
	        	    renderSwatchCarousel(); 
	        	    productTile.initializeEvents(); 
	        	    plpWishList();
	        	    initQuickViewPlusIconButtons();
	            });
		    }
		});
    	
    	if (window.matchMedia("(max-width: 600px)").matches) {
    		$('.look-products-col').slick({
	    	  dots: true,
	    	  arrows: false
	    	});
    	}
    	
    	$('.pdp-you-might-like-content .swatch-list').slick({
    		slidesToShow: 5,
	        slidesToScroll: 3,
	        focusOnSelect: true,
	        infinite: false
    	});
    	
    	//Render product swatch carousel
    	renderSwatchCarousel();   	    	

    	
    	//PDP wishlist heart icon
    	
    	$('body').on('click', '.pdp-wishlist-icon',function() {
    		var ajaxUrl;
    		var _this = $(this);
    		var currProductID = _this.attr('data-element-pid');
    		var data = {pid:currProductID};
    		
    		if(_this.hasClass("pdp-active-wishlist")){
    			ajaxUrl = _this.attr('data-ajax-remove');
    			_this.removeClass("pdp-active-wishlist");
    			var index = window.User.wishlistProducts.indexOf(currProductID);
    			window.User.wishlistProducts.splice(index, 1);
    		}else{
    			ajaxUrl = _this.attr('data-ajax-add');
    			_this.addClass("pdp-active-wishlist"); 
    			window.User.wishlistProducts.push(currProductID);
    		}
    		
    		$.ajax({
    			type: 'GET',
    	        url: ajaxUrl,
    	        data: data
    	    })
    	    .done(function (response) { });
    		
    	});
    	
    	
    	//PDP Filter Swatches
    	function filterAllVariant(currentElem){
    		$(".filter-swatches").show();
    		currentElem.parents('.shade-filter-tabs').siblings("#colorfamily_group").hide();
			$('.filter-swatches li')
			    .show(); 
			$('.filter-variation-select option')
		    	.show();
		}
    	
    	function filterNewVariant(currentElem){
    		$(".filter-swatches").show();
    		currentElem.parents('.shade-filter-tabs').siblings("#colorfamily_group").hide();
			$('.filter-swatches li').hide()
			    .filter('[data-new-variant="true"]')
			    .show();
			
			$('.filter-variation-select option').hide()
			    .filter('[data-new-variant="true"]')
			    .show(); 
		}
    	
    	function filterBestsellerVariant(currentElem){
    		$(".filter-swatches").show();
    		currentElem.parents('.shade-filter-tabs').siblings("#colorfamily_group").hide();
			$('.filter-swatches li').hide()
			    .filter('[data-best-seller="true"]')
			    .show(); 
			
			$('.filter-variation-select option').hide()
			    .filter('[data-best-seller="true"]')
			    .show(); 
		}
    	
    	
    	$("body").on("click",".tabs-title", function(e){
    		e.preventDefault();
    	    $(".tabs-title").removeClass("is-active");
    	    $(this).addClass("is-active");   
    	});
    	
    	$("body").on("click",".all-shades-label", function(e){
    		e.preventDefault();
    		filterAllVariant($(this));
    	});
    	
    	$("body").on("click",".new-shades-label", function(e){
    		e.preventDefault();
    		filterNewVariant($(this));	
    	});
    	
    	$("body").on("click",".bestsellers-shades-label", function(e){
    		e.preventDefault();
    		filterBestsellerVariant($(this));	
    	});
    	
    	//PDP Color Family
    	
    	$("body").on("click",".color-family-shades-label", function(e){
    		e.preventDefault();
    		$(this).parents('.shade-filter-tabs').siblings(".filter-swatches").hide();
    		$(this).parents('.shade-filter-tabs').siblings("#colorfamily_group").show();
    		$(this).parents('li.attribute').find('.filter-variant-dropdown .filter-variation-select option').show();
    		
    	    var sortable = $(this).parents('.shade-filter-tabs').siblings(".filter-swatches"),
    	        content = $(this).parents('.shade-filter-tabs').siblings("#colorfamily_group");

    	    var groups = [];
    	    sortable.find("li").each(function() { 
    	        var group = $(this).data("color-family");
    	        if($.inArray(group, groups) === -1) {
    	            groups.push(group);
    	        }
    	    });
    	    
    	    function isEmpty( el ){
	            return !$.trim(el.html())
	        }
	        
	        if( isEmpty(content) ){
	        	
	    	    groups.forEach(function(group) {
	    	        var liElements = sortable.find("li[data-color-family='" + group + "']");
	    	        
	    	        if(group == ""){
	    	    		group = "Others"
	    	    	}
	    	        
	    	       
	    	        content.append($("<p>").text(group));
	    	        content.append($("<ul id='pdp-swatches' class='color-family-swatches swatches color'>").html(liElements.clone().show()));   
	    	        
	    	    });
	        }
    	});
    	
    	//Product Description Read more/less
    	
		 if (window.matchMedia("(max-width: 600px)").matches) {
	    		$(".desc-section .readMore").on("click", function(){
	    		    $(".readLess").removeClass('visually-hidden ');
	    		    $(".readMore").addClass('visually-hidden ');
	    		    $(".desc-points").slideToggle();
	    		});
	    		$(".desc-section .readLess").on("click", function(){
	    		    $(".readLess").addClass('visually-hidden ');
	    		    $(".readMore").removeClass('visually-hidden ');
	    		    $(".desc-points").slideToggle();
	    		}); 
	    	}
	    
	   if (window.matchMedia("(max-width: 600px)").matches) {
	    	$(".seeSteps").on("click", function(){
	            $(".steps-container").slideToggle();
	            $(this).toggleClass("expanded");
	            if( $(this).hasClass("expanded") ){
	            	$(this).html("CLOSE STEPS");
	            }
	            else{
	            	$(this).html("SEE STEPS");
	            }
	        });	    	
    	}
    	
    	
    	initQuickViewPlusIconButtons();
    	
    	//This function creates a slider of recommended products
    	renderCarousel();

    	productTile.initializeEvents(); 

    	//Play Video
    	playAltVideo();
    	playCarouselVideo();    	
    	
    	selectedColorDropdown();
    	productTile.initAltImgOnHoverPLPGrid();
    	
	}
};

function plpWishList(){
	var wishlistProd = window.User.wishlistProducts;
	
	$('.pdp-main-redesign .pdp-other-products-featured-content .plp-wishlist-icon').on("click", function() {
		var ajaxUrl;
		var _this = $(this);
		var currProductID = _this.attr('data-element-pid');
		var data = {pid:currProductID};
		
		if(_this.hasClass("plp-active-wishlist")){
			ajaxUrl = _this.attr('data-ajax-remove');
			_this.removeClass("plp-active-wishlist");
			var index = window.User.wishlistProducts.indexOf(currProductID);
			window.User.wishlistProducts.splice(index, 1);
		}else{
			ajaxUrl = _this.attr('data-ajax-add');
			_this.addClass("plp-active-wishlist"); 
			window.User.wishlistProducts.push(currProductID);
		}
		
		$.ajax({
			type: 'GET',
	        url: ajaxUrl,
	        data: data
	    })
	    .done(function (response) { });
		
	});
	
	$(".pdp-main-redesign .pdp-other-products-featured-content .plp-wishlist-icon").each(function(){
		var _this = $(this);
		var currEle = _this.attr('data-element-pid');
		if(window.User.wishlistProducts != null && wishlistProd.indexOf(currEle) >= 0){
			_this.addClass("plp-active-wishlist");
		}
	});	
}

function setStarRatingDisplay(rating, elem) {
	let setWidth = 20 * rating;
	elem.css('width', setWidth + '%');
}

function initQuickViewPlusIconButtons() {
	if (!quickViewOnPlusIconEnabled) {
		return;
	}
	 
    $('.pdp-you-might-like-content, .pdp-other-products-featured-content, .pdp-content-section').find('.plp-icon-block .plp-quickshop-icon').off('click').on('click', function (e){
    	var pdpquickview = false;
		var pdpquickviewAtrr = $(this).attr('data-pdpquickview');
		if(pdpquickviewAtrr=='true'){
		    pdpquickview = true;
		}
    	var $tile = $(this).closest('.product-tile');
    	var $link = $tile.find('.thumb-link');
    	e.preventDefault();
			quickview.show({
				url: $link.attr('href'),
				source: 'quickview',
				pdpquickview: pdpquickview,
				customclass: 'pdp-quickview',
				callback: function(){
					images('pdp-quickview');
					variant();
					renderThumbnails('pdp-quickview');
					selectedColorDropdown('pdp-quickview');
					
					setStarRatingDisplay($('.b-pdp-quickview-bv-rating .averageRating').text().trim(), $('.b-pdp-quickview-bv-rating .stars-inner'))
					
					//Track GTM event of PDP QV
					analytics.trackQuickViewPageViewFromPDP("#modal-content");

					$('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function() {
						window.location.href = url + '#reviews'; // redirect when rating star is clicked
					});
						
					$(document).on('click', '.bv-popup-in .bv-read-review', function() {
						window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
					});
				}
			});       
    });
    
}

function renderThumbnails(containerClass){
	if($('#thumbnails').length > 0){
		if(containerClass == 'pdp-quickview'){
			$('#modal-content #thumbnails').empty();   // clear the list
		} else {
			$('#thumbnails').empty();	// clear the list
		}
		images(containerClass);					// populate the thumbnails
	}
};

function renderSwatchCarousel(){
	$('.pdp-other-products-featured-content .swatch-list').slick({
		slidesToShow: 5,
	    slidesToScroll: 3,
	    focusOnSelect: true,
	    infinite: false
	});
}

function renderCarousel(){
    var $carousel = $('.brand-carousel-recommendations').not('.slick-initialized');
    if (!$carousel || $carousel.length === 0 || $carousel.children().length === 0) {
        return;
    }
    
    $carousel.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        slide: 'li',
        dots: true,
        responsive: [
          {
        	  breakpoint: 600,
              settings: {
            	slidesToShow: 1,
      	        slidesToScroll: 1,
      	        infinite: true,
      	        arrows: false,
      	        dots: false
              }
          }
        ]
    });
}

function playAltVideo() {
	if (window.matchMedia("(min-width: 767px)").matches) {
	    $("body").on("click",".pdp-main-redesign .productthumbnail.video-thumbnail-image", function(e){
			e.preventDefault();
			var mainImageDiv = $(this).parents('#thumbnails').siblings('.product-primary-image').find(".main-image");
			mainImageDiv.find('#alt-video').fadeIn();
			
			var altVideoID = $(this).attr('data-videourl');
			mainImageDiv.find('#alt-video').attr('src',altVideoID);
			mainImageDiv.find('#alt-video')[0].src += "&autoplay=1";
			mainImageDiv.find(".primary-image").hide();
			$(this).parents('.product-image-container').siblings('.pdp-brand-zoom').find(".image-zoom").hide();
			$(".image-zoom").hide();
	    });
	    $("body").on("click",".pdp-main-redesign .productthumbnail", function(e){
	    	
	    	if( !($(this).hasClass('video-thumbnail-image')) ){
	    		var mainImageDiv = $(this).parents('#thumbnails').siblings('.product-primary-image').find(".main-image");
	    		mainImageDiv.find('#alt-video').attr('src','');
	    		mainImageDiv.find(".primary-image").show();	
	    		mainImageDiv.find('#alt-video').hide();
	    		$(this).parents('.product-image-container').siblings('.pdp-brand-zoom').find(".image-zoom").show();
	    		$(".image-zoom").show();
	    	}
	    });
	}
	$("body").on("mouseup touchstart", function(e){
	    var quickviewModalContainer = $(".quickview-modal");
	    // if the target of the click isn't the container
	    if (!quickviewModalContainer.is(e.target)){
	    	var videourl = $(".quickview-modal #alt-video").attr('src');
	    	if(!videourl){
	    		videourl = $(".quickview-modal #alt-video-small").attr('src');
	    	} 
	    	if(!videourl){
	    	    videourl = $("#primary #alt-video-small").attr('src');
	    	}
	    	if(videourl){
		    	var newurl = videourl.replace("autoplay=1", "autoplay=0");	        
		    	$("#primary #alt-video").attr('src', newurl);
		    	if (window.matchMedia("(min-width: 767px)").matches) {
		    		$(".quickview-modal #alt-video").attr('src', newurl);
		        } else{
		        	$(".quickview-modal #alt-video-small").attr('src', newurl);
		        	$("#primary #alt-video-small").attr('src', newurl);
		        }
	    	}
	    }
	}); 
}

function playCarouselVideo() {
	var thumbImageUrl = $('.tips-slider-nav .slick-current img').attr('src');
	$('.tips-slider-for iframe').css('background-image', 'url("'+ thumbImageUrl +'")');	
	
	$('.play-video-btn').show();
	
	$("body").on("click",".tips-slider-for", function(e){
		e.preventDefault();
		$('.tips-slider-nav .slick-current img').trigger('click');
		$('.play-video-btn').hide();
	});
	
	$("body").on("click",".tips-slider-nav .slick-slide", function(e){
		e.preventDefault();
		
		var carouselVideo = $(this).attr('data-video-url');
		$(".tips-slider-for #carousel-video").attr('src',carouselVideo);
		$("#carousel-video")[0].src += "&autoplay=1";
		$('.play-video-btn').hide();
		
		//update steps on click
		var stepsId = $('.tips-slider-nav .slick-current').attr('data-steps-id');
		$('.steps-row').hide();
		$('#'+stepsId).show();	
    });
	
	//update steps on load
	var stepsId = $('.tips-slider-nav .slick-current').attr('data-steps-id');
	$('.steps-row').hide();
	$('#'+stepsId).show();	
	
}

function selectedColorDropdown(containerClass) {
	var selectedColor = $('.filter-variation-select option:selected').html(); 
	var selectedColorDesc = $('.pdp-main-redesign .color-desc').html(); 
	
	if(containerClass == 'pdp-quickview'){
	    selectedColor = $('#modal-content .filter-variation-select option:selected').html(); 
		selectedColorDesc = $('#modal-content .pdp-main-redesign .color-desc').html();
		$('#modal-content #selected-color').html(selectedColor);
		$('#modal-content #selected-color-desc').html(selectedColorDesc);
	} else {
		$('#selected-color').html(selectedColor);
		$('#selected-color-desc').html(selectedColorDesc);
		
		var persSelectedColor = $('.miniproduct-actions .variation-select option:selected').attr('style');
		$('.selected-color-img').attr('style',persSelectedColor);
		
		var persSelectedColor = $('.miniproduct-actions .variation-select option:selected').html(); 
		$('#pers-selected-color').html(persSelectedColor);
	}
}		


module.exports = pdpredesign;
},{"./analytics":6,"./pages/product/image":51,"./pages/product/variant":56,"./product-tile":74,"./quickview":77,"./util":87,"imagesloaded":115}],73:[function(require,module,exports){
/**		    
    * --- control slide Quickview when Popup open
*/
var CarouselQuickview = {
    init: function() {
        var ptProductDetail = $('.pt_product-details');
        var productSlideLarge = ptProductDetail.find('.product-slide-large');
        var productSlideThumb = ptProductDetail.find('.product-slide-thumbnail');
        if(ptProductDetail.length) {
            if(productSlideLarge.length && !productSlideLarge.hasClass('slick-initialized')){
                ptProductDetail.find('.product-slide-large').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: '.product-slide-thumbnail',
                    dots: false
                });
            }
            if(productSlideThumb.length && !productSlideThumb.hasClass('slick-initialized')){
                ptProductDetail.find('.product-slide-thumbnail').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: '.product-slide-large',
                    arrows: false,
                    focusOnSelect: true,
                    vertical: true,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                vertical: false,
                                verticalSwiping: true,
                                slidesToShow: 4
                            }
                        }
                    ]
                });
            }
        }
        else {
            $('.product-slide-large').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                vertical: false
            });
        }
    }
}

module.exports = CarouselQuickview;
},{}],74:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
    images = require('./pages/product/image'),
	quickview = require('./quickview'),
	product = require('./pages/product'),
	variant = require('./pages/product/variant'),
	util = require('./util'),
    wishlistCustom = require('./wishlist.custom'),
    CarouselQuickview = require('./product-tile-carousel');


function initQuickViewButtons() {
	if (!quickViewEnabled) {
		return;
	}
	
    $('.tiles-container .product-image').on('mouseenter', function () {
        var $qvButton = $('#quickviewbutton');
        if ($qvButton.length === 0) {
            $qvButton = $('<a id="quickviewbutton" class="quickview">' + Resources.QUICK_VIEW + '</a>');
        }
        var $link = $(this).find('.thumb-link');
        $qvButton.attr({
            'href': $link.attr('href'),
            'title': $link.attr('title')
        }).appendTo(this);
        
        $qvButton.off();
        $qvButton.on('click', function (e) {
            e.preventDefault();

            var url = $(this).attr('href');

			quickview.show({
				url: $(this).attr('href'),
				source: 'quickview',
				callback: function(){
					images();
					variant();
					renderThumbnails();

					$('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function() {
						window.location.href = url + '#reviews'; // redirect when rating star is clicked
						});
						
					$(document).on('click', '.bv-popup-in .bv-read-review', function() {
						window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
					});
					product.initializeEvents();
				}
			});
            
        });
    });
    
}


function initQuickViewPlusIconButtons() {
	if (!quickViewOnPlusIconEnabled) {
		return;
	}
	  
    $('.tiles-container .plp-icon-block .plp-quickshop-icon').on('click', function (e){
    	var $tile = $(this).closest('.product-tile');
    	var $link = $tile.find('.thumb-link');
    	e.preventDefault();
			quickview.show({
				url: $link.attr('href'),
				source: 'quickview',
				callback: function(){
					images();
					variant();
					renderThumbnails();
					selectedColorDropdown();

					$('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function() {
						window.location.href = url + '#reviews'; // redirect when rating star is clicked
					});
						
					$(document).on('click', '.bv-popup-in .bv-read-review', function() {
						window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
					});
				}
			});       
    });
    
}


function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

function renderThumbnails(){
	if($('#thumbnails').length > 0){
		$('#thumbnails').empty();	// clear the list
		images();					// populate the thumbnails
	}
};

function initCarouselSwatches() {
	if ($(".plp-product-grid-block")[0]){
	    $('.swatch-list').not(".slick-slider").slick({
	    	dots: false,
	        focusOnSelect: true,
	        infinite: false,
	        slidesToShow: 5,
	        slidesToScroll: 3,
	        speed: 300
	    });  
	}
	$('.swatch-list').not(".slick-slider").slick({
    	dots: false,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 3,
        speed: 300
    });  
    
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    initQuickViewButtons();
    
    gridViewToggle();
    
    wishlistCustom.handleWishlist();
    
    $('.swatch-list').on('mouseleave', function () {
        // Restore current thumb image
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $thumb.data('current');

        if(!data) { return; }

        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
    $('.swatch-list .swatch').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) { return; }

        var $tile = $(this).closest('.product-tile');
        var productID = $tile.attr('data-itemid');
        var heartIcon = $('#hearting-'+productID);
        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');
        $tile.find('.thumb-link').attr('href', $(this).attr('href'));
        $tile.find('name-link').attr('href', $(this).attr('href'));

        var data = $(this).children('img').filter(':first').data('thumb');
        var dataAlt = $(this).children('img').filter(':first').data('thumb-alt');
        var dataVariantId = $(this).children('img').filter(':first').data('variant-sku');
        
        heartIcon.attr('data-element-pid', dataVariantId);
        var wishlistProd = window.User.wishlistProducts;	
        if(wishlistProd != null && wishlistProd.indexOf(dataVariantId) == -1){
        	heartIcon.removeClass("plp-active-wishlist");
		}else{
			heartIcon.addClass("plp-active-wishlist");
		}
       
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title
        };
        $thumb.attr(currentAttrs);
        $thumb.attr('data-alt-src', dataAlt);
        $thumb.data('current', currentAttrs);
    }).on('mouseenter', function () {
        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $(this).children('img').filter(':first').data('thumb'),
            current = $thumb.data('current');

        if(!data) { return; }

        // If this is the first time, then record the current img
        if (!current) {
            $thumb.data('current', {
                src: $thumb[0].src,
                alt: $thumb[0].alt,
                title: $thumb[0].title
            });
        }

        // Set the tile image to the values provided on the swatch data attributes
        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });

}

function selectedColorDropdown() {
	var selectedColor = $('.filter-variation-select option:selected').html(); 
	var selectedColorDesc = $('.pdp-main-redesign .color-desc').html(); 
	
	$('#selected-color').html(selectedColor);
	$('#selected-color-desc').html(selectedColorDesc);
	
	var persSelectedColor = $('.miniproduct-actions .variation-select option:selected').attr('style');
	$('.selected-color-img').attr('style',persSelectedColor);
	
	var persSelectedColor = $('.miniproduct-actions .variation-select option:selected').html(); 
	$('#pers-selected-color').html(persSelectedColor);
}	
function altHoverImgReplaceOnPLP() {
	if (SitePreferences.ENABLE_FLIPPING_IMG_ONPLP && $('img.plp-image-hover').length > 0) {
        $(document).on('mouseenter mouseleave', 'img.plp-image-hover', function() {    		
    	    if ($(this).attr('data-alt-src') != undefined && $(this).attr('data-alt-src').length > 0) {
                $(this).attr({src:$(this).attr('data-alt-src'), 'data-alt-src':$(this).attr('src')});   	    	 
    	    }    	 
    	});
    }
}

function globalQuickView() {
    $(document).off('click', '.js_quickview').on('click', '.js_quickview' , function(e) {
        e.preventDefault();
        var url = $(this).attr('href');

        quickview.show({
            url: url,
            source: 'quickview',
            class: "product-detail-view",
            callback: function () {
                images();
                variant();
                renderThumbnails();
                product.initializeEvents();
                wishlistCustom.handleWishlist();
                CarouselQuickview.init();
            }
        });
    });
}

exports.init = function () {
    var $tiles = $('.tiles-container .product-tile');
    if ($tiles.length === 0) { return; }

    initCarouselSwatches();
    initializeEvents();
    
    initQuickViewPlusIconButtons();
    
};

exports.initCarouselSwatches = initCarouselSwatches;
exports.initializeEvents = initializeEvents;
exports.initAltImgOnHoverPLPGrid = altHoverImgReplaceOnPLP;
exports.globalQuickView = globalQuickView;
},{"./pages/product":52,"./pages/product/image":51,"./pages/product/variant":56,"./product-tile-carousel":73,"./quickview":77,"./util":87,"./wishlist.custom":90,"imagesloaded":115}],75:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],76:[function(require,module,exports){
'use strict';
var util = require('./util');
var page = require('./page');
var modal = require('./modal');
var cache = {};

function initCache() {
    if ($('#EditAddressForm').length > 0) {
        cache["$formId"] = '#EditAddressForm';
        cache["$form"] = $('#EditAddressForm');
        cache["$source"] = 'dwfrm_shippingaddress';
        cache["$save"] = $('#EditAddressForm').find('.apply-button').attr('name');
    } else if ($('#dwfrm_singleshipping_shippingAddress').length > 0) {
        cache["$formId"] = '#dwfrm_singleshipping_shippingAddress';
        cache["$form"] = $('#dwfrm_singleshipping_shippingAddress');
        cache["$source"] = 'dwfrm_singleshipping_shippingAddress_addressFields';
        cache["$save"] = 'dwfrm_singleshipping_shippingAddress_save';
    }

    cache["$modal"] = modal.create("#qas-modal", "#qas-modal .modal-body", {closeOnClick: false, closeOnEsc: false});
}

function initEvents() {
    if (cache.$form && cache.$form.length > 0) {
        cache.$form.off('click').on('click', ' button[name="' + cache.$save + '"]', validate);
    }
}

function submitForm() {
	cache.$form.append('<input type="hidden" name="' + cache.$save + '"/>');
	cache.$form.trigger("submit");
}

function updateAddressForm(addr) {
	cache.$form.find('input[name$="_address1"]').val(addr.add1);
	cache.$form.find('input[name$="_address2"]').val(addr.add2);
	cache.$form.find('select[id$="_state"]'    ).val(addr.state ? addr.state.toUpperCase() : "");
	cache.$form.find('input[name$="_city"]'    ).val(addr.city);
	cache.$form.find('input[name$="_postal"]'  ).val(addr.zip);
}

function updateAddress(data) {
    $.ajax({
        type: 'POST',
        url: Urls.qasUpdateAddress,
        data: data,
        dataType: 'html'
    }).done(function (response, textStatus, request) {
        var response = JSON.parse(response);
        if (response.action === 'reValidate') {
            cache.$modal.close();
            validate('reValidate');
        } else {
            if (response.action !== 'useOrig') {
                updateAddressForm(response.address);
            }

            submitForm();
        }
    });
}

function validate(action) {
    if ($('#dwfrm_singleshipping_shippingAddress').length > 0 && !$('#EditAddressForm').is(':visible')) { //Ade -- if (cache.$formId === '#EditAddressForm' && 
        cache["$formId"] = '#dwfrm_singleshipping_shippingAddress';
        cache["$form"] = $('#dwfrm_singleshipping_shippingAddress');
        cache["$source"] = 'dwfrm_singleshipping_shippingAddress_addressFields';
        cache["$save"] = 'dwfrm_singleshipping_shippingAddress_save';
    }
    
    if (!cache.$form.validate().form()) {
        return;
    }

    var data = cache.$form.serialize()+'&source=' + cache.$source;
    if (typeof(action) === 'string') {
        data = data + '&dwfrm_addForm_action=' + action;
    }

	$.ajax({
		type: 'POST',
		url: Urls.qasVerifyAddress,
		data: data,
		dataType: 'html'
	}).done(function (content, textStatus, request) {
		if (/json/.test(request.getResponseHeader('Content-Type'))) {
			var response = JSON.parse(content);
			if (response.action === 'addrVerified') {
				updateAddressForm(response.address);
				submitForm();
			} else if (response.action === 'verified') {
				submitForm();
			}
		} else {
			cache.$modal.renderContent(content);

			$('.addForm').on('click', 'button', function () {
                var form = $(this).parents('form');
                form.append('<input type="hidden" name="' + $(this).attr('name') + '"/>');

                updateAddress(form.serialize());
                cache.$modal.close();

                return false;
            });
		}
	});

    return false;
}

var qas = {
    init: function () {
        if (SitePreferences.IS_QAS_ENABLED) {
            initCache();
            initEvents();
        }
    }
};

module.exports = qas;
},{"./modal":28,"./page":31,"./util":87}],77:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    product = require('./pages/product'),
    util = require('./util'),
    modal = require('./modal').global,
    _ = require('lodash');


var makeUrl = function (url, source, productListID) {
    if (source) {
        url = util.appendParamToURL(url, 'source', source);
    }
    if (productListID) {
        url = util.appendParamToURL(url, 'productlistid', productListID);
    }
    return url;
};

var removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

var quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
        }
        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('href');
        });
    },

    setup: function (qvUrl) {
        var $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        product.initializeEvents();

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }
        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));
        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options) {
        var url = makeUrl(options.url, options.source, options.productlistid);
        var cls_import = "";
        if(options.class) {
            cls_import = options.class;
        }

       modal.addCustomClass('edit-modal quickview-modal ' + cls_import);
       modal.renderByUrl(url);

       if(typeof options.callback === 'function') {
           modal.setCallback(options.callback);
       }
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

module.exports = quickview;

},{"./dialog":16,"./modal":28,"./pages/product":52,"./util":87,"lodash":116}],78:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
    init: function () {
        $('.product-review').each(function (index, review) {
            var pid = $(review).data('pid');
            if (!pid) {
                return;
            }
            // rating range from 2 - 5
            var rating = getRating(pid);
            var baseRating = Math.floor(rating);
            var starsCount = 0;
            for (var i = 0; i < baseRating; i++) {
                $('.rating', review).append('<i class="fa fa-star"></i>');
                starsCount++;
            }
            // give half star for anything in between
            if (rating > baseRating) {
                $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
                starsCount++;
            }
            if (starsCount < 5) {
                for (var j = 0; j < 5 - starsCount; j++) {
                    $('.rating', review).append('<i class="fa fa-star-o"></i>');
                }
            }
        });
    }
};

},{}],79:[function(require,module,exports){
'use strict';

var util = require('./util'),
    modal = require('./modal').global,
    ajax = require('./ajax'),
    sampleCookieName = "sample.selection.shown";

/**
 * Creates sample selection cookie
 */
var createSelectionShownCookie = function () {
    util.setCookie(sampleCookieName, "1");
}

/**
 * Checks if sample selection cookie exists
 * @return {boolean}
 */
var canShowSelection = function () {
    return (!SitePreferences.SAMPLES_ENABLED) ? false : true;
}

/**
 * Render Samples
 * @return {boolean}
 */
var showSelection = function () {
    // set selection cookie
    //createSelectionShownCookie();

    // render content to modal by url
    modal.addCustomClass('sample-selection');
    modal.renderByUrl(Urls.showSampleSelection);
}

var showSelectionInCart = function () {
    // render content to modal by url
    modal.addCustomClass('sample-selection');
    modal.renderByUrl(Urls.showSampleSelectionInCart);
}

var showPointExchangeInCart = function () {
    var url = Urls.showExchangeGiftsSelectionInCart;
    url = util.appendParamToURL(url, 'format', 'ajax');
    var originURL = location.href;
    var data = {
        originURL: originURL
    };

    $.ajax({
        type: 'GET',
        url: url,
        data: data,
        success: function (response) {
            if (typeof response === 'object' && !response.isUserAuthenticated) {
                var redirectURL = response.redirectURL;
                location.href = redirectURL;
            } else if (typeof response === 'string') {
                modal.renderContent(response, 'pointexchange-selection');
            }
        },
        failure: function () {
            modal.addCustomClass('normal-modal');
            modal.renderContent(Resources.SERVER_ERROR);
        }
    });
}

var showConfirmExchangeGiftsInCart = function () {
    // render content to modal by url
    modal.addCustomClass('pointexchange-confirm');
    modal.renderByUrl(Urls.showExchangeGiftsConfirmInCart);
}

exports.createSelectionShownCookie = createSelectionShownCookie;
exports.canShowSelection = canShowSelection;
exports.showSelection = showSelection;
exports.showSelectionInCart = showSelectionInCart;
exports.showPointExchangeInCart = showPointExchangeInCart;
},{"./ajax":5,"./modal":28,"./util":87}],80:[function(require,module,exports){
'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    $resultsContainer;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');
        var $submitButton = $searchForm.find('button[type="submit"]');

        // disable go button on page load
//        $submitButton.prop('disabled', true);
        
        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.on("focus", function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
        });

        $(document).on('click', function (e) {
            if (!$searchContainer.is(e.target)) {
                setTimeout(this.clearResults, 200);
            }
        }.bind(this));
        
        // on blur listener
        $searchField.on('blur', function (e) {
        	this.checkInput(e, $searchField, $submitButton, defaultValue);
        }.bind(this));
        
        // on key up listener
        $searchField.on("keyup", function (e) {

            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                this.checkInput(e, $searchField, $submitButton, defaultValue);
                return;
            }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));
        
        $submitButton.on('click', function(e){
        	this.checkInput(e, $searchField, $submitButton, defaultValue);
        }.bind(this));
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery) {
            runningQuery = null;
            return;
        }

        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(200, function () {$resultsContainer.empty();});
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    },
    
    checkInput: function (e, $searchField, $submitButton, defaultValue) {
    	if($searchField.val().trim().toLowerCase() == defaultValue.toLowerCase()){
    		e.preventDefault();
    		e.stopImmediatePropagation();
    		$searchField.val(defaultValue);
//    		$submitButton.prop('disabled', true);
            return false;
    	}
    }
};

module.exports = searchsuggest;

},{"./util":87}],81:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes Slick carousels
 */
exports.init = function () {
   $('.slick').slick();
};

},{}],82:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
    setSelectedStore: function (storeId) {
        var $selectedStore = $('.store-tile.' + storeId),
            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
            storeAddress = $selectedStore.find('.store-address').html(),
            storeStatus = $selectedStore.find('.store-status').data('status'),
            storeStatusText = $selectedStore.find('.store-status').text();
        this.selectedStore = storeId;

        $lineItem.find('.instore-delivery .selected-store-address')
            .data('storeId', storeId)
            .attr('data-store-id', storeId)
            .html(storeAddress);
        $lineItem.find('.instore-delivery .selected-store-availability')
            .data('status', storeStatus)
            .attr('data-status', storeStatus)
            .text(storeStatusText);
        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
    },
    cartSelectStore: function (selectedStore) {
        var self = this;
        inventory.getStoresInventory(this.uuid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: selectedStore,
                selectedStoreText: Resources.SELECTED_STORE,
                continueCallback: function () {},
                selectStoreCallback: self.setSelectedStore.bind(self)
            });
        }).done();
    },
    setDeliveryOption: function (value, storeId) {
        // set loading state
        $('.item-delivery-options')
            .addClass('loading')
            .children().hide();

        var data = {
            plid: this.uuid,
            storepickup: (value === 'store' ? true : false)
        };
        if (value === 'store') {
            data.storepickup = true;
            data.storeid = storeId;
        } else {
            data.storepickup = false;
        }
        $.ajax({
            url: Urls.setStorePickup,
            data: data,
            success: function () {
                // remove loading state
                $('.item-delivery-options')
                    .removeClass('loading')
                    .children().show();
            }
        });
    },
    init: function () {
        var self = this;
        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            self.uuid = $(this).data('uuid');
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.cartSelectStore(selectedStore);
                });
            } else {
                self.cartSelectStore(selectedStore);
            }
        });
        $('.item-delivery-options .delivery-option').on('click', function () {
            // reset the uuid
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            self.uuid = $(this).closest('.cart-row').data('uuid');
            self.setDeliveryOption($(this).val(), selectedStore);
        });
    }
};

module.exports = cartInventory;

},{"./":83}],83:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button" data-store-id="' + store.storeId + '"' +
        (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

var storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
    }
};

var zipPromptTemplate = function () {
    return [
        '<div id="preferred-store-panel">',
        '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>',
        '</div>'
    ].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
var validateZipCode = function (zipCode) {
    var regexes = {
            canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
            usa: /^\d{5}(-\d{4})?$/
        },
        valid = false;
    if (!zipCode) { return; }
    _.each(regexes, function (re) {
        var regexp = new RegExp(re);
        valid = regexp.test(zipCode);
    });
    return valid;
};

var storeinventory = {
    zipPrompt: function (callback) {
        var self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    click: function () {
                        var zipCode = $('#user-zip').val();
                        if (validateZipCode(zipCode)) {
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function () {
                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        var self = this,
            stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText,
            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
        dialog.open({
            html: storeList,
            options: {
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    click: function () {
                        self.setUserZip(null);
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    click: function () {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function () {
                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) { return; }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;

},{"../dialog":16,"../util":87,"lodash":116,"promise":118}],84:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    inventory = require('./'),
    util = require('../util');

var newLine = '\n';
var pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        var $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();

        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }
    }
};

module.exports = productInventory;

$('#product-image-carousel').slick({
	  dots: true,
	  infinite: false,
	  speed: 300,
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        infinite: true,
	        dots: true
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	  ]
	});


$('#product-video-carousel').slick({
	  dots: true,
	  infinite: false,
	  speed: 300,
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        infinite: true,
	        dots: true
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	  ]
	});




},{"../util":87,"./":83,"lodash":116}],85:[function(require,module,exports){
'use strict';

var util = require('./util');

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    var url = 'https://www.howsmyssl.com/a/check';
    var cookieName = 'dw_TLSWarning';
    var cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                util.setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                util.setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    var message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    var userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    var badBrowsers = ['MSIE 6.0','MSIE 7.0','MSIE 8.0','MSIE 9.0','MSIE 10.0',
                       'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3',
                       'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({url: Urls.TLSBadTLS});
        }
    }

    function reportBadBrowser () {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({url: Urls.TLSBadBrowser});
    }

    for (var i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var tokens = cookies[i].split('=');
        var cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{"./util":87}],86:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    $(document).tooltip({
        items: '.tooltip',
        track: true,
        content: function () {
            return $(this).find('.tooltip-content').html();
        }
    });

    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
};

},{}],87:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var widgetHeaderNewletter, widgetGiftCert, widgetGCCheckBalance;
var widgetLogin, widgetAccountCreation, widgetModalNewsLetter, 
    widgetCheckoutBilling, widgetContactUS;
var util = {
     filterArr: function (arr) {
        var finishedArr = new Array();

        arr.forEach(function (o) {
           if (typeof o === "object") {
               var finishedObj = new Object();

               Object.keys(o).forEach(function (k) {
                   if (!o[k]) { return; }
                   finishedObj[k] = o[k];
               });

               if (Object.keys(finishedObj).length > 0) {
                   finishedArr.push(finishedObj);
               }
           } else if (!!o) {
               finishedArr.push(o);
           }
        });

        return finishedArr;
    },

	filterObj: function(o) {
        var finishedObj = {};

        Object.keys(o).forEach(function (k) {
           if (!o[k]) { return; }
           else if (o[k] instanceof Array) {
              finishedObj[k] = this.filterArr(o[k]);
           } else {
              finishedObj[k] = o[k];
           }
        }, this);

        return finishedObj;
    },

    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     */
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';

        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {String} url the url from which the parameter will be removed
     * @param {String} name the name of parameter that will be removed from url
     */
    removeParamFromURL: function (url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function (url, params) {
        var _url = url;
        _.each(params, function (value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));

        return _url;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     **/
    getQueryString: function (url) {
        var qs;
        if (!_.isString(url)) { return; }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },

    updateQueryStringParam: function (url, paramName, newVal) {
        var _url = url;

        if (_url.indexOf(paramName) === -1) {
            return _url;
        }

        var newParamObj = new Object();
        newParamObj[paramName] = newVal;

        _url = this.removeParamFromURL(_url, paramName);
        _url = this.appendParamsToUrl(_url, newParamObj);

        return _url;
    },

    getHashParam: function (paramName) {
        var output = "";

        var hashParams = window.location.hash.replace("#", "").split("&");
        for (var i = 0; i < hashParams.length; i++) {
            if (hashParams[i].indexOf(paramName) > - 1) {
                output = hashParams[i].split("=")[1];
            }
        }

        return output;
    },

    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function (el, offsetToTop) {
        var top = el.offsetTop,
            left = el.offsetLeft,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (typeof(offsetToTop) !== 'undefined') {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return (
                top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );
        }

        if (document.compatMode === 'CSS1Compat') {
            return (
                top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
                left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
                (top + height) > window.document.documentElement.scrollTop &&
                (left + width) > window.document.documentElement.scrollLeft
            );
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function (path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function (urls) {
        var i, len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function (url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function () {
        var i = this.loadedCssFiles.length;
        while (0 > i--) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },

    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (qs) {
        if (!qs || qs.length === 0) { return {}; }
        var params = {},
            unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
            function ($0, $1, $2, $3) {
                params[$1] = $3;
            }
        );
        return params;
    },

    fillAddressFields: function (address, $form) {
        for (var field in address) {
            if (field === 'ID' || field === 'UUID' || field === 'key') {
                continue;
            }
            // if the key in address object ends with 'Code', remove that suffix
            // keys that ends with 'Code' are postalCode, stateCode and countryCode
            $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
            // update the state fields
            if (field === 'countryCode') {
                $form.find('[name$="country"]').trigger('change');
                // retrigger state selection after country has changed
                // this results in duplication of the state code, but is a necessary evil
                // for now because sometimes countryCode comes after stateCode
                $form.find('[name$="state"]').val(address.stateCode);
            }
        }
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function () {
        $('form').find('textarea[data-character-limit]').each(function () {
            var characterLimit = $(this).data('character-limit');
            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
                '<span class="char-remain-count">' + characterLimit + '</span>',
                '<span class="char-allowed-count">' + characterLimit + '</span>');

            //if window size is small then char-count should be after
            var containerPlacement = $(this).prev('div.char-count');
            var containerInsert = $('<div class="char-count"/>').insertBefore($(this));

            if ($(window).width() < 640) {
            	containerPlacement = $(this).next('div.char-count'); ;
            	containerInsert = $('<div class="char-count"/>').insertAfter($(this));
            }

            var charCountContainer = containerPlacement;
            if (charCountContainer.length === 0) {
                charCountContainer = containerInsert;
            }
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).trigger("change");
        });
    },
    /**
     * @function
     * @description Binds the onclick-event to a delete button on a given container,
     * which opens a confirmation box with a given message
     * @param {String} container The name of element to which the function will be bind
     * @param {String} message The message the will be shown upon a click
     */
    setDeleteConfirmation: function (container, message) {
        $(container).on('click', '.delete', function () {
            return window.confirm(message);
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function (xLocation) {
        $('html, body').animate({scrollTop: xLocation}, 500);
    },

    isMobile: function () {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var idx = 0;
        var isMobile = false;
        var userAgent = (navigator.userAgent).toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
            idx++;
        }
        return isMobile;
    },

    /**
     * @function getCookieSelector
     * @description Returns the cookie value
     **/
    getCookieSelector: function (cookieName) {
        var regularExpression = '(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$';
        var regExp = new RegExp(regularExpression, '');

        return document.cookie.replace(regExp, '$1');
    },

    /**
     * @function setCookie
     *
     * @param {string} key - The cookie name
     * @param {string} value - The cookie value
     * @param {integer} minutes - The number of minutes to expire the cookie
     **/
    setCookie: function (key, value, minutes) {
        var duration = '';

        if (minutes) {
            var date = new Date();

            date.setTime(date.getTime() + (minutes * 60 * 1000));

            duration = ' expires=' + date.toGMTString() + ';';
        }

        document.cookie = key + '=' + value + ';' + duration + ' path=/';
    },

    /**
     * @function validateEmail
     *
     * @description Returns boolean
     * @param {string} emailAddress - The email address
     **/
     validateEmail: function (emailAddress) {
        var emailRegExp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$');

        return emailRegExp.test(emailAddress);
     },

    /**
     * @function validateMessage
     *
     * @description Returns boolean
     * @param {string} message - The message
     **/
     validateMessage: function (message) {
        var messageRegExp = /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/;

        return messageRegExp.test(message);
     },

    /**
     * @function maximizeCheckoutSummary
     *
     * @description Maximizes/Expands the Order Checkout Summary
     **/
     maximizeCheckoutSummary: function () {
        if (SitePreferences.IS_CHECKOUT_MAXIMIZED) {
            $('.accordion-navigation').addClass('is-active');
            $('.accordion-title').attr('aria-expanded', true);
            $('.accordion-title').attr('aria-selected', true);
            $('#panel11a').css('display', 'block');
        }
     },
     
     /**
      * @function renderGoogleInvRecaptcha
      * 
      * @description Renders google invisible captcha on a given page.
      * 
      * @param {string} elementId - Element Id on which captcha iframe will be rendered. It should be present in the isml.
      * @param {integer} buttonID - Button ID/Class once captcha is successfull to trigger the submit button.
      * 
      * @Note This method can be modified as per the requirement.
      **/
     renderGoogleInvRecaptcha: function( elementId, buttonID, formID ){    	 
    	 /*if( SitePreferences.GOOGLE_RECAPTCHA == true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha == 'object'){         	
    		 try {         		
         		grecaptcha.render(elementId,{
             		'sitekey' : SitePreferences.RECAPTCHA_SITE_KEY,
             		'size'    : 'invisible',
             		'callback': function(e){
             			if ($('#'+formID).length > 0){ 
             			    $('#'+formID+' .hiddenCaptchaResponse').val(e);
             			}
             			$(buttonID).trigger("click");
             		}             		
             	});
         		
         	}
         	catch(err) {
         	    console.log(err.message);
         	}	
         }*/
     },     
     callingGoogleReCaptchaOnAjaxSubmit: function(){
    	 /*if( SitePreferences.GOOGLE_RECAPTCHA == true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha == 'object'){    	    	
    	    	try {
    	    		if( grecaptcha.getResponse() == '' ){
    	        		e.preventDefault();
    	        		e.stopPropagation();
    	        		grecaptcha.execute();
    	        		return false;
    	        	}
    	    	}
    	    	catch(err) {
    	    	    console.log(err.message);
    	    	}
    	    	
    	    }*/
     },     
     resettingGoogleInvRecaptcha: function(widgetOpt, formID){
		if( this.getGoogleRecaptchaEnableStatus(formID) == true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha == 'object'){
			var widgetOpt = (widgetOpt != undefined && widgetOpt!='') ? widgetOpt : 0;
			grecaptcha.reset(widgetOpt);
			return;
		}		
	},
	renderGoogleInvisibleReCaptchaFunc: function(){		
        if ( SitePreferences.GOOGLE_RECAPTCHA == true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha == 'object') {		           			
			//For Header Newsletter Form  Initialization Captcha DIV ID(newsletterrecaptcha)
			if ($('#newsletterrecaptcha').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_NEWSLETTER) {				
				widgetHeaderNewletter = this.renderInvisibleReCaptcha('newsletterrecaptcha',this.createCallbackFn(widgetHeaderNewletter,'headerNewsLetter', 'headernewslettersubmit'));
            }
			//For Modal Newsletter Form  Initialization	Captcha DIV ID(modalnewsletterrecaptcha)	
			if ($('#modalnewsletterrecaptcha').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_NEWSLETTER) {				
				widgetModalNewsLetter = this.renderInvisibleReCaptcha('modalnewsletterrecaptcha',this.createCallbackFn(widgetModalNewsLetter,'modalNewsLetter', 'modalnewslettersubmit'));
            }
			//For Gift Certificate Purchase Check Form Initialization Captcha DIV ID(giftcertrecaptcha)
			if ($('#giftcertrecaptcha').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_GIFTCERTIFICATE) {				
				widgetGiftCert = this.renderInvisibleReCaptcha('giftcertrecaptcha',this.createCallbackFn(widgetGiftCert,'GiftCertificateForm','AddToBasketButton'));
            }

              //For Gift Certificate Balance Check Form Initialization Captcha DIV ID(giftcertcheckbalance)
			if ($('#giftcertcheckbalance').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_GIFTCERTIFICATE) {				
				widgetGCCheckBalance = this.renderInvisibleReCaptcha('giftcertcheckbalance',this.createCallbackFn(widgetGCCheckBalance,'gcBalanceCheckForm','CheckBalanceButton'));
            }
			
			  //For Login Form Initialization Captcha DIV ID(loginrecaptcha)
			if ($('#loginrecaptcha').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_PROFILE) {				
				widgetLogin = this.renderInvisibleReCaptcha('loginrecaptcha',this.createCallbackFn(widgetLogin,'dwfrm_login', 'login'));
            }
			  //For Account Creation Form Initialization Captcha DIV ID(registrationrecaptcha)
			if ($('#registrationrecaptcha').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_PROFILE) {				
				widgetAccountCreation = this.renderInvisibleReCaptcha('registrationrecaptcha',this.createCallbackFn(widgetAccountCreation,'RegistrationForm','registrationSubmitButton'));
            }
			    //For Checkout Billing Form Initialization Captcha DIV ID(billingrecaptcha)
			if ($('#billingrecaptcha').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_CHECKOUT){				
				widgetCheckoutBilling = this.renderInvisibleReCaptcha('billingrecaptcha',this.createCallbackFn(widgetCheckoutBilling,'dwfrm_billing','dwfrm_billing_save'));
            }
			if ($('#contactusrecaptcha').length > 0 && SitePreferences.ENABLE_GRECAPTCHA_FOR_CONTACTUS){				
				widgetContactUS = this.renderInvisibleReCaptcha('contactusrecaptcha',this.createCallbackFn(widgetCheckoutBilling,'ContactUSForm','sendBtn'));
            }
		}				
	},
	renderInvisibleReCaptcha: function(recaptchaID,callbackFunction){		
		return grecaptcha.render(recaptchaID, {
			    'sitekey' 	: SitePreferences.RECAPTCHA_SITE_KEY,
			    "theme"		: "light",
			    'size'		: 'invisible',						    
			    'callback' 	: callbackFunction
			});
	},
	createCallbackFn: function (widget,formID,buttonID) {		
		return function(token) {			
	        $('#'+formID+' .g-recaptcha-response').val(token);
	        if ($('#'+formID).length > 0){ 	        	
 			    $('#'+formID+' .hiddenCaptchaResponse').val(token);
 			}
	        
	        if ($.trim(token) == '') {
	    		grecaptcha.reset(widget);
	    	}else{	    			    		
	    		$('#'+formID+' #'+buttonID).trigger("click");
	    	}
	    }
	},
	callingGoogleReCaptchaOnFormSubmitORAJAXCall: function(e, formID){	 
   	 if( this.getGoogleRecaptchaEnableStatus(formID) == true && SitePreferences.RECAPTCHA_SITE_KEY != null && typeof grecaptcha == 'object'){    	    	
   	    	try {   	    		
   	    		var widget_opt = this.getGoogleRecaptchaWidgetOptionNum(formID);   	    		
   	    		if( grecaptcha.getResponse(widget_opt) == '' ){
   	        		e.preventDefault();
   	        		e.stopPropagation();
   	        		grecaptcha.execute(widget_opt);   	        		
   	        		return false;
   	        	}   	    		
   	    	}
   	    	catch(err) {
   	    	    console.log(err.message);
   	    	}
   	    	
   	    }
    },
    getGoogleRecaptchaWidgetOptionNum: function(formID){
    	var widget_opt = 0;
    	if (formID == 'gcBalanceCheckForm') {
   			widget_opt= parseInt(widgetGCCheckBalance);
   		} else if (formID == 'GiftCertificateForm') {
   			widget_opt= parseInt(widgetGiftCert);
   		} else if (formID == 'headerNewsLetter') {
   			widget_opt= parseInt(widgetHeaderNewletter);
   		} else if (formID == 'modalNewsLetter') {
   			widget_opt= parseInt(widgetModalNewsLetter);
   		} else if (formID == 'RegistrationForm') {
   			widget_opt= parseInt(widgetAccountCreation);
   		} else if (formID == 'dwfrm_login') {
   			widget_opt= parseInt(widgetLogin);
   		} else if (formID == 'dwfrm_billing') {
   			widget_opt= parseInt(widgetCheckoutBilling);
   		} else if(formID == 'ContactUSForm') {
   		    widget_opt= parseInt(widgetContactUS);
   		}
    	return widget_opt;
    },
    getGoogleRecaptchaEnableStatus: function(formID){    	
    	var isRecaptchaEnabled = SitePreferences.GOOGLE_RECAPTCHA;
    	if(formID == 'gcBalanceCheckForm' || formID == 'GiftCertificateForm'){
    		isRecaptchaEnabled= (isRecaptchaEnabled && SitePreferences.ENABLE_GRECAPTCHA_FOR_GIFTCERTIFICATE);
   		}  else if(formID == 'headerNewsLetter' || formID == 'modalNewsLetter'){
   			isRecaptchaEnabled= (isRecaptchaEnabled && SitePreferences.ENABLE_GRECAPTCHA_FOR_NEWSLETTER);
   		}  else if(formID == 'RegistrationForm' || formID == 'dwfrm_login'){
   			isRecaptchaEnabled= (isRecaptchaEnabled && SitePreferences.ENABLE_GRECAPTCHA_FOR_PROFILE);
   		} else if(formID == 'dwfrm_billing'){
   			isRecaptchaEnabled= (isRecaptchaEnabled && SitePreferences.ENABLE_GRECAPTCHA_FOR_CHECKOUT);
   		} else if(formID == 'ContactUSForm'){
   			isRecaptchaEnabled= (isRecaptchaEnabled && SitePreferences.ENABLE_GRECAPTCHA_FOR_CONTACTUS);
   		} else {
   			isRecaptchaEnabled = false;
   		}
    	return isRecaptchaEnabled;
    },
    /**
     * Setting Payment Credit OR Debit card's CVV length
     * through BM sitepref Configuration.
     * */
    setCheckoutPaymentCardCVVLength: function(cardType) {    	
    	var setCVVCardLength = {
             'minLength': 3,
       		 'maxLength' : 4
       	};    	
    	if (SitePreferences.SET_PAYMENT_CARD_CVVNUMLEN !='' && 
    		SitePreferences.SET_PAYMENT_CARD_CVVNUMLEN !=undefined && 
    		SitePreferences.SET_PAYMENT_CARD_CVVNUMLEN != null && 
    		cardType != '' && cardType!=undefined) {
    		var getCVVCardLength = JSON.parse(SitePreferences.SET_PAYMENT_CARD_CVVNUMLEN); 
    		if (cardType == 'visa') {
                setCVVCardLength = getCVVCardLength.visa;
            } else if(cardType == 'amex') {
            	setCVVCardLength = getCVVCardLength.amex;
            } else if(cardType == 'mastercard') {
            	setCVVCardLength = getCVVCardLength.mastercard;
            } else if(cardType == 'unionpay') {
            	setCVVCardLength = getCVVCardLength.unionpay;
            } else if(cardType == 'discover') {
            	setCVVCardLength = getCVVCardLength.discover;
            }    		
    	} 
        return setCVVCardLength;	
    },
    
    /**
     * Customize SelectBox for singlepage checkout section
     * */    
    selectbox: function(){    	
    	//this.updateselect();
    	$(document).on('click','.spc-container .selected-option', function(){
    		var $h = 0;
    		var $this = $(this);
    		if($this.siblings('select').is(':disabled')){return false;}

			$('.custom-select.current_item select').trigger('blur');
			$('.custom-select').not($this.closest('.custom-select')).removeClass('current_item');
			$this.toggleClass('expanded');
			$this.siblings('.selection-list').css('top', $this.outerHeight() - 1);
			$this.closest('.custom-select').toggleClass('current_item');

    		if(!$this.closest('.custom-select').hasClass('current_item')){
    			$this.siblings('select').trigger('blur');
    			if(!util.isMobile()){
    				$this.siblings('select').addClass('focus_none').trigger('focus');
    			}
    		}

    		if($this.siblings('.selection-list').find('li').length > 10){
	    		$.each($this.siblings('.selection-list').find('li:visible').slice(0,10), function(){
	    			$h += $(this).outerHeight();
	    			$this.siblings('.selection-list').height($h - 1);
	    		});

	    		var h = 0;
	    		$.each($this.closest('.custom-select').find('.selection-list li:visible').splice(0, $this.closest('.custom-select').find('.selection-list li.selected:visible').index() - 1),function(){ h+=$(this).outerHeight();})
	    		$this.siblings('.selection-list').scrollTop(h);

    		}else{
    			$this.siblings('.selection-list').height("auto");
    		}
    		if ($(window).width() > 767) {
    	    	if($('.plp-content .plp-refine-main .selection-list').is(':visible')) {
    	    		$('.selected-option.selected').addClass('active-refine');
    	    	}
    	    	else{
    	    		$('.selected-option.selected').removeClass('active-refine');
    	    	}
    		}
    		//e.stopPropogation();
    	}).on('click','.spc-container .selection-list li', function(){
    		var $item = $(this).closest('.custom-select');
    			$item.find('li').removeClass('hover selected');
    			$(this).addClass('selected');
	    		$item.find('select option').eq($(this).index()).prop('selected', true);
	    		$item.find('.selected-option').html($(this).html());
	    		$('.selection-list li .shipping-name i').addClass('hide')
	            $('.selection-list li[data-value='+$('#shippingMethodSelect').val()+'] .shipping-name i').removeClass('hide');
	    		$item.find('.selected-option .icon-checkmark').removeClass('hide');
	    		$item.find('.selected-option').removeClass('expanded');
	    		$item.removeClass('current_item');
	    		$('.error-form.date-card').hide();
	    		$item.find('select').trigger('change');
	    		$item.find('select').trigger('blur');
	    		if(!util.isMobile()){
	    			$item.find('select').addClass('focus_none').trigger('focus');
    			}
    	}).on('change input','select', function(){
    		//util.updateselect(); 
    	}).on('focus','select', function(e){
    		if(!$(this).hasClass('focus_none') && !util.isMobile() && $(e.delegateTarget.activeElement).is(e.target)){
    			if($(this).closest('form').find(':input:not([type="hidden"])').first().attr('id') == $(this).attr('id') && !$(this).hasClass('focused-first')){
    				$(this).addClass('focused-first');
    				return;
    			}
    			$(this).siblings('.selected-option').trigger('click');
    		}
    	});

    	$(document).on('click', function (e) {
             if (!$('.custom-select.current_item').is(e.target) && !$('.custom-select.current_item').find('*').is(e.target)) {
            	util.closeselectbox();
            	if ($(window).width() > 767) {
        	    	if($('.plp-content .plp-refine-main .selection-list').is(':visible')) {
        	    		$('.selected-option.selected').addClass('active-refine');
        	    	}
        	    	else{
        	    		$('.selected-option.selected').removeClass('active-refine');
        	    	}
        		}
             }
        });
    	   	

    	$('body').off('keydown').on('keydown', function (e) {
			var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0,
					$active_select = $('.custom-select.current_item');

				if($active_select.length > 0 && !util.isMobile()) {
					e.preventDefault();
					var $list = $active_select.find('li'),
							$active;

					if(!$active_select.find('li.selected').length) {
						$active_select
							.find('li')
							.eq($active_select.find('option:selected').index())
							.addClass('selected');
					}

					if(key === 8) { // Delete key
						window.$currentkeycode = window.$currentkeycode.slice(0, -1);
					} else {
						window.$currentkeycode += $.trim(String.fromCharCode(key).toLowerCase());
					}
					$active = $active_select.find("li[label^='" + window.$currentkeycode + "']");

					if($active.length == 0){
						window.$currentkeycode = window.$currentkeycode.substr(window.$currentkeycode.length - 1, 1);
						$active = $active_select.find("li[label^='" + window.$currentkeycode + "']");
					}

					if(key == 40){
						$active = $active_select.find('li.selected');
						if($active.next().length > 0){
							$active_select.find('li').removeClass('selected');
							$active.next().addClass('selected');
						}
					}else if(key == 38){
						$active = $active_select.find('li.selected');
						if($active.prev().length > 0){
							$active_select.find('li').removeClass('selected');
							$active.prev().addClass('selected');
						}
					}
					else if(key === 13){
						if($active.length == 0 && $active_select.find('li.selected').length > 0){
							$active_select.find('li.selected').trigger('click');
						}else{
							$active.eq(0).trigger('click');
						}
					}else if(key === 9 || key === 27){
						util.closeselectbox();
					}else if($active.length != 0){
						$list.removeClass('selected');
						$active.eq(0).addClass('selected');
					}
					if(key === 8) { // Delete key
						return false;
					}

					var h = 0;
					if($active_select.find('.selection-list li.selected').length > 0){
						$.each($active_select.find('.selection-list li').splice(0, $active_select.find('.selection-list li.selected').index() - 1),function(){ h+=$(this).outerHeight();})
					}

					$active_select.find('.selection-list').scrollTop(h);
				}
		}).off('click').on('click', function (e) {
				$('select').removeClass('select-focus');
				$('.ui-dialog:visible .dialogInput').remove();
		});
    },
    closeselectbox: function(){
        $('.custom-select.current_item select').trigger('blur');
    	$('.custom-select').removeClass('current_item');
    	$('.custom-select li').removeClass('hover');
    	$('select').removeClass('focus_none');
    },
    /**
    * Single Page Checkout current Steps maintained.
    */
    singlePageNextCheckoutStep: function (spcsteps) {
    	$('.checkout-progress-container .step').removeClass('active');
    	$('.button-checkoutstep').hide();
    	let $ShippingCol = $('.spc-shipping');
    	let $BillingCol = $('.spc-billing');
    	let $OrderSummaryCol = $('.spc-summary');
		if (spcsteps == 2 && spcsteps !== undefined) {
			$ShippingCol.removeClass('section-overlay').addClass('active inprogress');			
			$BillingCol.addClass('section-overlay');
			$OrderSummaryCol.addClass('section-overlay'); 
			
		} else if(spcsteps == 3 && spcsteps !== undefined){
			$ShippingCol.addClass('section-overlay').css('pointer-events','all');
			$BillingCol.removeClass('section-overlay').addClass('active inprogress');			
			$OrderSummaryCol.addClass('section-overlay');
			$('.button-checkoutstep.shipping').show();
		} else if(spcsteps == 4 && spcsteps !== undefined){
			$ShippingCol.addClass('section-overlay');			
			$BillingCol.addClass('section-overlay');
			$OrderSummaryCol.removeClass('section-overlay').addClass('active inprogress'); 
			$('.button-checkoutstep').show();
		} else {
			$ShippingCol.addClass('section-overlay');
			$ShippingCol.addClass('inprogress');
			$BillingCol.addClass('section-overlay');
			$OrderSummaryCol.addClass('section-overlay');
		}
	},
	displayCVNErrorMessage: function (display) {
		if(display!==undefined && display!='' && display == 'show'){
			$('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').removeClass('hide').show();
            $('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').html(Resources.VALIDATE_CVN);
		} else {
			$('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').html('');
		    $('.creditcard-tile.selected .cvnvalidationerror.errorshow.error').hide();
		    $('input:radio[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID][value=CREDIT_CARD]').attr('checked', true);
		}    		
	},
	setSpcCheckoutSteps: function(steps) {
		var steps = (steps!==undefined && steps > 0 && steps!== null)? steps : 1;
		window.SessionAttributes.SPC_CHKOUTSTEPS = steps;
		$('.spcCheckoutSteps').val(steps);
	},
	formFieldFocusOnError: function(form){
		if (!$(form).validate().form()) { 
		    var $curObj  = $(form).find('.form-row').find('.input-select.error, .input-text.error').first();
	        $curObj.trigger("focus");
	    }	
	},
	isMacOS: function(){
		if(navigator.userAgent.indexOf('Mac') > 0 && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
	    	$('body').addClass('mac-os');
	    }
	},
	isApplePayPresent: function(){
		setTimeout(function(){
			if($.trim($(".spc-apple-pay .other-payment").html()).indexOf("isapplepay") == -1) {
				$('.spc-apple-pay').addClass('apple-pay-present');
			}
		}, 3000); 
	},
	/**
	 * Below function is for providing auto suggestion field for Checkout address on Global Core.
	 * We have used the third party service(QAS) to get the suggested address to display
	 * at Store front level.It is implemented for both the Checkout experiences.
	 * It is implemented for Only Shipping address1 form field for both the checkout flow.
	 * We have implemented for the current US only .If we want implement for other country we have to 
	 * customize accordingly.
	 * **/
	autoSuggestionAddressField: function(checkoutPageType) {		
		if (SitePreferences.IS_QAS_AUTO_SUGGESTION_ENABLE) {
		    var $shippingForm = $(document).find('.spc-shipping.active .checkoutShippingAddress');
		    let $city = $shippingForm.find('input[id$="_city"]');
		    let $state = $shippingForm.find('select[name$="_state"]');
		    let $postalCode = $shippingForm.find('input[id$="_postal"]');
		    let $phone = $shippingForm.find('input[id$="_phone"]');
		    let $numOfCharAllowed = SitePreferences.NUMBER_OF_CHAR_ON_PREDECTIVESEARCH;
		    $numOfCharAllowed = (($numOfCharAllowed !== undefined && $numOfCharAllowed != '') ? $numOfCharAllowed : 3);
		    $shippingForm.find('input[id$="_address1"]').attr("autocomplete", "nope");		    
		    $shippingForm.find('input[id$="_address1"]')
		        .on("keydown", function(event) {
		            if (event.keyCode === $.ui.keyCode.TAB &&
		                $(this).autocomplete("instance").menu.active) {
		                event.preventDefault();
		            }
		        })
		        .autocomplete({
		            source: function(request, response) {
		                $.ajax({
		                    url: Urls.checkoutAutoSuuggesionAdress,
		                    type: "GET",
		                    data: {
		                        term: request.term,
		                        format: 'ajax'
		                    },
		                    beforeSend: function() {
		                        $city.val(null);
		                        $state.val(null);		                        
		                        $postalCode.val(null);
		                        $(this).css("background", "#FFF url(LoaderIcon.gif) no-repeat 165px");
		                        $shippingForm.find('input[id$="_address1"]').addClass("ui-autocomplete-loading");
		                    },
		                    success: function(data) {
		                    	$shippingForm.find('input[id$="_address1"]').removeClass("ui-autocomplete-loading");
		                    	response($.map(data.addresssearchresults, function(value, key) {
		                            return {
		                                label: value.suggestion,
		                                value: value.label,
		                                city: value.city,
		                                zipcode: value.zipcode,
		                                state: value.state,
		                                suggestion: value.suggestion
		                            };
		                        }));
		                    }
		                });
		            },
		            select: function(event, ui) {
		                // Prevent value from being put in the input:
		                this.value = ui.item.value;
		                $city.val(ui.item.city).trigger('focus');
		                $state.val(ui.item.state).trigger('focus');
		                $postalCode.val(ui.item.zipcode).trigger('focus');
		                $phone.trigger('focus');
		                event.preventDefault();
		            },
		            minLength: $numOfCharAllowed,
		            delay: 100
		        });
		}
	},
    /**
     * @function
     * @description Convert 2 bytes to 1 byte
     * @param {String} value The input field which will be validated
     */
    replaceTwoByteToOneByteNumber : function(value) {
        var fieldValue = value;
        var oneByteCharacters = '0,1,2,3,4,5,6,7,8,9,-'.split(',');
        var twoByteCharacters = '０,１,２,３,４,５,６,７,８,９,－'.split(',');

        for (var i = 0; i < fieldValue.length; i++) {
            var fieldChar = fieldValue.charAt(i);
            var towByteCharIdx = twoByteCharacters.indexOf(fieldChar);

            if (towByteCharIdx > -1 && (towByteCharIdx in oneByteCharacters)) {
                fieldValue = fieldValue.replace(new RegExp(twoByteCharacters[towByteCharIdx]), oneByteCharacters[towByteCharIdx]);
            }
        }

        return fieldValue;
    },
	
};

module.exports = util;

},{"lodash":116}],88:[function(require,module,exports){
'use strict';
const EventNames = require('./constants/EventNames');
var formPrepare = require('./pages/checkout/formPrepare');

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
    phone: {
        us: naPhone,
        ca: naPhone,
        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
        it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
        other: /^\(?([0-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/
    },
    postal: {
        us: /^\d{5}(-\d{4})?$/,
        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
        it: /^([0-9]){5}$/,
        jp: /^([0-9]){3}[-]([0-9]){4}$/,
        cn: /^([0-9]){6}$/,
        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/,
        other: /^\d{5}(-\d{4})?$/
    },
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    name: /^[a-zA-Z\s.-]*$/,
    simpletext: /^[0-9a-zA-Z .#,'-]*$/,
    password: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$/,
    loginpassword: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{6,20}$/,
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    hasPOBox: /^ *(((box|bin)[-. \/\\]?\d+)|(.*p[ \s]?[ \.]? ?(o|0)[ \s]?[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|Post Box|post office|post office box|((box|bin)|b) *(number|num|#)? *\d*\d+)/i,
    message: /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/,
    ordernumber: /^[0-9a-z\s-\(\)#]*$/i,
    cvn: /^\d{3,4}$/,
    alphanumeric: /^[a-z0-9]+$/i,
    addr2regex: /^[0-9a-zA-Z .,'#]*$/
};
// global form validator settings
var settings = {
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
        if (!this.checkable(element)) {
            this.element(element);
        }
    },
    errorPlacement: function(error, element) {
        var formGroup = $(element).closest('.form-group');
        if (formGroup.length) {
            error.appendTo(formGroup.find('.error-custom'));
        } else {
            error.insertBefore($(element));
        }
    },
    ignore: ":hidden, .ignore"
};

/**
 * @function
 * @description Validates a given credit card if it has the correct format
 * @param {String} value of credit card which will be validated
 */
var luhnCheck = (function (arr) {
    return function (ccNum) {
        var len = ccNum.length;
        var bit = 1;
        var sum = 0;
        var val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
    var country = $(el).closest('form').find('.country option:selected').val()

    if (country == undefined || country.length === 0 || !regex.phone[country.toLowerCase()]) {
        var country = 'other';
    }

    var rgx = regex.phone[country.toLowerCase()];
    var isOptional = this.optional(el);
    var isValid = rgx.test($.trim(value));

    // format the phone number
    value = value.replace(/[^\d]/g, "");
    $(el).val(value.replace(/^(\d{3})[\s-]*(\d{3})[\s-]*(\d+)$/, "($1) $2-$3"));
    return isOptional || isValid;
};

/**
 * @function
 * @description Validates that a Address2 is not a Address2
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateAddress2 = function (value) {
    var isValid = regex.addr2regex.test($.trim(value));
    return isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
    var isValid = regex.notCC.test($.trim(value));
    return isValid;
};

/**
 * @function
 * @description Validates that a name contains no special characters, except for "-"
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateName = function (value) {
    var isValid = regex.name.test($.trim(value));
    return isValid;
};

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateName, Resources.INVALID_OWNER);

/**
* Add Address2 validation method to jQuery validation plugin.
* Text fields must have 'address2' css class to be validated as address2
*/
$.validator.addMethod('address2', validateAddress2, Resources.INVALID_ADDRESS2);

/**
 * Add First and Last Name validation method to jQuery validation plugin.
 * Text fields must have 'firstname' or 'lastname' css class to be validated.
 */
$.validator.addMethod('firstname', validateName, Resources.INVALID_FIRSTNAME);
$.validator.addMethod('lastname', validateName, Resources.INVALID_LASTNAME);
$.validator.addMethod('fullname', validateName, simpleTextMessage);

$.validator.addMethod('simpletext', function (value) {
    var isValid = regex.simpletext.test($.trim(value));
    return isValid;
}, simpleTextMessage);

$.validator.addClassRules({
    city: {
        simpletext: true
    },
    address1: {
        simpletext: true,
        address: true
    },

    province: {
        simpletext: true
    }
});

/**
 * Add Alphanumeric method to jQuery validation plugin.
 * Text fields must have 'alphanumeric' css class to be validated.
 */
$.validator.addMethod('alphanumeric', function(value){
    var isValid = regex.alphanumeric.test($.trim(value));
    return isValid;
}, simpleTextMessage);

/**
 * Modify password validation method of jQuery validation plugin.
 * Text fields must have 'password' css class to be validated.
 */
$.validator.addMethod('create-password', function(value){
    var isValid = regex.password.test(value);
    return isValid;
}, Resources.VALIDATE_PASSWORD);

$.validator.addMethod('login-password', function(value){
    var isValid = regex.loginpassword.test(value);
    return isValid;
}, Resources.VALIDATE_PASSWORD);

/**
 * Modify email validation method of jQuery validation plugin.
 * Text fields must have 'email' css class to be validated.
 */
$.validator.addMethod('email', function(value){
    var isValid = regex.email.test($.trim(value));
    return isValid;
}, Resources.VALIDATE_EMAIL);

/**
 * Modify confirm email validation method of jQuery validation plugin.
 * Text fields must have 'confirmemail' css class to be validated.
 */
$.validator.addMethod('confirmemail', function(value){
    var email = $('.email').val();
    var isValid = email === value;
    return isValid;
}, Resources.VALIDATE_CONFIRM_EMAIL);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
    var isOptional = this.optional(el);
    var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

/**
 * Add CC number validation method to jQuery validation plugin.
 * Text fields must have 'number' css class to be validated
 */
$.validator.addMethod('number', function (value) {	// number == Credit card number
    var isValid = luhnCheck($.trim(value));
    return isValid;
}, Resources.VALIDATE_NUMBER);

/**
 * Add CVN number validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated
 */
$.validator.addMethod('cvn', function (value) {
    var minLen = $('.cvn').attr('minlength');
    minLen = ((minLen!==undefined && minLen !='' && minLen!==null))? minLen : 0;
    var maxLen = $('.cvn').attr('maxlength');
    maxLen = (maxLen!==undefined && maxLen !='' && maxLen!==null)? maxLen : 0;
    var isValid;
    if(minLen == 0 && maxLen == 0){
        isValid = regex.cvn.test($.trim(value));
    } else {
        var confRegxCvn = new RegExp('^[0-9]{'+minLen+','+maxLen+'}$');
        isValid = confRegxCvn.test($.trim(value));
    }

    return isValid;
}, Resources.VALIDATE_CVN);

/**
 * Add Order number validation method to jQuery validation plugin.
 * Text fields must have 'ordernumber' css class to be validated
 */
$.validator.addMethod('ordernumber', function (value) {
    var isValid = regex.ordernumber.test($.trim(value));
    return isValid;
}, Resources.INVALID_ORDER_NUMBER);

/**
 * Add equal value validation method to jQuery validation plugin.
 * Text fields must have 'equal-to' css class to be validated
 */
$.validator.addMethod('equal-to', function (value, el) {
    var equalTo = $(el).attr('equal-to');
    var $equalToEl = $(el).closest('form').find(equalTo);

    return  value === $equalToEl.val();

}, function(value, el){
    var message = $(el).attr('data-required-text');
    return message || Resources.VALIDATE_EQUALTO
});

/**
 * Add address validation method to jQuery validation plugin.
 * Text fields must have 'address1' css class to be validated
 */
$.validator.addMethod('address', function (value, el) {
    // check 'PO BOX' value in string and complement result
    var isValid = true;

    // If false, adress1 field containing "Po Box" or similar strings will be rejected
    if (!SitePreferences.ENABLE_POBOX_ADDRESS)
        isValid = !$.trim(value).match(regex.hasPOBox);

    return isValid;
}, Resources.ADDRESS_PO_BOX_ERROR);

/**
 * Add zipcode validation method to jQuery validation plugin.
 * Text fields must have 'zipcode' css class to be validated
 */
$.validator.addMethod('postal', function (value, el) {
    var $form = $(el).closest('form');
    var $country = $form.find('select[name$="_country"]');
    var selectedCountry = ($country.length > 0 && $country.val() != undefined && $country.val() != '') ? $country.val().toLowerCase() : 'us';

    var rgx = null;
    var isValid = false;
    if($(el).hasClass('global-zip')){
        // if universal, it accepts both US and CN values
        isValid = regex.postal['us'].test($.trim(value)) || regex.postal['cn'].test($.trim(value));
    } else {
        rgx = regex.postal[selectedCountry];
        isValid = (rgx!=undefined && rgx!='' && rgx!=null)? rgx.test($.trim(value)) : false;
    }

    return isValid;
}, Resources.INVALID_ZIP);

/**
 * Add postcode validation method to jQuery validation plugin.
 * Text fields must have 'postcode' css class to be validated
 * Adding this for China addresses
 */
$.validator.addMethod('postcode', function (value, el) {
    var $form = $(el).closest('form');
    var $country = $form.find('select[name$="_country"]');
    var selectedCountry = $country.length > 0 ? $country.val() : 'us';

    var rgx = regex.postal[selectedCountry];
    var isValid = rgx.test($.trim(value));

    return isValid;
}, Resources.INVALID_POSTAL);

/**
 * Add message validation method to jQuery validation plugin.
 * Text fields must have 'message' css class to be validated
 */
$.validator.addMethod('message', function (value, el) {
    var isValid = regex.message.test($.trim(value));
    return isValid;
}, Resources.INVALID_MESSAGE);


var requiredMessage = function(value, el) {
    var message = $(el).attr('data-required-text');
    return message || Resources.VALIDATE_REQUIRED
};

var simpleTextMessage = function(value, el) {
    var message = $(el).attr('data-required-text');
    return message || Resources.VALIDATE_REQUIRED
};

var passwordMessage = function(value, el) {
    var message = $(el).attr('data-required-text');
    return message || Resources.VALIDATE_PASSWORD
};

var maxLengthMessage = function(value, el) {
    var message = $(el).attr('data-required-text');
    return message || $.validator.format(Resources.VALIDATE_MAXLENGTH)
};

var minLengthMessage = function(value, el) {
    var message = $(el).attr('data-required-text');
    return message || $.validator.format(Resources.VALIDATE_MINLENGTH)
};


$.extend($.validator.messages, {
    required: requiredMessage,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    confirmemail: Resources.VALIDATE_CONFIRM_EMAIL,
    address1: Resources.ADDRESS_PO_BOX_ERROR,
    password: passwordMessage,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: maxLengthMessage,
    minlength: minLengthMessage,
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN),
    postal: Resources.INVALID_ZIP,
    message: Resources.INVALID_MESSAGE,
    fullname: simpleTextMessage,
    simpletext: simpleTextMessage,
    alphanumeric: simpleTextMessage
});
// Updated code to populate green tick check if the password meets the requirements.
var validator = {
    regex: regex,
    settings: settings,
    init: function () {
        var _self = this;
        $('form:not(.suppress)').each(function () {
            _self.initForm(this);
            $(window).trigger(EventNames.VALIDATOR_CUSTOM_INITIALIZE);
        }).on('blur', '.create-password', function(){
            var isValid = regex.password.test($(this).val()),
            currentItem = $(this),
            parentOfCurrent = currentItem.parent('.field-wrapper');
            if(isValid == true) {
                   parentOfCurrent.find('span.error').remove();
                   parentOfCurrent.addClass('ticmark').find('.create-password').removeClass('error');
            }else{
                   parentOfCurrent.removeClass('ticmark');
            }
       }).on('blur', '.login-password', function(){
           var isValid = regex.loginpassword.test($(this).val()),
           currentItem = $(this),
           parentOfCurrent = currentItem.parent('.field-wrapper');
           if(isValid == true) {
                  parentOfCurrent.find('span.error').remove();
                  parentOfCurrent.addClass('ticmark').find('.login-password').removeClass('error');
           }else{
                  parentOfCurrent.removeClass('ticmark');
           }
      }).on('blur','.passwordconfirm, .newpasswordconfirm', function () {
            var currentItem = $(this),
                   currentPassword = $('.login-password').val(),
                   confirmPassword = $('.passwordconfirm,.newpasswordconfirm').val(),
                   parentOfCurrent = currentItem.parent('.field-wrapper'),
                   existError = $('.login-password').parent('.field-wrapper').find('span.error').length;
            if((currentPassword === confirmPassword) && existError == 0) {
                   parentOfCurrent.find('span.error').remove();
            parentOfCurrent.addClass('ticmark').find('.passwordconfirm').removeClass('error');
            }else{
                   parentOfCurrent.removeClass('ticmark');
            }
       });
        $('.cvn, .regcustpclCVN').on('blur focusout keypress keyup', function(e) {
            var keycode = e.keyCode || e.which;
            if (keycode != 13 && keycode != 8 && keycode != 0 && (keycode < 48 || keycode > 57)) {
                return false;
            }
        });
    },
    initForm: function (f, submitHandler) {
        var _self = this;
        var $form = $(f);
        $form.validate(_self.settings);
        $(window).trigger(EventNames.VALIDATOR_CUSTOM_INITIALIZE);
    }
};

module.exports = validator;

},{"./constants/EventNames":12,"./pages/checkout/formPrepare":38}],89:[function(require,module,exports){
var modal = require('./modal').global;

module.exports = {
	init: function (cb) {
		if(typeof window.YT !== "undefined") {
			return cb();
		}

		window.onYouTubeIframeAPIReady = cb;

		// load youtube iframe api
		var tag = document.createElement("script");

		tag.async = true;
		tag.src = "https://www.youtube.com/iframe_api";

		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},

	playInline: function ($ele, videoId) {
		var eleId = $ele.attr("id");
		if(!eleId || !videoId) { return; }

		new YT.Player(eleId, {
			videoId: videoId,
			width: $ele.width(),
			height: $ele.height(),
			playerVars: {rel: 0},
			events: {
				onReady: function (evt) {
					var player = evt.target;
					player.playVideo();
				}
			}
		})
	},

	playInModal: function (videoId) {
		if(!videoId) { return; }

		modal.setContent('<div class="responsive-embed"><div id="video-player"></div></div>');

		new YT.Player("video-player", {
			videoId: videoId,
			events: {
				onReady: function (evt) {
					var player = evt.target;
					modal.events.onOpen(function () {
						var modalBodyWidth = $(".modal-body").width();
						//$("#video-player").width(modalBodyWidth);
						player.playVideo();
					});
					modal.events.onClose(function () { player.destroy(); });
					modal.open();
				}
			}
		})
	}
};
},{"./modal":28}],90:[function(require,module,exports){
'use strict';

var util = require('./util');

function handleWishlist() {
    $('.swatch-list .swatch').on('click', function(e) {
        e.preventDefault();
        var $tile = $(this).closest('.product-tile');
        var wishlistIconHref = $tile.find('a.wishlist-icon').attr('href');
        var pidVariation = typeof $(this).data('pid') !== 'undefined' ? $(this).data('pid') : $tile.find('a.selected').data('pid'),
            wishlistIconHref = wishlistIconHref.split('?')[0] + '?pid=' + pidVariation;
        $tile.find('a.wishlist-icon').attr("href", wishlistIconHref);

        var ajaxUrl = util.appendParamsToUrl(Urls.isProductInProductList, {
            pid: pidVariation
        });
        $.ajax({
            type: 'GET',
            url: ajaxUrl,
            dataType: 'json',
            pid: pidVariation
        }).done(function(response) {
            if (response.isInWishlist == true) {
                var wishlistIconRemoveHref = util.appendParamsToUrl(Urls.wishlistRemove, {
                    pid: pidVariation
                });
                $tile.find('a.wishlist-icon').removeAttr('id');
                $tile.find('a.wishlist-icon').removeAttr('data-action');
                $tile.find('a.wishlist-icon').attr("href", wishlistIconRemoveHref);
                $tile.find('a.wishlist-icon').addClass('remove-from-wishlist');
                $tile.find('.iconfont-heart').addClass('iconfont-heart_solid').removeClass('iconfont-heart');
            } else {
                var wishlistIconAddHref = util.appendParamsToUrl(Urls.wishlistAdd, {
                    pid: pidVariation
                });
                $tile.find('a.wishlist-icon').attr('id', 'save-for-later');
                $tile.find('a.wishlist-icon').attr('data-action', 'wishlist');
                $tile.find('a.wishlist-icon').attr("href", wishlistIconAddHref);
                $tile.find('a.wishlist-icon').removeClass('remove-from-wishlist');
                $tile.find('.iconfont-heart_solid').addClass('iconfont-heart').removeClass('iconfont-heart_solid');
            }
        });
    })

    $('.wishlist-icon').off('click').on('click', function() {
        var currentUrl = window.location.href;
        $('.wishlist-sourceUrl').val(currentUrl);
    });
}
exports.handleWishlist = handleWishlist;
},{"./util":87}],91:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":92}],92:[function(require,module,exports){
(function (global){(function (){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],93:[function(require,module,exports){

},{}],94:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBind = require('./');

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

},{"./":95,"get-intrinsic":108}],95:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var GetIntrinsic = require('get-intrinsic');
var setFunctionLength = require('set-function-length');

var $TypeError = require('es-errors/type');
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = require('es-define-property');
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"es-define-property":97,"es-errors/type":103,"function-bind":107,"get-intrinsic":108,"set-function-length":132}],96:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');

var gopd = require('gopd');

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};

},{"es-define-property":97,"es-errors/syntax":102,"es-errors/type":103,"gopd":109}],97:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

},{"get-intrinsic":108}],98:[function(require,module,exports){
'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

},{}],99:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Error;

},{}],100:[function(require,module,exports){
'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

},{}],101:[function(require,module,exports){
'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

},{}],102:[function(require,module,exports){
'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

},{}],103:[function(require,module,exports){
'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

},{}],104:[function(require,module,exports){
'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

},{}],105:[function(require,module,exports){
/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {

'use strict';

var docElem = document.documentElement;

var bind = function() {};

function getIEEvent( obj ) {
  var event = window.event;
  // add event.target
  event.target = event.target || event.srcElement || obj;
  return event;
}

if ( docElem.addEventListener ) {
  bind = function( obj, type, fn ) {
    obj.addEventListener( type, fn, false );
  };
} else if ( docElem.attachEvent ) {
  bind = function( obj, type, fn ) {
    obj[ type + fn ] = fn.handleEvent ?
      function() {
        var event = getIEEvent( obj );
        fn.handleEvent.call( fn, event );
      } :
      function() {
        var event = getIEEvent( obj );
        fn.call( obj, event );
      };
    obj.attachEvent( "on" + type, obj[ type + fn ] );
  };
}

var unbind = function() {};

if ( docElem.removeEventListener ) {
  unbind = function( obj, type, fn ) {
    obj.removeEventListener( type, fn, false );
  };
} else if ( docElem.detachEvent ) {
  unbind = function( obj, type, fn ) {
    obj.detachEvent( "on" + type, obj[ type + fn ] );
    try {
      delete obj[ type + fn ];
    } catch ( err ) {
      // can't delete window object properties
      obj[ type + fn ] = undefined;
    }
  };
}

var eventie = {
  bind: bind,
  unbind: unbind
};

// ----- module definition ----- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( eventie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = eventie;
} else {
  // browser global
  window.eventie = eventie;
}

})( window );

},{}],106:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],107:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":106}],108:[function(require,module,exports){
'use strict';

var undefined;

var $Error = require('es-errors');
var $EvalError = require('es-errors/eval');
var $RangeError = require('es-errors/range');
var $ReferenceError = require('es-errors/ref');
var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');
var $URIError = require('es-errors/uri');

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();
var hasProto = require('has-proto')();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('hasown');
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"es-errors":99,"es-errors/eval":98,"es-errors/range":100,"es-errors/ref":101,"es-errors/syntax":102,"es-errors/type":103,"es-errors/uri":104,"function-bind":107,"has-proto":111,"has-symbols":112,"hasown":114}],109:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

},{"get-intrinsic":108}],110:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;

},{"es-define-property":97}],111:[function(require,module,exports){
'use strict';

var test = {
	__proto__: null,
	foo: {}
};

var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object);
};

},{}],112:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":113}],113:[function(require,module,exports){
'use strict';

/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],114:[function(require,module,exports){
'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

},{"function-bind":107}],115:[function(require,module,exports){
/*!
 * imagesLoaded v3.2.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'eventEmitter/EventEmitter',
      'eventie/eventie'
    ], function( EventEmitter, eventie ) {
      return factory( window, EventEmitter, eventie );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('wolfy87-eventemitter'),
      require('eventie')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EventEmitter,
      window.eventie
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EventEmitter, eventie ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var objToString = Object.prototype.toString;
function isArray( obj ) {
  return objToString.call( obj ) == '[object Array]';
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

  // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {Array, Element, NodeList, String} elem
   * @param {Object or Function} options - if function, use as callback
   * @param {Function} onAlways - callback function
   */
  function ImagesLoaded( elem, options, onAlways ) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if ( !( this instanceof ImagesLoaded ) ) {
      return new ImagesLoaded( elem, options, onAlways );
    }
    // use elem as selector string
    if ( typeof elem == 'string' ) {
      elem = document.querySelectorAll( elem );
    }

    this.elements = makeArray( elem );
    this.options = extend( {}, this.options );

    if ( typeof options == 'function' ) {
      onAlways = options;
    } else {
      extend( this.options, options );
    }

    if ( onAlways ) {
      this.on( 'always', onAlways );
    }

    this.getImages();

    if ( $ ) {
      // add jQuery Deferred object
      this.jqDeferred = new $.Deferred();
    }

    // HACK check async to allow time to bind listeners
    var _this = this;
    setTimeout( function() {
      _this.check();
    });
  }

  ImagesLoaded.prototype = new EventEmitter();

  ImagesLoaded.prototype.options = {};

  ImagesLoaded.prototype.getImages = function() {
    this.images = [];

    // filter & find items if we have an item selector
    for ( var i=0; i < this.elements.length; i++ ) {
      var elem = this.elements[i];
      this.addElementImages( elem );
    }
  };

  /**
   * @param {Node} element
   */
  ImagesLoaded.prototype.addElementImages = function( elem ) {
    // filter siblings
    if ( elem.nodeName == 'IMG' ) {
      this.addImage( elem );
    }
    // get background image on element
    if ( this.options.background === true ) {
      this.addElementBackgroundImages( elem );
    }

    // find children
    // no non-element nodes, #143
    var nodeType = elem.nodeType;
    if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
      return;
    }
    var childImgs = elem.querySelectorAll('img');
    // concat childElems to filterFound array
    for ( var i=0; i < childImgs.length; i++ ) {
      var img = childImgs[i];
      this.addImage( img );
    }

    // get child background images
    if ( typeof this.options.background == 'string' ) {
      var children = elem.querySelectorAll( this.options.background );
      for ( i=0; i < children.length; i++ ) {
        var child = children[i];
        this.addElementBackgroundImages( child );
      }
    }
  };

  var elementNodeTypes = {
    1: true,
    9: true,
    11: true
  };

  ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
    var style = getStyle( elem );
    // get url inside url("...")
    var reURL = /url\(['"]*([^'"\)]+)['"]*\)/gi;
    var matches = reURL.exec( style.backgroundImage );
    while ( matches !== null ) {
      var url = matches && matches[1];
      if ( url ) {
        this.addBackground( url, elem );
      }
      matches = reURL.exec( style.backgroundImage );
    }
  };

  // IE8
  var getStyle = window.getComputedStyle || function( elem ) {
    return elem.currentStyle;
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function( img ) {
    var loadingImage = new LoadingImage( img );
    this.images.push( loadingImage );
  };

  ImagesLoaded.prototype.addBackground = function( url, elem ) {
    var background = new Background( url, elem );
    this.images.push( background );
  };

  ImagesLoaded.prototype.check = function() {
    var _this = this;
    this.progressedCount = 0;
    this.hasAnyBroken = false;
    // complete if no images
    if ( !this.images.length ) {
      this.complete();
      return;
    }

    function onProgress( image, elem, message ) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout( function() {
        _this.progress( image, elem, message );
      });
    }

    for ( var i=0; i < this.images.length; i++ ) {
      var loadingImage = this.images[i];
      loadingImage.once( 'progress', onProgress );
      loadingImage.check();
    }
  };

  ImagesLoaded.prototype.progress = function( image, elem, message ) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // progress event
    this.emit( 'progress', this, image, elem );
    if ( this.jqDeferred && this.jqDeferred.notify ) {
      this.jqDeferred.notify( this, image );
    }
    // check if completed
    if ( this.progressedCount == this.images.length ) {
      this.complete();
    }

    if ( this.options.debug && console ) {
      console.log( 'progress: ' + message, image, elem );
    }
  };

  ImagesLoaded.prototype.complete = function() {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emit( eventName, this );
    this.emit( 'always', this );
    if ( this.jqDeferred ) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[ jqMethod ]( this );
    }
  };

  // --------------------------  -------------------------- //

  function LoadingImage( img ) {
    this.img = img;
  }

  LoadingImage.prototype = new EventEmitter();

  LoadingImage.prototype.check = function() {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      // report based on naturalWidth
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    this.proxyImage = new Image();
    eventie.bind( this.proxyImage, 'load', this );
    eventie.bind( this.proxyImage, 'error', this );
    // bind to image as well for Firefox. #191
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.proxyImage.src = this.img.src;
  };

  LoadingImage.prototype.getIsImageComplete = function() {
    return this.img.complete && this.img.naturalWidth !== undefined;
  };

  LoadingImage.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.img, message );
  };

  // ----- events ----- //

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function( event ) {
    var method = 'on' + event.type;
    if ( this[ method ] ) {
      this[ method ]( event );
    }
  };

  LoadingImage.prototype.onload = function() {
    this.confirm( true, 'onload' );
    this.unbindEvents();
  };

  LoadingImage.prototype.onerror = function() {
    this.confirm( false, 'onerror' );
    this.unbindEvents();
  };

  LoadingImage.prototype.unbindEvents = function() {
    eventie.unbind( this.proxyImage, 'load', this );
    eventie.unbind( this.proxyImage, 'error', this );
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  // -------------------------- Background -------------------------- //

  function Background( url, element ) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  }

  // inherit LoadingImage prototype
  Background.prototype = new LoadingImage();

  Background.prototype.check = function() {
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.img.src = this.url;
    // check if image is already complete
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      this.unbindEvents();
    }
  };

  Background.prototype.unbindEvents = function() {
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  Background.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.element, message );
  };

  // -------------------------- jQuery -------------------------- //

  ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
    jQuery = jQuery || window.jQuery;
    if ( !jQuery ) {
      return;
    }
    // set local variable
    $ = jQuery;
    // $().imagesLoaded()
    $.fn.imagesLoaded = function( options, callback ) {
      var instance = new ImagesLoaded( this, options, callback );
      return instance.jqDeferred.promise( $(this) );
    };
  };
  // try making plugin
  ImagesLoaded.makeJQueryPlugin();

  // --------------------------  -------------------------- //

  return ImagesLoaded;

});

},{"eventie":105,"wolfy87-eventemitter":135}],116:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],117:[function(require,module,exports){
(function (global){(function (){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require('./util.inspect');
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./util.inspect":93}],118:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":123}],119:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":92}],120:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":119}],121:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

},{"./core.js":119}],122:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":119}],123:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":119,"./done.js":120,"./es6-extensions.js":121,"./finally.js":122,"./node-extensions.js":124,"./synchronous.js":125}],124:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":119,"asap":91}],125:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._65 === 3) {
      return this._55.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._55;
  };

  Promise.prototype.getReason = function () {
    if (this._65 === 3) {
      return this._55.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._55;
  };

  Promise.prototype.getState = function () {
    if (this._65 === 3) {
      return this._55.getState();
    }
    if (this._65 === -1 || this._65 === -2) {
      return 0;
    }

    return this._65;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":119}],126:[function(require,module,exports){
(function (global){(function (){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],127:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],128:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":127,"./parse":129,"./stringify":130}],129:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

},{"./utils":131}],130:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":127,"./utils":131,"side-channel":133}],131:[function(require,module,exports){
'use strict';

var formats = require('./formats');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"./formats":127}],132:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var define = require('define-data-property');
var hasDescriptors = require('has-property-descriptors')();
var gOPD = require('gopd');

var $TypeError = require('es-errors/type');
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};

},{"define-data-property":96,"es-errors/type":103,"get-intrinsic":108,"gopd":109,"has-property-descriptors":110}],133:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bind/callBound');
var inspect = require('object-inspect');

var $TypeError = require('es-errors/type');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	for (; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			// eslint-disable-next-line no-extra-parens
			curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('.').ListNode<typeof value>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @type {WeakMap<object, unknown>} */ var $wm;
	/** @type {Map<object, unknown>} */ var $m;
	/** @type {import('.').RootNode<unknown>} */ var $o;

	/** @type {import('.').Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

},{"call-bind/callBound":94,"es-errors/type":103,"get-intrinsic":108,"object-inspect":117}],134:[function(require,module,exports){
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

'use strict';

var punycode = require('punycode/');

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = require('qs');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

},{"punycode/":126,"qs":128}],135:[function(require,module,exports){
/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

},{}]},{},[8]);
